import configment from '@adc/configment';
import * as _ from 'lodash';
import ___default, { isNil, keyBy, get, isEqual, escapeRegExp } from 'lodash';
import coreLogger from '@adc/logger';
import { SubscriptionClient } from 'subscriptions-transport-ws';
import React, { useState, useRef, useEffect, useCallback, useLayoutEffect, useMemo, isValidElement } from 'react';
import moment from 'moment';
import ms from 'ms';
import * as adcHooks from '@adc/hooks';
import { usePrevious, useIsMounted, useOnce } from '@adc/hooks';
import * as graph from '@adc/sdk';
import { G, gql, enums as enums$1 } from '@adc/sdk';
import moment$1 from 'moment-timezone';
import parse from 'url-parse';
import { match, P } from 'ts-pattern';
import * as fetch from '@adc/fetch';
import fetch__default from '@adc/fetch';
import * as constants$2 from '@adc/constants';
import { contactNumbers, graph as graph$1, geo } from '@adc/constants';
import { conformToMask } from 'react-text-mask';
import tinycolor from 'tinycolor2';
import pluralize from 'pluralize';
import { isAfter } from 'date-fns';
import gql$1 from 'graphql-tag';
import MurmurHash3 from 'imurmurhash';
import instrument from '@adc/instrument';
import { z } from 'zod';
import LRUCache from 'lru-cache';

function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var _extendStatics = function extendStatics(d, b) {
  _extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
  };
  return _extendStatics(d, b);
};
function __extends(d, b) {
  if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  _extendStatics(d, b);
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return _assign.apply(this, arguments);
};
function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}
function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}
function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
}

var logger$9 = coreLogger.forModule('blueprint:GraphWebsocket');
var MAXIMUM_GRAPH_CONTEXT_UPDATE_RATE = 400;
var GraphWebsocket = function () {
  function GraphWebsocket(options) {
    if (options === void 0) {
      options = {};
    }
    var _this = this;
    this.client = new SubscriptionClient(configment.get('RESI_GRAPH_API_SUBSCRIPTIONS_URL') + '/graphql/subscriptions', _assign({
      reconnect: true,
      connectionCallback: function connectionCallback() {
        _this.markAndResolve();
      },
      reconnectionAttempts: 10
    }, options), WebSocket, 'adc-graphql-ws');
    this.markAndResolve = ___default.noop;
    this.waitForEstablishedConnection = new Promise(function (resolve) {
      var markResolved = false;
      var markAndResolve = function markAndResolve() {
        if (markResolved) return;
        markResolved = true;
        resolve();
      };
      _this.markAndResolve = markAndResolve;
    });
    this.eventListeners = {
      onConnected: [],
      onDisconnected: [],
      onReconnected: [],
      onError: []
    };
    this.pendingSubscriptionsCount = 0;
    this.pendingWaitAttemptsCount = 3;
    this.client.onConnected(function () {
      _this.eventListeners.onConnected.forEach(function (listener) {
        return listener();
      });
    });
    this.client.onDisconnected(function () {
      _this.eventListeners.onDisconnected.forEach(function (listener) {
        return listener();
      });
    });
    this.client.onReconnected(function () {
      _this.eventListeners.onReconnected.forEach(function (listener) {
        return listener();
      });
    });
    this.client.onError(function (error) {
      _this.eventListeners.onError.forEach(function (listener) {
        return listener(error);
      });
    });
  }
  GraphWebsocket.prototype.onConnected = function (listener) {
    this.eventListeners.onConnected.push(listener);
  };
  GraphWebsocket.prototype.onDisconnected = function (listener) {
    this.eventListeners.onDisconnected.push(listener);
  };
  GraphWebsocket.prototype.onReconnected = function (listener) {
    this.eventListeners.onReconnected.push(listener);
  };
  GraphWebsocket.prototype.onError = function (listener) {
    this.eventListeners.onError.push(listener);
  };
  GraphWebsocket.prototype.subscribe = function (_a) {
    var _this = this;
    var operationOptions = _a.operationOptions,
      onData = _a.onData,
      onError = _a.onError;
    this.pendingSubscriptionsCount++;
    return this.waitForEstablishedConnection.then(function () {
      var unsubscriber = _this.client.request(operationOptions).subscribe({
        error: function error(_error) {
          onError(_error);
        },
        next: function next(_a) {
          var data = _a.data,
            errors = _a.errors;
          if (errors && errors.length) {
            logger$9.warn(errors);
          }
          if (!data) return;
          onData(data);
        }
      });
      var operationId = _this.client.nextOperationId;
      _this.pendingSubscriptionsCount--;
      return {
        unsubscribe: unsubscriber.unsubscribe,
        operationId: operationId,
        resubscribe: ___default.noop,
        updateContext: ___default.debounce(function (context) {
          _this.client.sendMessage(operationId, 'GQL_CONTEXT_UPDATE', {
            context: context
          });
        }, MAXIMUM_GRAPH_CONTEXT_UPDATE_RATE)
      };
    });
  };
  GraphWebsocket.prototype.close = function () {
    this.client.close();
  };
  GraphWebsocket.prototype.restart = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!(this.pendingSubscriptionsCount > 0 && this.pendingWaitAttemptsCount > 0)) return [3, 2];
            return [4, waitFor(300)];
          case 1:
            _a.sent();
            this.pendingWaitAttemptsCount--;
            return [3, 0];
          case 2:
            return [4, this.client.close(false)];
          case 3:
            _a.sent();
            this.pendingWaitAttemptsCount = 3;
            return [2];
        }
      });
    });
  };
  return GraphWebsocket;
}();
var waitFor = function waitFor(delay) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, delay);
  });
};
var NullGraphWebsocket = function () {
  function NullGraphWebsocket() {}
  NullGraphWebsocket.prototype.onConnected = function () {};
  NullGraphWebsocket.prototype.onDisconnected = function () {};
  NullGraphWebsocket.prototype.onReconnected = function () {};
  NullGraphWebsocket.prototype.onError = function () {};
  NullGraphWebsocket.prototype.subscribe = function () {
    return Promise.resolve({
      unsubscribe: function unsubscribe() {},
      resubscribe: function resubscribe() {},
      updateContext: function updateContext() {},
      operationId: Infinity
    });
  };
  NullGraphWebsocket.prototype.close = function () {};
  NullGraphWebsocket.prototype.restart = function () {};
  return NullGraphWebsocket;
}();

var logger$8 = coreLogger.forModule('devicestorage');
var NullDeviceStorage = function () {
  function NullDeviceStorage(options) {
    if (options === void 0) {
      options = {
        namespace: ''
      };
    }
    this.namespace = options.namespace;
  }
  NullDeviceStorage.prototype.get = function () {
    return Promise.resolve(null);
  };
  NullDeviceStorage.prototype.set = function () {
    return Promise.resolve();
  };
  NullDeviceStorage.prototype.publish = function () {
    ___default.noop();
  };
  NullDeviceStorage.prototype.subscribe = function () {
    return function () {
      return ___default.noop();
    };
  };
  return NullDeviceStorage;
}();
var DeviceStorageAdapter = function () {
  function DeviceStorageAdapter(options) {
    if (options === void 0) {
      options = {
        storage: new NullDeviceStorage()
      };
    }
    this._storage = options.storage;
  }
  DeviceStorageAdapter.prototype.get = function (key) {
    return __awaiter(this, void 0, void 0, function () {
      var item, err_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);
            return [4, this._storage.get(key)];
          case 1:
            item = _a.sent();
            return [2, item];
          case 2:
            err_1 = _a.sent();
            logger$8.error(err_1);
            return [3, 3];
          case 3:
            return [2, null];
        }
      });
    });
  };
  DeviceStorageAdapter.prototype.set = function (key, value) {
    return __awaiter(this, void 0, void 0, function () {
      var err_2;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);
            return [4, this._storage.set(key, value)];
          case 1:
            _a.sent();
            this.publish(key, value);
            return [3, 3];
          case 2:
            err_2 = _a.sent();
            logger$8.error(err_2);
            return [3, 3];
          case 3:
            return [2];
        }
      });
    });
  };
  DeviceStorageAdapter.prototype.publish = function (key, newValue) {
    if (typeof this._storage.publish === 'function') {
      this._storage.publish(key, newValue);
    }
  };
  DeviceStorageAdapter.prototype.subscribe = function (listener) {
    if (typeof this._storage.subscribe === 'function') {
      return this._storage.subscribe(listener);
    }
    return function () {
      return ___default.noop();
    };
  };
  return DeviceStorageAdapter;
}();
var WebLocalStorage = function () {
  function WebLocalStorage(options) {
    if (options === void 0) {
      options = {
        namespace: ''
      };
    }
    this.namespace = options.namespace;
  }
  WebLocalStorage.prototype.get = function (key) {
    try {
      var item = window.localStorage.getItem(key);
      return Promise.resolve(item);
    } catch (err) {
      return Promise.reject(err);
    }
  };
  WebLocalStorage.prototype.set = function (key, value) {
    try {
      window.localStorage.setItem(key, value);
      return Promise.resolve();
    } catch (err) {
      return Promise.reject(err);
    }
  };
  WebLocalStorage.prototype.publish = function (key, newValue) {
    window.dispatchEvent(new StorageEvent('storage', {
      key: key,
      newValue: newValue
    }));
  };
  WebLocalStorage.prototype.subscribe = function (listener) {
    window.addEventListener('storage', listener);
    return function () {
      window.removeEventListener('storage', listener);
    };
  };
  return WebLocalStorage;
}();

var computeNextOnlinePollingOffset = function computeNextOnlinePollingOffset(currentDateTime, segments) {
  if (segments.every(function (_a) {
    var segment_status = _a.segment_status;
    return segment_status === G.OnlineAuctionSegmentStatus.Pending || segment_status === G.OnlineAuctionSegmentStatus.Ended;
  })) {
    return SUPPORTED_OFFSETS.SLACK;
  }
  var currentInstant = getLocalTimeIfNecessary(moment(currentDateTime));
  var estimatedFinishingTimeDeltas = segments.filter(function (_a) {
    var segment_status = _a.segment_status;
    return segment_status !== G.OnlineAuctionSegmentStatus.Ended;
  }).map(function (_a) {
    var initial_end_date = _a.initial_end_date;
    return moment(initial_end_date).diff(currentInstant, 'milliseconds');
  });
  var priorityDelta = Math.min.apply(Math, estimatedFinishingTimeDeltas);
  if (priorityDelta < ms('30s')) {
    return SUPPORTED_OFFSETS.CRITICAL;
  } else if (priorityDelta < ms('2m')) {
    return SUPPORTED_OFFSETS.URGENT;
  } else {
    return SUPPORTED_OFFSETS.NORMAL;
  }
};

var CURRENT_SERVER_TIME_POLLING_INTERVAL = ms('1m');
var SUPPORTED_OFFSETS = {
  SLACK: ms('5m'),
  NORMAL: ms('2m'),
  URGENT: ms('30s'),
  CRITICAL: ms('10s')
};
var getLocalTimeIfNecessary = function getLocalTimeIfNecessary(m) {
  return (m === null || m === void 0 ? void 0 : m.isValid()) ? m : moment();
};

var TIME_STYLES = "\n  color: #fff;\n  text-transform: uppercase;\n  padding: 3px 6px;\n  background-color: #5A4FFF;\n  border-radius: 4px;\n  font: monospace;\n";
var START_OF_TIME = Date.now();
var timestamp = function timestamp() {
  return "".concat(moment().diff(START_OF_TIME, 'seconds'), " AR");
};
var timestampf = function timestampf() {
  var messages = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    messages[_i] = arguments[_i];
  }
  return console.log.apply(console, __spreadArray(["%c".concat(timestamp()), TIME_STYLES], messages, false));
};
var DynamicIntervalPoller = function () {
  function DynamicIntervalPoller(id, onData, onError, onEvent) {
    var _this = this;
    this.id = id;
    this.frequency = this.lastPollOffset = SUPPORTED_OFFSETS.NORMAL;
    this.onData = onData;
    this.onError = onError;
    this.onEvent = onEvent;
    this.subjectIds = [];
    this.schedulePoll = ___default.debounce(function () {
      _this.terminate();
      _this.triggerPoll();
    }, 500);
  }
  DynamicIntervalPoller.prototype.setPollingFrequency = function (newFrequency) {
    this.frequency = newFrequency;
    return this;
  };
  DynamicIntervalPoller.prototype.setOnData = function (newOnData) {
    this.onData = newOnData;
    return this;
  };
  DynamicIntervalPoller.prototype.setPollingExecutor = function (newPollingExecutor) {
    if (this.poller !== newPollingExecutor) {
      this.poller = newPollingExecutor;
    }
    return this;
  };
  DynamicIntervalPoller.prototype.setSubjectIds = function (newSubjectIds) {
    this.subjectIds = newSubjectIds;
    return this;
  };
  DynamicIntervalPoller.prototype.calculateNextOffset = function () {
    var nextPollOffset = ___default.isFunction(this.frequency) ? this.frequency() : this.frequency;
    if (this.lastPollOffset !== nextPollOffset) {
      this.onEvent('polling:frequency_change', {
        previous: this.lastPollOffset,
        current: nextPollOffset
      });
    }
    return nextPollOffset;
  };
  DynamicIntervalPoller.prototype.potentiallyScheduleNewPoll = function (newFrequency) {
    this.frequency = newFrequency;
    var nextPollOffset = this.calculateNextOffset();
    if (nextPollOffset !== this.lastPollOffset) {
      timestampf('Polling frequency change detected. Scheduling new poll.', {
        previous: ms(this.lastPollOffset, {
          long: true
        }),
        next: ms(nextPollOffset, {
          long: true
        })
      });
      this.lastPollOffset = nextPollOffset;
      this.schedulePoll();
    }
    return this;
  };
  DynamicIntervalPoller.prototype.triggerPoll = function () {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
      var error_1;
      var _this = this;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            if (!this.poller || !((_a = this.subjectIds) === null || _a === void 0 ? void 0 : _a.length)) {
              return [2];
            }
            timestampf('Triggering new poll: ' + this.id);
            _b.label = 1;
          case 1:
            _b.trys.push([1, 3, 4, 5]);
            this.currentAbortController = new AbortController();
            return [4, this.poller({
              subjectIds: this.subjectIds,
              controller: this.currentAbortController
            }).then(function (data) {
              return _this.onData({
                id: _this.id,
                data: (data === null || data === void 0 ? void 0 : data.length) ? data : [],
                source: 'polling'
              });
            })];
          case 2:
            _b.sent();
            return [3, 5];
          case 3:
            error_1 = _b.sent();
            this.onError({
              id: this.id,
              source: 'polling',
              error: error_1
            });
            return [3, 5];
          case 4:
            this.lastPollOffset = this.calculateNextOffset();
            this.timeoutRef = setTimeout(this.triggerPoll.bind(this), this.lastPollOffset);
            return [7];
          case 5:
            return [2];
        }
      });
    });
  };
  DynamicIntervalPoller.prototype.terminate = function () {
    var _a;
    timestampf('Terminating poller: ' + this.id);
    (_a = this.currentAbortController) === null || _a === void 0 ? void 0 : _a.abort();
    clearTimeout(this.timeoutRef);
  };
  return DynamicIntervalPoller;
}();
var deterministicSerialization = function deterministicSerialization(keys) {
  return keys.sort().join('-');
};
function useRealtimeWatcher(_a) {
  var id = _a.id,
    subjectIds = _a.subjectIds,
    polling = _a.polling,
    websocket = _a.websocket,
    onData = _a.onData,
    _onError = _a.onError,
    _b = _a.onEvent,
    onEvent = _b === void 0 ? ___default.noop : _b;
  var _c = useState(deterministicSerialization(subjectIds)),
    triggerKey = _c[0],
    setTriggerKey = _c[1];
  var prevTriggerKey = usePrevious(triggerKey);
  var unsubscribe = useRef(null);
  var pollingExecutor = useRef(polling ? new DynamicIntervalPoller(id, onData, _onError, onEvent).setPollingFrequency(polling.frequency).setPollingExecutor(polling.executor) : null);
  var onDataRef = useRef(onData);
  useEffect(function () {
    var _a;
    (_a = pollingExecutor.current) === null || _a === void 0 ? void 0 : _a.setOnData(onData);
    onDataRef.current = onData;
  }, [onData]);
  useEffect(function () {
    var _a;
    (polling === null || polling === void 0 ? void 0 : polling.executor) && ((_a = pollingExecutor.current) === null || _a === void 0 ? void 0 : _a.setPollingExecutor(polling.executor));
  }, [polling === null || polling === void 0 ? void 0 : polling.executor]);
  useEffect(function () {
    if (!(polling === null || polling === void 0 ? void 0 : polling.enabled)) {
      onEvent('polling:disabled', {
        id: id
      });
    }
    if (!(websocket === null || websocket === void 0 ? void 0 : websocket.enabled)) {
      onEvent('websocket:disabled', {
        id: id
      });
    } else {
      websocket.graphWebsocket.onConnected(function () {
        return onEvent('websocket:connected', {
          id: id
        });
      });
      websocket.graphWebsocket.onDisconnected(function () {
        return onEvent('websocket:disconnected', {
          id: id
        });
      });
      websocket.graphWebsocket.onReconnected(function () {
        return onEvent('websocket:reconnected', {
          id: id
        });
      });
    }
    return function () {
      var _a, _b;
      (_a = pollingExecutor.current) === null || _a === void 0 ? void 0 : _a.terminate();
      (_b = unsubscribe.current) === null || _b === void 0 ? void 0 : _b.call(unsubscribe);
    };
  }, []);
  useEffect(function () {
    var _a;
    setTriggerKey(deterministicSerialization(subjectIds));
    (_a = pollingExecutor.current) === null || _a === void 0 ? void 0 : _a.setSubjectIds(subjectIds);
  }, [subjectIds]);
  useEffect(function () {
    var _a;
    if (!(polling === null || polling === void 0 ? void 0 : polling.enabled)) {
      return;
    }
    timestampf('New frequency function detected.');
    (_a = pollingExecutor.current) === null || _a === void 0 ? void 0 : _a.potentiallyScheduleNewPoll(polling.frequency);
  }, [polling === null || polling === void 0 ? void 0 : polling.frequency, polling === null || polling === void 0 ? void 0 : polling.enabled]);
  useEffect(function () {
    var _a;
    if (!(polling === null || polling === void 0 ? void 0 : polling.enabled) || !triggerKey) {
      return;
    }
    timestampf('New trigger key detected.');
    (_a = pollingExecutor.current) === null || _a === void 0 ? void 0 : _a.schedulePoll();
  }, [triggerKey, polling === null || polling === void 0 ? void 0 : polling.enabled]);
  var onWebsocketData = useCallback(function (data) {
    if (websocket) onDataRef.current({
      id: id,
      source: 'websocket',
      data: websocket.dataExtractor(data)
    });
  }, [onDataRef]);
  useEffect(function () {
    var _a, _b;
    if (!(websocket === null || websocket === void 0 ? void 0 : websocket.enabled)) {
      return;
    }
    if (!triggerKey) {
      return;
    }
    if (prevTriggerKey !== triggerKey) {
      onEvent('websocket:resubscribe', {
        id: id
      });
      (_a = unsubscribe.current) === null || _a === void 0 ? void 0 : _a.call(unsubscribe);
      websocket.graphWebsocket.subscribe({
        operationOptions: websocket.executor({
          subjectIds: subjectIds
        }),
        onData: onWebsocketData,
        onError: function onError(error) {
          return _onError({
            id: id,
            source: 'websocket',
            error: error
          });
        }
      }).then(function (graphSubscriber) {
        unsubscribe.current = function () {
          graphSubscriber.unsubscribe();
        };
        return true;
      }).catch(function (err) {
        return err;
      });
      onEvent('polling:preemptively_schedule', {
        id: id
      });
      (_b = pollingExecutor.current) === null || _b === void 0 ? void 0 : _b.schedulePoll();
    }
  }, [triggerKey, id, onData, _onError, onEvent, websocket, subjectIds, prevTriggerKey, onWebsocketData]);
}

var SPECIAL_SELF_REFERENCE = Symbol.for('adc.blueprint.idempotent_element_self_ref');
var embeddableOperation = function embeddableOperation(name) {
  return [___default.camelCase(configment.get('APP_NAME', '')), name].filter(Boolean).join('_');
};

var logger$7 = coreLogger.forModule('blueprint:idempotentCollection');
var CURRENT_USER_FIELDS_PREFIX = 'current_user_';
function createBlueprintBoundElement(element, utils, attemptWriteRef, attemptBatchWriteRef) {
  var boundElement = element;
  boundElement.$ = boundElement.__methods__ = Object.fromEntries(Object.entries(utils).map(function (_a) {
    var k = _a[0],
      f = _a[1];
    return [k, f.bind(null, element)];
  }));
  boundElement[SPECIAL_SELF_REFERENCE] = {
    attemptWriteRef: attemptWriteRef,
    attemptBatchWriteRef: attemptBatchWriteRef
  };
  return boundElement;
}
function useIdempotentBlueprintCollection(initialCollection, _a) {
  if (initialCollection === void 0) {
    initialCollection = [];
  }
  var _b = _a.primaryKey,
    primaryKey = _b === void 0 ? 'id' : _b,
    _c = _a.idempotencyKey,
    idempotencyKey = _c === void 0 ? 'update_date' : _c,
    _d = _a.utils,
    utils = _d === void 0 ? {} : _d,
    _e = _a.updateBehavior,
    updateBehavior = _e === void 0 ? 'overwrite' : _e,
    _f = _a.collectionName,
    collectionName = _f === void 0 ? 'blueprint:idempotentCollection' : _f;
  var _g = useState(new Map()),
    collectionIdempotencyTracking = _g[0],
    setCollectionIdempotencyTracking = _g[1];
  var _h = useState({
      raw: initialCollection,
      mapped: initialCollection.reduce(function (acc, element) {
        return acc.set(element[primaryKey], createBlueprintBoundElement(element, utils, attemptWriteRef, attemptBatchWriteRef));
      }, new Map())
    }),
    collection = _h[0],
    setCollection = _h[1];
  var attemptWrite = useCallback(function (_a) {
    var _b = _a.data,
      data = _b === void 0 ? [] : _b,
      source = _a.source,
      _c = _a.force,
      force = _c === void 0 ? false : _c;
    var shouldForceUpdate = source === 'local_optimistic_action' || force;
    var updatedReason = shouldForceUpdate ? 'force' : null;
    var changedElements = data.filter(Boolean).filter(function (element) {
      var previouslySeenAt = collectionIdempotencyTracking.get(element[primaryKey]);
      var hasUpdatedFromIdempotencyKey = !previouslySeenAt || new Date(element[idempotencyKey]) > new Date(previouslySeenAt);
      updatedReason = hasUpdatedFromIdempotencyKey ? 'key_advance' : updatedReason;
      var hasUpdatedDataShape = false;
      if (!hasUpdatedFromIdempotencyKey && !shouldForceUpdate) {
        var currentElementCurrentUserFields = ___default.pickBy(element, function (_, key) {
          return typeof key === 'string' && (key === null || key === void 0 ? void 0 : key.startsWith(CURRENT_USER_FIELDS_PREFIX));
        });
        var collectionElementCurrentUserFields = ___default.pickBy(collection.mapped.get(element[primaryKey]), function (_, key) {
          return typeof key === 'string' && (key === null || key === void 0 ? void 0 : key.startsWith(CURRENT_USER_FIELDS_PREFIX));
        });
        hasUpdatedDataShape = !___default.isMatch(collectionElementCurrentUserFields, currentElementCurrentUserFields);
        updatedReason = hasUpdatedDataShape ? 'shape_delta' : updatedReason;
      }
      var hasBeenUpdated = hasUpdatedFromIdempotencyKey || hasUpdatedDataShape;
      logger$7.forModule("".concat(collectionName, ":state:debug")).debug(element[primaryKey], ' => ', {
        hasBeenUpdated: hasBeenUpdated,
        shouldForceUpdate: shouldForceUpdate,
        updatedReason: updatedReason,
        existing: previouslySeenAt,
        new: element[idempotencyKey]
      });
      return hasBeenUpdated || shouldForceUpdate;
    });
    var upsertRequired = !___default.isEmpty(changedElements);
    logger$7.forModule(collectionName).info("Data Transport Effectiveness.", {
      source: source,
      causedChange: upsertRequired
    });
    if (!upsertRequired) {
      return;
    }
    var updatedCollectionIdempotencyTracking = new Map(collectionIdempotencyTracking);
    changedElements.forEach(function (element) {
      return updatedCollectionIdempotencyTracking.set(element[primaryKey], element[idempotencyKey]);
    });
    var updatedCollection = {
      raw: [],
      mapped: new Map(collection.mapped)
    };
    changedElements.forEach(function (element) {
      var currentElement = updatedCollection.mapped.get(element[primaryKey]);
      var newElement = updateBehavior === 'overwrite' ? element : ___default.mergeWith({}, currentElement, element, function (_, srcValue) {
        if (Array.isArray(srcValue)) {
          return srcValue;
        }
        return undefined;
      });
      updatedCollection.mapped.set(element[primaryKey], createBlueprintBoundElement(newElement, utils, attemptWriteRef, attemptBatchWriteRef));
    });
    updatedCollection.raw = Array.from(updatedCollection.mapped.values()).map(function (_a) {
      _a.$;
        _a.__methods__;
        var element = __rest(_a, ["$", "__methods__"]);
      return element;
    });
    setCollectionIdempotencyTracking(updatedCollectionIdempotencyTracking);
    setCollection(updatedCollection);
  }, [collection.mapped, collectionIdempotencyTracking, idempotencyKey, primaryKey, updateBehavior, utils]);
  var attemptBatchWrite = useCallback(function (batchedData) {
    var shouldUpdateState = false;
    var updatedCollectionIdempotencyTracking = new Map(collectionIdempotencyTracking);
    var updatedCollection = {
      raw: [],
      mapped: new Map(collection.mapped)
    };
    batchedData.forEach(function (data) {
      if (data.path && data.updateBehavior === 'overwrite') {
        data.data.forEach(function (element) {
          var collectionElement = updatedCollection.mapped.get(element[primaryKey]);
          var newElement = ___default.merge({}, collectionElement);
          if (data.path && element[data.path]) {
            newElement[data.path] = element[data.path];
            updatedCollection.mapped.set(element[primaryKey], createBlueprintBoundElement(newElement, utils, attemptWriteRef, attemptBatchWriteRef));
            updatedCollectionIdempotencyTracking.set(element[primaryKey], element[idempotencyKey]);
            shouldUpdateState = true;
          }
        });
      } else if (!data.path && data.updateBehavior === 'overwrite') {
        data.data.forEach(function (element) {
          updatedCollection.mapped.set(element[primaryKey], createBlueprintBoundElement(element, utils, attemptWriteRef, attemptBatchWriteRef));
          updatedCollectionIdempotencyTracking.set(element[primaryKey], element[idempotencyKey]);
          shouldUpdateState = true;
        });
      } else {
        var shouldForceUpdate_1 = data.source === 'local_optimistic_action' || data.force;
        var updatedReason_1 = shouldForceUpdate_1 ? 'force' : null;
        var changedElements = data.data.filter(Boolean).filter(function (element) {
          var previouslySeenAt = collectionIdempotencyTracking.get(element[primaryKey]);
          var hasUpdatedFromIdempotencyKey = !previouslySeenAt || new Date(element[idempotencyKey]) > new Date(previouslySeenAt);
          updatedReason_1 = hasUpdatedFromIdempotencyKey ? 'key_advance' : updatedReason_1;
          var hasUpdatedDataShape = false;
          if (!hasUpdatedFromIdempotencyKey && !shouldForceUpdate_1) {
            var currentElementCurrentUserFields = ___default.pickBy(element, function (_, key) {
              return typeof key === 'string' && (key === null || key === void 0 ? void 0 : key.startsWith(CURRENT_USER_FIELDS_PREFIX));
            });
            var collectionElementCurrentUserFields = ___default.pickBy(collection.mapped.get(element[primaryKey]), function (_, key) {
              return typeof key === 'string' && (key === null || key === void 0 ? void 0 : key.startsWith(CURRENT_USER_FIELDS_PREFIX));
            });
            hasUpdatedDataShape = !___default.isMatch(collectionElementCurrentUserFields, currentElementCurrentUserFields);
            updatedReason_1 = hasUpdatedDataShape ? 'shape_delta' : updatedReason_1;
          }
          var hasBeenUpdated = hasUpdatedFromIdempotencyKey || hasUpdatedDataShape;
          logger$7.forModule("".concat(collectionName, ":state:debug")).debug(element[primaryKey], ' => ', {
            hasBeenUpdated: hasBeenUpdated,
            shouldForceUpdate: shouldForceUpdate_1,
            updatedReason: updatedReason_1,
            existing: previouslySeenAt,
            new: element[idempotencyKey]
          });
          return hasBeenUpdated || shouldForceUpdate_1;
        });
        var upsertRequired = !___default.isEmpty(changedElements);
        shouldUpdateState = upsertRequired;
        logger$7.forModule(collectionName).info("Data Transport Effectiveness.", {
          source: data.source,
          causedChange: upsertRequired
        });
        if (!upsertRequired) {
          return;
        }
        changedElements.forEach(function (element) {
          return updatedCollectionIdempotencyTracking.set(element[primaryKey], element[idempotencyKey]);
        });
        changedElements.forEach(function (element) {
          var currentElement = updatedCollection.mapped.get(element[primaryKey]);
          var newElement = ___default.merge({}, currentElement, element);
          updatedCollection.mapped.set(element[primaryKey], createBlueprintBoundElement(newElement, utils, attemptWriteRef, attemptBatchWriteRef));
        });
      }
    });
    updatedCollection.raw = Array.from(updatedCollection.mapped.values()).map(function (_a) {
      _a.$;
        _a.__methods__;
        var element = __rest(_a, ["$", "__methods__"]);
      return element;
    });
    if (shouldUpdateState) {
      setCollectionIdempotencyTracking(updatedCollectionIdempotencyTracking);
      setCollection(updatedCollection);
    }
  }, [collection.mapped, collectionIdempotencyTracking, idempotencyKey, primaryKey, updateBehavior, utils]);
  var attemptWriteRef = useRef(attemptWrite);
  useEffect(function () {
    attemptWriteRef.current = attemptWrite;
  }, [attemptWrite]);
  var attemptBatchWriteRef = useRef(attemptBatchWrite);
  useEffect(function () {
    attemptBatchWriteRef.current = attemptBatchWrite;
  }, [attemptBatchWrite]);
  useEffect(function () {
    attemptWriteRef.current({
      data: initialCollection,
      source: 'initial_mount'
    });
  }, [initialCollection]);
  return {
    collection: collection,
    attemptWrite: attemptWrite,
    attemptBatchWrite: attemptBatchWrite
  };
}

var logger$6 = coreLogger.forModule('blueprint:localstorage');
function useLocalStorage(_a) {
  var _this = this;
  var key = _a.key,
    initialValue = _a.initialValue,
    onValueSet = _a.onValueSet,
    deviceStorage = _a.deviceStorage;
  var getValueFromLocalStorage = useCallback(function () {
    return __awaiter(_this, void 0, void 0, function () {
      var item, error_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);
            return [4, deviceStorage.get(key)];
          case 1:
            item = _a.sent();
            if (!___default.isEmpty(item)) {
              return [2, JSON.parse(String(item))];
            }
            return [3, 3];
          case 2:
            error_1 = _a.sent();
            logger$6.error(error_1);
            return [3, 3];
          case 3:
            return [2, initialValue];
        }
      });
    });
  }, [initialValue, key, deviceStorage]);
  var _b = useState(initialValue),
    storedValue = _b[0],
    setStoredValue = _b[1];
  useEffect(function () {
    var handleEnabledChange = function handleEnabledChange() {
      return __awaiter(_this, void 0, void 0, function () {
        var value;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4, getValueFromLocalStorage()];
            case 1:
              value = _a.sent();
              if (!___default.isEmpty(value)) {
                setStoredValue(value);
              }
              return [2];
          }
        });
      });
    };
    handleEnabledChange().catch(function (e) {
      return logger$6.error(e);
    });
  }, [getValueFromLocalStorage]);
  var setValue = useCallback(function (value) {
    return __awaiter(_this, void 0, void 0, function () {
      var error_2;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);
            return [4, deviceStorage.set(key, JSON.stringify(value))];
          case 1:
            _a.sent();
            setStoredValue(value);
            if (typeof onValueSet === 'function') {
              onValueSet(value, key);
            }
            return [3, 3];
          case 2:
            error_2 = _a.sent();
            logger$6.error(error_2);
            return [3, 3];
          case 3:
            return [2];
        }
      });
    });
  }, [key, onValueSet, deviceStorage, setStoredValue]);
  var storageEventListener = useCallback(function (event) {
    if (key === event.key && event.newValue !== event.oldValue) {
      var newValue = JSON.parse(String(event.newValue)) || initialValue;
      setStoredValue(newValue);
      if (typeof onValueSet === 'function') {
        onValueSet(newValue, key);
      }
    }
  }, [initialValue, key, onValueSet]);
  useLayoutEffect(function () {
    if (typeof window === 'undefined') return;
    var unsubscribe = deviceStorage.subscribe(storageEventListener);
    return function () {
      return unsubscribe();
    };
  }, [deviceStorage, storageEventListener]);
  return [storedValue, setValue];
}

var TargetAudience;
(function (TargetAudience) {
  TargetAudience["SELLER"] = "SELLER";
  TargetAudience["BUYER"] = "BUYER";
  TargetAudience["AUCTION_STAFF"] = "AUCTION_STAFF";
})(TargetAudience || (TargetAudience = {}));

var index$c = /*#__PURE__*/Object.freeze({
  __proto__: null,
  DeviceStorageAdapter: DeviceStorageAdapter,
  GraphWebsocket: GraphWebsocket,
  NullDeviceStorage: NullDeviceStorage,
  NullGraphWebsocket: NullGraphWebsocket,
  get TargetAudience () { return TargetAudience; },
  WebLocalStorage: WebLocalStorage,
  useIdempotentBlueprintCollection: useIdempotentBlueprintCollection,
  useLocalStorage: useLocalStorage,
  useRealtimeWatcher: useRealtimeWatcher
});

var WhatChangedFields;
(function (WhatChangedFields) {
  WhatChangedFields["paymentType"] = "/terms/payment_type";
  WhatChangedFields["offerAmount"] = "/terms/offer_amount";
  WhatChangedFields["downPaymentAmount"] = "/terms/down_payment_amount";
  WhatChangedFields["earnestMoneyDepositAmount"] = "/terms/earnest_money_deposit_amount";
  WhatChangedFields["closeEscrowDuration"] = "/terms/close_escrow_duration";
  WhatChangedFields["leasebackDuration"] = "/terms/leaseback_duration";
  WhatChangedFields["leasebackAmount"] = "/terms/leaseback_amount";
  WhatChangedFields["sellerConcessionAmount"] = "/terms/seller_concession_amount";
  WhatChangedFields["commission"] = "/terms/commission/0";
  WhatChangedFields["agentCommissionAmount"] = "/terms/commission/0/agent_commission_amount";
  WhatChangedFields["paidBy"] = "/terms/commission/0/paid_by";
  WhatChangedFields["inspectionContingencyPeriodDuration"] = "/terms/inspection_contingency_period_duration";
  WhatChangedFields["optionPeriodDuration"] = "/terms/option_period_duration";
  WhatChangedFields["optionPeriodCostAmount"] = "/terms/option_period_cost_amount";
  WhatChangedFields["financingContingencyDuration"] = "/terms/financing_contingency_duration";
  WhatChangedFields["appraisalContingencyDuration"] = "/terms/appraisal_contingency_duration";
  WhatChangedFields["additionalNotes"] = "/terms/notes/additional_notes";
})(WhatChangedFields || (WhatChangedFields = {}));

var AuctionExpressionRule;
(function (AuctionExpressionRule) {
  AuctionExpressionRule["Percentage"] = "PERCENTAGE";
  AuctionExpressionRule["Flat"] = "FLAT";
  AuctionExpressionRule["PercentageOrMinimum"] = "PERCENTAGE_OR_MINIMUM";
  AuctionExpressionRule["PercentageOrMaximum"] = "PERCENTAGE_OR_MAXIMUM";
  AuctionExpressionRule["PercentageOrMinimumAndMaximum"] = "PERCENTAGE_OR_MINIMUM_AND_MAXIMUM";
})(AuctionExpressionRule || (AuctionExpressionRule = {}));

var types$4 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get AuctionExpressionRule () { return AuctionExpressionRule; },
  get WhatChangedFields () { return WhatChangedFields; }
});

var formatMoney$1 = function formatMoney(val, overrides, hideDecimals) {
  if (hideDecimals === void 0) {
    hideDecimals = false;
  }
  if (Number.isFinite(val)) {
    var stringVal = String(val);
    var number = hideDecimals ? Number.parseInt(stringVal) : Number.parseFloat(stringVal);
    var minimumFractionDigits = Number.isInteger(number) ? 0 : 2;
    return number.toLocaleString('en-US', _assign({
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: minimumFractionDigits
    }, overrides));
  }
  return String(val) || '';
};
var MARKETING_SUPPORT_PREFIXES = ['utm', 'sfid', 'sfmc', 'marketing'];
var extractMarketingSupportPrefixes = function extractMarketingSupportPrefixes(urlString) {
  try {
    if (!urlString) return null;
    var query = parse(urlString, true).query;
    return ___default.pickBy(query, function (_, key) {
      return MARKETING_SUPPORT_PREFIXES.some(function (prefix) {
        return key.startsWith(prefix);
      });
    });
  } catch (_a) {
    return null;
  }
};
var _getTextFromReactNode = function getTextFromReactNode(richTextNode) {
  if (___default.isNil(richTextNode)) return '';
  return match(_typeof(richTextNode)).with('string', function () {
    return richTextNode;
  }).with('number', function () {
    return richTextNode.toString();
  }).with('boolean', function () {
    return '';
  }).with('object', function () {
    var _a;
    if (richTextNode instanceof Array) return richTextNode.map(_getTextFromReactNode).join('');
    if (richTextNode.props) {
      var nodeWithProps = richTextNode;
      if ((_a = nodeWithProps.props) === null || _a === void 0 ? void 0 : _a.children) {
        var children = nodeWithProps.props.children;
        return _getTextFromReactNode(children);
      }
    }
    return '';
  }).otherwise(function () {
    console.warn('Unresolved `richTextNode` of type:', _typeof(richTextNode), richTextNode);
    return '';
  });
};
var isNumberType = function isNumberType(obj) {
  return typeof obj === 'number';
};
var isBooleanType = function isBooleanType(obj) {
  return typeof obj === 'boolean';
};
var isStringType = function isStringType(obj) {
  return typeof obj === 'string';
};
var UNRESOLVED_TAGS_MATCH_PATTERN = /({{?[^}]+}})/g;
var removeTagDelimiters = function removeTagDelimiters(tag) {
  return tag.slice(2, tag.length - 2);
};
var interpolate = function interpolate(unresolvedInput, ctx, replacer) {
  var output = [];
  var pattern = UNRESOLVED_TAGS_MATCH_PATTERN;
  var processedInput = unresolvedInput;
  var result = pattern.exec(processedInput);
  while (result !== null) {
    var matchIndex = result.index;
    var match_1 = result[0];
    var contentBeforeMatch = processedInput.substring(0, matchIndex);
    var key = removeTagDelimiters(match_1);
    var value = ___default.get(ctx, key) || '';
    var replacedMatch = Array.isArray(value) ? value.join(',') : value;
    if (replacer) {
      replacedMatch = replacer(key, replacedMatch);
    }
    output.push(contentBeforeMatch);
    output.push(replacedMatch);
    processedInput = processedInput.substring(matchIndex + match_1.length, processedInput.length + 1);
    pattern.lastIndex = 0;
    result = pattern.exec(processedInput);
  }
  if (processedInput) {
    output.push(processedInput);
  }
  return output;
};
var calculateTimeZone = function calculateTimeZone() {
  return moment$1.tz.guess() || Intl.DateTimeFormat().resolvedOptions().timeZone;
};

var utils$7 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  calculateTimeZone: calculateTimeZone,
  extractMarketingSupportPrefixes: extractMarketingSupportPrefixes,
  formatMoney: formatMoney$1,
  getTextFromReactNode: _getTextFromReactNode,
  interpolate: interpolate,
  isBooleanType: isBooleanType,
  isNumberType: isNumberType,
  isStringType: isStringType
});

var shortenFlatLabel = function shortenFlatLabel(label) {
  var _a;
  if (typeof label !== 'string') return null;
  var auctionExpression = AuctionExpression.parse(label);
  if (auctionExpression) {
    var values = auctionExpression.getValues();
    return (_a = values === null || values === void 0 ? void 0 : values.shortenedLabel) !== null && _a !== void 0 ? _a : label;
  }
  return label;
};
var PERCENTAGE_AMOUNT = '(?<percentage>[1-9]\\d{0,1}(\\.\\d+)?|100)%';
var AMOUNT = '\\d+([,]\\d+)*(\\.\\d+)?';
var FLAT_AMOUNT = "\\$(?<flat>".concat(AMOUNT, ")");
var MINIMUM_AMOUNT = "\\$(?<minimumAmount>".concat(AMOUNT, ") minimum");
var MAXIMUM_AMOUNT = "\\$(?<maximumAmount>".concat(AMOUNT, ") maximum");
var FLAT_REGEX = new RegExp("^".concat(FLAT_AMOUNT, "$"), 'i');
var PERCENTAGE_REGEX = new RegExp("^".concat(PERCENTAGE_AMOUNT, "$"), 'i');
var PERCENTAGE_OR_MINIMUM_REGEX = new RegExp("^".concat(PERCENTAGE_AMOUNT, " or ").concat(MINIMUM_AMOUNT, "$"), 'i');
var PERCENTAGE_OR_MAXIMUM_REGEX = new RegExp("^".concat(PERCENTAGE_AMOUNT, " or ").concat(MAXIMUM_AMOUNT, "$"), 'i');
var PERCENTAGE_OR_MINIMUM_AND_MAXIMUM_REGEX = new RegExp("^".concat(PERCENTAGE_AMOUNT, " or ").concat(MINIMUM_AMOUNT, " and ").concat(MAXIMUM_AMOUNT, "$"), 'i');
var calculatePercentageAmount = function calculatePercentageAmount(amount, percentage) {
  return parseFloat((amount / 100 * parseFloat(percentage)).toFixed(2));
};
var shortenMoneyLabel = function shortenMoneyLabel(label) {
  var number = parseInt(label.replace(/,/g, ''), 10);
  if (!isNaN(number)) {
    var formattedNumber = number % 1000 === 0 ? "$".concat(number / 1000, "k") : "$".concat(number);
    return formattedNumber;
  }
  return label;
};
var flatParser = function flatParser(rule) {
  var _a;
  if (!FLAT_REGEX.test(rule)) return null;
  var flat = (((_a = FLAT_REGEX.exec(rule)) === null || _a === void 0 ? void 0 : _a.groups) || {}).flat;
  if (!flat) return null;
  return parseFloat(flat);
};
var flatValuesParser = function flatValuesParser(rule) {
  var flatParserResult = flatParser(rule);
  if (!flatParserResult) return null;
  var label = formatMoney$1(flatParserResult);
  return {
    label: label,
    type: AuctionExpressionRule.Flat,
    shortenedLabel: shortenMoneyLabel("".concat(flatParserResult))
  };
};
var percentageParser = function percentageParser(rule, amount) {
  var _a;
  if (!PERCENTAGE_REGEX.test(rule)) return null;
  var percentage = (((_a = PERCENTAGE_REGEX.exec(rule)) === null || _a === void 0 ? void 0 : _a.groups) || {}).percentage;
  if (!percentage) return null;
  return calculatePercentageAmount(amount, percentage);
};
var percentageValuesParser = function percentageValuesParser(rule) {
  var _a;
  if (!PERCENTAGE_REGEX.test(rule)) return null;
  var percentage = (((_a = PERCENTAGE_REGEX.exec(rule)) === null || _a === void 0 ? void 0 : _a.groups) || {}).percentage;
  if (!percentage) return null;
  return {
    label: rule,
    shortenedLabel: "".concat(parseInt(percentage), "%"),
    type: AuctionExpressionRule.Percentage
  };
};
var percentageOrMinimumParser = function percentageOrMinimumParser(rule, amount) {
  var _a;
  if (!PERCENTAGE_OR_MINIMUM_REGEX.test(rule)) return null;
  var _b = ((_a = PERCENTAGE_OR_MINIMUM_REGEX.exec(rule)) === null || _a === void 0 ? void 0 : _a.groups) || {},
    percentage = _b.percentage,
    minimumAmount = _b.minimumAmount;
  if (!percentage || !minimumAmount) return null;
  var calculatedAmount = calculatePercentageAmount(amount, percentage);
  var parsedMinimumAmount = parseFloat(minimumAmount);
  return calculatedAmount < parsedMinimumAmount ? parsedMinimumAmount : calculatedAmount;
};
var percentageOrMinimumValuesParser = function percentageOrMinimumValuesParser(rule) {
  var _a;
  if (!PERCENTAGE_OR_MINIMUM_REGEX.test(rule)) return null;
  var _b = ((_a = PERCENTAGE_OR_MINIMUM_REGEX.exec(rule)) === null || _a === void 0 ? void 0 : _a.groups) || {},
    percentage = _b.percentage,
    minimumAmount = _b.minimumAmount;
  if (!percentage || !minimumAmount) return null;
  return {
    label: "".concat(percentage, "% or $").concat(minimumAmount, " (whichever is greater)"),
    shortenedLabel: "".concat(parseInt(percentage), "% or ").concat(shortenMoneyLabel(minimumAmount)),
    type: AuctionExpressionRule.PercentageOrMinimum
  };
};
var percentageOrMaximumParser = function percentageOrMaximumParser(rule, amount) {
  var _a;
  if (!PERCENTAGE_OR_MAXIMUM_REGEX.test(rule)) return null;
  var _b = ((_a = PERCENTAGE_OR_MAXIMUM_REGEX.exec(rule)) === null || _a === void 0 ? void 0 : _a.groups) || {},
    percentage = _b.percentage,
    maximumAmount = _b.maximumAmount;
  if (!percentage || !maximumAmount) return null;
  var calculatedAmount = calculatePercentageAmount(amount, percentage);
  var parsedMaximumAmount = parseFloat(maximumAmount);
  return calculatedAmount > parsedMaximumAmount ? parsedMaximumAmount : calculatedAmount;
};
var percentageOrMaximumValuesParser = function percentageOrMaximumValuesParser(rule) {
  var _a;
  if (!PERCENTAGE_OR_MAXIMUM_REGEX.test(rule)) return null;
  var _b = ((_a = PERCENTAGE_OR_MAXIMUM_REGEX.exec(rule)) === null || _a === void 0 ? void 0 : _a.groups) || {},
    percentage = _b.percentage,
    maximumAmount = _b.maximumAmount;
  if (!percentage || !maximumAmount) return null;
  return {
    label: "".concat(percentage, "% or $").concat(maximumAmount, " (whichever is less)"),
    shortenedLabel: "".concat(parseInt(percentage), "% or ").concat(shortenMoneyLabel(maximumAmount), " maximum"),
    type: AuctionExpressionRule.PercentageOrMaximum
  };
};
var percentageOrMinimumAndMaximumParser = function percentageOrMinimumAndMaximumParser(rule, amount) {
  var _a;
  if (!PERCENTAGE_OR_MINIMUM_AND_MAXIMUM_REGEX.test(rule)) return null;
  var _b = ((_a = PERCENTAGE_OR_MINIMUM_AND_MAXIMUM_REGEX.exec(rule)) === null || _a === void 0 ? void 0 : _a.groups) || {},
    percentage = _b.percentage,
    minimumAmount = _b.minimumAmount,
    maximumAmount = _b.maximumAmount;
  if (!percentage || !minimumAmount || !maximumAmount) return null;
  var calculatedAmount = calculatePercentageAmount(amount, percentage);
  var parsedMinimumAmount = parseFloat(minimumAmount);
  var parsedMaximumAmount = parseFloat(maximumAmount);
  if (calculatedAmount < parsedMinimumAmount) return parsedMinimumAmount;
  if (calculatedAmount > parsedMaximumAmount) return parsedMaximumAmount;
  return calculatedAmount;
};
var percentageOrMinimumAndMaximumValuesParser = function percentageOrMinimumAndMaximumValuesParser(rule) {
  var _a;
  if (!PERCENTAGE_OR_MINIMUM_AND_MAXIMUM_REGEX.test(rule)) return null;
  var _b = ((_a = PERCENTAGE_OR_MINIMUM_AND_MAXIMUM_REGEX.exec(rule)) === null || _a === void 0 ? void 0 : _a.groups) || {},
    percentage = _b.percentage,
    minimumAmount = _b.minimumAmount,
    maximumAmount = _b.maximumAmount;
  if (!percentage || !minimumAmount || !maximumAmount) return null;
  return {
    label: "".concat(percentage, "% or between $").concat(minimumAmount, " and $").concat(maximumAmount),
    shortenedLabel: "".concat(parseInt(percentage), "% or between ").concat(shortenMoneyLabel(minimumAmount), " and ").concat(shortenMoneyLabel(maximumAmount)),
    type: AuctionExpressionRule.PercentageOrMinimumAndMaximum
  };
};
var AuctionExpressionsMap = new Map();
var AuctionExpression = function () {
  function AuctionExpression(expression) {
    this.expression = expression === null || expression === void 0 ? void 0 : expression.trim();
  }
  AuctionExpression.parse = function (expression) {
    if (AuctionExpressionsMap.has(expression)) {
      return AuctionExpressionsMap.get(expression);
    }
    var newAuctionExpression = new AuctionExpression(expression);
    AuctionExpressionsMap.set(expression, newAuctionExpression);
    return newAuctionExpression;
  };
  AuctionExpression.prototype.evaluate = function (amount) {
    var _this = this;
    if (!this.expression) return null;
    return AuctionExpression.PARSER_PRECEDENCE.map(function (parser) {
      return parser(_this.expression, amount);
    }).find(Boolean);
  };
  AuctionExpression.prototype.getValues = function () {
    var _this = this;
    if (!this.expression) return null;
    return AuctionExpression.VALUES_PARSER_PRECEDENCE.map(function (parser) {
      return parser(_this.expression);
    }).find(Boolean);
  };
  AuctionExpression.PARSER_PRECEDENCE = [flatParser, percentageParser, percentageOrMinimumParser, percentageOrMaximumParser, percentageOrMinimumAndMaximumParser];
  AuctionExpression.VALUES_PARSER_PRECEDENCE = [flatValuesParser, percentageValuesParser, percentageOrMinimumValuesParser, percentageOrMaximumValuesParser, percentageOrMinimumAndMaximumValuesParser];
  return AuctionExpression;
}();

var globalPhysicalStructures = [{
  value: '4PLEX_BUILDING',
  text: '4 Plex Building',
  adcSearchMapping: 'Single-family'
}, {
  value: '4PLEX_UNIT',
  text: '4 Plex Unit',
  adcSearchMapping: 'Single-family'
}, {
  value: '3PLEX_UNIT',
  text: '3Plex Unit',
  adcSearchMapping: 'Condos & Townhouses'
}, {
  value: 'FOUR_PLEX_BUILDING',
  text: '4 Plex Building',
  adcSearchMapping: 'Single-family'
}, {
  value: 'FOUR_PLEX_UNIT',
  text: '4 Plex Unit',
  adcSearchMapping: 'Condos & Townhouses'
}, {
  value: 'COMMERCIAL',
  text: 'Commercial',
  adcSearchMapping: 'Single-family'
}, {
  value: 'THREE_PLEX_BUILDING',
  text: '3 Plex building',
  adcSearchMapping: 'Single-family'
}, {
  value: 'APARTMENT_BUILDING',
  text: 'Apartment Building',
  adcSearchMapping: 'Condos & Townhouses'
}, {
  value: 'APARTMENT_COMPLEX',
  text: 'Apartment Complex',
  adcSearchMapping: 'Condos & Townhouses'
}, {
  value: 'APARTMENT_UNIT',
  text: 'Apartment Unit',
  adcSearchMapping: 'Condos & Townhouses'
}, {
  value: 'ATTACHED_GARAGE',
  text: 'Attached Garage',
  adcSearchMapping: 'Single-family'
}, {
  value: 'CONDOMINIUM_BUILDING',
  text: 'Condominium Building',
  adcSearchMapping: 'Condos & Townhouses'
}, {
  value: 'CONDOMINIUM_UNIT',
  text: 'Condominium Unit',
  adcSearchMapping: 'Single-family'
}, {
  value: 'COOP_BUILDING',
  text: 'Co-op Building',
  adcSearchMapping: 'Condos & Townhouses'
}, {
  value: 'COOP_UNIT',
  text: 'Co-op Unit',
  adcSearchMapping: 'Single-family'
}, {
  value: 'DETACHED_GARAGE',
  text: 'Detached Garage',
  adcSearchMapping: 'Condos & Townhouses'
}, {
  value: 'DUPLEX_BUILDING',
  text: 'Duplex Building',
  adcSearchMapping: 'Condos & Townhouses'
}, {
  value: 'DUPLEX_UNIT',
  text: 'Duplex Unit',
  adcSearchMapping: 'Single-family'
}, {
  value: 'FLOOR',
  text: 'Floor',
  adcSearchMapping: 'Condos & Townhouses'
}, {
  value: 'HI_RISE_CONDO_UNIT',
  text: 'High-Rise Condo Unit',
  adcSearchMapping: 'Single-family'
}, {
  value: 'LAND',
  text: 'Land',
  adcSearchMapping: 'Land'
}, {
  value: 'LOFT',
  text: 'Loft',
  adcSearchMapping: 'Condos & Townhouses'
}, {
  value: 'MANUFACTURED_HOME',
  text: 'Manufactured Home',
  adcSearchMapping: 'Single-family'
}, {
  value: 'MOBILE_HOME',
  text: 'Mobile Home',
  adcSearchMapping: 'Single-family'
}, {
  value: 'MODULAR_HOME',
  text: 'Modular Home',
  adcSearchMapping: 'Single-family'
}, {
  value: 'MULTI_UNIT_BUILDING',
  text: 'Multi Unit Building',
  adcSearchMapping: 'Single-family'
}, {
  value: 'OTHER',
  text: 'Other',
  adcSearchMapping: 'Condos & Townhouses'
}, {
  value: 'PUD_HOME',
  text: 'PUD Home',
  adcSearchMapping: 'Single-family'
}, {
  value: 'SINGLE_FAMILY_ATTACHED',
  text: 'Single Family Attached',
  adcSearchMapping: 'Single-family'
}, {
  value: 'SINGLE_FAMILY_DETACHED',
  text: 'Single Family Detached',
  adcSearchMapping: 'Single-family'
}, {
  value: 'SINGLE_FAMILY_HOME',
  text: 'Single Family Home',
  adcSearchMapping: 'Single-family'
}, {
  value: 'STUDIO',
  text: 'Studio',
  adcSearchMapping: 'Single-family'
}, {
  value: 'TOWNHOUSE',
  text: 'Townhouse',
  adcSearchMapping: 'Single-family'
}, {
  value: 'THREE_PLEX_UNIT',
  text: 'Triplex',
  adcSearchMapping: 'Condos & Townhouses'
}, {
  value: 'TWIN_HOME',
  text: 'Twin Home',
  adcSearchMapping: 'Single-family'
}, {
  value: 'ROW_HOUSE',
  text: 'Row House',
  adcSearchMapping: 'Single-family'
}];

var constants$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  globalPhysicalStructures: globalPhysicalStructures
});

var AUTHENTICATED_USER_LIVE_AUCTION_SEGMENT_FIELDS = "\n  fragment AuthenticatedUserLiveAuctionSegmentFragment on LiveAuctionSegment {\n     current_highest_bid {\n       belongs_to_current_user\n     }\n     current_user_highest_bid {\n       bid_amount\n     }\n     current_user_remote_bid {\n       remote_bid_amount\n       purchase_profile_id\n     }\n     current_user_bidding_status\n     bidding_status\n     bidder_count\n     bid_count\n   }\n";
var getLatestLiveAuctionSegments = function getLatestLiveAuctionSegments(controller, hasAuthenticatedUser, listingIds) {
  if (!listingIds) {
    return Promise.resolve();
  }
  return fetch.forAuctionGraph({
    variables: {
      listingIds: listingIds,
      hasAuthenticatedUser: hasAuthenticatedUser
    },
    query: gql(templateObject_1$h || (templateObject_1$h = __makeTemplateObject(["\n          query ", "($listingIds: [ID!]!, $hasAuthenticatedUser: Boolean!) {\n            live_auction_segments_batched(\n              filters: { listing_ids: $listingIds }\n            ) {\n              listing_id\n              update_date\n              auction_segment_id\n              current_highest_bid {\n                bid_amount\n                bid_id\n                bid_type\n                listing_id\n                updated_date\n              }\n              end_status\n              configuration {\n                bid_increment_amount\n                state_deposit_rule\n              }\n              pending_update_status\n              segment_status\n              starting_bid_amount\n              bid_extend {\n                bid_extend_date_time\n              }\n              ...AuthenticatedUserLiveAuctionSegmentFragment @include(if: $hasAuthenticatedUser)\n            }\n          }\n          ", "\n        "], ["\n          query ", "($listingIds: [ID!]!, $hasAuthenticatedUser: Boolean!) {\n            live_auction_segments_batched(\n              filters: { listing_ids: $listingIds }\n            ) {\n              listing_id\n              update_date\n              auction_segment_id\n              current_highest_bid {\n                bid_amount\n                bid_id\n                bid_type\n                listing_id\n                updated_date\n              }\n              end_status\n              configuration {\n                bid_increment_amount\n                state_deposit_rule\n              }\n              pending_update_status\n              segment_status\n              starting_bid_amount\n              bid_extend {\n                bid_extend_date_time\n              }\n              ...AuthenticatedUserLiveAuctionSegmentFragment @include(if: $hasAuthenticatedUser)\n            }\n          }\n          ", "\n        "])), embeddableOperation('blueprint_getTransactionalLiveSegments'), AUTHENTICATED_USER_LIVE_AUCTION_SEGMENT_FIELDS)
  }, {
    controller: controller
  }).then(function (res) {
    return res.body;
  }).then(function (_a) {
    var data = _a.data,
      errors = _a.errors;
    if (data === null || data.live_auction_segments_batched === null) {
      throw partialGraphErrorFactory$1('Could not fetch latest live segments', errors);
    }
    return data.live_auction_segments_batched;
  });
};
var getLatestLiveFocusedListingsSegments = function getLatestLiveFocusedListingsSegments(controller, listingIds) {
  if (!listingIds) {
    return Promise.resolve();
  }
  return fetch.forAuctionGraph({
    variables: {
      listingIds: listingIds
    },
    query: gql(templateObject_2$d || (templateObject_2$d = __makeTemplateObject(["\n          query ", "($listingIds: [ID!]!) {\n            live_auction_segments_batched(\n              filters: { listing_ids: $listingIds }\n            ) {\n              listing_id\n              update_date\n              auction_segment_id\n              bids {\n                bid_id\n                bid_amount\n                bid_type\n                bidder_number\n                belongs_to_current_user\n                listing_id\n                updated_date\n              }\n            }\n          }\n        "], ["\n          query ", "($listingIds: [ID!]!) {\n            live_auction_segments_batched(\n              filters: { listing_ids: $listingIds }\n            ) {\n              listing_id\n              update_date\n              auction_segment_id\n              bids {\n                bid_id\n                bid_amount\n                bid_type\n                bidder_number\n                belongs_to_current_user\n                listing_id\n                updated_date\n              }\n            }\n          }\n        "])), embeddableOperation('blueprint_getTransactionalFocusedListings'))
  }, {
    controller: controller
  }).then(function (res) {
    return res.body;
  }).then(function (_a) {
    var data = _a.data,
      errors = _a.errors;
    if (data === null || data.live_auction_segments_batched === null) {
      throw partialGraphErrorFactory$1('Could not fetch latest live segments for focused listings', errors);
    }
    return data.live_auction_segments_batched;
  });
};
var getLatestLiveListings = function getLatestLiveListings(listingIds, controller) {
  return fetch.forAuctionGraph({
    query: gql(templateObject_3$7 || (templateObject_3$7 = __makeTemplateObject(["\n            query ", "($listingIds: [ID!]!) {\n              listings_batched(filters: { listing_ids: $listingIds }) {\n                update_date\n                listing_id\n                listing_status\n                auction {\n                  starting_bid\n                }\n                reserve_price\n              }\n            }\n          "], ["\n            query ", "($listingIds: [ID!]!) {\n              listings_batched(filters: { listing_ids: $listingIds }) {\n                update_date\n                listing_id\n                listing_status\n                auction {\n                  starting_bid\n                }\n                reserve_price\n              }\n            }\n          "])), embeddableOperation('blueprint_getLiveListings')),
    variables: {
      listingIds: listingIds
    }
  }, {
    controller: controller
  }).then(function (res) {
    return res.body;
  }).then(function (_a) {
    var data = _a.data,
      errors = _a.errors;
    if (data === null || data.listings_batched === null) {
      throw partialGraphErrorFactory$1('Could not fetch latest live listings', errors);
    }
    return data.listings_batched;
  });
};
var submitLiveRemoteBid = function submitLiveRemoteBid(segment, input) {
  return fetch.forAuctionGraph({
    query: gql(templateObject_4$6 || (templateObject_4$6 = __makeTemplateObject(["\n        mutation ", "($input: SubmitRemoteBidInput!) {\n          submitRemoteBid(input: $input) {\n            party_id\n          }\n        }\n      "], ["\n        mutation ", "($input: SubmitRemoteBidInput!) {\n          submitRemoteBid(input: $input) {\n            party_id\n          }\n        }\n      "])), embeddableOperation('blueprint_submitRemoteBid')),
    variables: {
      input: {
        listing_id: segment.listing_id,
        purchase_profile_id: input.purchase_profile_id,
        bid_amount: input.bid_amount
      }
    }
  }).then(function (res) {
    return res.body;
  }).then(function (_a) {
    var data = _a.data,
      errors = _a.errors;
    if (data === null || data.submitRemoteBid === null) {
      throw partialGraphErrorFactory$1('Unable to submit remote bid', errors);
    }
    return data.submitRemoteBid;
  });
};
var updateLiveRemoteBid = function updateLiveRemoteBid(segment, input) {
  return fetch.forAuctionGraph({
    query: "\n        mutation ".concat(embeddableOperation('blueprint_updateRemoteBid'), "($input: UpdateRemoteBidInput!) {\n          updateRemoteBid(input: $input) {\n            party_id\n          }\n        }\n      "),
    variables: {
      input: {
        listing_id: segment.listing_id,
        bid_amount: input.bid_amount
      }
    }
  }).then(function (res) {
    return res.body;
  }).then(function (_a) {
    var data = _a.data,
      errors = _a.errors;
    if (data === null || data.updateRemoteBid === null) {
      throw partialGraphErrorFactory$1('Unable to update remote bid', errors);
    }
    return data.updateRemoteBid;
  });
};
var templateObject_1$h, templateObject_2$d, templateObject_3$7, templateObject_4$6;

var formatEnum$1 = function formatEnum(enumVal) {
  return (enumVal || '').split('_').map(___default.capitalize).join(' ');
};
var DEFAULT_DATE_FORMAT = 'YYYY-MM-DD';
var formatDate$1 = function formatDate(date, format) {
  return moment(date).format(format || DEFAULT_DATE_FORMAT);
};
var phoneNumberMask = ['(', /[2-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
var formatPhoneNumber = function formatPhoneNumber(value) {
  var digits = (value + '').replace(/[^\d]/g, '');
  return digits.length === 10 && digits === '' + parseInt(digits, 10) ? conformToMask(digits, phoneNumberMask).conformedValue : value;
};

var formatters = /*#__PURE__*/Object.freeze({
  __proto__: null,
  DEFAULT_DATE_FORMAT: DEFAULT_DATE_FORMAT,
  formatDate: formatDate$1,
  formatEnum: formatEnum$1,
  formatPhoneNumber: formatPhoneNumber
});

var AUTHENTICATED_USER_ONLINE_AUCTION_SEGMENT_FIELDS = gql(templateObject_1$g || (templateObject_1$g = __makeTemplateObject(["\n  fragment AuthenticatedUserOnlineAuctionSegmentFragment on OnlineAuctionSegment {\n    current_reserve_amount @include(if: $isSellerAudience)\n    match_bid_count\n    bid_count\n    buyer_bid_count\n    current_user_highest_bid {\n      record_status\n      listing_id\n      bid_amount\n      bid_id\n      bidder_party_id\n      type\n      version\n      updated_date\n      rank\n      ...OnlineAuctionSegmentBidTermsFragment\n      negotiation_sequence {\n        latest_counter_bid {\n          listing_id\n          bid_amount\n          bid_id\n          bidder_party_id\n          type\n          version\n          updated_date\n          ...OnlineAuctionSegmentBidTermsFragment\n        }\n      }\n    }\n    current_user_max_bid {\n      max_bid_amount\n      record_status\n    }\n    current_user_bidding_status\n  }\n"], ["\n  fragment AuthenticatedUserOnlineAuctionSegmentFragment on OnlineAuctionSegment {\n    current_reserve_amount @include(if: $isSellerAudience)\n    match_bid_count\n    bid_count\n    buyer_bid_count\n    current_user_highest_bid {\n      record_status\n      listing_id\n      bid_amount\n      bid_id\n      bidder_party_id\n      type\n      version\n      updated_date\n      rank\n      ...OnlineAuctionSegmentBidTermsFragment\n      negotiation_sequence {\n        latest_counter_bid {\n          listing_id\n          bid_amount\n          bid_id\n          bidder_party_id\n          type\n          version\n          updated_date\n          ...OnlineAuctionSegmentBidTermsFragment\n        }\n      }\n    }\n    current_user_max_bid {\n      max_bid_amount\n      record_status\n    }\n    current_user_bidding_status\n  }\n"])));
var SELLER_EXCLUSIVE_ONLINE_AUCTION_SEGMENT_FIELDS = gql(templateObject_2$c || (templateObject_2$c = __makeTemplateObject(["\n  fragment SellerExclusiveOnlineAuctionSegmentFragment on OnlineAuctionSegment {\n    current_highest_buyer_bid {\n      bid_amount\n    }\n    current_reserve_amount @include(if: $hasAuthenticatedUser)\n    seller_counter_bid_count\n    configuration @include(if: $hasAuthenticatedUser) {\n      review_date\n      review_date_updatable_by_date\n      is_highest_and_best_round_allowed\n    }\n    result {\n      winning_bid_amount @include(if: $hasAuthenticatedUser)\n      winning_bidder_user @include(if: $hasAuthenticatedUser) {\n        first_name\n        last_name\n        email\n        party {\n          phones {\n            phone_id\n            number\n          }\n        }\n      }\n    }\n  }\n"], ["\n  fragment SellerExclusiveOnlineAuctionSegmentFragment on OnlineAuctionSegment {\n    current_highest_buyer_bid {\n      bid_amount\n    }\n    current_reserve_amount @include(if: $hasAuthenticatedUser)\n    seller_counter_bid_count\n    configuration @include(if: $hasAuthenticatedUser) {\n      review_date\n      review_date_updatable_by_date\n      is_highest_and_best_round_allowed\n    }\n    result {\n      winning_bid_amount @include(if: $hasAuthenticatedUser)\n      winning_bidder_user @include(if: $hasAuthenticatedUser) {\n        first_name\n        last_name\n        email\n        party {\n          phones {\n            phone_id\n            number\n          }\n        }\n      }\n    }\n  }\n"])));
var ONLINE_AUCTION_SEGMENT_BID_TERMS = gql(templateObject_3$6 || (templateObject_3$6 = __makeTemplateObject(["\n  fragment OnlineAuctionSegmentBidTermsFragment on OnlineAuctionSegmentBid {\n    terms {\n      seller_net_offer_amount\n      buyer_net_offer_amount\n      market_place_fee_amount\n      market_place_fee_percentage\n      status\n      offer_amount\n      offeror_type\n      buyers_premium_amount\n      seller_concession_amount\n      earnest_money_deposit_amount\n      down_payment_amount\n      payment_type\n      close_escrow_duration\n      leaseback_amount\n      leaseback_duration\n      option_period_duration\n      option_period_cost_amount\n      inspection_contingency_period_duration\n      is_agent_included\n      financing_contingency_duration\n      appraisal_contingency_duration\n      seller_concession_amount\n      notes {\n        additional_notes\n        latest_update_reason\n      }\n      expiration_date\n      commission {\n        paid_by\n        agent_commission_amount\n      }\n      documents {\n        document_id\n        document_purpose_type\n        urn\n        document {\n          file_descriptor {\n            content_type\n          }\n        }\n      }\n    }\n  }\n"], ["\n  fragment OnlineAuctionSegmentBidTermsFragment on OnlineAuctionSegmentBid {\n    terms {\n      seller_net_offer_amount\n      buyer_net_offer_amount\n      market_place_fee_amount\n      market_place_fee_percentage\n      status\n      offer_amount\n      offeror_type\n      buyers_premium_amount\n      seller_concession_amount\n      earnest_money_deposit_amount\n      down_payment_amount\n      payment_type\n      close_escrow_duration\n      leaseback_amount\n      leaseback_duration\n      option_period_duration\n      option_period_cost_amount\n      inspection_contingency_period_duration\n      is_agent_included\n      financing_contingency_duration\n      appraisal_contingency_duration\n      seller_concession_amount\n      notes {\n        additional_notes\n        latest_update_reason\n      }\n      expiration_date\n      commission {\n        paid_by\n        agent_commission_amount\n      }\n      documents {\n        document_id\n        document_purpose_type\n        urn\n        document {\n          file_descriptor {\n            content_type\n          }\n        }\n      }\n    }\n  }\n"])));
var ONLINE_AUCTION_SEGMENT_BIDS_RANKING = gql(templateObject_4$5 || (templateObject_4$5 = __makeTemplateObject(["\n  fragment OnlineAuctionSegmentBidsRankingFragment on OnlineAuctionSegment {\n    bids_ranking @include(if: $hasAuthenticatedUser) {\n      listing_id\n      online_segment_id\n      ranking {\n        belongs_to_current_user @include(if: $hasAuthenticatedUser)\n        is_viewable_by_current_user @include(if: $hasAuthenticatedUser)\n        overtake_delta @include(if: $hasAuthenticatedUser)\n        net_offer_equal_delta @include(if: $hasAuthenticatedUser)\n        bid_id\n        party_id\n        rank\n        seller_assigned_score\n        system_calculated_score\n        max_tied_rank\n        bid {\n          listing_id\n          bid_amount\n          bid_id\n          bidder_party_id\n          type\n          version\n          updated_date\n          created_date\n          audit_history {\n            updated_date\n            delta {\n              added\n              modified\n              removed\n            }\n          }\n          ...OnlineAuctionSegmentBidTermsFragment\n          negotiation_sequence {\n            counters {\n              listing_id\n              bid_amount\n              bid_id\n              bidder_party_id\n              type\n              version\n              updated_date\n              created_date\n              ...OnlineAuctionSegmentBidTermsFragment\n            }\n            latest_counter_bid {\n              listing_id\n              bid_amount\n              bid_id\n              bidder_party_id\n              type\n              version\n              updated_date\n              ...OnlineAuctionSegmentBidTermsFragment\n            }\n          }\n        }\n        party {\n          person {\n            first_name\n            last_name\n          }\n        }\n      }\n    }\n  }\n"], ["\n  fragment OnlineAuctionSegmentBidsRankingFragment on OnlineAuctionSegment {\n    bids_ranking @include(if: $hasAuthenticatedUser) {\n      listing_id\n      online_segment_id\n      ranking {\n        belongs_to_current_user @include(if: $hasAuthenticatedUser)\n        is_viewable_by_current_user @include(if: $hasAuthenticatedUser)\n        overtake_delta @include(if: $hasAuthenticatedUser)\n        net_offer_equal_delta @include(if: $hasAuthenticatedUser)\n        bid_id\n        party_id\n        rank\n        seller_assigned_score\n        system_calculated_score\n        max_tied_rank\n        bid {\n          listing_id\n          bid_amount\n          bid_id\n          bidder_party_id\n          type\n          version\n          updated_date\n          created_date\n          audit_history {\n            updated_date\n            delta {\n              added\n              modified\n              removed\n            }\n          }\n          ...OnlineAuctionSegmentBidTermsFragment\n          negotiation_sequence {\n            counters {\n              listing_id\n              bid_amount\n              bid_id\n              bidder_party_id\n              type\n              version\n              updated_date\n              created_date\n              ...OnlineAuctionSegmentBidTermsFragment\n            }\n            latest_counter_bid {\n              listing_id\n              bid_amount\n              bid_id\n              bidder_party_id\n              type\n              version\n              updated_date\n              ...OnlineAuctionSegmentBidTermsFragment\n            }\n          }\n        }\n        party {\n          person {\n            first_name\n            last_name\n          }\n        }\n      }\n    }\n  }\n"])));
var getCurrentServerTime = function getCurrentServerTime() {
  return fetch.forAuctionGraph({
    query: "\n        query ".concat(embeddableOperation('blueprint_getCurrentTime'), " {\n          current_online_auction_time\n        }\n      ")
  }).then(function (res) {
    return res.body;
  }).then(function (_a) {
    var data = _a.data;
    if (data === null) {
      coreLogger.forModule('blueprint:time').warn('Failed to get Current Server Time');
    }
    return data === null || data === void 0 ? void 0 : data.current_online_auction_time;
  });
};
var getLatestOnlineSegments = function getLatestOnlineSegments(controller, hasAuthenticatedUser, listingIds, isSellerAudience) {
  if (hasAuthenticatedUser === void 0) {
    hasAuthenticatedUser = false;
  }
  if (isSellerAudience === void 0) {
    isSellerAudience = false;
  }
  return fetch.forAuctionGraph({
    variables: {
      listingIds: listingIds,
      hasAuthenticatedUser: hasAuthenticatedUser,
      isSellerAudience: isSellerAudience
    },
    query: gql(templateObject_5$2 || (templateObject_5$2 = __makeTemplateObject(["\n                query ", "($listingIds: [ID!]!, $hasAuthenticatedUser: Boolean!, $isSellerAudience: Boolean!) {\n                  online_segments_batched(filters: { listing_ids: $listingIds }) {\n                    __typename\n                    update_date\n                    listing_id\n                    online_segment_id\n                    start_date\n                    initial_end_date\n                    current_increment_amount\n                    segment_type\n                    segment_status\n                    reserve_status\n                    current_time\n                    starting_bid_amount\n                    match_bidding_period_end_date\n                    is_match_bidding_ended\n                    current_highest_bid {\n                      bid_amount\n                      belongs_to_current_user @include(if: $hasAuthenticatedUser)\n                      type\n                    }\n                    current_bid_extension {\n                      extension_type\n                      reason\n                    }\n                    subject_to_status\n                    configuration {\n                      bids_away_status\n                      is_one_away_enabled\n                      is_one_away_displayed\n                      is_initial_end_date_extended\n                      is_match_bidding_enabled\n                      is_max_bidding_enabled\n                      should_bid_again\n                      review_date\n                    }\n                    result {\n                      winning_bid_amount\n                    }\n                    ...AuthenticatedUserOnlineAuctionSegmentFragment @include(if: $hasAuthenticatedUser)\n                    ...SellerExclusiveOnlineAuctionSegmentFragment @include(if: $isSellerAudience)\n                  }\n                }\n                ", "\n                ", "\n                ", "\n            "], ["\n                query ", "($listingIds: [ID!]!, $hasAuthenticatedUser: Boolean!, $isSellerAudience: Boolean!) {\n                  online_segments_batched(filters: { listing_ids: $listingIds }) {\n                    __typename\n                    update_date\n                    listing_id\n                    online_segment_id\n                    start_date\n                    initial_end_date\n                    current_increment_amount\n                    segment_type\n                    segment_status\n                    reserve_status\n                    current_time\n                    starting_bid_amount\n                    match_bidding_period_end_date\n                    is_match_bidding_ended\n                    current_highest_bid {\n                      bid_amount\n                      belongs_to_current_user @include(if: $hasAuthenticatedUser)\n                      type\n                    }\n                    current_bid_extension {\n                      extension_type\n                      reason\n                    }\n                    subject_to_status\n                    configuration {\n                      bids_away_status\n                      is_one_away_enabled\n                      is_one_away_displayed\n                      is_initial_end_date_extended\n                      is_match_bidding_enabled\n                      is_max_bidding_enabled\n                      should_bid_again\n                      review_date\n                    }\n                    result {\n                      winning_bid_amount\n                    }\n                    ...AuthenticatedUserOnlineAuctionSegmentFragment @include(if: $hasAuthenticatedUser)\n                    ...SellerExclusiveOnlineAuctionSegmentFragment @include(if: $isSellerAudience)\n                  }\n                }\n                ", "\n                ", "\n                ", "\n            "])), embeddableOperation('blueprint_getTransactionalOnlineSegments'), ONLINE_AUCTION_SEGMENT_BID_TERMS, AUTHENTICATED_USER_ONLINE_AUCTION_SEGMENT_FIELDS, SELLER_EXCLUSIVE_ONLINE_AUCTION_SEGMENT_FIELDS)
  }, {
    controller: controller
  }).then(function (res) {
    return res.body;
  }).then(function (_a) {
    var data = _a.data,
      errors = _a.errors;
    if (data === null || data.online_segments_batched === null) {
      throw partialGraphErrorFactory$1('Could not fetch latest online segments', errors);
    }
    return data.online_segments_batched;
  });
};
var getLatestOnlineFocusedListingsSegments = function getLatestOnlineFocusedListingsSegments(controller, hasAuthenticatedUser, listingIds, isSellerAudience) {
  if (hasAuthenticatedUser === void 0) {
    hasAuthenticatedUser = false;
  }
  if (isSellerAudience === void 0) {
    isSellerAudience = false;
  }
  return fetch.forAuctionGraph({
    variables: {
      listingIds: listingIds,
      isSellerAudience: isSellerAudience,
      hasAuthenticatedUser: hasAuthenticatedUser
    },
    query: gql(templateObject_6$1 || (templateObject_6$1 = __makeTemplateObject(["\n                query ", "($listingIds: [ID!]!, $isSellerAudience :Boolean!, $hasAuthenticatedUser: Boolean!) {\n                  online_segments_batched(filters: { listing_ids: $listingIds }) {\n                    __typename\n                    segment_type\n                    segment_status\n                    listing_id\n                    update_date\n                    current_user_bidding_status @include(if: $hasAuthenticatedUser)\n                    configuration {\n                      review_date\n                    }\n                    ...OnlineAuctionSegmentBidsRankingFragment @include(if: $hasAuthenticatedUser)\n                    ...SellerExclusiveOnlineAuctionSegmentFragment @include(if: $isSellerAudience)\n                  }\n                }\n                ", "\n                ", "\n                ", "\n\n            "], ["\n                query ", "($listingIds: [ID!]!, $isSellerAudience :Boolean!, $hasAuthenticatedUser: Boolean!) {\n                  online_segments_batched(filters: { listing_ids: $listingIds }) {\n                    __typename\n                    segment_type\n                    segment_status\n                    listing_id\n                    update_date\n                    current_user_bidding_status @include(if: $hasAuthenticatedUser)\n                    configuration {\n                      review_date\n                    }\n                    ...OnlineAuctionSegmentBidsRankingFragment @include(if: $hasAuthenticatedUser)\n                    ...SellerExclusiveOnlineAuctionSegmentFragment @include(if: $isSellerAudience)\n                  }\n                }\n                ", "\n                ", "\n                ", "\n\n            "])), embeddableOperation('blueprint_getTransactionalOnlineSegmentsFocused'), ONLINE_AUCTION_SEGMENT_BID_TERMS, ONLINE_AUCTION_SEGMENT_BIDS_RANKING, SELLER_EXCLUSIVE_ONLINE_AUCTION_SEGMENT_FIELDS)
  }, {
    controller: controller
  }).then(function (res) {
    return res.body;
  }).then(function (_a) {
    var data = _a.data,
      errors = _a.errors;
    if (data === null || data.online_segments_batched === null) {
      throw partialGraphErrorFactory$1('Could not fetch latest focused online segments', errors);
    }
    return data.online_segments_batched;
  });
};
var getLatestOnlineListings = function getLatestOnlineListings(listingIds, controller, hasAuthenticatedUser) {
  if (hasAuthenticatedUser === void 0) {
    hasAuthenticatedUser = false;
  }
  return fetch.forAuctionGraph({
    query: gql(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n                    query ", "($listingIds: [ID!]!, $hasAuthenticatedUser: Boolean!) {\n                        listings_batched(filters: { listing_ids: $listingIds }) {\n                            updated_date\n                            is_current_user_registered_for_online_auction @include(if: $hasAuthenticatedUser)\n                            listing_id\n                            listing_status\n                            auction {\n                                starting_bid\n                            }\n                        }\n                    }\n                "], ["\n                    query ", "($listingIds: [ID!]!, $hasAuthenticatedUser: Boolean!) {\n                        listings_batched(filters: { listing_ids: $listingIds }) {\n                            updated_date\n                            is_current_user_registered_for_online_auction @include(if: $hasAuthenticatedUser)\n                            listing_id\n                            listing_status\n                            auction {\n                                starting_bid\n                            }\n                        }\n                    }\n                "])), embeddableOperation('blueprint_getOnlineListings')),
    variables: {
      listingIds: listingIds,
      hasAuthenticatedUser: hasAuthenticatedUser
    }
  }, {
    controller: controller
  }).then(function (res) {
    return res.body;
  }).then(function (_a) {
    var data = _a.data,
      errors = _a.errors;
    if (data === null || data.listings_batched === null) {
      throw partialGraphErrorFactory$1('Could not fetch latest online listings', errors);
    }
    return data.listings_batched;
  });
};
var submitOnlineMatchBid = function submitOnlineMatchBid(segment, input) {
  return fetch.forAuctionGraph({
    query: "\n        mutation blueprint_placeOnlineAuctionSegmentMatchBid(\n          $listingId: ID!,\n          $offerTemplateId: ID!\n        ) {\n          placeOnlineAuctionSegmentMatchBid(\n            listingId: $listingId,\n            offerTemplateId: $offerTemplateId\n          ) {\n            bid_id\n          }\n        }\n      ",
    variables: {
      listingId: segment.listing_id,
      offerTemplateId: input.offerTemplateId
    }
  }).then(function (res) {
    return res.body;
  }).then(function (_a) {
    var data = _a.data,
      errors = _a.errors;
    if (data === null || data.placeOnlineAuctionSegmentMatchBid === null) {
      throw partialGraphErrorFactory$1('Could not submit online match bid', errors);
    }
    return data.placeOnlineAuctionSegmentMatchBid;
  });
};
var submitOnlineRegularBid = function submitOnlineRegularBid(segment, input) {
  return fetch.forAuctionGraph({
    query: "\n        mutation ".concat(embeddableOperation('blueprint_updateOnlineAuctionSegmentHighestBid'), "($input: OnlineAuctionSegmentBidInput!) {\n          updateOnlineAuctionSegmentHighestBid(input: $input) {\n            bid_id\n            online_segment_id\n            listing_id\n            bid_amount\n            type\n            belongs_to_current_user\n            record_status\n            max_bid_update_date\n            created_date\n            updated_date\n          }\n        }\n      "),
    variables: {
      input: _assign({
        listing_id: segment.listing_id
      }, input)
    }
  }).then(function (res) {
    return res.body;
  }).then(function (_a) {
    var data = _a.data,
      errors = _a.errors;
    if (data === null || data.updateOnlineAuctionSegmentHighestBid === null) {
      throw partialGraphErrorFactory$1('Could not update online bid', errors);
    }
    return data.updateOnlineAuctionSegmentHighestBid;
  });
};
var upsertListingOnlineMaxBid = function upsertListingOnlineMaxBid(segment, input) {
  return fetch.forAuctionGraph({
    query: "\n        mutation ".concat(embeddableOperation('blueprint_upsertListingOnlineMaxBid'), "($input: ListingOnlineMaxBidInput!) {\n          upsertListingOnlineMaxBid(input: $input) {\n            max_bid_id\n            listing_id\n            property_id\n            max_bid_amount\n            record_status\n            created_date\n            updated_date\n          }\n        }\n      "),
    variables: {
      input: _assign({
        listing_id: segment.listing_id
      }, input)
    }
  }).then(function (res) {
    return res.body;
  }).then(function (_a) {
    var data = _a.data,
      errors = _a.errors;
    if (data === null || data.upsertListingOnlineMaxBid === null) {
      throw partialGraphErrorFactory$1('Could not create/update online max bid', errors);
    }
    return data.upsertListingOnlineMaxBid;
  });
};
var handleBidErrorMessage = function handleBidErrorMessage(errors) {
  var _a, _b;
  return match({
    code: ((_b = (_a = errors === null || errors === void 0 ? void 0 : errors[0]) === null || _a === void 0 ? void 0 : _a.extensions) === null || _b === void 0 ? void 0 : _b.specificErrorCode) || ''
  }).with({
    code: 'INVALID_FINANCE_AND_OR_APPRAISAL_CONTINGENCY_FOR_PAYMENT_TYPE'
  }, function () {
    var message = 'Please verify the number of days requested for your contingencies is accurate and try again.';
    return {
      message: message,
      unresolved_message: message
    };
  }).with({
    code: 'INVALID_DOWN_PAYMENT_AMOUNT'
  }, function () {
    var message = 'Please review your down payment amount and try again.';
    return {
      message: message,
      unresolved_message: message
    };
  }).with({
    code: 'PROOF_OF_FUNDS_DOCUMENT_MISSING'
  }, function () {
    var message = 'Please upload a proof of funds document and try again.';
    return {
      message: message,
      unresolved_message: message
    };
  }).with({
    code: 'INVALID_AGENT_COMMISSION'
  }, function () {
    var message = 'Please verify the amount entered for the buyer’s agent is accurate and try again.';
    return {
      message: message,
      unresolved_message: message
    };
  }).with({
    code: 'INVALID_DOWN_PAYMENT_AMOUNT'
  }, function () {
    var message = 'Please verify the amount entered for your down payment is accurate and try again.';
    return {
      message: message,
      unresolved_message: message
    };
  }).with({
    code: 'INVALID_EARNEST_MONEY_DEPOSIT_AMOUNT'
  }, function () {
    var message = 'Please verify the amount entered for your earnest money deposit is accurate and try again.';
    return {
      message: message,
      unresolved_message: message
    };
  }).with({
    code: 'INVALID_SELLER_CONCESSION_AMOUNT'
  }, function () {
    var message = 'Please verify the amount of requested seller paid closing costs is accurate and try again.';
    return {
      message: message,
      unresolved_message: message
    };
  }).with({
    code: 'MISSING_INSPECTION_CONTINGENCY_PERIOD_DURATION'
  }, function () {
    var message = 'Please verify the number of days requested for your contingencies is accurate and try again.';
    return {
      message: message,
      unresolved_message: message
    };
  }).with({
    code: 'MISSING_AGENT_COMMISSION'
  }, function () {
    var message = 'Please verify the amount entered for the buyer’s agent is accurate and try again.';
    return {
      message: message,
      unresolved_message: message
    };
  }).with({
    code: 'SEALED_BID_BELOW_STARTING_BID_CODE'
  }, function () {
    var message = "Please contact customer care at ".concat(formatPhoneNumber(contactNumbers.SMART_SALE_CONCIERGE), " for assistance.");
    return {
      message: message,
      unresolved_message: message
    };
  }).with({
    code: 'ONLINE_SEGMENT_ALREADY_ENDED'
  }, function () {
    var message = 'The seller is no longer accepting offers.';
    return {
      title: 'Listing has been removed.',
      message: message,
      unresolved_message: 'The seller is no longer accepting offers.{{more_properties}}'
    };
  }).with({
    code: 'NO_ACTIVE_ONLINE_SEGMENT_FOUND_FOR_LISTING'
  }, function () {
    var message = 'The seller is no longer accepting offers.';
    return {
      title: 'Listing has been removed.',
      message: message,
      unresolved_message: 'The seller is no longer accepting offers.{{more_properties}}'
    };
  }).with({
    code: 'PARTY_NOT_REGISTERED'
  }, function () {
    var message = 'Please complete the registration for this property and try again.';
    return {
      title: 'Listing has been removed.',
      message: message,
      unresolved_message: message
    };
  }).with({
    code: 'PARTY_PARTICIPATION_DISALLOWED'
  }, function () {
    var message = "Please contact customer care at ".concat(formatPhoneNumber(contactNumbers.ONLINE_BUYER_EXPERIENCE), " for assistance.");
    return {
      title: 'Listing has been removed.',
      message: message,
      unresolved_message: message
    };
  }).with({
    code: 'INVALID_SEGMENT_STATUS_FOR_BUYER_UPDATE'
  }, function () {
    var message = 'The seller is no longer accepting new offers.';
    return {
      message: message,
      unresolved_message: 'The seller is no longer accepting offers.{{more_properties}}'
    };
  }).otherwise(function () {
    var message = "Please contact customer care at ".concat(formatPhoneNumber(contactNumbers.ONLINE_BUYER_EXPERIENCE), " for assistance.");
    return {
      message: message,
      unresolved_message: message
    };
  });
};
var upsertSealedBid = function upsertSealedBid(_segment, variables) {
  return fetch.forAuctionGraph({
    query: "\n        mutation ".concat(embeddableOperation('blueprint_upsertSealedBid'), "($sealedBidInput: SealedBidInput!) {\n          upsertSealedBid(input: $sealedBidInput) {\n            bid_id\n            listing_id\n            bid_amount\n          }\n        }\n      "),
    variables: variables
  }).then(function (_a) {
    var _b = _a.body,
      data = _b.data,
      errors = _b.errors;
    if (!!(errors === null || errors === void 0 ? void 0 : errors[0])) {
      throw handleBidErrorMessage(errors);
    }
    return data.upsertSealedBid;
  }).catch(function () {
    throw handleBidErrorMessage();
  });
};
var acceptSellerCounterBid = function acceptSellerCounterBid(_segment, variables) {
  return fetch.forAuctionGraph({
    query: "\n        mutation ".concat(embeddableOperation('blueprint_acceptSellerCounterBid'), "(\n          $input: AcceptOrRejectBidInput!\n        ) {\n          acceptSellerCounterBid(input: $input) {\n            bid_id\n          }\n        }\n      "),
    variables: variables
  }).then(function (_a) {
    var _b = _a.body,
      data = _b.data,
      errors = _b.errors;
    if (!!(errors === null || errors === void 0 ? void 0 : errors[0])) {
      throw handleBidErrorMessage(errors);
    }
    return data.acceptSellerCounterBid;
  }).catch(function () {
    throw handleBidErrorMessage();
  });
};
var rejectSellerCounterBid = function rejectSellerCounterBid(_segment, variables) {
  return fetch.forAuctionGraph({
    query: "\n        mutation ".concat(embeddableOperation('blueprint_rejectSellerCounterBid'), "(\n          $input: AcceptOrRejectBidInput!\n        ) {\n          rejectSellerCounterBid(input: $input)\n        }\n      "),
    variables: variables
  }).then(function (_a) {
    var _b = _a.body,
      data = _b.data,
      errors = _b.errors;
    if (!!(errors === null || errors === void 0 ? void 0 : errors[0])) {
      throw handleBidErrorMessage(errors);
    }
    return data.rejectSellerCounterBid;
  }).catch(function () {
    throw handleBidErrorMessage();
  });
};
var withdrawSealedBid = function withdrawSealedBid(_segment, variables) {
  return fetch.forAuctionGraph({
    query: "\n        mutation ".concat(embeddableOperation('blueprint_withdrawSealedBid'), "($listing_id: ID!, $party_id: ID!) {\n          withdrawSealedBid(listingId: $listing_id, partyId: $party_id)\n        }\n      "),
    variables: variables
  }).then(function (_a) {
    var _b = _a.body,
      data = _b.data,
      errors = _b.errors;
    if (!!(errors === null || errors === void 0 ? void 0 : errors[0])) {
      throw handleBidErrorMessage(errors);
    }
    return data.withdrawSealedBid;
  }).catch(function () {
    throw handleBidErrorMessage();
  });
};
var acceptBuyerBid = function acceptBuyerBid(_segment, variables) {
  return fetch.forAuctionGraph({
    query: "\n            mutation ".concat(embeddableOperation('blueprint_acceptBuyerBid'), "($input: AcceptOrRejectBidInput!) {\n              acceptBuyerBid(input: $input) {\n                bid_id\n              }\n            }\n          "),
    variables: variables
  }).then(function (_a) {
    var _b = _a.body,
      data = _b.data,
      errors = _b.errors;
    if (!!(errors === null || errors === void 0 ? void 0 : errors[0])) {
      throw handleBidErrorMessage(errors);
    }
    return data.acceptBuyerBid;
  });
};
var placeSellerCounterBid = function placeSellerCounterBid(_segment, variables) {
  return fetch.forAuctionGraph({
    query: "\n            mutation ".concat(embeddableOperation('blueprint_placeSellerCounterBid'), "(\n              $input: SellerCounterBidInput!\n            ) {\n              placeSellerCounterBid(input: $input) {\n                bid_id\n              }\n            }\n          "),
    variables: variables
  }).then(function (_a) {
    var _b = _a.body,
      data = _b.data,
      errors = _b.errors;
    if (!!(errors === null || errors === void 0 ? void 0 : errors[0])) {
      throw handleBidErrorMessage(errors);
    }
    return data.placeSellerCounterBid;
  });
};
var updateListingReserve = function updateListingReserve(_segment, _a) {
  var listing_id = _a.listing_id,
    current_reserve_amount = _a.current_reserve_amount;
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_b) {
      return [2, fetch.forAuctionGraph({
        query: "\n            mutation ".concat(embeddableOperation('blueprint_patchOnlineAuctionSegment'), "(\n              $input: OnlineAuctionSegmentInput!\n            ) {\n              patchOnlineAuctionSegment(input: $input) {\n                listing_id\n              }\n            }\n          "),
        variables: {
          input: {
            listing_id: listing_id,
            current_reserve_amount: current_reserve_amount,
            update_source: 'LISTING_PORTAL'
          }
        }
      }).then(function (_a) {
        var _b = _a.body,
          data = _b.data,
          errors = _b.errors;
        if (!!(errors === null || errors === void 0 ? void 0 : errors[0])) {
          throw handleBidErrorMessage(errors);
        }
        return data.patchOnlineAuctionSegment;
      })];
    });
  });
};
var updateOnlineSegmentFragments = function updateOnlineSegmentFragments(_segment, _a) {
  var listing_id = _a.listing_id,
    review_date = _a.review_date;
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_b) {
      return [2, fetch.forAuctionGraph({
        query: "\n            mutation ".concat(embeddableOperation('blueprint_updateOnlineSegmentFragments'), "(\n              $input: OnlineSegmentFragmentsInput!\n            ) {\n              updateOnlineSegmentFragments(input: $input) {\n                listing_id\n              }\n            }\n          "),
        variables: {
          input: {
            listing_id: listing_id,
            fragments: [{
              type: 'OFFER_REVIEW_PERIOD',
              start_date: review_date,
              status: 'PENDING'
            }]
          }
        }
      }).then(function (_a) {
        var _b = _a.body,
          data = _b.data,
          errors = _b.errors;
        if (!!(errors === null || errors === void 0 ? void 0 : errors[0])) {
          throw handleBidErrorMessage(errors);
        }
        return data.updateOnlineSegmentFragments;
      })];
    });
  });
};
var updateListingReviewDate = function updateListingReviewDate(_segment, _a) {
  var listing_id = _a.listing_id,
    review_date = _a.review_date;
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_b) {
      return [2, fetch.forAuctionGraph({
        query: "\n            mutation ".concat(embeddableOperation('blueprint_patchOnlineAuctionSegment'), "(\n              $input: OnlineAuctionSegmentInput!\n            ) {\n              patchOnlineAuctionSegment(input: $input) {\n                listing_id\n              }\n            }\n          "),
        variables: {
          input: {
            listing_id: listing_id,
            configuration: {
              review_date: review_date
            },
            update_source: 'LISTING_PORTAL'
          }
        }
      }).then(function (_a) {
        var _b = _a.body,
          data = _b.data,
          errors = _b.errors;
        if (!!(errors === null || errors === void 0 ? void 0 : errors[0])) {
          throw handleBidErrorMessage(errors);
        }
        return data.patchOnlineAuctionSegment;
      })];
    });
  });
};
var rejectBuyerBid = function rejectBuyerBid(_segment, variables) {
  return fetch.forAuctionGraph({
    query: "\n        mutation ".concat(embeddableOperation('blueprint_rejectBuyerBid'), "($input: AcceptOrRejectBidInput!) {\n          rejectBuyerBid(input: $input)\n        }\n      "),
    variables: variables
  }).then(function (_a) {
    var _b = _a.body,
      data = _b.data,
      errors = _b.errors;
    if (!!(errors === null || errors === void 0 ? void 0 : errors[0])) {
      throw handleBidErrorMessage(errors);
    }
    return data.rejectBuyerBid;
  });
};
var withdrawSellerCounterBid = function withdrawSellerCounterBid(_segment, variables) {
  return fetch.forAuctionGraph({
    query: "\n        mutation ".concat(embeddableOperation('blueprint_withdrawSellerCounterBid'), "(\n          $input: AcceptOrRejectBidInput!\n        ) {\n          withdrawSellerCounterBid(input: $input)\n        }\n      "),
    variables: variables
  }).then(function (_a) {
    var _b = _a.body,
      data = _b.data,
      errors = _b.errors;
    if (!!(errors === null || errors === void 0 ? void 0 : errors[0])) {
      throw handleBidErrorMessage(errors);
    }
    return data.withdrawSellerCounterBid;
  });
};
var startHighestAndBestRound = function startHighestAndBestRound(_segment, variables) {
  return fetch.forAuctionGraph({
    query: "\n        mutation ".concat(embeddableOperation('blueprint_startHighestAndBestRound'), "($listingId: ID!) {\n          startHighestAndBestRound(listingId: $listingId)\n        }\n      "),
    variables: variables
  }).then(function (_a) {
    var _b = _a.body,
      data = _b.data,
      errors = _b.errors;
    if (!!(errors === null || errors === void 0 ? void 0 : errors[0])) {
      throw handleBidErrorMessage(errors);
    }
    return data.startHighestAndBestRound;
  });
};
var templateObject_1$g, templateObject_2$c, templateObject_3$6, templateObject_4$5, templateObject_5$2, templateObject_6$1, templateObject_7;

var partialGraphErrorFactory$1 = function partialGraphErrorFactory(message, errors) {
  var e = new Error(message);
  e.errors = errors;
  return e;
};

var providers$7 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getCurrentServerTime: getCurrentServerTime,
  getLatestLiveAuctionSegments: getLatestLiveAuctionSegments,
  getLatestLiveFocusedListingsSegments: getLatestLiveFocusedListingsSegments,
  getLatestLiveListings: getLatestLiveListings,
  getLatestOnlineListings: getLatestOnlineListings,
  getLatestOnlineSegments: getLatestOnlineSegments,
  partialGraphErrorFactory: partialGraphErrorFactory$1,
  submitLiveRemoteBid: submitLiveRemoteBid,
  submitOnlineMatchBid: submitOnlineMatchBid,
  submitOnlineRegularBid: submitOnlineRegularBid,
  updateLiveRemoteBid: updateLiveRemoteBid,
  upsertListingOnlineMaxBid: upsertListingOnlineMaxBid
});

var ADDRESS_FRAGMENT = gql(templateObject_1$f || (templateObject_1$f = __makeTemplateObject(["\n  fragment Address on Address {\n    street_number\n    street_name\n    street_unit\n    country_primary_subdivision\n    country_secondary_subdivision\n    country_tertiary_subdivision\n    municipality\n    postal_code\n    coordinates {\n      lat\n      lon\n    }\n  }\n"], ["\n  fragment Address on Address {\n    street_number\n    street_name\n    street_unit\n    country_primary_subdivision\n    country_secondary_subdivision\n    country_tertiary_subdivision\n    municipality\n    postal_code\n    coordinates {\n      lat\n      lon\n    }\n  }\n"])));
var LISTING_BADGES_FRAGMENT = gql(templateObject_2$b || (templateObject_2$b = __makeTemplateObject(["\n  fragment ListingBadgesFields on Listing {\n    listing_status\n    listing_configuration {\n      product_type\n      broker_commission_message\n      buyer_premium_available\n      financing_available\n      is_first_look_enabled\n      first_look_end_date\n      interior_access_allowed\n      occupancy_status\n      redemption_expiration_date\n      trustee_sales_channel\n      is_buyers_premium_available\n      are_private_tours_available\n    }\n\n    listing_summary {\n      is_remote_bid_enabled\n      is_remote_before_and_during_auction_enabled\n    }\n\n    program_configuration {\n      buyers_premium_minimum_amount\n      buyers_premium_primary_amount\n      buyers_premium_commission_type\n    }\n\n    primary_property {\n      is_currently_saved\n      is_newly_listed\n    }\n\n    open_houses {\n      local_date\n      start_time\n      end_time\n    }\n\n    rental {\n      current_rent\n      lease_start_date\n      lease_expiration_date\n      is_security_deposit_charged\n      security_deposit_amount\n    }\n\n    short_sale {\n      agreement_expiration_date\n    }\n\n    event {\n      event_code\n      trustee_sale\n    }\n\n    parties {\n      party_role\n    }\n\n    venue {\n      venue_type\n    }\n\n    marketing_tags {\n      tag\n    }\n  }\n"], ["\n  fragment ListingBadgesFields on Listing {\n    listing_status\n    listing_configuration {\n      product_type\n      broker_commission_message\n      buyer_premium_available\n      financing_available\n      is_first_look_enabled\n      first_look_end_date\n      interior_access_allowed\n      occupancy_status\n      redemption_expiration_date\n      trustee_sales_channel\n      is_buyers_premium_available\n      are_private_tours_available\n    }\n\n    listing_summary {\n      is_remote_bid_enabled\n      is_remote_before_and_during_auction_enabled\n    }\n\n    program_configuration {\n      buyers_premium_minimum_amount\n      buyers_premium_primary_amount\n      buyers_premium_commission_type\n    }\n\n    primary_property {\n      is_currently_saved\n      is_newly_listed\n    }\n\n    open_houses {\n      local_date\n      start_time\n      end_time\n    }\n\n    rental {\n      current_rent\n      lease_start_date\n      lease_expiration_date\n      is_security_deposit_charged\n      security_deposit_amount\n    }\n\n    short_sale {\n      agreement_expiration_date\n    }\n\n    event {\n      event_code\n      trustee_sale\n    }\n\n    parties {\n      party_role\n    }\n\n    venue {\n      venue_type\n    }\n\n    marketing_tags {\n      tag\n    }\n  }\n"])));
var FIELDS_REQUIRING_ACTIVE_SESSION_FRAGMENT = gql(templateObject_3$5 || (templateObject_3$5 = __makeTemplateObject(["\n  fragment FieldsRequiringActiveSessionFields on Listing {\n    listing_id\n    is_current_user_first_look_qualified\n    is_current_user_registered_for_online_auction\n\n    current_user_online_registration {\n      registration_status\n    }\n\n    current_user_remote_bid @include(if: $isRemoteBiddingEnabled) {\n      remote_bid_amount\n    }\n\n    current_user_bid_deposit_requirements {\n      is_registration_deposit_applicable\n      is_registration_deposit_required_enabled\n      absolute_amount_required\n    }\n\n    is_current_user_allowed(\n      actions: [\n        ONLINE_BIDDING_REGISTRATION\n        ONLINE_REGULAR_BIDDING\n        ONLINE_PROXY_BIDDING\n        ONLINE_DIRECT_OFFER\n      ]\n    ) {\n      __typename\n      action\n      allowed\n      reason\n      reason_code\n    }\n    online_auction_segment(resolvePolicy: ORIGIN_ONLY) {\n      segment_status\n      current_user_max_bid {\n        max_bid_amount\n        record_status\n      }\n      bids_ranking {\n        ranking {\n          belongs_to_current_user\n        }\n      }\n      configuration {\n        is_registration_deposit_required_enabled\n      }\n      current_user_bidding_status\n    }\n  }\n"], ["\n  fragment FieldsRequiringActiveSessionFields on Listing {\n    listing_id\n    is_current_user_first_look_qualified\n    is_current_user_registered_for_online_auction\n\n    current_user_online_registration {\n      registration_status\n    }\n\n    current_user_remote_bid @include(if: $isRemoteBiddingEnabled) {\n      remote_bid_amount\n    }\n\n    current_user_bid_deposit_requirements {\n      is_registration_deposit_applicable\n      is_registration_deposit_required_enabled\n      absolute_amount_required\n    }\n\n    is_current_user_allowed(\n      actions: [\n        ONLINE_BIDDING_REGISTRATION\n        ONLINE_REGULAR_BIDDING\n        ONLINE_PROXY_BIDDING\n        ONLINE_DIRECT_OFFER\n      ]\n    ) {\n      __typename\n      action\n      allowed\n      reason\n      reason_code\n    }\n    online_auction_segment(resolvePolicy: ORIGIN_ONLY) {\n      segment_status\n      current_user_max_bid {\n        max_bid_amount\n        record_status\n      }\n      bids_ranking {\n        ranking {\n          belongs_to_current_user\n        }\n      }\n      configuration {\n        is_registration_deposit_required_enabled\n      }\n      current_user_bidding_status\n    }\n  }\n"])));
var ACTIVE_LISTINGS_FRAGMENT = gql(templateObject_4$4 || (templateObject_4$4 = __makeTemplateObject(["\n  fragment ActiveListingFields on Listing {\n    applicable_global_documents(filters: { media_usage_type_codes: [WEB] }) {\n      __typename\n      media_purpose_type_code\n      media_content_type\n      media_download_uri\n      media_file_name\n      media_internal_title\n      media_external_title\n      media_desc\n      priority_level_type_code\n      updated_date\n    }\n    attribution_source {\n      origin_code\n    }\n    auction {\n      auction_date\n      start_date_time\n      end_date\n      end_date_time\n      starting_bid\n      provisional_sale_date\n      is_outbid_active\n      is_online\n      bid_instruction {\n        nos_amount\n      }\n    }\n    current_listing {\n      listing_page_path\n    }\n    documents(filters: { document_usage_type_codes: [WEB] }) {\n      document_external_title\n      updated_date\n      metadata {\n        document_purpose_type_code\n      }\n      file_descriptor {\n        urls {\n          cdn\n          download\n        }\n      }\n    }\n    event {\n      title\n      trustee_sale\n      event_type\n      # Auction Number\n      event_code\n      event_id\n      event_schedule {\n        campaign_start_date\n      }\n      description\n    }\n    external_identifiers {\n      external_identifier\n      data_source\n    }\n    external_information {\n      collateral {\n        is_valuation_available\n      }\n    }\n    formatted_address(format: DOUBLE_LINE)\n    fcl_marketing {\n      appraiser_uri\n      clerk_of_court_uri\n    }\n    intake_source {\n      origin_code\n    }\n    is_coming_soon\n    is_hot\n    is_published\n    is_searchable\n    live_auction_segment(resolvePolicy: ORIGIN_ONLY) {\n      listing_id\n      __typename\n      starting_bid_amount\n    }\n    listing_configuration {\n      sale_instruction\n      total_estimated_debt\n      final_judgement_amount\n      occupancy_status\n      principal_original_amount\n      trustee_sales_agent\n      postponement_new_auction_date\n      postponement_new_auction_start_date\n      postponement_new_auction_end_date\n      postponement_new_auction_time\n      minimum_credit_bid_amount\n      trustee_sales_channel\n      is_third_party_online\n      is_reserve_displayed\n      is_proxy_bidding_enabled\n      asset_type\n      financing_available\n      title_insurance\n      monthly_hoa_amount\n      is_buyers_premium_available\n      is_earnest_money_deposit_available\n      is_first_look_enabled\n      first_look_end_date\n      product_type\n      broker_commission_message\n      buyer_premium_available\n      interior_access_allowed\n      redemption_expiration_date\n      is_direct_offer_enabled\n      is_minimum_bid_enabled\n    }\n    listing_id\n    listing_media {\n      media_external_title\n      media_download_uri\n      media_cdn_uri\n      updated_date\n      media_type\n    }\n    listing_page_path\n    listing_remarks {\n      # Property Description\n      mls_comment\n      # Disclaimer Field\n      legal_description\n      # Special Notes\n      special_notes\n      additional_seller_terms\n      special_proceedings_number\n    }\n    listing_summary {\n      is_remote_bid_enabled\n      show_opening_bid\n      is_remote_before_and_during_auction_enabled\n    }\n    listing_status\n    listing_status_group\n    listing_status_label\n    marketing_attributes(\n      resolveTags: true\n      attributeClasses: [FEATURE_TOGGLE, CONTENT]\n    ) {\n      ... on FeatureToggleMarketingAttribute {\n        attribute_type\n        is_enabled\n      }\n\n      ... on ContentMarketingAttribute {\n        default_display_value\n        attribute_type\n        show\n        label\n        message\n      }\n    }\n    marketing_tags {\n      tag\n    }\n    metrics {\n      pdp_view_count\n    }\n    offer_suggestion {\n      suggested_offer_low\n      suggested_offer_high\n    }\n    offers_summary {\n      has_accepted_direct_offer\n    }\n    online_auction_segment(resolvePolicy: ORIGIN_ONLY) {\n      listing_id\n      __typename\n      start_date\n      segment_type\n      bids_ranking {\n        ranking {\n          belongs_to_current_user\n        }\n      }\n      initial_end_date\n      current_time\n      reserve_status\n      configuration {\n        is_match_bidding_enabled\n        is_registration_deposit_required_enabled\n        bid_again_count\n        should_bid_again\n        is_registration_enabled\n      }\n      starting_bid_amount\n      subject_to_status\n      current_highest_bid {\n        bid_amount\n        type\n      }\n      segment_status\n      current_reserve_amount\n      current_increment_amount\n      bid_count\n      result {\n        winning_bid_amount\n      }\n    }\n    open_houses {\n      local_date\n      start_time\n      end_time\n    }\n    seller_terms {\n      leaseback_terms {\n        leaseback_period_in_days\n      }\n      inspection_terms {\n        is_option_contingency\n        is_contingency\n      }\n      finance_terms {\n        is_contingency\n        finance_preference\n      }\n    }\n    parties {\n      party_role\n      party_name\n      party_email\n      party_phone\n      party_license_number\n      party_address {\n        postal_code\n        street_description\n        municipality\n        country_primary_subdivision\n      }\n    }\n\n    photos {\n      file_descriptor {\n        urls {\n          cdn\n        }\n      }\n    }\n    primary_photo\n    primary_property {\n      first_activation_date\n      is_currently_saved\n      is_newly_listed\n      metrics {\n        pdp_view_count\n      }\n      property_id\n      summary {\n        total_bedrooms\n        total_bathrooms\n        living_size\n        year_built\n        apn\n        hoa_dues_amount\n        lot_size\n        structure_type_code\n        structure_type_group\n        valuation\n        street_address\n        formatted_address\n        address {\n          ...Address\n        }\n      }\n      land_parcels {\n        # APN Number?\n        parcel_number\n      }\n      vendor_report_url\n      has_vendor_information_available\n    }\n    primary_property_id\n    program_configuration {\n      deed_types\n      buyers_premium_minimum_amount\n      buyers_premium_primary_amount\n      buyers_premium_commission_type\n\n      earnest_money_deposit_minimum_amount\n      earnest_money_deposit_primary_amount\n      earnest_money_deposit_commission_type\n\n      third_party_title_provider\n      program_enrollment_code\n    }\n    recommended_listings {\n      ...ListingCardFields\n    }\n    rental {\n      current_rent\n      lease_start_date\n      lease_expiration_date\n      is_security_deposit_charged\n      security_deposit_amount\n    }\n    reserve_price\n\n    seller_plan {\n      seller_plan_code\n    }\n    seller_property {\n      street_description\n      country_primary_subdivision\n      country_secondary_subdivision\n      municipality\n      postal_code\n    }\n    short_sale {\n      agreement_expiration_date\n      is_income_producing\n    }\n\n    strategy {\n      selling_method_attributes {\n        online_segment_type\n      }\n    }\n    trustee {\n      sale_time\n      online_state_deposit_amount\n      partnership_details\n    }\n    trustee_reference_id\n    trustee_sale_number\n    valuation {\n      seller_current_value_amount\n    }\n    venue {\n      venue_id\n      venue_code\n      venue_title\n      venue_name\n      venue_url\n      venue_location_directions\n      venue_type\n      venue_address {\n        ...Address\n      }\n      venue_configuration {\n        venue_setting\n      }\n      venue_schedule {\n        initial_bidding_end_time\n        bid_start_local_date\n        bid_start_local_time\n        initial_bidding_end_local_date\n        initial_bidding_end_local_time\n      }\n    }\n    ...FieldsRequiringActiveSessionFields @include(if: $hasAuthenticatedUser)\n    ...ListingBadgesFields\n  }\n"], ["\n  fragment ActiveListingFields on Listing {\n    applicable_global_documents(filters: { media_usage_type_codes: [WEB] }) {\n      __typename\n      media_purpose_type_code\n      media_content_type\n      media_download_uri\n      media_file_name\n      media_internal_title\n      media_external_title\n      media_desc\n      priority_level_type_code\n      updated_date\n    }\n    attribution_source {\n      origin_code\n    }\n    auction {\n      auction_date\n      start_date_time\n      end_date\n      end_date_time\n      starting_bid\n      provisional_sale_date\n      is_outbid_active\n      is_online\n      bid_instruction {\n        nos_amount\n      }\n    }\n    current_listing {\n      listing_page_path\n    }\n    documents(filters: { document_usage_type_codes: [WEB] }) {\n      document_external_title\n      updated_date\n      metadata {\n        document_purpose_type_code\n      }\n      file_descriptor {\n        urls {\n          cdn\n          download\n        }\n      }\n    }\n    event {\n      title\n      trustee_sale\n      event_type\n      # Auction Number\n      event_code\n      event_id\n      event_schedule {\n        campaign_start_date\n      }\n      description\n    }\n    external_identifiers {\n      external_identifier\n      data_source\n    }\n    external_information {\n      collateral {\n        is_valuation_available\n      }\n    }\n    formatted_address(format: DOUBLE_LINE)\n    fcl_marketing {\n      appraiser_uri\n      clerk_of_court_uri\n    }\n    intake_source {\n      origin_code\n    }\n    is_coming_soon\n    is_hot\n    is_published\n    is_searchable\n    live_auction_segment(resolvePolicy: ORIGIN_ONLY) {\n      listing_id\n      __typename\n      starting_bid_amount\n    }\n    listing_configuration {\n      sale_instruction\n      total_estimated_debt\n      final_judgement_amount\n      occupancy_status\n      principal_original_amount\n      trustee_sales_agent\n      postponement_new_auction_date\n      postponement_new_auction_start_date\n      postponement_new_auction_end_date\n      postponement_new_auction_time\n      minimum_credit_bid_amount\n      trustee_sales_channel\n      is_third_party_online\n      is_reserve_displayed\n      is_proxy_bidding_enabled\n      asset_type\n      financing_available\n      title_insurance\n      monthly_hoa_amount\n      is_buyers_premium_available\n      is_earnest_money_deposit_available\n      is_first_look_enabled\n      first_look_end_date\n      product_type\n      broker_commission_message\n      buyer_premium_available\n      interior_access_allowed\n      redemption_expiration_date\n      is_direct_offer_enabled\n      is_minimum_bid_enabled\n    }\n    listing_id\n    listing_media {\n      media_external_title\n      media_download_uri\n      media_cdn_uri\n      updated_date\n      media_type\n    }\n    listing_page_path\n    listing_remarks {\n      # Property Description\n      mls_comment\n      # Disclaimer Field\n      legal_description\n      # Special Notes\n      special_notes\n      additional_seller_terms\n      special_proceedings_number\n    }\n    listing_summary {\n      is_remote_bid_enabled\n      show_opening_bid\n      is_remote_before_and_during_auction_enabled\n    }\n    listing_status\n    listing_status_group\n    listing_status_label\n    marketing_attributes(\n      resolveTags: true\n      attributeClasses: [FEATURE_TOGGLE, CONTENT]\n    ) {\n      ... on FeatureToggleMarketingAttribute {\n        attribute_type\n        is_enabled\n      }\n\n      ... on ContentMarketingAttribute {\n        default_display_value\n        attribute_type\n        show\n        label\n        message\n      }\n    }\n    marketing_tags {\n      tag\n    }\n    metrics {\n      pdp_view_count\n    }\n    offer_suggestion {\n      suggested_offer_low\n      suggested_offer_high\n    }\n    offers_summary {\n      has_accepted_direct_offer\n    }\n    online_auction_segment(resolvePolicy: ORIGIN_ONLY) {\n      listing_id\n      __typename\n      start_date\n      segment_type\n      bids_ranking {\n        ranking {\n          belongs_to_current_user\n        }\n      }\n      initial_end_date\n      current_time\n      reserve_status\n      configuration {\n        is_match_bidding_enabled\n        is_registration_deposit_required_enabled\n        bid_again_count\n        should_bid_again\n        is_registration_enabled\n      }\n      starting_bid_amount\n      subject_to_status\n      current_highest_bid {\n        bid_amount\n        type\n      }\n      segment_status\n      current_reserve_amount\n      current_increment_amount\n      bid_count\n      result {\n        winning_bid_amount\n      }\n    }\n    open_houses {\n      local_date\n      start_time\n      end_time\n    }\n    seller_terms {\n      leaseback_terms {\n        leaseback_period_in_days\n      }\n      inspection_terms {\n        is_option_contingency\n        is_contingency\n      }\n      finance_terms {\n        is_contingency\n        finance_preference\n      }\n    }\n    parties {\n      party_role\n      party_name\n      party_email\n      party_phone\n      party_license_number\n      party_address {\n        postal_code\n        street_description\n        municipality\n        country_primary_subdivision\n      }\n    }\n\n    photos {\n      file_descriptor {\n        urls {\n          cdn\n        }\n      }\n    }\n    primary_photo\n    primary_property {\n      first_activation_date\n      is_currently_saved\n      is_newly_listed\n      metrics {\n        pdp_view_count\n      }\n      property_id\n      summary {\n        total_bedrooms\n        total_bathrooms\n        living_size\n        year_built\n        apn\n        hoa_dues_amount\n        lot_size\n        structure_type_code\n        structure_type_group\n        valuation\n        street_address\n        formatted_address\n        address {\n          ...Address\n        }\n      }\n      land_parcels {\n        # APN Number?\n        parcel_number\n      }\n      vendor_report_url\n      has_vendor_information_available\n    }\n    primary_property_id\n    program_configuration {\n      deed_types\n      buyers_premium_minimum_amount\n      buyers_premium_primary_amount\n      buyers_premium_commission_type\n\n      earnest_money_deposit_minimum_amount\n      earnest_money_deposit_primary_amount\n      earnest_money_deposit_commission_type\n\n      third_party_title_provider\n      program_enrollment_code\n    }\n    recommended_listings {\n      ...ListingCardFields\n    }\n    rental {\n      current_rent\n      lease_start_date\n      lease_expiration_date\n      is_security_deposit_charged\n      security_deposit_amount\n    }\n    reserve_price\n\n    seller_plan {\n      seller_plan_code\n    }\n    seller_property {\n      street_description\n      country_primary_subdivision\n      country_secondary_subdivision\n      municipality\n      postal_code\n    }\n    short_sale {\n      agreement_expiration_date\n      is_income_producing\n    }\n\n    strategy {\n      selling_method_attributes {\n        online_segment_type\n      }\n    }\n    trustee {\n      sale_time\n      online_state_deposit_amount\n      partnership_details\n    }\n    trustee_reference_id\n    trustee_sale_number\n    valuation {\n      seller_current_value_amount\n    }\n    venue {\n      venue_id\n      venue_code\n      venue_title\n      venue_name\n      venue_url\n      venue_location_directions\n      venue_type\n      venue_address {\n        ...Address\n      }\n      venue_configuration {\n        venue_setting\n      }\n      venue_schedule {\n        initial_bidding_end_time\n        bid_start_local_date\n        bid_start_local_time\n        initial_bidding_end_local_date\n        initial_bidding_end_local_time\n      }\n    }\n    ...FieldsRequiringActiveSessionFields @include(if: $hasAuthenticatedUser)\n    ...ListingBadgesFields\n  }\n"])));
var templateObject_1$f, templateObject_2$b, templateObject_3$5, templateObject_4$4;

var LISTING_CARDS_FRAGMENT = gql(templateObject_1$e || (templateObject_1$e = __makeTemplateObject(["\n  fragment ListingCardFields on Listing {\n    listing_id\n    urn\n    listing_status_group\n    listing_status\n    listing_status_label(intent: SEARCH)\n    primary_photo\n    listing_photos_count\n    listing_page_path\n    reserve_price\n    is_hot\n    formatted_address(format: DOUBLE_LINE)\n\n    listing_configuration {\n      product_type\n      is_reserve_displayed\n      broker_commission\n      financing_available\n      buyer_premium_available\n      interior_access_allowed\n      occupancy_status\n      asset_type\n      is_first_look_enabled\n      is_direct_offer_enabled\n      is_third_party_online\n    }\n\n    venue {\n      venue_type\n    }\n\n    event {\n      event_code\n      trustee_sale\n    }\n\n    seller_property {\n      street_description\n      municipality\n      country_primary_subdivision\n      country_secondary_subdivision\n      postal_code\n    }\n\n    program_configuration {\n      program_enrollment_code\n    }\n    seller_terms {\n      inspection_terms {\n        is_option_contingency\n        is_contingency\n      }\n      leaseback_terms {\n        leaseback_period_in_days\n        leaseback_period_rent\n      }\n      finance_terms {\n        finance_preference\n        is_contingency\n      }\n      intent\n    }\n    primary_property {\n      property_id\n      summary {\n        total_bedrooms\n        total_bathrooms\n        square_footage\n        lot_size\n        year_built\n        valuation\n        structure_type_code\n        structure_type_group\n        address {\n          coordinates {\n            lon\n            lat\n          }\n        }\n      }\n      is_currently_saved\n      is_newly_listed\n      current_user_tracking_state {\n        is_seen\n        is_updated\n      }\n    }\n\n    auction {\n      start_date\n      end_date\n      starting_bid\n      is_online\n      bid_instruction {\n        nos_amount\n      }\n    }\n\n    parties {\n      party_role\n      party_name\n    }\n\n    marketing_tags {\n      tag\n    }\n    online_auction_segment(resolvePolicy: CACHE_ONLY) {\n      reserve_status\n      __typename\n      segment_type\n      current_highest_bid {\n        bid_amount\n      }\n    }\n\n    open_houses {\n      local_date\n      start_time\n      end_time\n    }\n\n    live_auction_segment(resolvePolicy: CACHE_ONLY) {\n      current_highest_bid {\n        bid_amount\n      }\n      configuration {\n        state_deposit_rule\n      }\n    }\n\n    listing_summary {\n      is_remote_bid_enabled\n      is_remote_before_and_during_auction_enabled\n      show_opening_bid\n    }\n\n    external_information(resolvePolicy: CACHE_ONLY) {\n      collateral {\n        summary {\n          estimated\n          low\n          high\n          type\n        }\n      }\n    }\n    valuation {\n      seller_current_value_amount\n    }\n    strategy {\n      selling_method_attributes {\n        online_segment_type\n      }\n    }\n  }\n"], ["\n  fragment ListingCardFields on Listing {\n    listing_id\n    urn\n    listing_status_group\n    listing_status\n    listing_status_label(intent: SEARCH)\n    primary_photo\n    listing_photos_count\n    listing_page_path\n    reserve_price\n    is_hot\n    formatted_address(format: DOUBLE_LINE)\n\n    listing_configuration {\n      product_type\n      is_reserve_displayed\n      broker_commission\n      financing_available\n      buyer_premium_available\n      interior_access_allowed\n      occupancy_status\n      asset_type\n      is_first_look_enabled\n      is_direct_offer_enabled\n      is_third_party_online\n    }\n\n    venue {\n      venue_type\n    }\n\n    event {\n      event_code\n      trustee_sale\n    }\n\n    seller_property {\n      street_description\n      municipality\n      country_primary_subdivision\n      country_secondary_subdivision\n      postal_code\n    }\n\n    program_configuration {\n      program_enrollment_code\n    }\n    seller_terms {\n      inspection_terms {\n        is_option_contingency\n        is_contingency\n      }\n      leaseback_terms {\n        leaseback_period_in_days\n        leaseback_period_rent\n      }\n      finance_terms {\n        finance_preference\n        is_contingency\n      }\n      intent\n    }\n    primary_property {\n      property_id\n      summary {\n        total_bedrooms\n        total_bathrooms\n        square_footage\n        lot_size\n        year_built\n        valuation\n        structure_type_code\n        structure_type_group\n        address {\n          coordinates {\n            lon\n            lat\n          }\n        }\n      }\n      is_currently_saved\n      is_newly_listed\n      current_user_tracking_state {\n        is_seen\n        is_updated\n      }\n    }\n\n    auction {\n      start_date\n      end_date\n      starting_bid\n      is_online\n      bid_instruction {\n        nos_amount\n      }\n    }\n\n    parties {\n      party_role\n      party_name\n    }\n\n    marketing_tags {\n      tag\n    }\n    online_auction_segment(resolvePolicy: CACHE_ONLY) {\n      reserve_status\n      __typename\n      segment_type\n      current_highest_bid {\n        bid_amount\n      }\n    }\n\n    open_houses {\n      local_date\n      start_time\n      end_time\n    }\n\n    live_auction_segment(resolvePolicy: CACHE_ONLY) {\n      current_highest_bid {\n        bid_amount\n      }\n      configuration {\n        state_deposit_rule\n      }\n    }\n\n    listing_summary {\n      is_remote_bid_enabled\n      is_remote_before_and_during_auction_enabled\n      show_opening_bid\n    }\n\n    external_information(resolvePolicy: CACHE_ONLY) {\n      collateral {\n        summary {\n          estimated\n          low\n          high\n          type\n        }\n      }\n    }\n    valuation {\n      seller_current_value_amount\n    }\n    strategy {\n      selling_method_attributes {\n        online_segment_type\n      }\n    }\n  }\n"])));
var webListingFragment = gql(templateObject_2$a || (templateObject_2$a = __makeTemplateObject(["\n  fragment ListingCardFields on Listing {\n    listing_id\n    urn\n    listing_status_group\n    listing_status\n    listing_status_label(intent: SEARCH)\n    primary_photo\n    primary_property_id\n    listing_photos_count\n    listing_page_path\n    reserve_price\n    is_hot\n    formatted_address(format: DOUBLE_LINE)\n    listing_configuration {\n      product_type\n      is_reserve_displayed\n      broker_commission\n      financing_available\n      buyer_premium_available\n      interior_access_allowed\n      occupancy_status\n      asset_type\n      is_first_look_enabled\n      is_direct_offer_enabled\n      is_third_party_online\n    }\n    attribution_source {\n      origin_code\n    }\n    external_identifiers {\n      data_source\n      external_identifier\n    }\n    venue {\n      venue_type\n    }\n    event {\n      event_code\n      trustee_sale\n    }\n    valuation {\n      seller_current_value_amount\n    }\n    strategy {\n      selling_method_attributes {\n        online_segment_type\n      }\n    }\n    seller_property {\n      street_description\n      municipality\n      country_primary_subdivision\n      country_secondary_subdivision\n      postal_code\n    }\n    program_configuration {\n      program_enrollment_code\n    }\n    primary_property {\n      property_id\n      summary {\n        total_bedrooms\n        total_bathrooms\n        square_footage\n        lot_size\n        year_built\n        valuation\n        structure_type_code\n        structure_type_group\n        address {\n          coordinates {\n            lon\n            lat\n          }\n        }\n      }\n      is_currently_saved @include(if: $hasAuthenticatedUser)\n      is_newly_listed\n      current_user_tracking_state {\n        is_seen\n        is_updated\n      }\n    }\n    auction {\n      start_date\n      end_date\n      starting_bid\n      is_online\n      visible_auction_start_date_time\n      bid_instruction {\n        nos_amount\n      }\n    }\n    parties {\n      party_role\n      party_name\n    }\n    marketing_tags {\n      tag\n    }\n    online_auction_segment(resolvePolicy: CACHE_ONLY) {\n      __typename\n      segment_type\n      reserve_status\n      current_highest_bid {\n        bid_amount\n      }\n    }\n    open_houses {\n      local_date\n      start_time\n      end_time\n    }\n    live_auction_segment(resolvePolicy: CACHE_ONLY) {\n      current_highest_bid {\n        bid_amount\n      }\n      configuration {\n        state_deposit_rule\n      }\n    }\n    listing_summary {\n      is_remote_bid_enabled\n      is_remote_before_and_during_auction_enabled\n      show_opening_bid\n    }\n    external_information(resolvePolicy: CACHE_ONLY) {\n      collateral {\n        summary {\n          estimated\n          low\n          high\n          type\n        }\n      }\n    }\n  }\n  fragment ListingPopupCardFields on Listing {\n    listing_id\n    formatted_address_line_1: formatted_address(format: SINGLE_LINE)\n    listing_summary {\n      is_remote_bid_enabled\n      is_remote_before_and_during_auction_enabled\n      show_opening_bid\n    }\n    listing_status_group\n    listing_page_path\n    primary_photo\n    reserve_price\n\n    listing_configuration {\n      product_type\n      asset_type\n      is_third_party_online\n    }\n\n    event {\n      event_code\n    }\n\n    seller_property {\n      street_description\n      country_secondary_subdivision\n      municipality\n      postal_code\n    }\n\n    program_configuration {\n      program_enrollment_code\n    }\n\n    primary_property {\n      property_id\n      summary {\n        total_bedrooms\n        total_bathrooms\n        square_footage\n        address {\n          coordinates {\n            lat\n            lon\n          }\n        }\n      }\n      is_newly_listed\n      current_user_tracking_state {\n        is_seen\n        is_updated\n      }\n    }\n\n    auction {\n      starting_bid\n      is_online\n      bid_instruction {\n        nos_amount\n      }\n    }\n\n    online_auction_segment(resolvePolicy: CACHE_ONLY) {\n      listing_id\n      __typename\n      start_date\n      segment_type\n      initial_end_date\n      current_time\n      reserve_status\n      configuration {\n        is_match_bidding_enabled\n        is_registration_deposit_required_enabled\n        bid_again_count\n        should_bid_again\n      }\n      starting_bid_amount\n      subject_to_status\n      current_highest_bid {\n        bid_amount\n        type\n      }\n      segment_status\n      current_reserve_amount\n      current_increment_amount\n      bid_count\n      result {\n        winning_bid_amount\n      }\n    }\n\n    live_auction_segment(resolvePolicy: CACHE_ONLY) {\n      current_highest_bid {\n        bid_amount\n      }\n    }\n  }\n"], ["\n  fragment ListingCardFields on Listing {\n    listing_id\n    urn\n    listing_status_group\n    listing_status\n    listing_status_label(intent: SEARCH)\n    primary_photo\n    primary_property_id\n    listing_photos_count\n    listing_page_path\n    reserve_price\n    is_hot\n    formatted_address(format: DOUBLE_LINE)\n    listing_configuration {\n      product_type\n      is_reserve_displayed\n      broker_commission\n      financing_available\n      buyer_premium_available\n      interior_access_allowed\n      occupancy_status\n      asset_type\n      is_first_look_enabled\n      is_direct_offer_enabled\n      is_third_party_online\n    }\n    attribution_source {\n      origin_code\n    }\n    external_identifiers {\n      data_source\n      external_identifier\n    }\n    venue {\n      venue_type\n    }\n    event {\n      event_code\n      trustee_sale\n    }\n    valuation {\n      seller_current_value_amount\n    }\n    strategy {\n      selling_method_attributes {\n        online_segment_type\n      }\n    }\n    seller_property {\n      street_description\n      municipality\n      country_primary_subdivision\n      country_secondary_subdivision\n      postal_code\n    }\n    program_configuration {\n      program_enrollment_code\n    }\n    primary_property {\n      property_id\n      summary {\n        total_bedrooms\n        total_bathrooms\n        square_footage\n        lot_size\n        year_built\n        valuation\n        structure_type_code\n        structure_type_group\n        address {\n          coordinates {\n            lon\n            lat\n          }\n        }\n      }\n      is_currently_saved @include(if: $hasAuthenticatedUser)\n      is_newly_listed\n      current_user_tracking_state {\n        is_seen\n        is_updated\n      }\n    }\n    auction {\n      start_date\n      end_date\n      starting_bid\n      is_online\n      visible_auction_start_date_time\n      bid_instruction {\n        nos_amount\n      }\n    }\n    parties {\n      party_role\n      party_name\n    }\n    marketing_tags {\n      tag\n    }\n    online_auction_segment(resolvePolicy: CACHE_ONLY) {\n      __typename\n      segment_type\n      reserve_status\n      current_highest_bid {\n        bid_amount\n      }\n    }\n    open_houses {\n      local_date\n      start_time\n      end_time\n    }\n    live_auction_segment(resolvePolicy: CACHE_ONLY) {\n      current_highest_bid {\n        bid_amount\n      }\n      configuration {\n        state_deposit_rule\n      }\n    }\n    listing_summary {\n      is_remote_bid_enabled\n      is_remote_before_and_during_auction_enabled\n      show_opening_bid\n    }\n    external_information(resolvePolicy: CACHE_ONLY) {\n      collateral {\n        summary {\n          estimated\n          low\n          high\n          type\n        }\n      }\n    }\n  }\n  fragment ListingPopupCardFields on Listing {\n    listing_id\n    formatted_address_line_1: formatted_address(format: SINGLE_LINE)\n    listing_summary {\n      is_remote_bid_enabled\n      is_remote_before_and_during_auction_enabled\n      show_opening_bid\n    }\n    listing_status_group\n    listing_page_path\n    primary_photo\n    reserve_price\n\n    listing_configuration {\n      product_type\n      asset_type\n      is_third_party_online\n    }\n\n    event {\n      event_code\n    }\n\n    seller_property {\n      street_description\n      country_secondary_subdivision\n      municipality\n      postal_code\n    }\n\n    program_configuration {\n      program_enrollment_code\n    }\n\n    primary_property {\n      property_id\n      summary {\n        total_bedrooms\n        total_bathrooms\n        square_footage\n        address {\n          coordinates {\n            lat\n            lon\n          }\n        }\n      }\n      is_newly_listed\n      current_user_tracking_state {\n        is_seen\n        is_updated\n      }\n    }\n\n    auction {\n      starting_bid\n      is_online\n      bid_instruction {\n        nos_amount\n      }\n    }\n\n    online_auction_segment(resolvePolicy: CACHE_ONLY) {\n      listing_id\n      __typename\n      start_date\n      segment_type\n      initial_end_date\n      current_time\n      reserve_status\n      configuration {\n        is_match_bidding_enabled\n        is_registration_deposit_required_enabled\n        bid_again_count\n        should_bid_again\n      }\n      starting_bid_amount\n      subject_to_status\n      current_highest_bid {\n        bid_amount\n        type\n      }\n      segment_status\n      current_reserve_amount\n      current_increment_amount\n      bid_count\n      result {\n        winning_bid_amount\n      }\n    }\n\n    live_auction_segment(resolvePolicy: CACHE_ONLY) {\n      current_highest_bid {\n        bid_amount\n      }\n    }\n  }\n"])));
var templateObject_1$e, templateObject_2$a;

var isForeclosure = function isForeclosure(listing) {
  var _a;
  return [enums$1.ProductType.Trustee, enums$1.ProductType.FclMarketing].includes((_a = listing.listing_configuration) === null || _a === void 0 ? void 0 : _a.product_type);
};
var getProductType = function getProductType(listing) {
  return ___default.get(listing, 'listing_configuration.product_type', '');
};
var getAssetType$1 = function getAssetType(listing) {
  return ___default.get(listing, 'listing_configuration.asset_type', '');
};
var getOriginCode = function getOriginCode(listing) {
  return ___default.get(listing, 'attribution_source.origin_code', '');
};
var getSegmentType = function getSegmentType(listing) {
  return ___default.get(listing, 'strategy.selling_method_attributes.online_segment_type', '');
};
var getTrusteeSale = function getTrusteeSale(listing) {
  return ___default.get(listing, 'event.trustee_sale', false);
};
var getVenueType = function getVenueType(listing) {
  return ___default.get(listing, 'venue.venue_type', '');
};
var getPartyMemberByRole = function getPartyMemberByRole(listing, role) {
  var _a;
  return (_a = listing.parties) === null || _a === void 0 ? void 0 : _a.find(function (party) {
    return (party === null || party === void 0 ? void 0 : party.party_role) === role;
  });
};
var hasADCAuctioneer = function hasADCAuctioneer(listing) {
  return ___default.get(listing, 'listing_configuration.trustee_sales_channel') === 'AUCTIONEERING';
};
var isLive = function isLive(listing) {
  return getVenueType(listing) === constants$2.graph.enums.VenueType.LIVE;
};
var isTPS = function isTPS(listing) {
  return getTrusteeSale(listing);
};
var isREO = function isREO(listing) {
  return getAssetType$1(listing) === graph.enums.AssetType.BankOwned;
};
var isTPSLive = function isTPSLive(listing) {
  return isTPS(listing) && isLive(listing);
};
var isTPSOnline = function isTPSOnline(listing) {
  return isTPS(listing) && getVenueType(listing) === constants$2.graph.enums.VenueType.ONLINE && hasADCAuctioneer(listing);
};
var isShortSale = function isShortSale(listing) {
  return getProductType(listing) === constants$2.graph.enums.ProductType.SHORT_SALE;
};
var isPrivateSeller = function isPrivateSeller(listing) {
  return getAssetType$1(listing) === graph.enums.AssetType.PrivateSeller;
};
var isSmartSale = function isSmartSale(listing) {
  return getProductType(listing) === graph.enums.ProductType.PrivateSeller;
};
var isSparkOffer$1 = function isSparkOffer(listing) {
  return isPrivateSeller(listing) && getOriginCode(listing) === graph.enums.AttributionSourceType.SparkOffer;
};
var shouldDisplayListPrice$1 = function shouldDisplayListPrice(listing) {
  return isSparkOffer$1(listing) || isPrivateSeller(listing) && getSegmentType(listing) === graph.enums.OnlineAuctionSegmentType.SealedBid;
};
var isFCLMarketing$2 = function isFCLMarketing(listing) {
  return getProductType(listing) === constants$2.graph.enums.ProductType.FCL_MARKETING;
};
var getBrokerAgent = function getBrokerAgent(listing) {
  return getPartyMemberByRole(listing, constants$2.graph.enums.ListingPartyRole.LISTING_AGENT);
};
var getForeclosureContact = function getForeclosureContact(listing) {
  return getPartyMemberByRole(listing, constants$2.graph.enums.ListingPartyRole.FORECLOSURE_ATTORNEY_CONTACT);
};
var hasMarketingTag = function hasMarketingTag(listing, name) {
  var _a;
  return (_a = listing.marketing_tags) === null || _a === void 0 ? void 0 : _a.find(function (listingTag) {
    return (listingTag === null || listingTag === void 0 ? void 0 : listingTag.tag) === name;
  });
};
var formatMoney = function formatMoney(value, overrides, hideDecimals, defaultValue) {
  if (hideDecimals === void 0) {
    hideDecimals = false;
  }
  if (defaultValue === void 0) {
    defaultValue = '';
  }
  var val = hideDecimals ? value : Number.parseFloat(value);
  if (Number.isFinite(val)) {
    var minimumFractionDigits = Number.isInteger(val) ? 0 : 2;
    return val.toLocaleString('en-US', _assign({
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: minimumFractionDigits
    }, overrides));
  }
  return val || defaultValue;
};

var priorities = [enums$1.GlobalMediaPriorityLevel.Highest, enums$1.GlobalMediaPriorityLevel.High, enums$1.GlobalMediaPriorityLevel.Medium, enums$1.GlobalMediaPriorityLevel.Low, enums$1.GlobalMediaPriorityLevel.Lowest];
var getClosingCompanyData$1 = function getClosingCompanyData(listing) {
  var listingParties = (listing === null || listing === void 0 ? void 0 : listing.parties) || [];
  var wireCompanyContact = listingParties.find(function (elem) {
    return (elem === null || elem === void 0 ? void 0 : elem.party_role) === enums$1.ListingPartyRole.TitleCompanyContact;
  });
  var wireCompany = listingParties.find(function (elem) {
    return (elem === null || elem === void 0 ? void 0 : elem.party_role) === enums$1.ListingPartyRole.TitleCompany;
  });
  var wireAddress = (wireCompany === null || wireCompany === void 0 ? void 0 : wireCompany.party_address) || (wireCompanyContact === null || wireCompanyContact === void 0 ? void 0 : wireCompanyContact.party_address) || {};
  var closingCompany = {
    party_name: (wireCompany === null || wireCompany === void 0 ? void 0 : wireCompany.party_name) || (wireCompanyContact === null || wireCompanyContact === void 0 ? void 0 : wireCompanyContact.party_name) || '',
    party_phone: (wireCompanyContact === null || wireCompanyContact === void 0 ? void 0 : wireCompanyContact.party_phone) || (wireCompany === null || wireCompany === void 0 ? void 0 : wireCompany.party_phone) || '',
    party_email: (wireCompanyContact === null || wireCompanyContact === void 0 ? void 0 : wireCompanyContact.party_email) || (wireCompany === null || wireCompany === void 0 ? void 0 : wireCompany.party_email) || '',
    street_description: wireAddress.street_description || '',
    municipality: wireAddress.municipality || '',
    country_primary_subdivision: wireAddress.country_primary_subdivision || '',
    postal_code: wireAddress.postal_code || ''
  };
  var party_name = closingCompany.party_name,
    street_description = closingCompany.street_description,
    municipality = closingCompany.municipality,
    country_primary_subdivision = closingCompany.country_primary_subdivision,
    postal_code = closingCompany.postal_code,
    party_phone = closingCompany.party_phone,
    party_email = closingCompany.party_email;
  return {
    party_name: party_name,
    address: (street_description ? street_description + ', ' : '') + (municipality ? municipality + ', ' : '') + country_primary_subdivision + ' ' + postal_code,
    party_phone: party_phone,
    party_email: party_email
  };
};
var getMarketingAttributeMessage = function getMarketingAttributeMessage(listing, attributeType) {
  var marketingAttribute = (listing.marketing_attributes || []).find(function (elem) {
    return (elem === null || elem === void 0 ? void 0 : elem.attribute_type) === attributeType;
  });
  if (marketingAttribute && marketingAttribute.__typename === 'ContentMarketingAttribute') {
    return marketingAttribute.message;
  }
  return null;
};
var getPartnershipDetails$1 = function getPartnershipDetails(listing) {
  var _a;
  return ((_a = listing.trustee) === null || _a === void 0 ? void 0 : _a.partnership_details) || getMarketingAttributeMessage(listing, enums$1.MarketingAttributeType.SalesAgentContact);
};
var getPaymentInformation$1 = function getPaymentInformation(listing) {
  return getMarketingAttributeMessage(listing, enums$1.MarketingAttributeType.DepositCheckVerbiage);
};
var getProvisionalSaleDateTime$1 = function getProvisionalSaleDateTime(listing) {
  var _a, _b;
  var auctionStartDateTime = (_a = listing.auction) === null || _a === void 0 ? void 0 : _a.start_date;
  var guessedTimezone = calculateTimeZone();
  return moment$1((_b = listing.auction) === null || _b === void 0 ? void 0 : _b.provisional_sale_date).format('MMM DD') + ', ' + moment$1(auctionStartDateTime).tz(guessedTimezone).format('hh:mm a z');
};
var getSellerDeedTypeLabel$1 = function getSellerDeedTypeLabel(listing) {
  var _a;
  return (((_a = listing.program_configuration) === null || _a === void 0 ? void 0 : _a.deed_types) || []).map(function (deedType) {
    return match(deedType).when(function (deedType) {
      return deedType === enums$1.ListingDeedType.WarrantyDeed;
    }, function () {
      return 'Warranty Deed';
    }).when(function (deedType) {
      return deedType === enums$1.ListingDeedType.SpecialWarrantyDeed;
    }, function () {
      return 'Special Warranty Deed';
    }).when(function (deedType) {
      return deedType === enums$1.ListingDeedType.QuitclaimDeed;
    }, function () {
      return 'Quitclaim Deed';
    }).when(function (deedType) {
      return deedType === enums$1.ListingDeedType.QdAssignmentInterest;
    }, function () {
      return "Quitclaim Deed and Assignment of Interest in Sheriff's Deed";
    }).when(function (deedType) {
      return deedType === enums$1.ListingDeedType.QdAssignmentCert;
    }, function () {
      return "Quitclaim Deed and Assignment of Sheriff's Certificate of Title";
    }).when(function (deedType) {
      return deedType === enums$1.ListingDeedType.TrusteeDeed;
    }, function () {
      return "Trustee's Deed";
    }).when(function (deedType) {
      return deedType === enums$1.ListingDeedType.ReleaseDeed;
    }, function () {
      return 'Release Deed';
    }).otherwise(function () {
      return null;
    });
  }).filter(Boolean).join(' or ');
};
var getTitleInsurancePaidBy$1 = function getTitleInsurancePaidBy(listing) {
  var _a;
  return match((_a = listing.listing_configuration) === null || _a === void 0 ? void 0 : _a.title_insurance).when(function (titleInsurance) {
    return titleInsurance === enums$1.ListingTitleInsurancePolicy.BuyerToPay;
  }, function () {
    return 'Buyer';
  }).when(function (titleInsurance) {
    return titleInsurance === enums$1.ListingTitleInsurancePolicy.SellerToPay;
  }, function () {
    return 'Seller';
  }).when(function (titleInsurance) {
    return titleInsurance === enums$1.ListingTitleInsurancePolicy.NotOffered;
  }, function () {
    return 'Not Available';
  }).when(function (titleInsurance) {
    return titleInsurance === enums$1.ListingTitleInsurancePolicy.ReferToPsa;
  }, function () {
    return 'Refer to Purchase Agreement';
  }).otherwise(function () {
    return 'Unknown';
  });
};
var isAuctionOnline = function isAuctionOnline(listing) {
  var _a;
  return (_a = listing.auction) === null || _a === void 0 ? void 0 : _a.is_online;
};
var isFclOnlineAuction = function isFclOnlineAuction(listing) {
  return isForeclosure(listing) && isAuctionOnline(listing);
};
var isTPSOhio$1 = function isTPSOhio(listing) {
  var _a;
  return Boolean(isFclOnlineAuction(listing) && ((_a = listing.seller_property) === null || _a === void 0 ? void 0 : _a.country_primary_subdivision) === 'OH');
};
var isTPSIllinois = function isTPSIllinois(listing) {
  var _a;
  return Boolean(isFclOnlineAuction(listing) && ((_a = listing.seller_property) === null || _a === void 0 ? void 0 : _a.country_primary_subdivision) === 'IL');
};
var isFCLMarketing$1 = function isFCLMarketing(listing) {
  var _a;
  return ((_a = listing.listing_configuration) === null || _a === void 0 ? void 0 : _a.product_type) === enums$1.ProductType.FclMarketing;
};
var splitEnumArrayByField = function splitEnumArrayByField(original) {
  var res = {};
  var auxDocumentList = __spreadArray([], original, true);
  auxDocumentList.sort(function (a, b) {
    return getDocumentTitle$1(a) < getDocumentTitle$1(b) ? -1 : 1;
  });
  auxDocumentList.forEach(function (originalField) {
    var docType = getDocumentType(originalField);
    if (docType) {
      var resultField = res[docType];
      var resultFieldPriority = resultField && getDocumentPriority(resultField);
      var originalFieldPriority = getDocumentPriority(originalField);
      var isNewPriorityLevelHigher = originalFieldPriority && resultFieldPriority && priorities.indexOf(originalFieldPriority) <= priorities.indexOf(resultFieldPriority);
      if (!resultField || isNewPriorityLevelHigher) {
        res[docType] = originalField;
      }
    }
  });
  return res;
};
var getDocumentTitle$1 = function getDocumentTitle(document) {
  if (document) {
    if (isGlobalMediaType(document)) {
      return document.media_external_title || '';
    }
    return document.document_external_title || '';
  }
  return '';
};
var getDocumentUrl = function getDocumentUrl(document) {
  var _a, _b, _c, _d;
  if (document) {
    if (isGlobalMediaType(document)) {
      return document.media_download_uri || null;
    }
    return ((_b = (_a = document.file_descriptor) === null || _a === void 0 ? void 0 : _a.urls) === null || _b === void 0 ? void 0 : _b.cdn) || ((_d = (_c = document.file_descriptor) === null || _c === void 0 ? void 0 : _c.urls) === null || _d === void 0 ? void 0 : _d.download) || null;
  }
  return null;
};
var getSpecialDocuments$1 = function getSpecialDocuments(documentList, isTPSOhio) {
  if (isTPSOhio === void 0) {
    isTPSOhio = false;
  }
  var documentMapping = splitEnumArrayByField(documentList);
  return {
    titleReport: documentMapping[enums$1.PropertyDocumentPurposeType.PreliminaryTitleReport],
    addendum: documentMapping[enums$1.PropertyDocumentPurposeType.PropertyConditionAddendumAndRelease] || documentMapping[enums$1.GlobalMediaPurpose.PurchaseAgreementAddendum],
    noticeOfSale: documentMapping[enums$1.PropertyDocumentPurposeType.NoticeOfSale],
    propertyInspectionReport: documentMapping[enums$1.PropertyDocumentPurposeType.InspectionReport],
    additionalPropertyInfo: documentMapping[enums$1.PropertyDocumentPurposeType.RedactedBrokerPriceOpinion],
    sampleCertOfSale: documentMapping[enums$1.GlobalMediaPurpose.SampleTrusteeCertOfSale],
    sampleDeed: documentMapping[enums$1.GlobalMediaPurpose.SampleDeed],
    purchaseAgreement: documentMapping[enums$1.GlobalMediaPurpose.PurchaseAgreement],
    termsAndConditions: isTPSOhio ? documentMapping[enums$1.GlobalMediaPurpose.TermsAndConditions] : undefined,
    legalDescription: isTPSOhio ? documentMapping[enums$1.PropertyDocumentPurposeType.LegalDescription] : undefined
  };
};
var formatDocumentsForDisplay$1 = function formatDocumentsForDisplay(documents) {
  return documents.map(function (doc) {
    return {
      label: getDocumentTitle$1(doc),
      url: getDocumentUrl(doc),
      updatedDate: new Date((doc === null || doc === void 0 ? void 0 : doc.updated_date) || ''),
      type: getDocumentType(doc)
    };
  });
};
var getAllDocuments$1 = function getAllDocuments(listing) {
  var documents = listing.documents || [];
  var globalDocuments = listing.applicable_global_documents || [];
  return __spreadArray(__spreadArray([], documents, true), globalDocuments, true);
};
var isGlobalMediaType = function isGlobalMediaType(document) {
  return (document === null || document === void 0 ? void 0 : document.__typename) === 'GlobalMedia';
};
var getDocumentType = function getDocumentType(document) {
  var _a;
  if (document) {
    if (isGlobalMediaType(document)) {
      return document.media_purpose_type_code || '';
    }
    return ((_a = document.metadata) === null || _a === void 0 ? void 0 : _a.document_purpose_type_code) || '';
  }
  return '';
};
var getDocumentPriority = function getDocumentPriority(document) {
  return isGlobalMediaType(document) ? document.priority_level_type_code : null;
};
var getPDPTargetingContext = function getPDPTargetingContext(listing) {
  var _a;
  return {
    kind: 'blueprint-listing-usePage',
    key: listing.listing_id,
    listing_status: listing.listing_status,
    asset_type: (_a = listing.listing_configuration) === null || _a === void 0 ? void 0 : _a.asset_type
  };
};

var listingUtils$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  formatDocumentsForDisplay: formatDocumentsForDisplay$1,
  getAllDocuments: getAllDocuments$1,
  getClosingCompanyData: getClosingCompanyData$1,
  getDocumentTitle: getDocumentTitle$1,
  getDocumentType: getDocumentType,
  getDocumentUrl: getDocumentUrl,
  getMarketingAttributeMessage: getMarketingAttributeMessage,
  getPDPTargetingContext: getPDPTargetingContext,
  getPartnershipDetails: getPartnershipDetails$1,
  getPaymentInformation: getPaymentInformation$1,
  getProvisionalSaleDateTime: getProvisionalSaleDateTime$1,
  getSellerDeedTypeLabel: getSellerDeedTypeLabel$1,
  getSpecialDocuments: getSpecialDocuments$1,
  getTitleInsurancePaidBy: getTitleInsurancePaidBy$1,
  isAuctionOnline: isAuctionOnline,
  isFCLMarketing: isFCLMarketing$1,
  isFclOnlineAuction: isFclOnlineAuction,
  isGlobalMediaType: isGlobalMediaType,
  isTPSIllinois: isTPSIllinois,
  isTPSOhio: isTPSOhio$1,
  splitEnumArrayByField: splitEnumArrayByField
});

var formatEnum = function formatEnum(enumVal) {
  return (enumVal || '').split('_').map(___default.capitalize).join(' ');
};
var BASE_COLORS = {
  BLUE: '#036EB5',
  GREEN: '#509B13',
  PURPLE: '#a639bc',
  GRAY: '#868b8e'
};
var FADED_LABEL_BASE = '#5c676e';
var labelSettings = [-5, 0];
var fadedSettings = [30, 60];
var fadedLabelSettings = [6, 0];
var lightenAndDesaturateHexColor = function lightenAndDesaturateHexColor(hexColor, lightenAmount, desaturationAmount) {
  var color = tinycolor(hexColor);
  var lightenedColor = color.lighten(lightenAmount);
  var desaturatedLightenedColor = lightenedColor.desaturate(desaturationAmount);
  return desaturatedLightenedColor.toHexString();
};
var getColorVariations = function getColorVariations(baseColor) {
  var colorDark = lightenAndDesaturateHexColor.apply(void 0, __spreadArray([baseColor], labelSettings, false));
  return {
    color: baseColor,
    colorDark: colorDark,
    colorFaded: lightenAndDesaturateHexColor.apply(void 0, __spreadArray([baseColor], fadedSettings, false)),
    colorDarkFaded: lightenAndDesaturateHexColor.apply(void 0, __spreadArray([FADED_LABEL_BASE], fadedLabelSettings, false))
  };
};
var PRODUCT_TYPE_LABELS = ___default.mapValues(___default.mapKeys(enums$1.ProductType, function (value) {
  return value;
}), function (value) {
  if (value.includes('REO')) return 'Bank Owned';
  if (value === 'TRUSTEE' || value === 'FCL_MARKETING') return 'Foreclosure Sale';
  if (value === 'SHORT_SALE') return 'Short Sale';
  if (value.includes('PRIVATE_SELLER')) return 'Private Seller';
  return formatEnum(value);
});
var getProductTypeColors = function getProductTypeColors(assetType) {
  return match(assetType).when(function (assetType) {
    return assetType === enums$1.AssetType.BankOwned;
  }, function () {
    return getColorVariations(BASE_COLORS.BLUE);
  }).when(function (assetType) {
    return assetType === enums$1.AssetType.Foreclosure;
  }, function () {
    return getColorVariations(BASE_COLORS.GREEN);
  }).when(function (assetType) {
    return assetType === enums$1.AssetType.ShortSale;
  }, function () {
    return getColorVariations(BASE_COLORS.PURPLE);
  }).when(function (assetType) {
    return assetType === enums$1.AssetType.PrivateSeller;
  }, function () {
    return getColorVariations(BASE_COLORS.PURPLE);
  }).otherwise(function () {
    return getColorVariations(BASE_COLORS.GRAY);
  });
};
var getDisplayIndicator = function getDisplayIndicator(listing) {
  var _a, _b;
  var assetType = ((_a = listing.listing_configuration) === null || _a === void 0 ? void 0 : _a.asset_type) || null;
  var productType = (_b = listing.listing_configuration) === null || _b === void 0 ? void 0 : _b.product_type;
  var label = productType ? PRODUCT_TYPE_LABELS[productType] : undefined;
  var colorVariations = getProductTypeColors(assetType);
  return _assign({
    label: label,
    description: getProductTypeDescription(listing)
  }, colorVariations);
};
var CUSTOM_PRODUCT_TYPES = {
  BANK: 'bank',
  TPS_ONLINE: 'tps-online',
  TPS_LIVE: 'tps-live'
};
var getProductTypeDescription = function getProductTypeDescription(listing) {
  var _a, _b, _c;
  var isOnlineEvent = isFclOnlineAuction(listing);
  var productType = (_a = listing.listing_configuration) === null || _a === void 0 ? void 0 : _a.product_type;
  var isThirdPartyOnline = (_b = listing.listing_configuration) === null || _b === void 0 ? void 0 : _b.is_third_party_online;
  var descriptionPropertyType;
  if ((_c = listing.event) === null || _c === void 0 ? void 0 : _c.trustee_sale) {
    descriptionPropertyType = isOnlineEvent || isThirdPartyOnline ? CUSTOM_PRODUCT_TYPES.TPS_ONLINE : CUSTOM_PRODUCT_TYPES.TPS_LIVE;
  } else {
    descriptionPropertyType = productType && [enums$1.ProductType.Rentals, enums$1.ProductType.ShortSale, enums$1.ProductType.PrivateSellerInstitutional, enums$1.ProductType.PrivateSellerIndividual, enums$1.ProductType.PrivateSeller].includes(productType) ? productType : CUSTOM_PRODUCT_TYPES.BANK;
  }
  return match(descriptionPropertyType).when(function (descriptionPropertyType) {
    return descriptionPropertyType === enums$1.ProductType.ShortSale;
  }, function () {
    return ['A Lender-assisted sale when a borrower may be behind on their mortgage payments or owe more than the property is worth. Lender approval may be required.'];
  }).when(function (descriptionPropertyType) {
    return descriptionPropertyType.includes(enums$1.ProductType.PrivateSeller);
  }, function () {
    return ['This property is owned by a private seller.'];
  }).when(function (descriptionPropertyType) {
    return descriptionPropertyType === enums$1.ProductType.Rentals;
  }, function () {
    return ['Rentals are tenant-occupied properties with a lease in place.', 'This is a unique investment opportunity that could provide cash flow from day 1 after closing.'];
  }).when(function (descriptionPropertyType) {
    return descriptionPropertyType === CUSTOM_PRODUCT_TYPES.TPS_ONLINE;
  }, function () {
    return ['Foreclosures occur when a lender attempts to sell a property to recover the balance of the loan.', 'Foreclosure properties are generally sold at in-person public auctions, but this foreclosure sale is allowed to be conducted online.'];
  }).when(function (descriptionPropertyType) {
    return descriptionPropertyType === CUSTOM_PRODUCT_TYPES.BANK;
  }, function () {
    return ['Bank-owned properties are typically sold through online auctions. These properties are owned by the lending institution.'];
  }).when(function (descriptionPropertyType) {
    return descriptionPropertyType === CUSTOM_PRODUCT_TYPES.TPS_LIVE;
  }, function () {
    return ['These properties are generally sold at in-person public auctions.', 'Foreclosures occur when a lender attempts to sell a property to recover the balance of the loan.'];
  }).otherwise(function () {
    return [];
  });
};

var BadgePriority;
(function (BadgePriority) {
  BadgePriority[BadgePriority["FIRST"] = 1] = "FIRST";
  BadgePriority[BadgePriority["SECOND"] = 2] = "SECOND";
  BadgePriority[BadgePriority["THIRD"] = 3] = "THIRD";
  BadgePriority[BadgePriority["FOURTH"] = 4] = "FOURTH";
  BadgePriority[BadgePriority["FIFTH"] = 5] = "FIFTH";
  BadgePriority[BadgePriority["SIXTH"] = 6] = "SIXTH";
  BadgePriority[BadgePriority["SEVENTH"] = 7] = "SEVENTH";
  BadgePriority[BadgePriority["EIGHTH"] = 8] = "EIGHTH";
  BadgePriority[BadgePriority["NINTH"] = 9] = "NINTH";
})(BadgePriority || (BadgePriority = {}));
var BadgeMode;
(function (BadgeMode) {
  BadgeMode["EXPANDED"] = "expanded";
  BadgeMode["CONDENSED"] = "condensed";
})(BadgeMode || (BadgeMode = {}));
var MarketingTags;
(function (MarketingTags) {
  MarketingTags["GOTO"] = "GOTO";
  MarketingTags["PRCD"] = "PRCD";
  MarketingTags["NEWV"] = "NEWV";
})(MarketingTags || (MarketingTags = {}));

var types$3 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get BadgeMode () { return BadgeMode; },
  get BadgePriority () { return BadgePriority; },
  get MarketingTags () { return MarketingTags; }
});

var ListingBadge = function () {
  function ListingBadge(listing, segment) {
    this.listing = listing;
    this.segment = segment;
  }
  Object.defineProperty(ListingBadge.prototype, "content", {
    get: function get() {
      return '';
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ListingBadge.prototype, "title", {
    get: function get() {
      return null;
    },
    enumerable: false,
    configurable: true
  });
  ListingBadge.prototype.getShouldBeIncluded = function (props) {
    var _a;
    var constructedBadge = this.constructor;
    return ((_a = constructedBadge.shouldBeIncluded) === null || _a === void 0 ? void 0 : _a.call(constructedBadge, props)) || false;
  };
  ListingBadge.prototype.getOverrideProps = function (listing) {
    var _a;
    var constructedBadge = this.constructor;
    return (_a = constructedBadge.overrideProps) === null || _a === void 0 ? void 0 : _a.call(constructedBadge, listing);
  };
  ListingBadge.prototype.get = function (name) {
    return this.constructor[name];
  };
  ListingBadge.renderPriority = BadgePriority.FOURTH;
  ListingBadge.titleIcon = 'check';
  ListingBadge.title = '';
  ListingBadge.textIcon = 'check';
  ListingBadge.summary = 'Yes';
  ListingBadge.contentPositive = true;
  ListingBadge.shouldBeHoisted = false;
  ListingBadge.content = '';
  ListingBadge.tooltipContent = '';
  ListingBadge.color = undefined;
  ListingBadge.overrideProps = function (_) {
    return {};
  };
  ListingBadge.shouldBeIncluded = function (_props) {
    return false;
  };
  ListingBadge.condensedTitleIcon = '';
  ListingBadge.condensedTitle = '';
  return ListingBadge;
}();

var ShortSaleBadge = function (_super) {
  __extends(ShortSaleBadge, _super);
  function ShortSaleBadge() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  ShortSaleBadge.shouldBeIncluded = function (_a) {
    var listing = _a.listing,
      opts = _a.opts;
    return (opts === null || opts === void 0 ? void 0 : opts.badgeMode) === BadgeMode.EXPANDED && isShortSale(listing);
  };
  ShortSaleBadge.id = 'ShortSaleBadge';
  ShortSaleBadge.title = 'Short Sale';
  ShortSaleBadge.titleIcon = 'sign';
  ShortSaleBadge.content = "This property is part of Auction.com's Short Sale program. Learn more";
  return ShortSaleBadge;
}(ListingBadge);
var ShortSaleOpenHousesAvailableBadge = function (_super) {
  __extends(ShortSaleOpenHousesAvailableBadge, _super);
  function ShortSaleOpenHousesAvailableBadge() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  ShortSaleOpenHousesAvailableBadge.shouldBeIncluded = function (_a) {
    var listing = _a.listing,
      opts = _a.opts;
    if ((opts === null || opts === void 0 ? void 0 : opts.badgeMode) === BadgeMode.CONDENSED) return false;
    var brokerAgent = getBrokerAgent(listing);
    return ___default.get(listing, 'listing_configuration.interior_access_allowed', true) && ___default.isPlainObject(brokerAgent) && isShortSale(listing);
  };
  ShortSaleOpenHousesAvailableBadge.id = 'ShortSaleOpenHousesAvailableBadge';
  ShortSaleOpenHousesAvailableBadge.summary = 'Open Houses Scheduled';
  ShortSaleOpenHousesAvailableBadge.titleIcon = 'unlock-alt';
  ShortSaleOpenHousesAvailableBadge.shouldBeHoisted = true;
  ShortSaleOpenHousesAvailableBadge.content = 'For dates and times or to schedule a private showing contact the listing agent';
  return ShortSaleOpenHousesAvailableBadge;
}(ShortSaleBadge);

var RentalBadge = function (_super) {
  __extends(RentalBadge, _super);
  function RentalBadge() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  RentalBadge.shouldBeIncluded = function (_a) {
    var listing = _a.listing,
      opts = _a.opts;
    return (opts === null || opts === void 0 ? void 0 : opts.badgeMode) === BadgeMode.EXPANDED && getProductType(listing) === constants$2.graph.enums.ProductType.RENTALS && isREO(listing);
  };
  RentalBadge.id = 'RentalBadge';
  RentalBadge.title = 'Income Producing';
  RentalBadge.summary = 'Yes';
  RentalBadge.titleIcon = 'hands-usd';
  RentalBadge.importantInfoRenderPriority = BadgePriority.NINTH;
  return RentalBadge;
}(ListingBadge);

var FirstLookBadge = function (_super) {
  __extends(FirstLookBadge, _super);
  function FirstLookBadge() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  FirstLookBadge.shouldBeIncluded = function (_a) {
    var listing = _a.listing,
      opts = _a.opts;
    if ((opts === null || opts === void 0 ? void 0 : opts.badgeMode) === BadgeMode.CONDENSED) return false;
    var isFirstLookEnabled = ___default.get(listing, 'listing_configuration.is_first_look_enabled', '');
    return Boolean(isFirstLookEnabled);
  };
  Object.defineProperty(FirstLookBadge.prototype, "content", {
    get: function get() {
      var _a;
      var formattedFirstLookDate = moment((_a = this.listing.listing_configuration) === null || _a === void 0 ? void 0 : _a.first_look_end_date).format('MM/DD/YYYY');
      return "Sold only to buyers who intend to live in the property or Approved Entities, until ".concat(formattedFirstLookDate);
    },
    enumerable: false,
    configurable: true
  });
  FirstLookBadge.title = 'First Look Program';
  FirstLookBadge.titleIcon = 'door-open';
  FirstLookBadge.textIcon = 'check';
  FirstLookBadge.renderPriority = BadgePriority.FOURTH;
  return FirstLookBadge;
}(ListingBadge);

var BrokerCoopAvailableBadge = function (_super) {
  __extends(BrokerCoopAvailableBadge, _super);
  function BrokerCoopAvailableBadge() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  BrokerCoopAvailableBadge.shouldBeIncluded = function (_a) {
    var _b;
    var listing = _a.listing;
    return Boolean(((_b = listing.listing_configuration) === null || _b === void 0 ? void 0 : _b.broker_commission_message) && isREO(listing)) && !isPrivateSeller(listing);
  };
  BrokerCoopAvailableBadge.prototype.dynamicContent = function () {
    var _a;
    return "".concat((_a = this.listing.listing_configuration) === null || _a === void 0 ? void 0 : _a.broker_commission_message, " commission is available.");
  };
  BrokerCoopAvailableBadge.title = 'Broker Co-op';
  BrokerCoopAvailableBadge.titleIcon = 'handshake';
  BrokerCoopAvailableBadge.condensedTitle = 'Broker Commission Available';
  BrokerCoopAvailableBadge.renderPriority = BadgePriority.SIXTH;
  BrokerCoopAvailableBadge.contentPositive = true;
  BrokerCoopAvailableBadge.summary = 'Available';
  return BrokerCoopAvailableBadge;
}(ListingBadge);
var BrokerCoopUnavailableBadge = function (_super) {
  __extends(BrokerCoopUnavailableBadge, _super);
  function BrokerCoopUnavailableBadge() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  BrokerCoopUnavailableBadge.shouldBeIncluded = function (_a) {
    var listing = _a.listing,
      opts = _a.opts;
    return (opts === null || opts === void 0 ? void 0 : opts.badgeMode) === BadgeMode.EXPANDED && !BrokerCoopAvailableBadge.shouldBeIncluded({
      listing: listing
    }) && !isPrivateSeller(listing);
  };
  BrokerCoopUnavailableBadge.title = 'Broker Co-op';
  BrokerCoopUnavailableBadge.id = 'BrokerCoopUnavailableBadge';
  BrokerCoopUnavailableBadge.titleIcon = 'handshake';
  BrokerCoopUnavailableBadge.textIcon = 'times';
  BrokerCoopUnavailableBadge.renderPriority = BadgePriority.SIXTH;
  BrokerCoopUnavailableBadge.contentPositive = false;
  BrokerCoopUnavailableBadge.summary = 'Not Offered';
  BrokerCoopUnavailableBadge.content = 'No Broker/Agent commission on this property. Learn more about Broker Co-op.';
  return BrokerCoopUnavailableBadge;
}(ListingBadge);

var occupancyStatus = function occupancyStatus(listing) {
  return ___default.get(listing, 'listing_configuration.occupancy_status', '');
};
var PropertyOccupiedBadge = function (_super) {
  __extends(PropertyOccupiedBadge, _super);
  function PropertyOccupiedBadge() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  PropertyOccupiedBadge.shouldBeIncluded = function (_a) {
    var listing = _a.listing,
      opts = _a.opts;
    return (opts === null || opts === void 0 ? void 0 : opts.badgeMode) === BadgeMode.EXPANDED && occupancyStatus(listing) === graph$1.enums.OccupancyStatus.OCCUPIED;
  };
  PropertyOccupiedBadge.id = 'PropertyOccupiedBadge';
  PropertyOccupiedBadge.title = 'Occupancy';
  PropertyOccupiedBadge.titleIcon = 'users';
  PropertyOccupiedBadge.textIcon = 'times';
  PropertyOccupiedBadge.summary = 'Occupied';
  PropertyOccupiedBadge.renderPriority = BadgePriority.SECOND;
  PropertyOccupiedBadge.importantInfoRenderPriority = BadgePriority.FIRST;
  PropertyOccupiedBadge.contentPositive = false;
  PropertyOccupiedBadge.shouldBeHoisted = true;
  return PropertyOccupiedBadge;
}(ListingBadge);
var PropertyUnknownOccupancyBadge = function (_super) {
  __extends(PropertyUnknownOccupancyBadge, _super);
  function PropertyUnknownOccupancyBadge() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  PropertyUnknownOccupancyBadge.shouldBeIncluded = function (_a) {
    var listing = _a.listing,
      opts = _a.opts;
    var isUnknown = occupancyStatus(listing) === graph$1.enums.OccupancyStatus.UNKNOWN || ___default.isNil(occupancyStatus(listing));
    return (opts === null || opts === void 0 ? void 0 : opts.badgeMode) === BadgeMode.EXPANDED && isUnknown;
  };
  PropertyUnknownOccupancyBadge.id = 'PropertyUnknownOccupancyBadge';
  PropertyUnknownOccupancyBadge.summary = 'Occupancy Unknown';
  return PropertyUnknownOccupancyBadge;
}(PropertyOccupiedBadge);
var PropertyVacantBadge = function (_super) {
  __extends(PropertyVacantBadge, _super);
  function PropertyVacantBadge() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  PropertyVacantBadge.shouldBeIncluded = function (_a) {
    var listing = _a.listing;
    return occupancyStatus(listing) === graph$1.enums.OccupancyStatus.VACANT;
  };
  Object.defineProperty(PropertyVacantBadge.prototype, "content", {
    get: function get() {
      return isREO(this.listing) ? 'Although the property is vacant, do not enter unless interior access is available and you receive permission from the owner or agent.' : 'Although the property is believed to be vacant, do not enter premises. Trespassing is a crime.';
    },
    enumerable: false,
    configurable: true
  });
  PropertyVacantBadge.title = 'Occupancy';
  PropertyVacantBadge.id = 'PropertyVacantBadge';
  PropertyVacantBadge.titleIcon = 'users';
  PropertyVacantBadge.textIcon = 'check';
  PropertyVacantBadge.summary = 'Vacant';
  PropertyVacantBadge.condensedTitle = 'Vacant';
  PropertyVacantBadge.condensedTitleIcon = 'sign';
  PropertyVacantBadge.renderPriority = BadgePriority.SECOND;
  PropertyVacantBadge.importantInfoRenderPriority = BadgePriority.FIRST;
  PropertyVacantBadge.contentPositive = true;
  PropertyVacantBadge.shouldBeHoisted = true;
  return PropertyVacantBadge;
}(PropertyOccupiedBadge);

var buyersPremiumAvailableValueReceived = function buyersPremiumAvailableValueReceived(listing) {
  return Object.prototype.hasOwnProperty.call(listing.listing_configuration || {}, 'is_buyers_premium_available') || Object.prototype.hasOwnProperty.call(listing.listing_configuration || {}, 'buyer_premium_available');
};
var isBuyersPremiumAvailable = function isBuyersPremiumAvailable(listing) {
  var _a, _b;
  return ((_a = listing.listing_configuration) === null || _a === void 0 ? void 0 : _a.buyer_premium_available) || ((_b = listing.listing_configuration) === null || _b === void 0 ? void 0 : _b.is_buyers_premium_available);
};
var premiumMinimumAmount$1 = function premiumMinimumAmount(listing) {
  var _a;
  return ((_a = listing.program_configuration) === null || _a === void 0 ? void 0 : _a.buyers_premium_minimum_amount) || 0;
};
var premiumPrimaryAmount$1 = function premiumPrimaryAmount(listing) {
  var _a;
  return ((_a = listing.program_configuration) === null || _a === void 0 ? void 0 : _a.buyers_premium_primary_amount) || 0;
};
var hasPremiumStrategySet = function hasPremiumStrategySet(listing) {
  return premiumMinimumAmount$1(listing) > 0 || premiumPrimaryAmount$1(listing) > 0;
};
var hasZeroBuyersPremiumState = function hasZeroBuyersPremiumState(listing) {
  return premiumMinimumAmount$1(listing) === 0 && premiumPrimaryAmount$1(listing) === 0;
};
var interpolateString = function interpolateString(template, input) {
  var newTemplate = template || '%s';
  var newInput = input.slice();
  return newTemplate.replace(/%s/g, function () {
    return String(newInput.shift());
  });
};
var BUYERS_PREMIUM_EXPLANATIONS$1 = {
  MESSAGE: 'Winner will be charged a fee for this property. %s',
  FIXED_AMOUNT: '%s regardless of Winning Bid Amount.',
  PERCENTAGE_WITH_GUARANTEED_MINIMUM: '%s% of Winning Bid Amount (A minimum of %s will apply)'
};
var BuyerPremiumAvailableBadge = function (_super) {
  __extends(BuyerPremiumAvailableBadge, _super);
  function BuyerPremiumAvailableBadge() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  BuyerPremiumAvailableBadge.shouldBeIncluded = function (_a) {
    var _b;
    var listing = _a.listing,
      opts = _a.opts;
    return Boolean((opts === null || opts === void 0 ? void 0 : opts.badgeMode) === BadgeMode.EXPANDED && isBuyersPremiumAvailable(listing) && hasPremiumStrategySet(listing) && (isTPSOnline(listing) || isREO(listing) || isPrivateSeller(listing) && ((_b = listing.listing_configuration) === null || _b === void 0 ? void 0 : _b.buyers_premium_paid_by) === graph$1.enums.ListingPaidBy.BUYER));
  };
  Object.defineProperty(BuyerPremiumAvailableBadge.prototype, "content", {
    get: function get() {
      var _a = this.listing.program_configuration || {},
        buyers_premium_commission_type = _a.buyers_premium_commission_type,
        buyers_premium_minimum_amount = _a.buyers_premium_minimum_amount,
        buyers_premium_primary_amount = _a.buyers_premium_primary_amount;
      var suffix = '';
      if (buyers_premium_commission_type === graph$1.enums.CommissionStrategyType.DOLLAR) {
        suffix = interpolateString(BUYERS_PREMIUM_EXPLANATIONS$1.FIXED_AMOUNT, [formatMoney(String(buyers_premium_primary_amount))]);
      } else if (buyers_premium_commission_type === graph$1.enums.CommissionStrategyType.PERCENTAGE) {
        suffix = interpolateString(BUYERS_PREMIUM_EXPLANATIONS$1.PERCENTAGE_WITH_GUARANTEED_MINIMUM, [String(buyers_premium_primary_amount), formatMoney(String(buyers_premium_minimum_amount))]);
      }
      return interpolateString(BUYERS_PREMIUM_EXPLANATIONS$1.MESSAGE, [suffix]);
    },
    enumerable: false,
    configurable: true
  });
  BuyerPremiumAvailableBadge.id = 'BuyerPremiumAvailableBadge';
  BuyerPremiumAvailableBadge.title = "Buyer's Premium";
  BuyerPremiumAvailableBadge.titleIcon = 'dollar-sign';
  BuyerPremiumAvailableBadge.textIcon = 'times';
  BuyerPremiumAvailableBadge.contentPositive = false;
  BuyerPremiumAvailableBadge.overrideProps = function (listing) {
    var buyersPremiumMinAmount = premiumMinimumAmount$1(listing);
    var buyersPremiumAmount = premiumPrimaryAmount$1(listing);
    var type = ___default.get(listing.program_configuration, 'buyers_premium_commission_type');
    var calculatedSummary = [type === graph$1.enums.CommissionStrategyType.PERCENTAGE && buyersPremiumAmount ? "".concat(buyersPremiumAmount, "%") : '', buyersPremiumMinAmount ? formatMoney(String(buyersPremiumMinAmount)) : ''].filter(Boolean).join(' or ');
    return {
      summary: calculatedSummary || 'Applicable'
    };
  };
  return BuyerPremiumAvailableBadge;
}(ListingBadge);
var BuyerPremiumUnavailableBadge = function (_super) {
  __extends(BuyerPremiumUnavailableBadge, _super);
  function BuyerPremiumUnavailableBadge() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  BuyerPremiumUnavailableBadge.shouldBeIncluded = function (_a) {
    var listing = _a.listing;
    return (isTPSOnline(listing) || isREO(listing)) && (buyersPremiumAvailableValueReceived(listing) && !isBuyersPremiumAvailable(listing) || isBuyersPremiumAvailable(listing) && hasZeroBuyersPremiumState(listing));
  };
  BuyerPremiumUnavailableBadge.title = "Buyer's Premium";
  BuyerPremiumUnavailableBadge.titleIcon = 'dollar-sign';
  BuyerPremiumUnavailableBadge.condensedTitle = "No Buyer's Premium";
  BuyerPremiumUnavailableBadge.renderPriority = BadgePriority.FOURTH;
  BuyerPremiumUnavailableBadge.condensedTitleIcon = 'ban';
  BuyerPremiumUnavailableBadge.contentPositive = false;
  BuyerPremiumUnavailableBadge.summary = 'Not Applicable';
  BuyerPremiumUnavailableBadge.content = "Winner will not be charged a Buyer's Premium for this property.";
  BuyerPremiumUnavailableBadge.overrideProps = function (listing) {
    var contentPositive = Boolean(isBuyersPremiumAvailable(listing) && hasZeroBuyersPremiumState(listing));
    var calculatedSummary = '';
    if (!isBuyersPremiumAvailable(listing)) {
      calculatedSummary = '';
    } else {
      var amount = premiumMinimumAmount$1(listing);
      calculatedSummary = ___default.isFinite(amount) ? String(formatMoney(String(amount))) : '';
    }
    return {
      contentPositive: contentPositive,
      calculatedSummary: calculatedSummary
    };
  };
  return BuyerPremiumUnavailableBadge;
}(ListingBadge);

var CashOnlyBadge = function (_super) {
  __extends(CashOnlyBadge, _super);
  function CashOnlyBadge() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  CashOnlyBadge.shouldBeIncluded = function (_a) {
    var listing = _a.listing,
      opts = _a.opts;
    return (opts === null || opts === void 0 ? void 0 : opts.badgeMode) === BadgeMode.EXPANDED && !___default.get(listing, 'listing_configuration.financing_available', false) && !isPrivateSeller(listing);
  };
  Object.defineProperty(CashOnlyBadge.prototype, "content", {
    get: function get() {
      var _a;
      var trustee = ((_a = this.listing.event) === null || _a === void 0 ? void 0 : _a.trustee_sale) || false;
      return "Conventional financing is NOT accepted for this property. ".concat(trustee ? 'What should I bring?' : 'Learn more');
    },
    enumerable: false,
    configurable: true
  });
  CashOnlyBadge.title = 'Cash Only';
  CashOnlyBadge.id = 'CashOnlyBadge';
  CashOnlyBadge.titleIcon = 'money-bill';
  CashOnlyBadge.contentPositive = false;
  return CashOnlyBadge;
}(ListingBadge);
var FinancingAvailableBadge = function (_super) {
  __extends(FinancingAvailableBadge, _super);
  function FinancingAvailableBadge() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  FinancingAvailableBadge.shouldBeIncluded = function (_a) {
    var listing = _a.listing;
    return ___default.get(listing, 'listing_configuration.financing_available', false) && !isPrivateSeller(listing);
  };
  FinancingAvailableBadge.summary = 'Eligible for Financing';
  FinancingAvailableBadge.titleIcon = 'money-bill';
  FinancingAvailableBadge.condensedTitle = 'Financing Available';
  FinancingAvailableBadge.renderPriority = BadgePriority.FIFTH;
  FinancingAvailableBadge.shouldBeHoisted = true;
  FinancingAvailableBadge.content = 'Buyers are responsible for determining financing eligibility prior to bidding. Learn More';
  return FinancingAvailableBadge;
}(ListingBadge);

var OpenHouseScheduledBadge = function (_super) {
  __extends(OpenHouseScheduledBadge, _super);
  function OpenHouseScheduledBadge() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  OpenHouseScheduledBadge.shouldBeIncluded = function (_a) {
    var _b;
    var listing = _a.listing,
      opts = _a.opts;
    if ((opts === null || opts === void 0 ? void 0 : opts.badgeMode) === BadgeMode.CONDENSED) return false;
    var openHouseSchedules = listing.open_houses || [];
    return Boolean(Boolean(openHouseSchedules.length) && ((_b = openHouseSchedules[0]) === null || _b === void 0 ? void 0 : _b.date) && isREO(listing));
  };
  OpenHouseScheduledBadge.id = 'OpenHouseScheduledBadge';
  OpenHouseScheduledBadge.title = 'Open House';
  OpenHouseScheduledBadge.titleIcon = 'sign-in-alt';
  return OpenHouseScheduledBadge;
}(ListingBadge);
var getMostRecentOpenHouse = function getMostRecentOpenHouse(listing) {
  var openHouseList = listing.open_houses || [];
  var now = new Date();
  var activeOpenHousePeriods = openHouseList.filter(function (openHouse) {
    if (!openHouse || typeof openHouse.local_date !== 'string' || typeof openHouse.start_time !== 'string') {
      return false;
    }
    var dateStr = "".concat(openHouse.local_date, "T").concat(openHouse.start_time);
    var dateObj = new Date(dateStr);
    return !isNaN(dateObj.getTime()) && dateObj >= now;
  }).sort(function (a, b) {
    var aDate = new Date("".concat(a.local_date, "T").concat(a.start_time));
    var bDate = new Date("".concat(b.local_date, "T").concat(b.start_time));
    return aDate - bDate;
  });
  return activeOpenHousePeriods.length ? activeOpenHousePeriods[0] : null;
};
var NextOpenHouseBadge = function (_super) {
  __extends(NextOpenHouseBadge, _super);
  function NextOpenHouseBadge() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(NextOpenHouseBadge.prototype, "title", {
    get: function get() {
      var mostRecentOpenHouse = getMostRecentOpenHouse(this.listing);
      if (!(mostRecentOpenHouse === null || mostRecentOpenHouse === void 0 ? void 0 : mostRecentOpenHouse.local_date)) return '';
      var openHouseDate = new Date("".concat(mostRecentOpenHouse.local_date, " ").concat(mostRecentOpenHouse.end_time));
      return "Open ".concat(openHouseDate.getMonth() + 1, "/").concat(openHouseDate.getDate());
    },
    enumerable: false,
    configurable: true
  });
  NextOpenHouseBadge.shouldBeIncluded = function (_a) {
    var _b;
    var listing = _a.listing;
    return Boolean((_b = getMostRecentOpenHouse(listing)) === null || _b === void 0 ? void 0 : _b.local_date);
  };
  NextOpenHouseBadge.renderPriority = BadgePriority.FIRST;
  return NextOpenHouseBadge;
}(ListingBadge);

var InteriorAccessAvailableBadge = function (_super) {
  __extends(InteriorAccessAvailableBadge, _super);
  function InteriorAccessAvailableBadge() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  InteriorAccessAvailableBadge.shouldBeIncluded = function (_a) {
    var _b;
    var listing = _a.listing;
    var brokerAgent = getBrokerAgent(listing);
    return ___default.get(listing, 'listing_configuration.interior_access_allowed', false) && ___default.isPlainObject(brokerAgent) && (isREO(listing) || isShortSale(listing)) && !Boolean((_b = getMostRecentOpenHouse(listing)) === null || _b === void 0 ? void 0 : _b.local_date);
  };
  Object.defineProperty(InteriorAccessAvailableBadge.prototype, "content", {
    get: function get() {
      var brokerAgent = getBrokerAgent(this.listing) || {};
      return "Access is available through the listing agent ".concat(brokerAgent.party_name, " Contact Agent");
    },
    enumerable: false,
    configurable: true
  });
  InteriorAccessAvailableBadge.id = 'InteriorAccessAvailableBadge';
  InteriorAccessAvailableBadge.title = 'Interior Access';
  InteriorAccessAvailableBadge.titleIcon = 'unlock-alt';
  InteriorAccessAvailableBadge.condensedTitleIcon = 'door-open';
  InteriorAccessAvailableBadge.renderPriority = BadgePriority.THIRD;
  return InteriorAccessAvailableBadge;
}(ListingBadge);
var InteriorAccessAvailableNoAgentBadge = function (_super) {
  __extends(InteriorAccessAvailableNoAgentBadge, _super);
  function InteriorAccessAvailableNoAgentBadge() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  InteriorAccessAvailableNoAgentBadge.shouldBeIncluded = function (_a) {
    var _b;
    var listing = _a.listing;
    var brokerAgent = getBrokerAgent(listing);
    return ___default.get(listing, 'listing_configuration.interior_access_allowed', false) && !brokerAgent && (isREO(listing) || isShortSale(listing)) && !Boolean((_b = getMostRecentOpenHouse(listing)) === null || _b === void 0 ? void 0 : _b.local_date);
  };
  InteriorAccessAvailableNoAgentBadge.id = 'InteriorAccessAvailableNoAgentBadge';
  InteriorAccessAvailableNoAgentBadge.title = 'Interior Access';
  InteriorAccessAvailableNoAgentBadge.titleIcon = 'unlock-alt';
  InteriorAccessAvailableNoAgentBadge.condensedTitleIcon = 'door-open';
  InteriorAccessAvailableNoAgentBadge.renderPriority = BadgePriority.THIRD;
  InteriorAccessAvailableNoAgentBadge.content = 'Licensed agents only, please contact {{interiorAccessNumber}} for details.';
  return InteriorAccessAvailableNoAgentBadge;
}(ListingBadge);
var InteriorAccessUnavailableBadge = function (_super) {
  __extends(InteriorAccessUnavailableBadge, _super);
  function InteriorAccessUnavailableBadge() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  InteriorAccessUnavailableBadge.shouldBeIncluded = function (_a) {
    var listing = _a.listing,
      opts = _a.opts;
    return (opts === null || opts === void 0 ? void 0 : opts.badgeMode) === BadgeMode.EXPANDED && !___default.get(listing, 'listing_configuration.interior_access_allowed', false) && (isREO(listing) || isShortSale(listing));
  };
  InteriorAccessUnavailableBadge.title = 'Interior Access';
  InteriorAccessUnavailableBadge.titleIcon = 'unlock-alt';
  InteriorAccessUnavailableBadge.summary = 'No';
  InteriorAccessUnavailableBadge.contentPositive = false;
  InteriorAccessUnavailableBadge.content = 'Interior access is not available for this property.';
  return InteriorAccessUnavailableBadge;
}(ListingBadge);

var listingStatus = function listingStatus(listing) {
  return ___default.get(listing, 'listing_status', '');
};
var ClearedForSaleYesBadge = function (_super) {
  __extends(ClearedForSaleYesBadge, _super);
  function ClearedForSaleYesBadge() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  ClearedForSaleYesBadge.shouldBeIncluded = function (_a) {
    var listing = _a.listing,
      opts = _a.opts;
    return (opts === null || opts === void 0 ? void 0 : opts.badgeMode) === BadgeMode.EXPANDED && listingStatus(listing) === graph.enums.ListingStatus.SalePendingCleared && isTPSLive(listing) && !isPrivateSeller(listing);
  };
  ClearedForSaleYesBadge.title = 'Cleared For Auction';
  ClearedForSaleYesBadge.titleIcon = 'clipboard-check';
  ClearedForSaleYesBadge.contentPositive = true;
  ClearedForSaleYesBadge.summary = 'Yes';
  ClearedForSaleYesBadge.content = 'We confirmed that this property will sell on auction day. It should not be postponed or cancelled.';
  ClearedForSaleYesBadge.renderPriority = BadgePriority.FIRST;
  return ClearedForSaleYesBadge;
}(ListingBadge);
var ClearedForSaleComingSoonBadge = function (_super) {
  __extends(ClearedForSaleComingSoonBadge, _super);
  function ClearedForSaleComingSoonBadge() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  ClearedForSaleComingSoonBadge.shouldBeIncluded = function (_a) {
    var listing = _a.listing,
      opts = _a.opts;
    return (opts === null || opts === void 0 ? void 0 : opts.badgeMode) === BadgeMode.EXPANDED && (listingStatus(listing) === graph.enums.ListingStatus.PostponedPendingScheduling || graph.enums.ListingStatus.SaleFailed) && isTPSLive(listing) && !isPrivateSeller(listing);
  };
  ClearedForSaleComingSoonBadge.title = 'Cleared For Auction';
  ClearedForSaleComingSoonBadge.titleIcon = 'clipboard-check';
  ClearedForSaleComingSoonBadge.contentPositive = false;
  ClearedForSaleComingSoonBadge.summary = 'No';
  ClearedForSaleComingSoonBadge.content = 'This property is postponed. Awaiting new auction date and time.';
  return ClearedForSaleComingSoonBadge;
}(ListingBadge);
var ClearedForSalePendingBadge = function (_super) {
  __extends(ClearedForSalePendingBadge, _super);
  function ClearedForSalePendingBadge() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  ClearedForSalePendingBadge.shouldBeIncluded = function (_a) {
    var listing = _a.listing,
      opts = _a.opts;
    return (opts === null || opts === void 0 ? void 0 : opts.badgeMode) === BadgeMode.EXPANDED && listingStatus(listing) === graph.enums.ListingStatus.SalePending && isTPSLive(listing) && !isPrivateSeller(listing);
  };
  ClearedForSalePendingBadge.title = 'Cleared For Auction';
  ClearedForSalePendingBadge.id = 'ClearedForSalePendingBadge';
  ClearedForSalePendingBadge.titleIcon = 'clipboard-check';
  ClearedForSalePendingBadge.contentPositive = false;
  ClearedForSalePendingBadge.summary = 'Not Yet';
  ClearedForSalePendingBadge.content = 'The auction is scheduled. It may be cancelled or postponed.';
  return ClearedForSalePendingBadge;
}(ListingBadge);
var ClearedForSalePostponedBadge = function (_super) {
  __extends(ClearedForSalePostponedBadge, _super);
  function ClearedForSalePostponedBadge() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  ClearedForSalePostponedBadge.shouldBeIncluded = function (_a) {
    var listing = _a.listing,
      opts = _a.opts;
    return (opts === null || opts === void 0 ? void 0 : opts.badgeMode) === BadgeMode.EXPANDED && listingStatus(listing) === graph.enums.ListingStatus.Postponed && isTPSLive(listing) && !isPrivateSeller(listing);
  };
  Object.defineProperty(ClearedForSalePostponedBadge.prototype, "content", {
    get: function get() {
      var _a;
      var postponementDate = ((_a = this.listing.listing_configuration) === null || _a === void 0 ? void 0 : _a.postponement_new_auction_date) || '';
      var postponedDate = moment(postponementDate, DEFAULT_DATE_FORMAT);
      var outputDate = postponedDate.isValid() ? postponedDate.format('MMM DD') : 'TBD';
      return "No, this auction has been postponed to ".concat(outputDate);
    },
    enumerable: false,
    configurable: true
  });
  ClearedForSalePostponedBadge.title = 'Cleared For Auction';
  ClearedForSalePostponedBadge.titleIcon = 'clipboard-check';
  ClearedForSalePostponedBadge.contentPositive = false;
  ClearedForSalePostponedBadge.summary = 'No';
  return ClearedForSalePostponedBadge;
}(ListingBadge);

var ConductedByADCOnlineBadge = function (_super) {
  __extends(ConductedByADCOnlineBadge, _super);
  function ConductedByADCOnlineBadge() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  ConductedByADCOnlineBadge.shouldBeIncluded = function (_a) {
    var listing = _a.listing,
      opts = _a.opts;
    return (opts === null || opts === void 0 ? void 0 : opts.badgeMode) === BadgeMode.EXPANDED && isTPSOnline(listing) && !isPrivateSeller(listing);
  };
  ConductedByADCOnlineBadge.title = 'Conducted by Auction.com';
  ConductedByADCOnlineBadge.id = 'ConductedByADCOnlineBadge';
  ConductedByADCOnlineBadge.titleIcon = 'gavel';
  ConductedByADCOnlineBadge.content = 'This is an online auction conducted by Auction.com. Learn More.';
  return ConductedByADCOnlineBadge;
}(ListingBadge);
var ConductedByADCLiveBadge = function (_super) {
  __extends(ConductedByADCLiveBadge, _super);
  function ConductedByADCLiveBadge() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  ConductedByADCLiveBadge.shouldBeIncluded = function (_a) {
    var listing = _a.listing,
      opts = _a.opts;
    return (opts === null || opts === void 0 ? void 0 : opts.badgeMode) === BadgeMode.EXPANDED && isTPSLive(listing) && hasADCAuctioneer(listing) && !isPrivateSeller(listing);
  };
  ConductedByADCLiveBadge.id = 'ConductedByADCLiveBadge';
  ConductedByADCLiveBadge.content = 'Auction.com will conduct the sale in person. Download the app for real time updates and time-saving benefits.';
  return ConductedByADCLiveBadge;
}(ConductedByADCOnlineBadge);
var NotConductedByADCLive = function (_super) {
  __extends(NotConductedByADCLive, _super);
  function NotConductedByADCLive() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  NotConductedByADCLive.shouldBeIncluded = function (_a) {
    var listing = _a.listing,
      opts = _a.opts;
    return (opts === null || opts === void 0 ? void 0 : opts.badgeMode) === BadgeMode.EXPANDED && isTPSLive(listing) && !hasADCAuctioneer(listing) && !isPrivateSeller(listing);
  };
  NotConductedByADCLive.id = 'NotConductedByADCLive';
  NotConductedByADCLive.summary = 'No';
  NotConductedByADCLive.contentPositive = false;
  NotConductedByADCLive.content = 'This in-person auction will be conducted by a third party at a county location. Learn More.';
  return NotConductedByADCLive;
}(ConductedByADCOnlineBadge);
var NotConductedByADCFCLBadge = function (_super) {
  __extends(NotConductedByADCFCLBadge, _super);
  function NotConductedByADCFCLBadge() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  NotConductedByADCFCLBadge.shouldBeIncluded = function (_a) {
    var listing = _a.listing,
      opts = _a.opts;
    return (opts === null || opts === void 0 ? void 0 : opts.badgeMode) === BadgeMode.EXPANDED && isFCLMarketing$2(listing) && !isPrivateSeller(listing);
  };
  NotConductedByADCFCLBadge.id = 'NotConductedByADCFCLBadge';
  NotConductedByADCFCLBadge.summary = 'No';
  NotConductedByADCFCLBadge.contentPositive = false;
  NotConductedByADCFCLBadge.content = 'This is an online auction conducted by a third party at the county website. Learn More';
  return NotConductedByADCFCLBadge;
}(ConductedByADCOnlineBadge);

var AgentInformationBadge = function (_super) {
  __extends(AgentInformationBadge, _super);
  function AgentInformationBadge() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  AgentInformationBadge.shouldBeIncluded = function (_a) {
    var listing = _a.listing,
      opts = _a.opts;
    return (opts === null || opts === void 0 ? void 0 : opts.badgeMode) === BadgeMode.EXPANDED && ___default.isPlainObject(getBrokerAgent(listing)) && isREO(listing);
  };
  AgentInformationBadge.title = 'Contact Agent Info';
  AgentInformationBadge.id = 'AgentInformationBadge';
  AgentInformationBadge.titleIcon = 'user-tie';
  AgentInformationBadge.content = 'Get in touch with the listing agent for this property';
  return AgentInformationBadge;
}(ListingBadge);

var SubjectToRedemptionBadge = function (_super) {
  __extends(SubjectToRedemptionBadge, _super);
  function SubjectToRedemptionBadge() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  SubjectToRedemptionBadge.shouldBeIncluded = function (_a) {
    var listing = _a.listing,
      opts = _a.opts;
    return (opts === null || opts === void 0 ? void 0 : opts.badgeMode) === BadgeMode.EXPANDED && getProductType(listing) === 'REDEMPTION' && isREO(listing);
  };
  Object.defineProperty(SubjectToRedemptionBadge.prototype, "content", {
    get: function get() {
      var _a;
      var redemptionDate = String(((_a = this.listing.listing_configuration) === null || _a === void 0 ? void 0 : _a.redemption_expiration_date) || '');
      var date = moment.tz(redemptionDate, DEFAULT_DATE_FORMAT, 'America/Los_Angeles');
      var contextSuffix = date.isValid() ? " until ".concat(date.format('MMM DD, YYYY')) : '.';
      return "Per state laws, there is a period when certain parties have an opportunity to \"redeem\" a foreclosed property".concat(contextSuffix, " Learn More");
    },
    enumerable: false,
    configurable: true
  });
  SubjectToRedemptionBadge.id = 'SubjectToRedemptionBadge';
  SubjectToRedemptionBadge.title = 'Subject To Redemption';
  SubjectToRedemptionBadge.titleIcon = 'exclamation-triangle';
  SubjectToRedemptionBadge.textIcon = 'times';
  SubjectToRedemptionBadge.contentPositive = false;
  SubjectToRedemptionBadge.importantInfoRenderPriority = BadgePriority.FOURTH;
  return SubjectToRedemptionBadge;
}(ListingBadge);

var ForeclosureContactInformationBadge = function (_super) {
  __extends(ForeclosureContactInformationBadge, _super);
  function ForeclosureContactInformationBadge() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  ForeclosureContactInformationBadge.shouldBeIncluded = function (_a) {
    var listing = _a.listing,
      opts = _a.opts;
    return (opts === null || opts === void 0 ? void 0 : opts.badgeMode) === BadgeMode.EXPANDED && isTPS(listing) && ___default.isPlainObject(getForeclosureContact(listing));
  };
  Object.defineProperty(ForeclosureContactInformationBadge.prototype, "content", {
    get: function get() {
      var contact = getForeclosureContact(this.listing) || {};
      var secondLine = contact.party_phone ? "Borrowers/homeowners should call {{".concat(contact.party_phone, "}}") : '';
      return "".concat(contact.party_name || '', " \n\n        ").concat(secondLine);
    },
    enumerable: false,
    configurable: true
  });
  ForeclosureContactInformationBadge.id = 'ForeclosureContactInformationBadge';
  ForeclosureContactInformationBadge.title = 'Foreclosure Contact Info';
  ForeclosureContactInformationBadge.titleIcon = 'phone';
  ForeclosureContactInformationBadge.importantInfoRenderPriority = BadgePriority.FIFTH;
  return ForeclosureContactInformationBadge;
}(ListingBadge);

var TitleAndLiensBadge = function (_super) {
  __extends(TitleAndLiensBadge, _super);
  function TitleAndLiensBadge() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  TitleAndLiensBadge.shouldBeIncluded = function (_a) {
    var listing = _a.listing,
      opts = _a.opts;
    return (opts === null || opts === void 0 ? void 0 : opts.badgeMode) === BadgeMode.EXPANDED && !isPrivateSeller(listing);
  };
  TitleAndLiensBadge.id = 'TitleAndLiensBadge';
  TitleAndLiensBadge.title = 'Title and Liens';
  TitleAndLiensBadge.summary = 'Title and Liens';
  TitleAndLiensBadge.titleIcon = 'file-certificate';
  TitleAndLiensBadge.contentPositive = false;
  TitleAndLiensBadge.shouldBeHoisted = true;
  TitleAndLiensBadge.importantInfoRenderPriority = BadgePriority.THIRD;
  return TitleAndLiensBadge;
}(ListingBadge);

var RemoteBidBadge = function (_super) {
  __extends(RemoteBidBadge, _super);
  function RemoteBidBadge() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  RemoteBidBadge.shouldBeIncluded = function (_a) {
    var listing = _a.listing,
      opts = _a.opts;
    var _b = listing.listing_summary || {},
      is_remote_bid_enabled = _b.is_remote_bid_enabled,
      is_remote_before_and_during_auction_enabled = _b.is_remote_before_and_during_auction_enabled;
    var remoteBidEnabled = is_remote_bid_enabled || is_remote_before_and_during_auction_enabled;
    return Boolean((opts === null || opts === void 0 ? void 0 : opts.badgeMode) === BadgeMode.CONDENSED && remoteBidEnabled);
  };
  RemoteBidBadge.title = 'Remote Bid';
  RemoteBidBadge.summary = '';
  RemoteBidBadge.renderPriority = BadgePriority.FIRST;
  return RemoteBidBadge;
}(ListingBadge);

var NewlyListedBadge = function (_super) {
  __extends(NewlyListedBadge, _super);
  function NewlyListedBadge() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  NewlyListedBadge.shouldBeIncluded = function (_a) {
    var _b;
    var listing = _a.listing,
      opts = _a.opts;
    return Boolean((opts === null || opts === void 0 ? void 0 : opts.badgeMode) === BadgeMode.CONDENSED && ((_b = listing.primary_property) === null || _b === void 0 ? void 0 : _b.is_newly_listed));
  };
  NewlyListedBadge.title = 'Newly Listed';
  NewlyListedBadge.summary = '';
  NewlyListedBadge.titleIcon = 'certificate';
  NewlyListedBadge.content = '';
  NewlyListedBadge.renderPriority = BadgePriority.FIRST;
  return NewlyListedBadge;
}(ListingBadge);

var FinanceAllowedBadge = function (_super) {
  __extends(FinanceAllowedBadge, _super);
  function FinanceAllowedBadge() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  FinanceAllowedBadge.shouldBeIncluded = function () {
    return true;
  };
  Object.defineProperty(FinanceAllowedBadge.prototype, "content", {
    get: function get() {
      var _a, _b;
      return ((_b = (_a = this.listing.seller_terms) === null || _a === void 0 ? void 0 : _a.finance_terms) === null || _b === void 0 ? void 0 : _b.finance_preference) === enums$1.ListingFinanceType.Conventional ? 'Yes' : 'No';
    },
    enumerable: false,
    configurable: true
  });
  FinanceAllowedBadge.title = 'Financing Allowed';
  FinanceAllowedBadge.titleIcon = 'money-bill';
  FinanceAllowedBadge.contentPositive = false;
  FinanceAllowedBadge.tooltipContent = 'Indicates whether the property can be purchased with conventional financing options. If "No," the purchase must be with cash or cash equivalent, such as hard money loans.';
  return FinanceAllowedBadge;
}(ListingBadge);

var AcceptedContingenciesBadge = function (_super) {
  __extends(AcceptedContingenciesBadge, _super);
  function AcceptedContingenciesBadge() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  AcceptedContingenciesBadge.shouldBeIncluded = function (_a) {
    var listing = _a.listing;
    return isPrivateSeller(listing);
  };
  Object.defineProperty(AcceptedContingenciesBadge.prototype, "content", {
    get: function get() {
      var _a, _b, _c, _d, _e, _f;
      return [((_b = (_a = this.listing.seller_terms) === null || _a === void 0 ? void 0 : _a.finance_terms) === null || _b === void 0 ? void 0 : _b.is_contingency) && 'Financing', ((_d = (_c = this.listing.seller_terms) === null || _c === void 0 ? void 0 : _c.inspection_terms) === null || _d === void 0 ? void 0 : _d.is_contingency) && 'Inspection', ((_f = (_e = this.listing.seller_terms) === null || _e === void 0 ? void 0 : _e.inspection_terms) === null || _f === void 0 ? void 0 : _f.is_option_contingency) && 'Option Period'].filter(Boolean).join(', ') || 'None';
    },
    enumerable: false,
    configurable: true
  });
  AcceptedContingenciesBadge.title = 'Accepted Contingencies';
  AcceptedContingenciesBadge.titleIcon = 'file-signature';
  AcceptedContingenciesBadge.contentPositive = false;
  AcceptedContingenciesBadge.sellerTermsRenderPriority = BadgePriority.SECOND;
  AcceptedContingenciesBadge.tooltipContent = 'List of contingencies that the seller is willing to consider such as inspection, appraisal, or financing. "None" means the sale is as-is, with no contingencies.';
  return AcceptedContingenciesBadge;
}(ListingBadge);

var RentBackBadge = function (_super) {
  __extends(RentBackBadge, _super);
  function RentBackBadge() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  RentBackBadge.shouldBeIncluded = function () {
    return true;
  };
  Object.defineProperty(RentBackBadge.prototype, "content", {
    get: function get() {
      var _a, _b;
      var rentBack = (_b = (_a = this.listing.seller_terms) === null || _a === void 0 ? void 0 : _a.leaseback_terms) === null || _b === void 0 ? void 0 : _b.leaseback_period_in_days;
      return rentBack ? "".concat(rentBack, " ").concat(pluralize('Day', rentBack)) : 'None';
    },
    enumerable: false,
    configurable: true
  });
  RentBackBadge.id = 'RentBackBadge';
  RentBackBadge.title = 'Rentback';
  RentBackBadge.titleIcon = 'house-person-return';
  RentBackBadge.contentPositive = false;
  RentBackBadge.tooltipContent = 'The rentback period is the number of days the seller is requesting to stay in the property after the sale closes.';
  return RentBackBadge;
}(ListingBadge);
var RentbackOffer = function (_super) {
  __extends(RentbackOffer, _super);
  function RentbackOffer() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  RentbackOffer.shouldBeIncluded = function (_a) {
    var _b, _c;
    var listing = _a.listing;
    var rentbackPeriod = (_c = (_b = listing.seller_terms) === null || _b === void 0 ? void 0 : _b.leaseback_terms) === null || _c === void 0 ? void 0 : _c.leaseback_period_in_days;
    return Boolean(!isTPS(listing) && rentbackPeriod);
  };
  RentbackOffer.id = 'RentbackOffer';
  RentbackOffer.title = 'Rentback';
  RentbackOffer.titleIcon = 'user-tie';
  RentbackOffer.renderPriority = BadgePriority.THIRD;
  RentbackOffer.importantInfoRenderPriority = BadgePriority.SECOND;
  return RentbackOffer;
}(ListingBadge);
var RentbackAuction = function (_super) {
  __extends(RentbackAuction, _super);
  function RentbackAuction() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  RentbackAuction.shouldBeIncluded = function (_a) {
    var _b, _c;
    var listing = _a.listing;
    var rentbackPeriod = (_c = (_b = listing.seller_terms) === null || _b === void 0 ? void 0 : _b.leaseback_terms) === null || _c === void 0 ? void 0 : _c.leaseback_period_in_days;
    return Boolean(isTPS(listing) && rentbackPeriod);
  };
  RentbackAuction.id = 'RentbackAuction';
  RentbackAuction.title = 'Rentback';
  RentbackAuction.titleIcon = 'user-tie';
  RentbackAuction.importantInfoRenderPriority = BadgePriority.SECOND;
  return RentbackAuction;
}(ListingBadge);
var RentbackRequestedPeriod = function (_super) {
  __extends(RentbackRequestedPeriod, _super);
  function RentbackRequestedPeriod() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  RentbackRequestedPeriod.shouldBeIncluded = function (_a) {
    var _b, _c, _d, _e;
    var listing = _a.listing;
    var rentbackPeriod = (_c = (_b = listing.seller_terms) === null || _b === void 0 ? void 0 : _b.leaseback_terms) === null || _c === void 0 ? void 0 : _c.leaseback_period_in_days;
    var isAuctionDisposition = ((_e = (_d = listing.strategy) === null || _d === void 0 ? void 0 : _d.selling_method_attributes) === null || _e === void 0 ? void 0 : _e.online_segment_type) === enums$1.OnlineAuctionSegmentType.English;
    return Boolean(!isAuctionDisposition && rentbackPeriod);
  };
  Object.defineProperty(RentbackRequestedPeriod.prototype, "content", {
    get: function get() {
      var _a, _b;
      var rentbackPeriod = (_b = (_a = this.listing.seller_terms) === null || _a === void 0 ? void 0 : _a.leaseback_terms) === null || _b === void 0 ? void 0 : _b.leaseback_period_in_days;
      return "Rentback for ".concat(rentbackPeriod, " days");
    },
    enumerable: false,
    configurable: true
  });
  RentbackRequestedPeriod.title = 'Rentback Requested';
  RentbackRequestedPeriod.titleIcon = 'house-user';
  RentbackRequestedPeriod.sellerTermsRenderPriority = BadgePriority.SIXTH;
  return RentbackRequestedPeriod;
}(ListingBadge);
var RentbackRequiredPeriod = function (_super) {
  __extends(RentbackRequiredPeriod, _super);
  function RentbackRequiredPeriod() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  RentbackRequiredPeriod.shouldBeIncluded = function (_a) {
    var _b, _c, _d, _e;
    var listing = _a.listing;
    var rentbackPeriod = (_c = (_b = listing.seller_terms) === null || _b === void 0 ? void 0 : _b.leaseback_terms) === null || _c === void 0 ? void 0 : _c.leaseback_period_in_days;
    var isAuctionDisposition = ((_e = (_d = listing.strategy) === null || _d === void 0 ? void 0 : _d.selling_method_attributes) === null || _e === void 0 ? void 0 : _e.online_segment_type) === enums$1.OnlineAuctionSegmentType.English;
    return Boolean(isAuctionDisposition && rentbackPeriod);
  };
  Object.defineProperty(RentbackRequiredPeriod.prototype, "content", {
    get: function get() {
      var _a, _b;
      var rentbackPeriod = (_b = (_a = this.listing.seller_terms) === null || _a === void 0 ? void 0 : _a.leaseback_terms) === null || _b === void 0 ? void 0 : _b.leaseback_period_in_days;
      return "Rentback for ".concat(rentbackPeriod, " days");
    },
    enumerable: false,
    configurable: true
  });
  RentbackRequiredPeriod.title = 'Rentback Required';
  RentbackRequiredPeriod.titleIcon = 'house-user';
  RentbackRequiredPeriod.sellerTermsRenderPriority = BadgePriority.SIXTH;
  return RentbackRequiredPeriod;
}(ListingBadge);

var PrivateToursBadge = function (_super) {
  __extends(PrivateToursBadge, _super);
  function PrivateToursBadge() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  PrivateToursBadge.shouldBeIncluded = function () {
    return true;
  };
  Object.defineProperty(PrivateToursBadge.prototype, "content", {
    get: function get() {
      var _a;
      return ((_a = this.listing.listing_configuration) === null || _a === void 0 ? void 0 : _a.are_private_tours_available) ? 'Yes' : 'No';
    },
    enumerable: false,
    configurable: true
  });
  PrivateToursBadge.title = 'Private Tours Allowed';
  PrivateToursBadge.titleIcon = 'house-lock';
  PrivateToursBadge.contentPositive = false;
  PrivateToursBadge.tooltipContent = 'This property allows private tours upon request to the listing agent.';
  return PrivateToursBadge;
}(ListingBadge);

var EarnestMoneyDepositBadge = function (_super) {
  __extends(EarnestMoneyDepositBadge, _super);
  function EarnestMoneyDepositBadge() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  EarnestMoneyDepositBadge.shouldBeIncluded = function (_listingArgs) {
    return true;
  };
  Object.defineProperty(EarnestMoneyDepositBadge.prototype, "content", {
    get: function get() {
      var program_configuration = this.listing.program_configuration;
      var primaryAmount = (program_configuration === null || program_configuration === void 0 ? void 0 : program_configuration.earnest_money_deposit_primary_amount) ? "".concat(String(program_configuration === null || program_configuration === void 0 ? void 0 : program_configuration.earnest_money_deposit_primary_amount), "%") : '';
      var minimunAmount = (program_configuration === null || program_configuration === void 0 ? void 0 : program_configuration.earnest_money_deposit_minimum_amount) ? "".concat(formatMoney$1(program_configuration === null || program_configuration === void 0 ? void 0 : program_configuration.earnest_money_deposit_minimum_amount)) : '';
      if (!primaryAmount) {
        return minimunAmount;
      }
      if (!minimunAmount) {
        return primaryAmount;
      }
      return "".concat(primaryAmount, " (").concat(minimunAmount, " min)");
    },
    enumerable: false,
    configurable: true
  });
  EarnestMoneyDepositBadge.title = 'Earnest Money Deposit';
  EarnestMoneyDepositBadge.titleIcon = 'money-check-dollar';
  EarnestMoneyDepositBadge.moneyValue = false;
  EarnestMoneyDepositBadge.contentPositive = false;
  EarnestMoneyDepositBadge.sellerTermsRenderPriority = BadgePriority.FOURTH;
  EarnestMoneyDepositBadge.tooltipContent = 'A deposit placed by the buyer to let the seller know that the buyer is earnest or serious about buying the property.';
  return EarnestMoneyDepositBadge;
}(ListingBadge);
var EarnestMoneyDepositBadgeTerm = function (_super) {
  __extends(EarnestMoneyDepositBadgeTerm, _super);
  function EarnestMoneyDepositBadgeTerm() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  EarnestMoneyDepositBadgeTerm.shouldBeIncluded = function (_a) {
    var listing = _a.listing;
    var program_configuration = listing.program_configuration;
    return Boolean(((program_configuration === null || program_configuration === void 0 ? void 0 : program_configuration.earnest_money_deposit_primary_amount) || (program_configuration === null || program_configuration === void 0 ? void 0 : program_configuration.earnest_money_deposit_minimum_amount)) && isPrivateSeller(listing));
  };
  Object.defineProperty(EarnestMoneyDepositBadgeTerm.prototype, "content", {
    get: function get() {
      var program_configuration = this.listing.program_configuration;
      var formattedMinimumAmount = (program_configuration === null || program_configuration === void 0 ? void 0 : program_configuration.earnest_money_deposit_minimum_amount) && formatMoney$1(program_configuration === null || program_configuration === void 0 ? void 0 : program_configuration.earnest_money_deposit_minimum_amount);
      if (!(program_configuration === null || program_configuration === void 0 ? void 0 : program_configuration.earnest_money_deposit_primary_amount)) {
        return String(formattedMinimumAmount);
      }
      if (!(program_configuration === null || program_configuration === void 0 ? void 0 : program_configuration.earnest_money_deposit_minimum_amount)) {
        return "".concat(program_configuration === null || program_configuration === void 0 ? void 0 : program_configuration.earnest_money_deposit_primary_amount, "%");
      }
      return "".concat(program_configuration === null || program_configuration === void 0 ? void 0 : program_configuration.earnest_money_deposit_primary_amount, "% (").concat(formattedMinimumAmount, " min)");
    },
    enumerable: false,
    configurable: true
  });
  return EarnestMoneyDepositBadgeTerm;
}(EarnestMoneyDepositBadge);

var FinanceContingency = function (_super) {
  __extends(FinanceContingency, _super);
  function FinanceContingency() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  FinanceContingency.shouldBeIncluded = function (_a) {
    var _b, _c;
    var listing = _a.listing;
    return Boolean((_c = (_b = listing.seller_terms) === null || _b === void 0 ? void 0 : _b.finance_terms) === null || _c === void 0 ? void 0 : _c.is_contingency);
  };
  FinanceContingency.id = 'FinanceContingency';
  FinanceContingency.title = 'Finance Contingency';
  FinanceContingency.titleIcon = 'user-tie';
  FinanceContingency.importantInfoRenderPriority = BadgePriority.SIXTH;
  return FinanceContingency;
}(ListingBadge);
var InspectionContigency = function (_super) {
  __extends(InspectionContigency, _super);
  function InspectionContigency() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  InspectionContigency.shouldBeIncluded = function (_a) {
    var _b, _c;
    var listing = _a.listing;
    return Boolean((_c = (_b = listing.seller_terms) === null || _b === void 0 ? void 0 : _b.inspection_terms) === null || _c === void 0 ? void 0 : _c.is_contingency);
  };
  InspectionContigency.id = 'InspectionContigency';
  InspectionContigency.title = 'Inspection Contingency';
  InspectionContigency.titleIcon = 'user-tie';
  InspectionContigency.importantInfoRenderPriority = BadgePriority.SEVENTH;
  return InspectionContigency;
}(ListingBadge);

var OptionFee = function (_super) {
  __extends(OptionFee, _super);
  function OptionFee() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  OptionFee.shouldBeIncluded = function (_a) {
    var _b, _c, _d;
    var listing = _a.listing;
    return Boolean(((_c = (_b = listing.seller_terms) === null || _b === void 0 ? void 0 : _b.inspection_terms) === null || _c === void 0 ? void 0 : _c.is_option_contingency) && ((_d = listing.seller_property) === null || _d === void 0 ? void 0 : _d.country_primary_subdivision) && ['GA', 'TX'].includes(listing.seller_property.country_primary_subdivision));
  };
  OptionFee.id = 'OptionFee';
  OptionFee.title = 'Option Fee';
  OptionFee.titleIcon = 'user-tie';
  OptionFee.importantInfoRenderPriority = BadgePriority.EIGHTH;
  return OptionFee;
}(ListingBadge);

var AcceptedPaymentTypesBadge = function (_super) {
  __extends(AcceptedPaymentTypesBadge, _super);
  function AcceptedPaymentTypesBadge() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  AcceptedPaymentTypesBadge.shouldBeIncluded = function (_a) {
    var listing = _a.listing;
    return isPrivateSeller(listing);
  };
  Object.defineProperty(AcceptedPaymentTypesBadge.prototype, "content", {
    get: function get() {
      var _a, _b, _c;
      var hasFinancePreference = !!((_b = (_a = this.listing.seller_terms) === null || _a === void 0 ? void 0 : _a.finance_terms) === null || _b === void 0 ? void 0 : _b.finance_preference) && this.listing.seller_terms.finance_terms.finance_preference !== enums$1.ListingFinanceType.Cash;
      var hasFinancingAvailable = (_c = this.listing.listing_configuration) === null || _c === void 0 ? void 0 : _c.financing_available;
      return hasFinancePreference || hasFinancingAvailable ? 'Cash, Financing' : 'Cash';
    },
    enumerable: false,
    configurable: true
  });
  AcceptedPaymentTypesBadge.title = 'Accepted Payment Type';
  AcceptedPaymentTypesBadge.titleIcon = 'file-lines';
  AcceptedPaymentTypesBadge.sellerTermsRenderPriority = BadgePriority.FIRST;
  return AcceptedPaymentTypesBadge;
}(ListingBadge);

var OptionPeriod = function (_super) {
  __extends(OptionPeriod, _super);
  function OptionPeriod() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  OptionPeriod.shouldBeIncluded = function (_a) {
    var _b;
    var listing = _a.listing;
    return Boolean(isPrivateSeller(listing) && ((_b = listing.seller_property) === null || _b === void 0 ? void 0 : _b.country_primary_subdivision) && ['GA', 'TX'].includes(listing.seller_property.country_primary_subdivision));
  };
  Object.defineProperty(OptionPeriod.prototype, "content", {
    get: function get() {
      var _a, _b;
      return ((_b = (_a = this.listing.seller_terms) === null || _a === void 0 ? void 0 : _a.inspection_terms) === null || _b === void 0 ? void 0 : _b.is_option_contingency) ? 'Yes' : 'No';
    },
    enumerable: false,
    configurable: true
  });
  OptionPeriod.title = 'Option Period';
  OptionPeriod.titleIcon = 'magnifying-glass';
  OptionPeriod.sellerTermsRenderPriority = BadgePriority.THIRD;
  return OptionPeriod;
}(ListingBadge);

var AdditionalTermsBadge = function (_super) {
  __extends(AdditionalTermsBadge, _super);
  function AdditionalTermsBadge() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  AdditionalTermsBadge.shouldBeIncluded = function (_a) {
    var _b, _c;
    var listing = _a.listing;
    var auctioneerInfo = (_b = listing.marketing_attributes) === null || _b === void 0 ? void 0 : _b.find(function (item) {
      return (item === null || item === void 0 ? void 0 : item.attribute_type) === enums$1.MarketingAttributeType.AuctioneerLicensing;
    });
    var transactionDetails = (_c = listing.marketing_attributes) === null || _c === void 0 ? void 0 : _c.find(function (item) {
      return (item === null || item === void 0 ? void 0 : item.attribute_type) === enums$1.MarketingAttributeType.TransactionDetails;
    });
    return Boolean(auctioneerInfo || (transactionDetails === null || transactionDetails === void 0 ? void 0 : transactionDetails.message));
  };
  AdditionalTermsBadge.id = 'AdditionalTermsBadge';
  AdditionalTermsBadge.title = 'Additional Documents';
  AdditionalTermsBadge.titleIcon = 'file-lines';
  AdditionalTermsBadge.sellerTermsRenderPriority = BadgePriority.SEVENTH;
  AdditionalTermsBadge.content = 'Read the additional documents here';
  return AdditionalTermsBadge;
}(ListingBadge);

var LIVE_BIDDING_MINIMUM = 1;
var LIVE_BID_INCREMENT_MINIMUM = 100;
var VALID_LISTING_STATUSES_TO_BID = new Set([enums$1.ListingStatus.AuctionInProgress, enums$1.ListingStatus.SalePending, enums$1.ListingStatus.SalePendingCleared]);
var DISALLOWED_SEGMENT_END_STATUSES_TO_BID = new Set([enums$1.LiveAuctionSegmentBidEndStatus.FinalizingBid, enums$1.LiveAuctionSegmentBidEndStatus.Sold, enums$1.LiveAuctionSegmentBidEndStatus.NoSale]);
var calculateAskingBid = function calculateAskingBid(segment, listing) {
  var _a, _b, _c;
  var startingBid = (segment === null || segment === void 0 ? void 0 : segment.starting_bid_amount) || ((_a = listing === null || listing === void 0 ? void 0 : listing.auction) === null || _a === void 0 ? void 0 : _a.starting_bid) || LIVE_BIDDING_MINIMUM;
  var bidIncrementAmount = (_b = segment === null || segment === void 0 ? void 0 : segment.configuration) === null || _b === void 0 ? void 0 : _b.bid_increment_amount;
  var currentHighestBidAmount = (_c = segment === null || segment === void 0 ? void 0 : segment.current_highest_bid) === null || _c === void 0 ? void 0 : _c.bid_amount;
  if (currentHighestBidAmount) return currentHighestBidAmount + (bidIncrementAmount || LIVE_BID_INCREMENT_MINIMUM);
  return bidIncrementAmount ? startingBid + bidIncrementAmount : startingBid;
};
var calculateAuctionValues$1 = function calculateAuctionValues(segment, listing) {
  var _a;
  return {
    askingBidAmount: calculateAskingBid(segment, listing),
    currentUserHighestBidAmount: getCurrentUserHighestBidAmount(segment),
    currentHighestBidAmount: (_a = segment === null || segment === void 0 ? void 0 : segment.current_highest_bid) === null || _a === void 0 ? void 0 : _a.bid_amount,
    currentUserNextBidAmount: calculateNextBid(segment, listing, getCurrentUserHighestBidAmount(segment))
  };
};
var calculateNextBid = function calculateNextBid(segment, listing, defaultInitialValue) {
  var _a, _b, _c;
  var bidIncrementAmount = (_a = segment === null || segment === void 0 ? void 0 : segment.configuration) === null || _a === void 0 ? void 0 : _a.bid_increment_amount;
  var startingBid = (segment === null || segment === void 0 ? void 0 : segment.starting_bid_amount) || ((_b = listing === null || listing === void 0 ? void 0 : listing.auction) === null || _b === void 0 ? void 0 : _b.starting_bid) || LIVE_BIDDING_MINIMUM;
  var currentHighestBidAmount = (_c = segment === null || segment === void 0 ? void 0 : segment.current_highest_bid) === null || _c === void 0 ? void 0 : _c.bid_amount;
  var nextBidAmount = bidIncrementAmount ? startingBid + bidIncrementAmount : startingBid;
  if (defaultInitialValue) nextBidAmount = Math.max(defaultInitialValue + (bidIncrementAmount || LIVE_BID_INCREMENT_MINIMUM), nextBidAmount);
  if (currentHighestBidAmount) nextBidAmount = Math.max(currentHighestBidAmount + (bidIncrementAmount || LIVE_BID_INCREMENT_MINIMUM), nextBidAmount);
  return nextBidAmount;
};
var calculateProposedBidBreakdown = function calculateProposedBidBreakdown(segment, proposedBidAmount) {
  var _a;
  var stateDepositRule = (_a = segment.configuration) === null || _a === void 0 ? void 0 : _a.state_deposit_rule;
  var calculatedStateDepositRule = String(stateDepositRule || '100%');
  var auctionExpression = AuctionExpression.parse(calculatedStateDepositRule);
  return {
    stateDepositRule: calculatedStateDepositRule,
    requiredStateDepositAmount: auctionExpression.evaluate(proposedBidAmount)
  };
};
var getBiddingStatusText$1 = function getBiddingStatusText(segment) {
  switch (segment.current_user_bidding_status || segment.bidding_status) {
    case enums$1.LiveAuctionSegmentBiddingStatus.Won:
      return {
        id: 'bidding:live:bid_status',
        title: "You've Won",
        intent: 'POSITIVE'
      };
    default:
      return null;
  }
};
var getCurrentUserHighestBidAmount = function getCurrentUserHighestBidAmount(segment) {
  var _a, _b;
  return ((_a = segment === null || segment === void 0 ? void 0 : segment.current_user_remote_bid) === null || _a === void 0 ? void 0 : _a.remote_bid_amount) || ((_b = segment === null || segment === void 0 ? void 0 : segment.current_user_highest_bid) === null || _b === void 0 ? void 0 : _b.bid_amount) || null;
};
var getStateDepositValues = function getStateDepositValues(segment, listing) {
  var _a, _b, _c, _d, _e, _f, _g;
  var stateDepositRule = (_a = segment.configuration) === null || _a === void 0 ? void 0 : _a.state_deposit_rule;
  var calculatedStateDepositRule = String(stateDepositRule || '100%');
  var auctionExpression = AuctionExpression.parse(calculatedStateDepositRule);
  var values = auctionExpression.getValues();
  var stateDepositPaymentDate = (_d = (_c = (_b = listing === null || listing === void 0 ? void 0 : listing.trustee_contract) === null || _b === void 0 ? void 0 : _b.expected_payments) === null || _c === void 0 ? void 0 : _c.find(function (p) {
    return (p === null || p === void 0 ? void 0 : p.payment_reason) === enums$1.TrusteeContractExpectedPaymentReason.StateDeposit;
  })) === null || _d === void 0 ? void 0 : _d.payment_date;
  var finalPaymentDeadline = (_g = (_f = (_e = listing === null || listing === void 0 ? void 0 : listing.trustee_contract) === null || _e === void 0 ? void 0 : _e.expected_payments) === null || _f === void 0 ? void 0 : _f.find(function (p) {
    return !(p === null || p === void 0 ? void 0 : p.payment_reason);
  })) === null || _g === void 0 ? void 0 : _g.payment_date;
  return {
    stateDepositRule: calculatedStateDepositRule,
    stateDepositLabel: values === null || values === void 0 ? void 0 : values.label,
    stateDepositShortenedLabel: values === null || values === void 0 ? void 0 : values.shortenedLabel,
    stateDepositType: values === null || values === void 0 ? void 0 : values.type,
    stateDepositPaymentDate: stateDepositPaymentDate ? new Date(stateDepositPaymentDate) : undefined,
    finalPaymentDeadline: finalPaymentDeadline ? new Date(finalPaymentDeadline) : undefined,
    shouldShowStateDeposit: Boolean(stateDepositRule) && stateDepositRule !== '100%'
  };
};
var getStateDepositText = function getStateDepositText(_segment, requiredStateDepositAmount) {
  if (!requiredStateDepositAmount) return null;
  var message = {
    id: 'bidding:live:state_deposit_text',
    title: "A winning bid deposit of ".concat(formatMoney$1(requiredStateDepositAmount), " will be debited from your available Remote Bid funds at time of sale."),
    intent: 'NEUTRAL'
  };
  return message;
};
var isValidListingStatusesToBid = function isValidListingStatusesToBid(listing) {
  return VALID_LISTING_STATUSES_TO_BID.has(listing.listing_status);
};
var isAcceptingRemoteBids = function isAcceptingRemoteBids(segment, listing) {
  return isValidListingStatusesToBid(listing) && (!segment.end_status || !DISALLOWED_SEGMENT_END_STATUSES_TO_BID.has(segment.end_status));
};
var submitOrUpdateRemoteBid = function submitOrUpdateRemoteBid(segment, bidAmount, purchaseProfileId) {
  return __awaiter(void 0, void 0, void 0, function () {
    var userAlreadyPlacedBid, biddingStatus, currentUserBiddingStatus;
    var _a;
    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          userAlreadyPlacedBid = Boolean(segment === null || segment === void 0 ? void 0 : segment.current_user_remote_bid);
          if (!userAlreadyPlacedBid) return [3, 2];
          return [4, updateLiveRemoteBid(segment, {
            bid_amount: bidAmount
          })];
        case 1:
          _b.sent();
          return [3, 4];
        case 2:
          return [4, submitLiveRemoteBid(segment, {
            purchase_profile_id: purchaseProfileId,
            bid_amount: bidAmount
          })];
        case 3:
          _b.sent();
          _b.label = 4;
        case 4:
          biddingStatus = (segment === null || segment === void 0 ? void 0 : segment.current_highest_bid) && (segment === null || segment === void 0 ? void 0 : segment.current_highest_bid.belongs_to_current_user) ? segment === null || segment === void 0 ? void 0 : segment.bidding_status : enums$1.LiveAuctionSegmentBiddingStatus.PlacingBid;
          currentUserBiddingStatus = (segment === null || segment === void 0 ? void 0 : segment.current_highest_bid) && (segment === null || segment === void 0 ? void 0 : segment.current_highest_bid.belongs_to_current_user) ? segment === null || segment === void 0 ? void 0 : segment.current_user_bidding_status : enums$1.LiveAuctionSegmentBiddingStatus.PlacingBid;
          (_a = segment[SPECIAL_SELF_REFERENCE].attemptWriteRef) === null || _a === void 0 ? void 0 : _a.current({
            data: [_assign(_assign({}, segment), {
              bidding_status: biddingStatus,
              current_user_bidding_status: currentUserBiddingStatus,
              current_user_remote_bid: {
                remote_bid_amount: bidAmount,
                purchase_profile_id: purchaseProfileId
              }
            })],
            source: 'local_optimistic_action'
          });
          return [2];
      }
    });
  });
};
var validateNextBidAmount = function validateNextBidAmount(segment, listing, nextBid) {
  var _a = calculateAuctionValues$1(segment, listing),
    askingBidAmount = _a.askingBidAmount,
    currentUserHighestBidAmount = _a.currentUserHighestBidAmount;
  var nextBidIsGreaterThanCurrentUserHighestBid = currentUserHighestBidAmount ? nextBid > currentUserHighestBidAmount : true;
  var safeAskingBidAmount = askingBidAmount || 0;
  var nextBidIsHigherOrEqualThanAskingBid = nextBid >= safeAskingBidAmount;
  if (!nextBidIsHigherOrEqualThanAskingBid || !nextBidIsGreaterThanCurrentUserHighestBid) {
    var currentUserBidIsGreaterThanAskingBid = currentUserHighestBidAmount && currentUserHighestBidAmount >= safeAskingBidAmount;
    var minimumNextBid = formatMoney$1(currentUserBidIsGreaterThanAskingBid ? currentUserHighestBidAmount : askingBidAmount || LIVE_BIDDING_MINIMUM);
    return {
      valid: false,
      message: currentUserBidIsGreaterThanAskingBid ? "Bid amount must be greater than ".concat(minimumNextBid, ".") : "Bid amount must be at least ".concat(minimumNextBid, ".")
    };
  }
  if (!isAcceptingRemoteBids(segment, listing)) return {
    valid: false,
    message: "You can't bid right now."
  };
  return {
    valid: true,
    message: ''
  };
};
var getUpdatedSegments = function getUpdatedSegments(oldSegment, newSegment) {
  var bids = oldSegment === null || oldSegment === void 0 ? void 0 : oldSegment.bids;
  var latestBid = bids === null || bids === void 0 ? void 0 : bids[0];
  var currentHighestBid = newSegment.current_highest_bid;
  var updatedBidHistory = [];
  if (!latestBid && !currentHighestBid) return null;else if (currentHighestBid && currentHighestBid.updated_date) {
    if (latestBid && latestBid.updated_date && bids.length) {
      if (latestBid.bid_id !== currentHighestBid.bid_id) {
        updatedBidHistory = currentHighestBid.updated_date > latestBid.updated_date ? __spreadArray([currentHighestBid], bids, true) : bids.filter(function (b) {
          return (b === null || b === void 0 ? void 0 : b.updated_date) && currentHighestBid.updated_date && (b === null || b === void 0 ? void 0 : b.updated_date) <= currentHighestBid.updated_date;
        });
        return _assign(_assign({}, newSegment), {
          bids: updatedBidHistory
        });
      } else {
        if (latestBid.updated_date !== currentHighestBid.updated_date) {
          updatedBidHistory = __spreadArray([currentHighestBid], bids.slice(1), true);
          return _assign(_assign({}, newSegment), {
            bids: updatedBidHistory
          });
        }
      }
    } else {
      updatedBidHistory.push(_assign({}, currentHighestBid));
      return _assign(_assign({}, newSegment), {
        bids: updatedBidHistory
      });
    }
  }
  return null;
};
var getBatchedSegmentData = function getBatchedSegmentData(source, focusedSegments, idempotentSegments) {
  var segmentsForFullOverWrite = focusedSegments.filter(function (l) {
    var segment = idempotentSegments.mapped.get(l.listing_id);
    return segment.auction_segment_id !== l.auction_segment_id;
  });
  var segmentsForPathOverwrite = focusedSegments.reduce(function (acc, current) {
    var segment = idempotentSegments.mapped.get(current.listing_id);
    var updatedSegment = getUpdatedSegments(segment, current);
    updatedSegment && acc.push(updatedSegment);
    return acc;
  }, []);
  var batchedData = [];
  (segmentsForPathOverwrite === null || segmentsForPathOverwrite === void 0 ? void 0 : segmentsForPathOverwrite.length) && batchedData.push({
    source: source,
    data: segmentsForPathOverwrite,
    path: 'bids',
    updateBehavior: 'overwrite'
  });
  (segmentsForFullOverWrite === null || segmentsForFullOverWrite === void 0 ? void 0 : segmentsForFullOverWrite.length) && batchedData.push({
    source: source,
    data: segmentsForFullOverWrite,
    updateBehavior: 'overwrite'
  });
  return batchedData;
};
var isEligibleForSaleFailed = function isEligibleForSaleFailed(segment, listing) {
  var _a, _b;
  var doesListingHasAB2424Constraint = Boolean((_a = listing.legal_constraints) === null || _a === void 0 ? void 0 : _a.find(function (constraint) {
    var _a;
    return constraint.is_applicable && ((_a = constraint.law_codes) === null || _a === void 0 ? void 0 : _a.includes(enums$1.LawCode.Ab2424));
  }));
  if (doesListingHasAB2424Constraint) return Boolean(((_b = segment.bids) === null || _b === void 0 ? void 0 : _b.filter(function (b) {
    return (b === null || b === void 0 ? void 0 : b.bid_type) !== enums$1.LiveAuctionSegmentBidType.OpeningBid;
  }).length) === 0);
  return false;
};
var liveAuctionUtils = {
  calculateAuctionValues: calculateAuctionValues$1,
  calculateProposedBidBreakdown: calculateProposedBidBreakdown,
  getBiddingStatusText: getBiddingStatusText$1,
  getStateDepositValues: getStateDepositValues,
  getStateDepositText: getStateDepositText,
  isAcceptingRemoteBids: isAcceptingRemoteBids,
  submitOrUpdateRemoteBid: submitOrUpdateRemoteBid,
  validateNextBidAmount: validateNextBidAmount,
  isEligibleForSaleFailed: isEligibleForSaleFailed
};

var WinningBidDepositBadge = function (_super) {
  __extends(WinningBidDepositBadge, _super);
  function WinningBidDepositBadge() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  WinningBidDepositBadge.shouldBeIncluded = function (_a) {
    var _b;
    var listing = _a.listing,
      segment = _a.segment;
    if (isForeclosure(listing)) {
      if ((_b = listing.trustee) === null || _b === void 0 ? void 0 : _b.online_state_deposit_amount) {
        return true;
      }
      if (segment && segment.__typename === 'LiveAuctionSegment') {
        var shouldShowStateDeposit = getStateDepositValues(segment, listing).shouldShowStateDeposit;
        return shouldShowStateDeposit;
      }
    }
    return false;
  };
  Object.defineProperty(WinningBidDepositBadge.prototype, "content", {
    get: function get() {
      var _a, _b;
      if ((_a = this.listing.trustee) === null || _a === void 0 ? void 0 : _a.online_state_deposit_amount) {
        return String(formatMoney(String((_b = this.listing.trustee) === null || _b === void 0 ? void 0 : _b.online_state_deposit_amount)));
      }
      if (this.segment && this.segment.__typename === 'LiveAuctionSegment') {
        var stateDepositLabel = getStateDepositValues(this.segment, this.listing).stateDepositLabel;
        return stateDepositLabel || '';
      }
      return '';
    },
    enumerable: false,
    configurable: true
  });
  WinningBidDepositBadge.title = 'Winning Bid Deposit';
  WinningBidDepositBadge.id = 'WinningBidDepositBadge';
  WinningBidDepositBadge.titleIcon = 'circle-dollar-to-slot';
  WinningBidDepositBadge.sellerTermsRenderPriority = BadgePriority.EIGHTH;
  WinningBidDepositBadge.tooltipContent = 'A Winning Bid Deposit is required for each property you successfully bid on and must be paid upon being declared the winning bidder. Further action will be required to submit the remaining balance.';
  return WinningBidDepositBadge;
}(ListingBadge);

var AVAILABLE_BADGES = [AgentInformationBadge, BrokerCoopAvailableBadge, BrokerCoopUnavailableBadge, BuyerPremiumAvailableBadge, BuyerPremiumUnavailableBadge, CashOnlyBadge, ClearedForSaleComingSoonBadge, ClearedForSalePendingBadge, ClearedForSalePostponedBadge, ClearedForSaleYesBadge, ConductedByADCLiveBadge, ConductedByADCOnlineBadge, FinancingAvailableBadge, FirstLookBadge, ForeclosureContactInformationBadge, InteriorAccessAvailableBadge, InteriorAccessAvailableNoAgentBadge, InteriorAccessUnavailableBadge, NewlyListedBadge, NotConductedByADCFCLBadge, NotConductedByADCLive, OpenHouseScheduledBadge, PropertyOccupiedBadge, PropertyUnknownOccupancyBadge, PropertyVacantBadge, RemoteBidBadge, RentalBadge, ShortSaleBadge, ShortSaleOpenHousesAvailableBadge, SubjectToRedemptionBadge, TitleAndLiensBadge];
var getCalculatedBadgeList = function getCalculatedBadgeList(_a) {
  var listing = _a.listing,
    priorityField = _a.priorityField,
    opts = _a.opts,
    badgeGroup = _a.badgeGroup,
    segment = _a.segment,
    viewingFrom = _a.viewingFrom;
  return ___default.chain(badgeGroup).map(function (Badge) {
    return new Badge(listing, segment);
  }).filter(function (badge) {
    return badge.getShouldBeIncluded({
      listing: listing,
      segment: segment,
      opts: opts,
      viewingFrom: viewingFrom
    });
  }).map(function (badge) {
    var overriddenProps = badge.getOverrideProps(listing);
    var fullBadge = {
      condensedTitle: badge.get('condensedTitle'),
      condensedTitleIcon: badge.get('condensedTitleIcon'),
      content: badge.content || badge.get('content'),
      contentPositive: badge.get('contentPositive'),
      color: badge.get('color'),
      renderPriority: badge.get(priorityField),
      shouldBeHoisted: badge.get('shouldBeHoisted'),
      summary: badge.get('summary'),
      textIcon: badge.get('textIcon'),
      title: badge.title || badge.get('title'),
      titleIcon: badge.get('titleIcon'),
      tooltipContent: badge.get('tooltipContent'),
      moneyValue: badge.get('moneyValue'),
      id: badge.get('id')
    };
    return _assign(_assign({}, fullBadge), overriddenProps);
  }).sortBy('title').sortBy('renderPriority').value();
};
var calculateBadges = function calculateBadges(listing, opts, badgeGroup) {
  var listingBadges = {
    hoistedBadges: [],
    nonHoistedBadges: []
  };
  var calculatedBadges = getCalculatedBadgeList({
    listing: listing,
    priorityField: 'renderPriority',
    opts: opts,
    badgeGroup: badgeGroup || AVAILABLE_BADGES
  });
  calculatedBadges.forEach(function (badge) {
    badge.shouldBeHoisted ? listingBadges.hoistedBadges.push(badge) : listingBadges.nonHoistedBadges.push(badge);
  });
  return listingBadges;
};
var PRIVATE_SELLER_BADGES = [FinanceAllowedBadge, AcceptedContingenciesBadge, PrivateToursBadge];
var SELLER_DASHBOARD_BADGES = __spreadArray(__spreadArray([], PRIVATE_SELLER_BADGES, true), [RentBackBadge, EarnestMoneyDepositBadge], false);
var calculatePrivateSellerBadges = function calculatePrivateSellerBadges(listing, viewingFrom) {
  var _a, _b;
  if (viewingFrom === void 0) {
    viewingFrom = graph.enums.CurrentTargetAudience.Seller;
  }
  var badges = viewingFrom === graph.enums.CurrentTargetAudience.Seller ? SELLER_DASHBOARD_BADGES : ___default.compact(__spreadArray(__spreadArray([], PRIVATE_SELLER_BADGES, true), [((_b = (_a = listing === null || listing === void 0 ? void 0 : listing.seller_terms) === null || _a === void 0 ? void 0 : _a.leaseback_terms) === null || _b === void 0 ? void 0 : _b.leaseback_period_in_days) ? RentBackBadge : undefined], false)).map(function (badge, index) {
    ___default.set(badge, 'renderPriority', index);
    return badge;
  });
  var calculatedBadges = calculateBadges(listing, undefined, badges);
  return calculatedBadges.hoistedBadges.flat().concat(calculatedBadges.nonHoistedBadges.flat());
};
var IMPORTANT_INFO_BADGE_GROUP = [PropertyOccupiedBadge, PropertyVacantBadge, RentbackOffer, RentbackAuction, TitleAndLiensBadge, SubjectToRedemptionBadge, ForeclosureContactInformationBadge, FinanceContingency, InspectionContigency, OptionFee, RentalBadge];
var calculatePDPRedesignBadges = function calculatePDPRedesignBadges(listing) {
  return getCalculatedBadgeList({
    listing: listing,
    priorityField: 'importantInfoRenderPriority',
    opts: {
      badgeMode: BadgeMode.EXPANDED
    },
    badgeGroup: IMPORTANT_INFO_BADGE_GROUP
  });
};
var SELLER_TERMS_BADGE_GROUP = [AcceptedPaymentTypesBadge, AcceptedContingenciesBadge, BuyerPremiumAvailableBadge, OptionPeriod, EarnestMoneyDepositBadgeTerm, RentbackRequestedPeriod, RentbackRequiredPeriod, AdditionalTermsBadge, ClearedForSalePostponedBadge, ClearedForSalePendingBadge, ClearedForSaleComingSoonBadge, ClearedForSaleYesBadge, NotConductedByADCFCLBadge, ConductedByADCOnlineBadge, ConductedByADCLiveBadge, NotConductedByADCLive, CashOnlyBadge, FinancingAvailableBadge, BrokerCoopAvailableBadge, BrokerCoopUnavailableBadge, WinningBidDepositBadge];
var calculatePDPSellerTermsBadges = function calculatePDPSellerTermsBadges(listing, segment) {
  var badges = getCalculatedBadgeList({
    listing: listing,
    priorityField: 'sellerTermsRenderPriority',
    opts: {
      badgeMode: BadgeMode.EXPANDED
    },
    badgeGroup: SELLER_TERMS_BADGE_GROUP,
    segment: segment
  });
  return badges;
};
var badges = {
  FinanceContingency: FinanceContingency,
  InspectionContigency: InspectionContigency,
  OptionFee: OptionFee,
  RentbackOffer: RentbackOffer,
  RentbackAuction: RentbackAuction,
  AdditionalTermsBadge: AdditionalTermsBadge,
  WinningBidDepositBadge: WinningBidDepositBadge
};

var ACTION_TERMS = {
  OH: {
    acceptedPaymentTypes: 'Cash via wire only.',
    buyerInformation: 'Complete a buyer information sheet provided to you within 2 hours of the auction.',
    paymentInstructions: 'Submit your deposit in the amount designated by the terms of the sale within 2 hours of auction end. The remaining balance will be due within 30 days.'
  },
  IL: {
    acceptedPaymentTypes: 'Cash via wire or certified check.',
    buyerInformation: 'We will contact you via phone within 2 hours of the close of the auction to collect the information for your receipt of sale.',
    paymentInstructions: 'You will be required to remit the full funds for your purchase by the next business day.'
  }
};

var getOnlineRegistrationActionTerms = function getOnlineRegistrationActionTerms(listing) {
  var input = {
    isTPSOhio: isTPSOhio$1(listing),
    isTPSIllinois: isTPSIllinois(listing)
  };
  return match(input).with({
    isTPSOhio: true,
    isTPSIllinois: false
  }, function () {
    return ACTION_TERMS.OH;
  }).with({
    isTPSOhio: false,
    isTPSIllinois: true
  }, function () {
    return ACTION_TERMS.IL;
  }).otherwise(function () {
    return {};
  });
};

var registrationUtils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getOnlineRegistrationActionTerms: getOnlineRegistrationActionTerms
});

var HotBadge = function (_super) {
  __extends(HotBadge, _super);
  function HotBadge() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  HotBadge.title = 'Hot';
  HotBadge.renderPriority = BadgePriority.THIRD;
  HotBadge.shouldBeIncluded = function (_a) {
    var listing = _a.listing;
    return Boolean(listing.is_hot);
  };
  return HotBadge;
}(ListingBadge);

var LikelyToGoToSaleBadge = function (_super) {
  __extends(LikelyToGoToSaleBadge, _super);
  function LikelyToGoToSaleBadge() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  LikelyToGoToSaleBadge.title = 'FCL Predict';
  LikelyToGoToSaleBadge.renderPriority = BadgePriority.THIRD;
  LikelyToGoToSaleBadge.shouldBeIncluded = function (_a) {
    var listing = _a.listing;
    return Boolean(hasMarketingTag(listing, MarketingTags.GOTO) && isForeclosure(listing));
  };
  return LikelyToGoToSaleBadge;
}(ListingBadge);

var NewlyVacantBadge = function (_super) {
  __extends(NewlyVacantBadge, _super);
  function NewlyVacantBadge() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  NewlyVacantBadge.title = 'Now Vacant';
  NewlyVacantBadge.overrideProps = function (listing) {
    return {
      renderPriority: isForeclosure(listing) ? BadgePriority.FOURTH : BadgePriority.FIRST
    };
  };
  NewlyVacantBadge.shouldBeIncluded = function (_a) {
    var listing = _a.listing;
    return Boolean(hasMarketingTag(listing, MarketingTags.NEWV));
  };
  return NewlyVacantBadge;
}(ListingBadge);

var PriceDroppedBadge = function (_super) {
  __extends(PriceDroppedBadge, _super);
  function PriceDroppedBadge() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  PriceDroppedBadge.title = 'Price Drop';
  PriceDroppedBadge.renderPriority = BadgePriority.SECOND;
  PriceDroppedBadge.shouldBeIncluded = function (_a) {
    var listing = _a.listing;
    return Boolean(hasMarketingTag(listing, MarketingTags.PRCD) && !isForeclosure(listing));
  };
  return PriceDroppedBadge;
}(ListingBadge);

var MakeAnOfferBadge = function (_super) {
  __extends(MakeAnOfferBadge, _super);
  function MakeAnOfferBadge() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  MakeAnOfferBadge.shouldBeIncluded = function (_a) {
    var _b, _c;
    var listing = _a.listing,
      viewingFrom = _a.viewingFrom;
    return ((_c = (_b = listing.strategy) === null || _b === void 0 ? void 0 : _b.selling_method_attributes) === null || _c === void 0 ? void 0 : _c.online_segment_type) === enums$1.OnlineAuctionSegmentType.SealedBid && viewingFrom === enums$1.CurrentTargetAudience.Buyer;
  };
  MakeAnOfferBadge.title = 'Make an Offer';
  MakeAnOfferBadge.renderPriority = BadgePriority.SECOND;
  MakeAnOfferBadge.color = 'purple';
  return MakeAnOfferBadge;
}(ListingBadge);

var availableBadges = [NextOpenHouseBadge, MakeAnOfferBadge, NewlyVacantBadge, PriceDroppedBadge, FirstLookBadge, InteriorAccessAvailableBadge, InteriorAccessAvailableNoAgentBadge, HotBadge, LikelyToGoToSaleBadge];
var calculatePropertyCardBadges = function calculatePropertyCardBadges(listing, viewingFrom) {
  var badges = getCalculatedBadgeList({
    listing: listing,
    priorityField: 'renderPriority',
    badgeGroup: availableBadges,
    viewingFrom: viewingFrom
  });
  return badges;
};

var GOING_ONCE_UPPER_BOUND = 12;
var GOING_TWICE_UPPER_BOUND = 6;
var ONLINE_BIDDING_MINIMUM = 1;
var CLOSING_WAITING_PERIOD_DAYS = 1;
var nextBusinessDay = function nextBusinessDay(date) {
  if (date.isoWeekday() > 5) {
    date.add(8 % date.isoWeekday(), 'days');
  }
  return date;
};
var calculateAuctionValues = function calculateAuctionValues(segment, listing) {
  return {
    nextBidAmount: getNextBidAmount(segment),
    nextProxyBidAmount: getNextProxyBidAmount$1(segment, listing),
    hasBids: hasBids(segment)
  };
};
var calculateOnlineAuctionValues = function calculateOnlineAuctionValues(segment, listing) {
  return {
    nextBidAmount: getNextBidAmount(segment),
    nextProxyBidAmount: getNextProxyBidAmount$1(segment, listing),
    hasBids: hasBids(segment)
  };
};
var didHighestBidMeetsReserve = function didHighestBidMeetsReserve(segment) {
  var _a;
  return !!((segment === null || segment === void 0 ? void 0 : segment.current_reserve_amount) && ((_a = segment.result) === null || _a === void 0 ? void 0 : _a.winning_bid_amount) && segment.result.winning_bid_amount >= segment.current_reserve_amount);
};
var formatCountdownTime = function formatCountdownTime(_segment, end) {
  var countDownTimeObject = {
    primary: '',
    secondary: ''
  };
  var endDateTime = moment(isNumberType(end) ? new Date().getTime() + end * 1000 : end);
  var duration = moment.duration(endDateTime.diff(Date()));
  if (duration.asDays() >= 1) {
    countDownTimeObject.primary = "".concat(duration.days(), "d ").concat(duration.hours(), "h");
  } else if (duration.asHours() >= 1) {
    countDownTimeObject.primary = "".concat(duration.hours(), "h ").concat(duration.minutes(), "m");
  } else if (duration.asMinutes() >= 1) {
    countDownTimeObject.primary = "".concat(duration.minutes(), "m ").concat(duration.seconds(), "s");
  } else {
    var seconds = duration.seconds();
    countDownTimeObject.primary = seconds > 0 ? "".concat(seconds, "s") : '';
    if (GOING_ONCE_UPPER_BOUND >= seconds) {
      if (seconds > GOING_TWICE_UPPER_BOUND) {
        countDownTimeObject.secondary = 'GOING ONCE!';
      } else if (seconds > 0) {
        countDownTimeObject.secondary = 'GOING TWICE!';
      } else {
        countDownTimeObject.secondary = "FINALIZING...";
      }
    }
  }
  return countDownTimeObject;
};
var getAuctionStatus = function getAuctionStatus(segment, listing) {
  var closedListingStatuses = [enums$1.ListingStatus.Closed, enums$1.ListingStatus.SaleGatekeeping, enums$1.ListingStatus.SalePaymentPending];
  switch (segment === null || segment === void 0 ? void 0 : segment.segment_status) {
    case enums$1.OnlineAuctionSegmentStatus.Pending:
      return 'Not Started';
    case enums$1.OnlineAuctionSegmentStatus.Started:
    case enums$1.OnlineAuctionSegmentStatus.SubjectToReserveMet:
    case enums$1.OnlineAuctionSegmentStatus.ReserveMet:
    case enums$1.OnlineAuctionSegmentStatus.SellerReviewPeriod:
      return 'Live';
    case enums$1.OnlineAuctionSegmentStatus.Ended:
      if (closedListingStatuses.includes(listing === null || listing === void 0 ? void 0 : listing.listing_status)) {
        return segment.subject_to_status === enums$1.SubjectToStatus.Pending ? 'Sold subject to' : 'Sold';
      }
      break;
  }
  return 'Gone';
};
var isAuctionInProgress = function isAuctionInProgress(segment) {
  var inProgressEnglishArray = [enums$1.OnlineAuctionSegmentStatus.Started, enums$1.OnlineAuctionSegmentStatus.SubjectToReserveMet, enums$1.OnlineAuctionSegmentStatus.ReserveMet];
  return segment.segment_type === enums$1.OnlineAuctionSegmentType.SealedBid ? __spreadArray(__spreadArray([], inProgressEnglishArray, true), [enums$1.OnlineAuctionSegmentStatus.HighestAndBestDecision, enums$1.OnlineAuctionSegmentStatus.HighestAndBestOpen, enums$1.OnlineAuctionSegmentStatus.SellerReviewPeriod], false).includes(segment === null || segment === void 0 ? void 0 : segment.segment_status) : inProgressEnglishArray.includes(segment === null || segment === void 0 ? void 0 : segment.segment_status);
};
var isOfferPathViewableForCurrentUser = function isOfferPathViewableForCurrentUser(segment) {
  if (segment.__typename === 'OnlineAuctionSegment' && segment.segment_type === enums$1.OnlineAuctionSegmentType.SealedBid) {
    var doesCurrentUserHasAnOffer_1 = Boolean(segment.current_user_bidding_status && ![enums$1.OnlineAuctionSegmentBiddingStatus.NoBid, enums$1.OnlineAuctionSegmentBiddingStatus.WithdrawnBid].includes(segment.current_user_bidding_status));
    var doesCurrentUserHasRejectedOfferAndSegmentIsEnded = enums$1.OnlineAuctionSegmentBiddingStatus.RejectedBid === segment.current_user_bidding_status && enums$1.OnlineAuctionSegmentStatus.Ended === segment.segment_status;
    if (!isAuctionInProgress(segment)) {
      if (doesCurrentUserHasRejectedOfferAndSegmentIsEnded) {
        return false;
      }
      return doesCurrentUserHasAnOffer_1;
    }
    return match(segment).with({
      segment_status: enums$1.OnlineAuctionSegmentStatus.HighestAndBestOpen,
      current_user_bidding_status: enums$1.OnlineAuctionSegmentBiddingStatus.NoBid
    }, function () {
      return false;
    }).with({
      segment_status: enums$1.OnlineAuctionSegmentStatus.HighestAndBestDecision
    }, function () {
      return doesCurrentUserHasAnOffer_1;
    }).otherwise(function () {
      return true;
    });
  }
  return false;
};
var getBiddingStatusText = function getBiddingStatusText(segment) {
  var _a;
  var messageId = 'bidding:online:bid_status';
  switch (segment.current_user_bidding_status) {
    case enums$1.OnlineAuctionSegmentBiddingStatus.HighestBid:
      var shouldBidAgain = (_a = segment.configuration) === null || _a === void 0 ? void 0 : _a.should_bid_again;
      return {
        id: messageId,
        title: shouldBidAgain ? 'Bid again. Below reserve.' : 'You are Ranked #1',
        intent: shouldBidAgain ? 'NEUTRAL' : 'POSITIVE'
      };
    case enums$1.OnlineAuctionSegmentBiddingStatus.Lost:
      return {
        id: messageId,
        title: 'You Did Not Win',
        intent: 'NEGATIVE'
      };
    case enums$1.OnlineAuctionSegmentBiddingStatus.Outbid:
      return {
        id: messageId,
        title: 'Your Rank has Changed',
        intent: 'NEGATIVE'
      };
    case enums$1.OnlineAuctionSegmentBiddingStatus.Won:
      return {
        id: messageId,
        title: "You've Won!",
        intent: 'POSITIVE'
      };
    default:
      return null;
  }
};
var getNextBidAmount = function getNextBidAmount(segment) {
  var currentIncrementAmount = segment.current_increment_amount;
  if (currentIncrementAmount === 0) currentIncrementAmount = ONLINE_BIDDING_MINIMUM;
  if (!hasBids(segment)) return segment.starting_bid_amount;
  return (segment.current_highest_bid ? segment.current_highest_bid.bid_amount : segment.starting_bid_amount) + (currentIncrementAmount !== null && currentIncrementAmount !== void 0 ? currentIncrementAmount : 0);
};
var getNextProxyBidAmount$1 = function getNextProxyBidAmount(segment, listing) {
  if (isProxyBiddingActive$1(segment, listing)) {
    var startingBidAmount = segment.starting_bid_amount;
    var maxBid = segment.current_user_max_bid;
    var currentUserMaxBidAmount = (maxBid === null || maxBid === void 0 ? void 0 : maxBid.record_status) !== enums$1.RecordStatus.Inactive ? maxBid === null || maxBid === void 0 ? void 0 : maxBid.max_bid_amount : null;
    return currentUserMaxBidAmount ? Math.max(startingBidAmount, currentUserMaxBidAmount + ONLINE_BIDDING_MINIMUM) : startingBidAmount;
  }
  return null;
};
var isAuctionNotStarted = function isAuctionNotStarted(segment) {
  return (segment === null || segment === void 0 ? void 0 : segment.segment_status) === enums$1.OnlineAuctionSegmentStatus.Pending;
};
var hasBids = function hasBids(segment) {
  return (segment.bid_count || 0) > 0;
};
var highestBidMeetsReserve = function highestBidMeetsReserve(segment) {
  return didHighestBidMeetsReserve(segment) || segment.reserve_status === enums$1.ReserveStatus.ReserveMet;
};
var isOnlineAuctionActive = function isOnlineAuctionActive(segment) {
  return [enums$1.OnlineAuctionSegmentStatus.Started, enums$1.OnlineAuctionSegmentStatus.SubjectToReserveMet, enums$1.OnlineAuctionSegmentStatus.ReserveMet, enums$1.OnlineAuctionSegmentStatus.HighestAndBestOpen, enums$1.OnlineAuctionSegmentStatus.HighestAndBestDecision, enums$1.OnlineAuctionSegmentStatus.SellerReviewPeriod].includes(segment.segment_status);
};
var isProxyBiddingActive$1 = function isProxyBiddingActive(segment, listing) {
  return isAuctionNotStarted(segment) && segment.configuration.is_max_bidding_enabled && Boolean(listing.is_current_user_registered_for_online_auction);
};
var getSellerDisclosureValues = function getSellerDisclosureValues(segment, listing, currentUserPartyId) {
  var _a, _b, _c;
  var marketingAttribute = (listing.marketing_attributes || []).find(function (elem) {
    return (elem === null || elem === void 0 ? void 0 : elem.attribute_type) === enums$1.MarketingAttributeType.SellerDisclosure;
  });
  var showSellerDisclosure = ((_a = segment === null || segment === void 0 ? void 0 : segment.current_highest_bid) === null || _a === void 0 ? void 0 : _a.type) === enums$1.OnlineAuctionSegmentBidType.Seller && (marketingAttribute === null || marketingAttribute === void 0 ? void 0 : marketingAttribute.show) === true;
  var bidAgainCount = ((_b = segment.configuration) === null || _b === void 0 ? void 0 : _b.bid_again_count) || 0;
  var isBidAgain = currentUserPartyId === ((_c = segment.current_highest_bid) === null || _c === void 0 ? void 0 : _c.bidder_party_id) && bidAgainCount > 0;
  var sellerDisclosureLabel = sellerDisclosureLabelMatch({
    isBidAgain: isBidAgain,
    show: showSellerDisclosure,
    label: marketingAttribute === null || marketingAttribute === void 0 ? void 0 : marketingAttribute.label
  });
  var sellerDisclosureTooltipText = sellerDisclosureTooltipMatch({
    isBidAgain: isBidAgain,
    show: showSellerDisclosure,
    tooltip: marketingAttribute === null || marketingAttribute === void 0 ? void 0 : marketingAttribute.message
  });
  return {
    showSellerDisclosure: showSellerDisclosure,
    sellerDisclosureLabel: sellerDisclosureLabel,
    sellerDisclosureTooltipText: sellerDisclosureTooltipText
  };
};
var sellerDisclosureLabelMatch = function sellerDisclosureLabelMatch(status) {
  return match(status).with({
    isBidAgain: true
  }, function () {
    return 'Counter Bid';
  }).when(function () {
    return status.show && status.label;
  }, function () {
    return status.label;
  }).otherwise(function () {
    return '';
  });
};
var sellerDisclosureTooltipMatch = function sellerDisclosureTooltipMatch(status) {
  return match(status).with({
    isBidAgain: true
  }, function () {
    return 'You did not meet the reserve. Bid Again.';
  }).when(function () {
    return status.show && status.tooltip;
  }, function () {
    return status.tooltip;
  }).otherwise(function () {
    return '';
  });
};
var shouldShowOneBidAway = function shouldShowOneBidAway(segment) {
  return enums$1.BidsAwayStatus.OneAwayDisplayed === segment.configuration.bids_away_status || enums$1.BidsAwayStatus.OneAway === segment.configuration.bids_away_status;
};
var shouldShowTwoBidAway = function shouldShowTwoBidAway(segment) {
  return enums$1.BidsAwayStatus.TwoAwayDisplayed === segment.configuration.bids_away_status || enums$1.BidsAwayStatus.TwoAway === segment.configuration.bids_away_status;
};
var calculateOccupancyDisclaimerRequirements = function calculateOccupancyDisclaimerRequirements(segment, listing) {
  var _a, _b, _c;
  var currentPropertyAssetType = (_a = listing.listing_configuration) === null || _a === void 0 ? void 0 : _a.asset_type;
  var currentPropertyOccupancyStatus = (_b = listing.listing_configuration) === null || _b === void 0 ? void 0 : _b.occupancy_status;
  var required = currentPropertyAssetType === enums$1.AssetType.BankOwned && currentPropertyOccupancyStatus === enums$1.OccupancyStatus.Occupied;
  var currentUserBiddingStatus = segment === null || segment === void 0 ? void 0 : segment.current_user_bidding_status;
  var acknowledged = Boolean(currentUserBiddingStatus) && currentUserBiddingStatus !== enums$1.OnlineAuctionSegmentBiddingStatus.NoBid || Boolean((_c = segment === null || segment === void 0 ? void 0 : segment.current_user_max_bid) === null || _c === void 0 ? void 0 : _c.max_bid_amount);
  return {
    required: required,
    acknowledged: acknowledged
  };
};
var isContractingPastDue = function isContractingPastDue(segment) {
  if (!segment.initial_end_date) {
    return false;
  }
  var provideByTime = nextBusinessDay(moment(segment.initial_end_date).add(CLOSING_WAITING_PERIOD_DAYS, 'days'));
  return moment().isAfter(provideByTime);
};
var shouldShowSealedBidTreatment = function shouldShowSealedBidTreatment(segment, featureFlags) {
  if (featureFlags === void 0) {
    featureFlags = {};
  }
  return Boolean(featureFlags['fe.resi.enable-private-seller'] && (segment === null || segment === void 0 ? void 0 : segment.__typename) === 'OnlineAuctionSegment' && segment.segment_type === enums$1.OnlineAuctionSegmentType.SealedBid);
};
var getOptimisticValueForNegotiationSequence = function getOptimisticValueForNegotiationSequence(nextBid, existingBid) {
  if (nextBid === null || nextBid === void 0 ? void 0 : nextBid.negotiation_sequence) {
    return nextBid.negotiation_sequence;
  }
  var negotiationSequence = (existingBid === null || existingBid === void 0 ? void 0 : existingBid.negotiation_sequence) || {
    start_date: new Date()
  };
  var existingNegotiationCounters = (negotiationSequence === null || negotiationSequence === void 0 ? void 0 : negotiationSequence.counters) || [];
  return _assign(_assign({}, negotiationSequence), {
    counters: __spreadArray(__spreadArray([], existingNegotiationCounters, true), [nextBid], false)
  });
};
var updateIfExistingBidInRanking = function updateIfExistingBidInRanking(attemptSegmentWrite, source, bid, bidRanking) {
  var _a, _b, _c;
  var existingBidRank = (_a = bidRanking === null || bidRanking === void 0 ? void 0 : bidRanking.ranking) === null || _a === void 0 ? void 0 : _a.find(function (r) {
    return r.bid_id === (bid === null || bid === void 0 ? void 0 : bid.bid_id);
  });
  if (existingBidRank && (existingBidRank.rank === (bid === null || bid === void 0 ? void 0 : bid.rank) || !(bid === null || bid === void 0 ? void 0 : bid.rank))) {
    var isBidWithdrawn = ((_b = bid === null || bid === void 0 ? void 0 : bid.terms) === null || _b === void 0 ? void 0 : _b.status) === enums$1.SealedBidStatus.Withdrawn;
    var nextRanking = __spreadArray([], bidRanking === null || bidRanking === void 0 ? void 0 : bidRanking.ranking, true);
    isBidWithdrawn ? nextRanking.splice(existingBidRank.rank - 1, 1) : nextRanking.splice(existingBidRank.rank - 1, 1, _assign(_assign({}, existingBidRank), {
      bid: _assign(_assign(_assign({}, existingBidRank.bid), bid), {
        negotiation_sequence: getOptimisticValueForNegotiationSequence(bid, existingBidRank.bid)
      })
    }));
    var updatedSegment = {
      listing_id: bidRanking === null || bidRanking === void 0 ? void 0 : bidRanking.listing_id,
      bids_ranking: _assign(_assign({}, bidRanking), {
        ranking: nextRanking
      })
    };
    if (((_c = bid === null || bid === void 0 ? void 0 : bid.terms) === null || _c === void 0 ? void 0 : _c.status) === enums$1.SealedBidStatus.SellerCountered) {
      updatedSegment = _assign(_assign({}, updatedSegment), {
        seller_counter_bid_count: 1
      });
    }
    var data = [updatedSegment];
    attemptSegmentWrite({
      data: data,
      source: source,
      force: true
    });
  }
};
var isHighestAndBestRound = function isHighestAndBestRound(segment) {
  return (segment === null || segment === void 0 ? void 0 : segment.segment_type) === enums$1.OnlineAuctionSegmentType.SealedBid && ((segment === null || segment === void 0 ? void 0 : segment.segment_status) === enums$1.OnlineAuctionSegmentStatus.HighestAndBestOpen || (segment === null || segment === void 0 ? void 0 : segment.segment_status) === enums$1.OnlineAuctionSegmentStatus.HighestAndBestDecision);
};
var isCurrentUserSealedBidRejected = function isCurrentUserSealedBidRejected(segment) {
  return (segment === null || segment === void 0 ? void 0 : segment.segment_type) === enums$1.OnlineAuctionSegmentType.SealedBid && (segment === null || segment === void 0 ? void 0 : segment.current_user_bidding_status) === graph.enums.OnlineAuctionSegmentBiddingStatus.RejectedBid;
};
var getCurrentUserSealedBid = function getCurrentUserSealedBid(segment) {
  var _a;
  return isCurrentUserSealedBidRejected(segment) ? segment === null || segment === void 0 ? void 0 : segment.current_user_highest_bid : (_a = getCurrentUserSealedBidRank(segment)) === null || _a === void 0 ? void 0 : _a.bid;
};
var getCurrentUserSealedBidRank = function getCurrentUserSealedBidRank(segment) {
  var _a;
  return (_a = segment.bids_ranking) === null || _a === void 0 ? void 0 : _a.ranking.find(function (bid) {
    return bid.belongs_to_current_user;
  });
};
var getCounterofferBid = function getCounterofferBid(segment, bid) {
  var _a, _b, _c;
  var segmentBid = bid !== null && bid !== void 0 ? bid : getCurrentUserSealedBidRank(segment);
  var counteroffer = (_b = (_a = segmentBid === null || segmentBid === void 0 ? void 0 : segmentBid.negotiation_sequence) === null || _a === void 0 ? void 0 : _a.latest_counter_bid) !== null && _b !== void 0 ? _b : null;
  if (!!((_c = counteroffer === null || counteroffer === void 0 ? void 0 : counteroffer.terms) === null || _c === void 0 ? void 0 : _c.expiration_date)) {
    var expirationDate = new Date(counteroffer.terms.expiration_date);
    return isAfter(expirationDate, new Date()) ? counteroffer : null;
  }
  return counteroffer;
};
var notAllowedStatusesToSubmitNewOfferAfterRejected = new Set([graph.enums.OnlineAuctionSegmentStatus.HighestAndBestDecision, graph.enums.OnlineAuctionSegmentStatus.Ended]);
var allowedStatusesToSubmitNewOffer = new Set([graph.enums.OnlineAuctionSegmentStatus.Started, graph.enums.OnlineAuctionSegmentStatus.SellerReviewPeriod, graph.enums.OnlineAuctionSegmentStatus.HighestAndBestOpen]);
var allowToSubmitNewOffers = function allowToSubmitNewOffers(segment) {
  if (isCurrentUserSealedBidRejected(segment)) {
    return !notAllowedStatusesToSubmitNewOfferAfterRejected.has(segment.segment_status);
  }
  return allowedStatusesToSubmitNewOffer.has(segment.segment_status);
};
var previousValueOrUndefined = function previousValueOrUndefined(currentValue, previousValue, isMoneyValue) {
  if (isMoneyValue === void 0) {
    isMoneyValue = false;
  }
  if (!!previousValue && currentValue !== previousValue) {
    return previousValue;
  }
  if (!!currentValue && !previousValue && isMoneyValue) {
    return 0;
  }
  return undefined;
};
var cleanFieldName = function cleanFieldName(fieldKey) {
  return fieldKey.replace('/terms/', '').replace('notes/', '');
};
var updatePreviousValues = function updatePreviousValues(currentOfferTerms, fieldKey, fieldValue, previousValues) {
  var _a;
  if (!fieldValue) return previousValues;
  var currentFieldValue = currentOfferTerms[fieldKey];
  var finalPreviousValue = previousValueOrUndefined(currentFieldValue, fieldValue, typeof fieldValue === 'number');
  if (finalPreviousValue !== undefined) {
    previousValues = _assign(_assign({}, previousValues), (_a = {}, _a[fieldKey] = fieldValue, _a));
  }
  return previousValues;
};
var getWhatFieldChanged = function getWhatFieldChanged(bid) {
  var _a;
  var currentOfferTerms = bid === null || bid === void 0 ? void 0 : bid.terms;
  var auditHistory = bid === null || bid === void 0 ? void 0 : bid.audit_history;
  if (!(auditHistory === null || auditHistory === void 0 ? void 0 : auditHistory.length) || auditHistory.length <= 1) return undefined;
  var previousValues = {};
  auditHistory.sort(function (a, b) {
    return moment(a === null || a === void 0 ? void 0 : a.updated_date).isBefore(b === null || b === void 0 ? void 0 : b.updated_date) ? -1 : moment(a === null || a === void 0 ? void 0 : a.updated_date).isAfter(b === null || b === void 0 ? void 0 : b.updated_date) ? 1 : 0;
  });
  var currentOfferDelta = (_a = auditHistory[auditHistory.length - 1]) === null || _a === void 0 ? void 0 : _a.delta;
  if (currentOfferDelta) {
    if ((currentOfferDelta === null || currentOfferDelta === void 0 ? void 0 : currentOfferDelta.modified) && Object.keys(currentOfferDelta === null || currentOfferDelta === void 0 ? void 0 : currentOfferDelta.modified).length > 0 || (currentOfferDelta === null || currentOfferDelta === void 0 ? void 0 : currentOfferDelta.added) && Object.keys(currentOfferDelta === null || currentOfferDelta === void 0 ? void 0 : currentOfferDelta.added).length > 0 || Array.isArray(currentOfferDelta === null || currentOfferDelta === void 0 ? void 0 : currentOfferDelta.removed) && (currentOfferDelta === null || currentOfferDelta === void 0 ? void 0 : currentOfferDelta.removed.length) > 0) {
      var fieldKeys = Object.values(WhatChangedFields);
      fieldKeys.forEach(function (fieldKey) {
        var _a, _b, _c, _d;
        var _e, _f, _g;
        var currentModifiedValue = (currentOfferDelta === null || currentOfferDelta === void 0 ? void 0 : currentOfferDelta.modified)[fieldKey];
        var currentAddedValue = (currentOfferDelta === null || currentOfferDelta === void 0 ? void 0 : currentOfferDelta.added)[fieldKey];
        var currentRemovedValue = ((_e = currentOfferDelta === null || currentOfferDelta === void 0 ? void 0 : currentOfferDelta.removed) === null || _e === void 0 ? void 0 : _e.includes(fieldKey)) ? fieldKey : undefined;
        if (currentModifiedValue !== undefined || currentRemovedValue !== undefined) {
          for (var i = auditHistory.length - 2; i >= 0; i--) {
            var entryDelta = (_f = auditHistory[i]) === null || _f === void 0 ? void 0 : _f.delta;
            var modiFiedValue = (entryDelta === null || entryDelta === void 0 ? void 0 : entryDelta.modified)[fieldKey];
            var added = entryDelta === null || entryDelta === void 0 ? void 0 : entryDelta.added;
            var addedTerms = added['/terms'];
            var addedFieldValue = added[fieldKey];
            var removedFieldValue = (_g = entryDelta === null || entryDelta === void 0 ? void 0 : entryDelta.removed) === null || _g === void 0 ? void 0 : _g.includes(fieldKey);
            if (modiFiedValue !== undefined) {
              previousValues = updatePreviousValues(currentOfferTerms, fieldKey, modiFiedValue, previousValues);
              break;
            } else if (addedTerms !== undefined) {
              var addedFieldValue_1 = addedTerms[cleanFieldName(fieldKey)];
              if (addedFieldValue_1 !== undefined) {
                previousValues = updatePreviousValues(currentOfferTerms, fieldKey, addedFieldValue_1, previousValues);
                break;
              }
            } else if (addedFieldValue !== undefined) {
              if (fieldKey === WhatChangedFields.commission) {
                var commission = addedFieldValue;
                if ((commission === null || commission === void 0 ? void 0 : commission.agent_commission_amount) !== undefined && (commission === null || commission === void 0 ? void 0 : commission.paid_by) !== undefined) {
                  previousValues = updatePreviousValues(currentOfferTerms, WhatChangedFields.agentCommissionAmount, commission.agent_commission_amount, previousValues);
                  previousValues = updatePreviousValues(currentOfferTerms, WhatChangedFields.paidBy, commission.paid_by, previousValues);
                }
              } else {
                previousValues = updatePreviousValues(currentOfferTerms, fieldKey, addedFieldValue, previousValues);
              }
              break;
            } else if (removedFieldValue) {
              previousValues = _assign(_assign({}, previousValues), (_a = {}, _a[fieldKey] = '', _a));
              break;
            }
          }
        } else if (currentAddedValue !== undefined) {
          if (fieldKey === WhatChangedFields.commission) {
            var commission = currentAddedValue;
            if ((commission === null || commission === void 0 ? void 0 : commission.agent_commission_amount) !== undefined && (commission === null || commission === void 0 ? void 0 : commission.paid_by) !== undefined) {
              previousValues = _assign(_assign({}, previousValues), (_b = {}, _b[WhatChangedFields.agentCommissionAmount] = 0, _b));
              previousValues = _assign(_assign({}, previousValues), (_c = {}, _c[WhatChangedFields.paidBy] = 'N/A', _c));
            }
          } else {
            previousValues = _assign(_assign({}, previousValues), (_d = {}, _d[fieldKey] = typeof currentAddedValue === 'number' ? 0 : '', _d));
          }
        }
      });
    }
  }
  return Object.keys(previousValues).length > 0 ? previousValues : undefined;
};
var onlineAuctionUtils = {
  calculateAuctionValues: calculateAuctionValues,
  calculateOnlineAuctionValues: calculateOnlineAuctionValues,
  didHighestBidMeetsReserve: didHighestBidMeetsReserve,
  formatCountdownTime: formatCountdownTime,
  getAuctionStatus: getAuctionStatus,
  isAuctionInProgress: isAuctionInProgress,
  isOfferPathViewableForCurrentUser: isOfferPathViewableForCurrentUser,
  getBiddingStatusText: getBiddingStatusText,
  getNextBidAmount: getNextBidAmount,
  getNextProxyBidAmount: getNextProxyBidAmount$1,
  getSellerDisclosureValues: getSellerDisclosureValues,
  hasBids: hasBids,
  highestBidMeetsReserve: highestBidMeetsReserve,
  isAuctionNotStarted: isAuctionNotStarted,
  isOnlineAuctionActive: isOnlineAuctionActive,
  isProxyBiddingActive: isProxyBiddingActive$1,
  shouldShowOneBidAway: shouldShowOneBidAway,
  shouldShowTwoBidAway: shouldShowTwoBidAway,
  shouldShowSealedBidTreatment: shouldShowSealedBidTreatment,
  calculateOccupancyDisclaimerRequirements: calculateOccupancyDisclaimerRequirements,
  submitOnlineMatchBid: submitOnlineMatchBid,
  submitOnlineRegularBid: submitOnlineRegularBid,
  upsertListingOnlineMaxBid: upsertListingOnlineMaxBid,
  isContractingPastDue: isContractingPastDue,
  isHighestAndBestRound: isHighestAndBestRound,
  upsertSealedBid: upsertSealedBid,
  acceptSellerCounterBid: acceptSellerCounterBid,
  rejectSellerCounterBid: rejectSellerCounterBid,
  withdrawSealedBid: withdrawSealedBid,
  acceptBuyerBid: acceptBuyerBid,
  placeSellerCounterBid: placeSellerCounterBid,
  updateListingReserve: updateListingReserve,
  updateListingReviewDate: updateListingReviewDate,
  rejectBuyerBid: rejectBuyerBid,
  startHighestAndBestRound: startHighestAndBestRound,
  withdrawSellerCounterBid: withdrawSellerCounterBid,
  getCurrentUserSealedBid: getCurrentUserSealedBid,
  getCounterofferBid: getCounterofferBid,
  getCurrentUserSealedBidRank: getCurrentUserSealedBidRank,
  isCurrentUserSealedBidRejected: isCurrentUserSealedBidRejected,
  allowToSubmitNewOffers: allowToSubmitNewOffers,
  updateOnlineSegmentFragments: updateOnlineSegmentFragments
};

var isEstCreditBidPending$1 = function isEstCreditBidPending(listing) {
  return !listing.reserve_price;
};
var isTrustee$1 = function isTrustee(listing) {
  var _a;
  return Boolean((_a = listing.event) === null || _a === void 0 ? void 0 : _a.trustee_sale);
};
var isCancelled$1 = function isCancelled(listing) {
  return listing.listing_status === enums$1.ListingStatus.Canceled;
};
var isPostponed$1 = function isPostponed(listing) {
  return [enums$1.ListingStatus.Postponed, enums$1.ListingStatus.PostponedPendingScheduling].includes(listing.listing_status);
};
var showOpeningBid$1 = function showOpeningBid(listing) {
  var _a;
  if (listing.listing_summary && !isNil(listing.listing_summary.show_opening_bid)) return Boolean(listing.listing_summary.show_opening_bid);
  var openingBidMarkettingAttribute = (_a = listing.marketing_attributes) === null || _a === void 0 ? void 0 : _a.find(function (ele) {
    return (ele === null || ele === void 0 ? void 0 : ele.attribute_type) === enums$1.MarketingAttributeType.OpeningBid;
  });
  return Boolean(openingBidMarkettingAttribute === null || openingBidMarkettingAttribute === void 0 ? void 0 : openingBidMarkettingAttribute.show);
};
var isClosed = function isClosed(listing) {
  return [enums$1.ListingStatus.Closed, enums$1.ListingStatus.SaleGatekeeping, enums$1.ListingStatus.SalePaymentPending].includes(listing.listing_status);
};
var isRemoteBidEnabled$1 = function isRemoteBidEnabled(listing) {
  var _a, _b;
  var listing_summary = listing.listing_summary;
  if (!(listing_summary === null || listing_summary === void 0 ? void 0 : listing_summary.is_remote_bid_enabled) && !(listing_summary === null || listing_summary === void 0 ? void 0 : listing_summary.is_remote_before_and_during_auction_enabled)) {
    var attributes = keyBy(listing.marketing_attributes, 'attribute_type');
    return Boolean(((_a = attributes === null || attributes === void 0 ? void 0 : attributes[enums$1.MarketingAttributeType.RemoteBid]) === null || _a === void 0 ? void 0 : _a.is_enabled) || ((_b = attributes === null || attributes === void 0 ? void 0 : attributes[enums$1.MarketingAttributeType.RemoteBidBeforeAndDuringAuction]) === null || _b === void 0 ? void 0 : _b.is_enabled));
  }
  return Boolean((listing_summary === null || listing_summary === void 0 ? void 0 : listing_summary.is_remote_bid_enabled) || (listing_summary === null || listing_summary === void 0 ? void 0 : listing_summary.is_remote_before_and_during_auction_enabled));
};
var isUsingSellerLevelFees$1 = function isUsingSellerLevelFees(listing) {
  var _a, _b;
  return Boolean(((_a = listing.listing_configuration) === null || _a === void 0 ? void 0 : _a.is_buyers_premium_available) || ((_b = listing.listing_configuration) === null || _b === void 0 ? void 0 : _b.is_earnest_money_deposit_available));
};
var isPositiveNumber = function isPositiveNumber(value) {
  return typeof value === 'number' && value >= 0;
};
var calculateMax = function calculateMax(a, b) {
  return [a, b].every(isPositiveNumber) ? Math.max(a, b) : null;
};
var calculateFlatFee = function calculateFlatFee(fee) {
  return isPositiveNumber(fee) ? fee : null;
};
var calculatePercentageFee = function calculatePercentageFee(base, percentage) {
  return [base, percentage].every(isPositiveNumber) ? parseFloat((base * (percentage / 100)).toFixed(2)) : null;
};
var premiumMinimumAmount = function premiumMinimumAmount(listing) {
  var _a;
  return (_a = listing.program_configuration) === null || _a === void 0 ? void 0 : _a.buyers_premium_minimum_amount;
};
var premiumPrimaryAmount = function premiumPrimaryAmount(listing) {
  var _a;
  return (_a = listing.program_configuration) === null || _a === void 0 ? void 0 : _a.buyers_premium_primary_amount;
};
var buyersPremiumCommissionType = function buyersPremiumCommissionType(listing) {
  var _a;
  return (_a = listing.program_configuration) === null || _a === void 0 ? void 0 : _a.buyers_premium_commission_type;
};
var calculateBuyersPremium = function calculateBuyersPremium(listing, bidAmount) {
  var fee;
  switch (buyersPremiumCommissionType(listing)) {
    case enums$1.CommissionStrategyType.Percentage:
      {
        fee = calculatePercentageFee(bidAmount, premiumPrimaryAmount(listing));
        break;
      }
    case enums$1.CommissionStrategyType.Dollar:
      {
        fee = calculateFlatFee(premiumPrimaryAmount(listing));
        break;
      }
    default:
      fee = null;
  }
  return calculateMax(fee, premiumMinimumAmount(listing));
};
var earnestMoneyDepositCommissionType = function earnestMoneyDepositCommissionType(listing) {
  var _a;
  return (_a = listing.program_configuration) === null || _a === void 0 ? void 0 : _a.earnest_money_deposit_commission_type;
};
var earnestMinimumAmount = function earnestMinimumAmount(listing) {
  var _a;
  return (_a = listing.program_configuration) === null || _a === void 0 ? void 0 : _a.earnest_money_deposit_minimum_amount;
};
var earnestPrimaryAmount = function earnestPrimaryAmount(listing) {
  var _a;
  return (_a = listing.program_configuration) === null || _a === void 0 ? void 0 : _a.earnest_money_deposit_primary_amount;
};
var calculateEarnestMoneyDeposit = function calculateEarnestMoneyDeposit(listing, totalPurchasePrice) {
  var fee;
  switch (earnestMoneyDepositCommissionType(listing)) {
    case enums$1.CommissionStrategyType.Percentage:
      {
        fee = calculatePercentageFee(totalPurchasePrice, earnestPrimaryAmount(listing));
        break;
      }
    case enums$1.CommissionStrategyType.Dollar:
      {
        fee = calculateFlatFee(earnestPrimaryAmount(listing));
        break;
      }
    default:
      fee = null;
  }
  return calculateMax(fee, earnestMinimumAmount(listing));
};
var getCostCalculations$1 = function getCostCalculations(listing, bidAmount) {
  var buyersPremium = calculateBuyersPremium(listing, bidAmount);
  var totalPurchasePrice = bidAmount + (buyersPremium || 0);
  var earnestMoneyDeposit = calculateEarnestMoneyDeposit(listing, totalPurchasePrice);
  return {
    buyersPremium: buyersPremium,
    totalPurchasePrice: totalPurchasePrice,
    earnestMoneyDeposit: earnestMoneyDeposit
  };
};
var BUYERS_PREMIUM_EXPLANATIONS = {
  ABSENT: "A Buyer's Premium does not apply to this property.",
  TYPE_FLAT: '{{amount}} regardless of Winning Bid Amount.',
  TYPE_PERCENT: '{{percentage}}% of winning bid or {{amount}}, whichever is higher. Only the winner pays this fee.'
};
var getBuyersPremiumExplanation$1 = function getBuyersPremiumExplanation(listing, bidAmount) {
  var buyersPremium = calculateBuyersPremium(listing, bidAmount);
  var _a = listing.program_configuration || {},
    buyers_premium_commission_type = _a.buyers_premium_commission_type,
    buyers_premium_minimum_amount = _a.buyers_premium_minimum_amount,
    buyers_premium_primary_amount = _a.buyers_premium_primary_amount;
  if (!buyersPremium) {
    return BUYERS_PREMIUM_EXPLANATIONS.ABSENT;
  } else if (buyers_premium_commission_type === enums$1.CommissionStrategyType.Dollar) {
    var amount_1 = formatMoney$1(buyersPremium);
    return interpolate(BUYERS_PREMIUM_EXPLANATIONS.TYPE_FLAT, {}, function () {
      return amount_1;
    }).join('');
  } else if (buyers_premium_commission_type === enums$1.CommissionStrategyType.Percentage) {
    var amount_2 = formatMoney$1(buyers_premium_minimum_amount !== null && buyers_premium_minimum_amount !== void 0 ? buyers_premium_minimum_amount : 0);
    return interpolate(BUYERS_PREMIUM_EXPLANATIONS.TYPE_PERCENT, {}, function (key) {
      return key === 'amount' ? amount_2 : buyers_premium_primary_amount;
    }).join('');
  } else {
    return null;
  }
};
var filterOpenHouses = function filterOpenHouses(listings) {
  if (!(listings === null || listings === void 0 ? void 0 : listings.length)) {
    return listings;
  }
  return listings.map(function (listing) {
    var _a, _b;
    if (!((_a = listing.open_houses) === null || _a === void 0 ? void 0 : _a.length)) {
      return listing;
    }
    var modifiedOpenHouseInfo = (_b = listing.open_houses) === null || _b === void 0 ? void 0 : _b.sort(function (a, b) {
      if (!(a === null || a === void 0 ? void 0 : a.local_date) || !(b === null || b === void 0 ? void 0 : b.local_date)) return 0;
      return new Date("".concat(a.local_date, " ").concat(a.end_time || '')).getTime() - new Date("".concat(b.local_date, " ").concat(b.end_time || '')).getTime();
    });
    modifiedOpenHouseInfo = modifiedOpenHouseInfo === null || modifiedOpenHouseInfo === void 0 ? void 0 : modifiedOpenHouseInfo.filter(function (oh) {
      var ohDate = (oh === null || oh === void 0 ? void 0 : oh.local_date) && new Date("".concat(oh.local_date, " ").concat(oh.end_time || ''));
      return ohDate && ohDate >= new Date();
    });
    return _assign(_assign({}, listing), {
      open_houses: modifiedOpenHouseInfo
    });
  });
};
var getPropertyTypeInfo = function getPropertyTypeInfo(_a) {
  var _b, _c, _d, _e;
  var listing = _a.listing,
    featureFlags = _a.featureFlags;
  if (isSparkOffer$1(listing)) return null;
  var listing_summary = listing.listing_summary,
    online_auction_segment = listing.online_auction_segment;
  var offerType = null;
  var combinedTextArray = [];
  if ((listing_summary === null || listing_summary === void 0 ? void 0 : listing_summary.is_remote_bid_enabled) || (listing_summary === null || listing_summary === void 0 ? void 0 : listing_summary.is_remote_before_and_during_auction_enabled)) {
    offerType = 'Remote Bid';
  } else {
    if (online_auction_segment && onlineAuctionUtils.shouldShowSealedBidTreatment(online_auction_segment, featureFlags)) {
      offerType = 'Offer';
    }
  }
  var bidDepositRule = get(listing, 'live_auction_segment.configuration.state_deposit_rule', '');
  if (bidDepositRule && !bidDepositRule.includes('100%') && (featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags['fe.resi.enable_state_deposit_treatment'])) {
    combinedTextArray.push("Winning Bid Deposit ".concat(shortenFlatLabel(bidDepositRule) || ''));
  }
  var physicalStructureCode = (_c = (_b = listing.primary_property) === null || _b === void 0 ? void 0 : _b.summary) === null || _c === void 0 ? void 0 : _c.structure_type_code;
  var physicalStructure = globalPhysicalStructures.find(function (entry) {
    return entry.value === physicalStructureCode;
  });
  var brokerName = (_e = (_d = listing.parties) === null || _d === void 0 ? void 0 : _d.find(function (p) {
    return (p === null || p === void 0 ? void 0 : p.party_role) === enums$1.ListingPartyRole.Broker;
  })) === null || _e === void 0 ? void 0 : _e.party_name;
  var structureInfoCombined = (physicalStructure ? physicalStructure.text : '') + (brokerName ? " Listed by ".concat(brokerName) : '');
  structureInfoCombined && combinedTextArray.push(structureInfoCombined);
  return {
    combinedTextArray: combinedTextArray,
    offerType: offerType,
    structureInfoCombined: structureInfoCombined
  };
};
var utils$6 = _assign(_assign({
  calculateBadges: calculateBadges,
  calculatePDPRedesignBadges: calculatePDPRedesignBadges,
  calculatePDPSellerTermsBadges: calculatePDPSellerTermsBadges,
  calculatePrivateSellerBadges: calculatePrivateSellerBadges,
  calculatePropertyCardBadges: calculatePropertyCardBadges,
  filterOpenHouses: filterOpenHouses,
  getCostCalculations: getCostCalculations$1,
  getBuyersPremiumExplanation: getBuyersPremiumExplanation$1,
  getDisplayIndicator: getDisplayIndicator,
  getPropertyTypeInfo: getPropertyTypeInfo,
  getSegmentType: getSegmentType,
  isCancelled: isCancelled$1,
  isClosed: isClosed,
  isEstCreditBidPending: isEstCreditBidPending$1,
  isPostponed: isPostponed$1,
  isPrivateSeller: isPrivateSeller,
  isRemoteBidEnabled: isRemoteBidEnabled$1,
  isSmartSale: isSmartSale,
  isSparkOffer: isSparkOffer$1,
  isTrustee: isTrustee$1,
  isUsingSellerLevelFees: isUsingSellerLevelFees$1,
  shouldDisplayListPrice: shouldDisplayListPrice$1,
  showOpeningBid: showOpeningBid$1
}, listingUtils$1), registrationUtils);

var fragments$3 = [ADDRESS_FRAGMENT, LISTING_CARDS_FRAGMENT, LISTING_BADGES_FRAGMENT, FIELDS_REQUIRING_ACTIVE_SESSION_FRAGMENT, ACTIVE_LISTINGS_FRAGMENT];
var fetchListingDataForNewlyAuthenticatedUser = function fetchListingDataForNewlyAuthenticatedUser(listingId, isRemoteBiddingEnabled) {
  return fetch.forAuctionGraph({
    query: "\n      ".concat(FIELDS_REQUIRING_ACTIVE_SESSION_FRAGMENT, "\n        query resiPdp_fetchDataForNewlyAuthenticatedUser($listingId: ID!, $isRemoteBiddingEnabled: Boolean!) {\n          listing(listingId: $listingId) {\n            ...FieldsRequiringActiveSessionFields\n          }\n        }\n      "),
    variables: {
      listingId: listingId,
      isRemoteBiddingEnabled: isRemoteBiddingEnabled
    }
  }).then(function (res) {
    return res.body.data;
  });
};
var getActiveListings = function getActiveListings(_a, _b) {
  var listingId = _a.listingId,
    isRemoteBiddingEnabled = _a.isRemoteBiddingEnabled,
    isLoggedIn = _a.isLoggedIn;
  var req = _b.req;
  return fetch.forAuctionGraph({
    query: gql(templateObject_1$d || (templateObject_1$d = __makeTemplateObject(["\n            ", "\n            query ", "($listingId: ID!, $isRemoteBiddingEnabled: Boolean!, $hasAuthenticatedUser: Boolean!) {\n              active_listing_summary(listingId: $listingId) {\n                active_listings {\n                  ...FieldsRequiringActiveSessionFields,\n                  ...ActiveListingFields\n\n                }\n              }\n            }\n        "], ["\n            ", "\n            query ", "($listingId: ID!, $isRemoteBiddingEnabled: Boolean!, $hasAuthenticatedUser: Boolean!) {\n              active_listing_summary(listingId: $listingId) {\n                active_listings {\n                  ...FieldsRequiringActiveSessionFields,\n                  ...ActiveListingFields\n\n                }\n              }\n            }\n        "])), fragments$3.join(), embeddableOperation('blueprint_getActiveListingSummary')),
    variables: {
      listingId: listingId,
      isRemoteBiddingEnabled: isRemoteBiddingEnabled,
      hasAuthenticatedUser: isLoggedIn
    }
  }, {
    req: req
  }).then(function (res) {
    return res.body;
  }).then(function (_a) {
    var data = _a.data,
      errors = _a.errors;
    if (data === null || data.active_listing_summary === null) {
      throw partialGraphErrorFactory$1('Could not fetch active listing summary', errors);
    }
    return data.active_listing_summary;
  }).then(function (response) {
    var _a;
    if (!((_a = response.active_listings) === null || _a === void 0 ? void 0 : _a.length)) {
      return response;
    }
    response.active_listings = filterOpenHouses(response.active_listings);
    return response;
  });
};
var templateObject_1$d;

var clearListingForLiveAuction = function clearListingForLiveAuction(listing, foreclosureListingInput) {
  return fetch.forAuctionGraph({
    query: "\n        mutation ".concat(embeddableOperation('blueprint_clearLiveListing'), "(\n          $input: UpdateForeclosureListingInput!\n        ) {\n          clearListing(\n            input: $input\n          ) {\n            listing_id\n          }\n        }\n        "),
    variables: {
      input: _assign({
        listing_id: listing.listing_id
      }, foreclosureListingInput)
    }
  }).then(function (res) {
    return res.body;
  }).then(function (_a) {
    var data = _a.data,
      errors = _a.errors;
    if (data === null || data.clearListing === null) {
      throw partialGraphErrorFactory$1('Unable to clear listing', errors);
    }
    return data.clearListing;
  });
};
var cancelListingForLiveAuction = function cancelListingForLiveAuction(listing, foreclosureListingInput) {
  return fetch.forAuctionGraph({
    query: "mutation ".concat(embeddableOperation('blueprint_cancelLiveListing'), "(\n          $input: CancelForeclosureListingInput!\n        ) {\n          cancelListing(\n            input: $input\n          )\n        }\n          "),
    variables: {
      input: _assign({
        listing_id: listing.listing_id
      }, foreclosureListingInput)
    }
  }).then(function (res) {
    return res.body;
  }).then(function (_a) {
    var data = _a.data,
      errors = _a.errors;
    if (data === null || !data.cancelListing) {
      throw partialGraphErrorFactory$1('Unable to cancel listing', errors);
    }
    return data.cancelListing;
  });
};
var postponeListingForLiveAuction = function postponeListingForLiveAuction(listing, foreclosureListingInput) {
  return fetch.forAuctionGraph({
    query: "mutation ".concat(embeddableOperation('blueprint_postponeLiveListing'), "(\n          $input: PostponeForeclosureListingInput!\n        ) {\n          postponeListing(\n            input: $input\n          )\n        }\n          "),
    variables: {
      input: _assign({
        listing_id: listing.listing_id
      }, foreclosureListingInput)
    }
  }).then(function (res) {
    return res.body;
  }).then(function (_a) {
    var data = _a.data,
      errors = _a.errors;
    if (data === null || !data.postponeListing) {
      throw partialGraphErrorFactory$1('Unable to postpone listing', errors);
    }
    return data.postponeListing;
  });
};
var getMerchandisedListings = function getMerchandisedListings(listingIds, controller) {
  return fetch.forAuctionGraph({
    query: gql(templateObject_1$c || (templateObject_1$c = __makeTemplateObject(["\n            query ", "($listingIds: [ID!]!) {\n                listings_batched(filters: { listing_ids: $listingIds }) {\n                  listing_id\n                }\n            }\n            ", "\n            "], ["\n            query ", "($listingIds: [ID!]!) {\n                listings_batched(filters: { listing_ids: $listingIds }) {\n                  listing_id\n                }\n            }\n            ", "\n            "])), embeddableOperation('blueprint_getMerchandisedListings'), fragments$2.merchandising.definition),
    variables: {
      listingIds: listingIds
    }
  }, {
    controller: controller
  }).then(function (res) {
    return res.body;
  }).then(function (_a) {
    var data = _a.data,
      errors = _a.errors;
    if (data === null || data.listings_batched === null) {
      throw partialGraphErrorFactory$1('Could not fetch latest online listings', errors);
    }
    return data.listings_batched;
  });
};
var getChangeRequests = function getChangeRequests(listingIds, controller) {
  return fetch.forAuctionGraph({
    query: gql(templateObject_2$9 || (templateObject_2$9 = __makeTemplateObject(["\n            query ", "($listingIds: [ID!]!) {\n                listings_batched(filters: { listing_ids: $listingIds }) {\n                  listing_id\n                  updated_date\n                  change_requests(filters: { review_statuses: [PENDING] }) {\n                    ", "\n                  }\n                }\n            }\n            ", "\n            "], ["\n            query ", "($listingIds: [ID!]!) {\n                listings_batched(filters: { listing_ids: $listingIds }) {\n                  listing_id\n                  updated_date\n                  change_requests(filters: { review_statuses: [PENDING] }) {\n                    ", "\n                  }\n                }\n            }\n            ", "\n            "])), embeddableOperation('blueprint_getChangeRequests'), fragments$2.changeRequest.reference, fragments$2.changeRequest.definition),
    variables: {
      listingIds: listingIds
    }
  }, {
    controller: controller
  }).then(function (res) {
    return res.body;
  }).then(function (_a) {
    var data = _a.data,
      errors = _a.errors;
    if (data === null || data.listings_batched === null) {
      throw partialGraphErrorFactory$1('Could not fetch latest change requests for online listings', errors);
    }
    return data.listings_batched;
  });
};
var templateObject_1$c, templateObject_2$9;

var providers$6 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  cancelListingForLiveAuction: cancelListingForLiveAuction,
  clearListingForLiveAuction: clearListingForLiveAuction,
  getActiveListings: getActiveListings,
  getChangeRequests: getChangeRequests,
  getMerchandisedListings: getMerchandisedListings,
  partialGraphErrorFactory: partialGraphErrorFactory$1,
  postponeListingForLiveAuction: postponeListingForLiveAuction
});

var calculateBidTypeForLiveAuctionClearance = function calculateBidTypeForLiveAuctionClearance(listing, creditBid, estimatedTotalDebt) {
  var _a, _b;
  if (((_a = listing.seller_property) === null || _a === void 0 ? void 0 : _a.country_primary_subdivision) && ['FL', 'NJ'].includes((_b = listing.seller_property) === null || _b === void 0 ? void 0 : _b.country_primary_subdivision)) {
    return enums$1.BidType.HighLow;
  } else if (creditBid < estimatedTotalDebt) return enums$1.BidType.Specified;else if (creditBid === estimatedTotalDebt) return enums$1.BidType.TotalDebt;
  return null;
};
var validateBidTypeForLiveAuctionClearance = function validateBidTypeForLiveAuctionClearance(listing, bidType, creditBid, totalEstimatedDebt) {
  var _a;
  if (((_a = listing.seller_property) === null || _a === void 0 ? void 0 : _a.country_primary_subdivision) && ['FL', 'NJ'].includes(listing.seller_property.country_primary_subdivision) && bidType !== enums$1.BidType.HighLow) {
    return {
      valid: false,
      message: 'Cannot select bid type other than High/Low'
    };
  } else if (bidType === enums$1.BidType.Specified && creditBid >= totalEstimatedDebt) return {
    valid: false,
    message: 'Cannot select Specified bid type when credit bid is equal to or greater then total debt'
  };else if (bidType === enums$1.BidType.TotalDebt && creditBid !== totalEstimatedDebt) return {
    valid: false,
    message: "Cannot select Total Debt bid type when credit bid and attorney's total debt amount do not match"
  };
  return {
    valid: true,
    message: ''
  };
};
var utils$5 = {
  calculateBidTypeForLiveAuctionClearance: calculateBidTypeForLiveAuctionClearance,
  validateBidTypeForLiveAuctionClearance: validateBidTypeForLiveAuctionClearance,
  clearListingForLiveAuction: clearListingForLiveAuction,
  cancelListingForLiveAuction: cancelListingForLiveAuction,
  postponeListingForLiveAuction: postponeListingForLiveAuction
};

var formatDocumentsForDisplay = formatDocumentsForDisplay$1,
  getAllDocuments = getAllDocuments$1,
  getClosingCompanyData = getClosingCompanyData$1,
  getDocumentTitle = getDocumentTitle$1,
  getPartnershipDetails = getPartnershipDetails$1,
  getPaymentInformation = getPaymentInformation$1,
  getProvisionalSaleDateTime = getProvisionalSaleDateTime$1,
  getSellerDeedTypeLabel = getSellerDeedTypeLabel$1,
  getSpecialDocuments = getSpecialDocuments$1,
  getTitleInsurancePaidBy = getTitleInsurancePaidBy$1,
  isFCLMarketing = isFCLMarketing$1,
  isTPSOhio = isTPSOhio$1;
var getDueDiligenceData = function getDueDiligenceData(listing) {
  return {
    titleInsurancePaidBy: getTitleInsurancePaidBy(listing),
    sellerDeedType: getSellerDeedTypeLabel(listing),
    closingCompanyData: getClosingCompanyData(listing),
    provisionalSaleDateTime: getProvisionalSaleDateTime(listing),
    partnershipDetails: getPartnershipDetails(listing),
    isFclMarketing: isFCLMarketing(listing),
    paymentInformation: getPaymentInformation(listing),
    isTPSOhio: isTPSOhio(listing),
    specialDocuments: getSpecialDocuments(getAllDocuments(listing), isTPSOhio(listing))
  };
};
var isListingIdOnly = function isListingIdOnly(listing) {
  return typeof listing === 'string';
};
var usePage = function usePage(_a) {
  var initialData = _a.initialData,
    featureFlags = _a.featureFlags,
    isLoggedIn = _a.isLoggedIn;
  var initialListing = useState(initialData[0])[0];
  var _b = useState(isListingIdOnly(initialListing) ? initialListing : initialListing.listing_id),
    currentListingId = _b[0],
    setCurrentListingId = _b[1];
  var isRemoteBiddingEnabled = featureFlags['fe.resi.enable-web-remote-bidding'];
  var getComputedListingValues = function getComputedListingValues(listing) {
    var documentList = getAllDocuments(listing);
    var specialDocs = ___default.invertBy(getSpecialDocuments(documentList, isTPSOhio(listing)), function (value) {
      return getDocumentTitle(value);
    });
    var sortedDocs = documentList.filter(function (doc) {
      return getDocumentTitle(doc) && !specialDocs[getDocumentTitle(doc)];
    });
    return {
      applicableDocuments: formatDocumentsForDisplay(sortedDocs),
      dueDiligence: getDueDiligenceData(listing)
    };
  };
  var initializeActiveListings = useCallback(function () {
    return __awaiter(void 0, void 0, void 0, function () {
      var response, extendedResponse;
      var _a;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            if (!initialListing) return [3, 2];
            return [4, getActiveListings({
              listingId: isListingIdOnly(initialListing) ? initialListing : initialListing.listing_id,
              isRemoteBiddingEnabled: isRemoteBiddingEnabled,
              isLoggedIn: isLoggedIn
            }, {
              req: null
            })];
          case 1:
            response = _b.sent();
            if ((_a = response === null || response === void 0 ? void 0 : response.active_listings) === null || _a === void 0 ? void 0 : _a.length) {
              extendedResponse = response === null || response === void 0 ? void 0 : response.active_listings.map(function (listing) {
                return _assign(_assign({}, listing), {
                  __computed__: getComputedListingValues(listing)
                });
              });
              attemptActiveListingsWrite({
                data: extendedResponse,
                source: 'local_optimistic_action'
              });
            }
            _b.label = 2;
          case 2:
            return [2];
        }
      });
    });
  }, [initialListing, getComputedListingValues]);
  useEffect(function () {
    if (featureFlags['app.enable-pdp-design-2025']) {
      initializeActiveListings();
    }
  }, []);
  var initialPDPListings = useMemo(function () {
    return !isListingIdOnly(initialListing) ? [_assign(_assign({}, initialListing), {
      __computed__: getComputedListingValues(initialListing)
    })] : [{
      listing_id: initialListing,
      __computed__: {
        applicableDocuments: [],
        dueDiligence: {}
      }
    }];
  }, [initialListing]);
  var refresh = function refresh() {
    return __awaiter(void 0, void 0, void 0, function () {
      var listing, err_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);
            return [4, fetchListingDataForNewlyAuthenticatedUser(currentListingId, isRemoteBiddingEnabled)];
          case 1:
            listing = _a.sent().listing;
            attemptActiveListingsWrite({
              data: [listing],
              source: 'local_optimistic_action'
            });
            return [3, 3];
          case 2:
            err_1 = _a.sent();
            console.error(err_1);
            return [3, 3];
          case 3:
            return [2];
        }
      });
    });
  };
  var updateSaveProperty = function updateSaveProperty(value) {
    if (currentListing) {
      attemptActiveListingsWrite({
        data: [_assign(_assign({}, currentListing), {
          primary_property: _assign(_assign({}, currentListing.primary_property), {
            is_currently_saved: value
          })
        })],
        source: 'local_optimistic_action'
      });
    }
  };
  var _c = useIdempotentBlueprintCollection(initialPDPListings, {
      primaryKey: 'listing_id',
      updateBehavior: 'merge',
      utils: listingUtils$1
    }),
    activeListings = _c.collection,
    attemptActiveListingsWrite = _c.attemptWrite;
  var currentListing = useMemo(function () {
    return activeListings.raw.find(function (listing) {
      return listing.listing_id === currentListingId;
    });
  }, [activeListings.raw, currentListingId]);
  return {
    data: {
      activeListings: activeListings,
      currentListing: currentListing
    },
    actions: {
      refresh: refresh,
      updateSaveProperty: updateSaveProperty,
      setCurrentListingId: setCurrentListingId
    }
  };
};

var listingLogger = coreLogger.forModule('blueprint:merchandised_listing');
var useMerchandisedListings = function useMerchandisedListings(_a) {
  var graphWebsocket = _a.graphWebsocket,
    initialData = _a.initialData;
  var subjectIds = useMemo(function () {
    return initialData.map(function (l) {
      return l.listing_id;
    });
  }, [initialData]);
  var _b = useIdempotentBlueprintCollection(initialData, {
      primaryKey: 'listing_id',
      idempotencyKey: 'updated_date',
      updateBehavior: 'merge',
      collectionName: 'blueprint:idempotent_collection:merchandised_listing'
    }),
    collection = _b.collection,
    attemptWrite = _b.attemptWrite;
  useRealtimeWatcher({
    id: 'useMerchandisedListing',
    subjectIds: subjectIds,
    websocket: {
      graphWebsocket: graphWebsocket,
      enabled: !configment.get('ENABLE_WEBSOCKET_KILL_SWITCH', false),
      executor: function executor() {
        return {
          query: gql(templateObject_1$b || (templateObject_1$b = __makeTemplateObject(["\n          subscription ", "($filters: ListingsUpdatedFilters) {\n            listingsUpdated(filters: $filters) {\n              ", "\n            }\n          }\n          ", "\n        "], ["\n          subscription ", "($filters: ListingsUpdatedFilters) {\n            listingsUpdated(filters: $filters) {\n              ", "\n            }\n          }\n          ", "\n        "])), embeddableOperation('blueprint_merchandisedListingsUpdated'), fragments$2.merchandising.reference, fragments$2.merchandising.definition),
          variables: {
            filters: {
              listingIds: subjectIds
            }
          }
        };
      },
      dataExtractor: function dataExtractor(data) {
        return [data.listingsUpdated].filter(Boolean);
      }
    },
    onData: function onData(payload) {
      var data = payload.data,
        source = payload.source;
      listingLogger.info("New merchandised listing data loaded. source=".concat(source), data);
      attemptWrite({
        source: source,
        data: data
      });
    },
    onError: function onError(error) {
      listingLogger.error('Realtime watcher error', error);
    },
    onEvent: function onEvent(event, ctx) {
      listingLogger.info('Have event', event, ctx);
    }
  });
  var data = useMemo(function () {
    return {
      listings: collection
    };
  }, [collection]);
  var output = useMemo(function () {
    return {
      data: data
    };
  }, [data]);
  return output;
};
var changeReqLogger = coreLogger.forModule('blueprint:change_requests');
var makeCollection = function makeCollection(collectionData) {
  return {
    raw: collectionData,
    mapped: collectionData.reduce(function (acc, element) {
      return acc.set(element.listing_id, element);
    }, new Map())
  };
};
var useChangeRequests = function useChangeRequests(_a) {
  var initialData = _a.initialData;
  var subjectIds = useMemo(function () {
    return initialData.map(function (l) {
      return l.listing_id;
    });
  }, [initialData]);
  var _b = useState(makeCollection(initialData)),
    collection = _b[0],
    setCollection = _b[1];
  useEffect(function () {
    setCollection(makeCollection(initialData));
  }, [initialData]);
  var attemptWrite = function attemptWrite(_a) {
    var source = _a.source,
      data = _a.data;
    var upsertRequired = !___default.isEqual(collection.raw, data);
    if (upsertRequired) {
      changeReqLogger.info("Data Transport Effectiveness.", {
        source: source,
        causedChange: upsertRequired
      });
      setCollection(makeCollection(data));
    }
  };
  useRealtimeWatcher({
    id: 'useChangeRequests',
    subjectIds: subjectIds,
    polling: {
      enabled: true,
      frequency: SUPPORTED_OFFSETS.URGENT,
      executor: function executor(_a) {
        var subjectIds = _a.subjectIds,
          controller = _a.controller;
        return (subjectIds === null || subjectIds === void 0 ? void 0 : subjectIds.length) ? getChangeRequests(subjectIds, controller) : Promise.resolve();
      }
    },
    onData: function onData(payload) {
      var data = payload.data,
        source = payload.source;
      changeReqLogger.info("New change requests data loaded. source=".concat(source), data);
      attemptWrite({
        source: source,
        data: data
      });
    },
    onError: function onError(error) {
      changeReqLogger.error('Realtime watcher error', error);
    },
    onEvent: function onEvent(event, ctx) {
      changeReqLogger.info('Have event', event, ctx);
    }
  });
  var data = useMemo(function () {
    return {
      listings: collection
    };
  }, [collection]);
  var output = useMemo(function () {
    return {
      data: data
    };
  }, [data]);
  return output;
};
var invitationLogger = coreLogger.forModule('blueprint:invitation');
var useInvitations = function useInvitations(_a) {
  var graphWebsocket = _a.graphWebsocket,
    initialData = _a.initialData;
  var subjectIds = useMemo(function () {
    return initialData.map(function (l) {
      return l.listing_id;
    });
  }, [initialData]);
  var invitationsInitialData = useMemo(function () {
    return initialData.map(function (l) {
      return {
        listing_id: l.listing_id,
        associated_invitations: l.associated_invitations
      };
    });
  }, [initialData]);
  var _b = useState(makeCollection(invitationsInitialData)),
    collection = _b[0],
    setCollection = _b[1];
  useEffect(function () {
    setCollection(makeCollection(invitationsInitialData));
  }, [invitationsInitialData]);
  var attemptWrite = function attemptWrite(_a) {
    var _b;
    var source = _a.source,
      data = _a.data;
    var action = data.action;
    var invitation = data.invitation;
    if (!invitation) {
      invitationLogger.info("Data Transport Effectiveness.", {
        source: source,
        causedChange: false
      });
      return;
    }
    if (invitation) {
      var invitationRelative = (_b = invitation.relatives) === null || _b === void 0 ? void 0 : _b.find(function (r) {
        return typeof (r === null || r === void 0 ? void 0 : r.object_id) === 'string' && Boolean(collection.mapped.get(r === null || r === void 0 ? void 0 : r.object_id));
      });
      var listingId_1 = typeof (invitationRelative === null || invitationRelative === void 0 ? void 0 : invitationRelative.object_id) === 'string' ? invitationRelative === null || invitationRelative === void 0 ? void 0 : invitationRelative.object_id : '';
      match(action).with('CREATED', function () {
        var newRawCollection = collection.raw.map(function (l) {
          if (l.listing_id === listingId_1) {
            return _assign(_assign({}, l), {
              associated_invitations: __spreadArray(__spreadArray([], Array.isArray(l.associated_invitations) ? l.associated_invitations : [], true), [invitation], false)
            });
          }
          return l;
        });
        setCollection(makeCollection(newRawCollection));
        invitationLogger.info("Data Transport Effectiveness.", {
          source: source,
          causedChange: true
        });
      }).with('REVOKED', 'ACCEPTED', function () {
        var newRawCollection = collection.raw.map(function (l) {
          if (l.listing_id === listingId_1) {
            return _assign(_assign({}, l), {
              associated_invitations: Array.isArray(l.associated_invitations) ? l.associated_invitations.map(function (inv) {
                if (inv.invitation_id === invitation.invitation_id) {
                  return invitation;
                }
                return inv;
              }) : []
            });
          }
          return l;
        });
        setCollection(makeCollection(newRawCollection));
        invitationLogger.info("Data Transport Effectiveness.", {
          source: source,
          causedChange: true
        });
      }).otherwise(function () {
        invitationLogger.info("Data Transport Effectiveness.", {
          source: source,
          causedChange: false
        });
      });
    }
  };
  useRealtimeWatcher({
    id: 'useMerchandisedListing',
    subjectIds: subjectIds,
    websocket: {
      graphWebsocket: graphWebsocket,
      enabled: !configment.get('ENABLE_WEBSOCKET_KILL_SWITCH', false),
      executor: function executor() {
        return {
          query: gql(templateObject_2$8 || (templateObject_2$8 = __makeTemplateObject(["\n          subscription ", "($filters: InvitationUpdatedFilters) {\n            invitationUpdated(filters: $filters) {\n              action\n              invitation {\n                ", "\n              }\n            }\n          }\n          ", "\n        "], ["\n          subscription ", "($filters: InvitationUpdatedFilters) {\n            invitationUpdated(filters: $filters) {\n              action\n              invitation {\n                ", "\n              }\n            }\n          }\n          ", "\n        "])), embeddableOperation('blueprint_invitationUpdated'), fragments$2.invitation.reference, fragments$2.invitation.definition),
          variables: {
            filters: {
              urns: subjectIds.map(function (listingId) {
                return "adc:listing:".concat(listingId);
              })
            }
          }
        };
      },
      dataExtractor: function dataExtractor(data) {
        return [data.invitationUpdated];
      }
    },
    onData: function onData(payload) {
      var data = payload.data,
        source = payload.source;
      invitationLogger.info("New invitation data loaded. source=".concat(source), data);
      if (source === 'websocket') {
        var invitationData = data[0];
        attemptWrite({
          source: source,
          data: invitationData
        });
      }
    },
    onError: function onError(error) {
      invitationLogger.error('Realtime watcher error', error);
    },
    onEvent: function onEvent(event, ctx) {
      invitationLogger.info('Have event', event, ctx);
    }
  });
  var data = useMemo(function () {
    return {
      listings: collection
    };
  }, [collection]);
  var output = useMemo(function () {
    return {
      data: data
    };
  }, [data]);
  return output;
};
var templateObject_1$b, templateObject_2$8;

var useLiveAuctionPreparation = function useLiveAuctionPreparation(_a) {
  var initialData = _a.initialData;
  var idempotentListings = useIdempotentBlueprintCollection(initialData === null || initialData === void 0 ? void 0 : initialData.listings, {
    primaryKey: 'listing_id',
    utils: utils$5,
    updateBehavior: 'merge'
  }).collection;
  var data = useMemo(function () {
    return {
      listings: idempotentListings
    };
  }, [idempotentListings]);
  var output = useMemo(function () {
    return {
      data: data
    };
  }, [data]);
  return output;
};

var hooks$6 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  useChangeRequests: useChangeRequests,
  useInvitations: useInvitations,
  useLiveAuctionPreparation: useLiveAuctionPreparation,
  useMerchandisedListings: useMerchandisedListings,
  usePage: usePage
});

__spreadArray(__spreadArray(__spreadArray([], Object.values(enums$1.PropertyDocumentPurposeType), true), Object.values(enums$1.GlobalMediaPurpose), true), Object.values(enums$1.GlobalMediaPriorityLevel), true);

var fragments$2 = {
  badges: {
    reference: '...BlueprintListingBadges',
    definition: "\n      fragment BlueprintListingBadges on Listing {\n      listing_status\n      listing_configuration {\n        product_type\n        broker_commission_message\n        buyer_premium_available\n        financing_available\n        is_first_look_enabled\n        first_look_end_date\n        interior_access_allowed\n        occupancy_status\n        redemption_expiration_date\n        trustee_sales_channel\n        is_buyers_premium_available\n      }\n\n      listing_summary {\n        is_remote_bid_enabled\n        is_remote_before_and_during_auction_enabled\n      }\n\n      program_configuration {\n        buyers_premium_minimum_amount\n        buyers_premium_primary_amount\n        buyers_premium_commission_type\n      }\n\n      primary_property {\n        is_currently_saved\n        is_newly_listed\n      }\n\n      open_houses {\n        local_date\n        start_time\n        end_time\n      }\n\n      rental {\n        current_rent\n        lease_start_date\n        lease_expiration_date\n        is_security_deposit_charged\n        security_deposit_amount\n      }\n\n      short_sale {\n        agreement_expiration_date\n      }\n\n      event {\n        event_code\n        trustee_sale\n      }\n\n      parties {\n        party_role\n      }\n\n      venue {\n        venue_type\n      }\n\n      marketing_tags {\n        tag\n      }\n    }\n    "
  },
  changeRequest: {
    reference: '...BlueprintChangeRequest',
    definition: "\n      fragment BlueprintChangeRequest on ObjectChange {\n        change_request_id\n        change_request\n        review_status\n        change_type\n        change_path_variable\n      }\n    "
  },
  invitation: {
    reference: '...BlueprintInvitation',
    definition: "\n      fragment BlueprintInvitation on Invitation {\n        __typename\n        invitation_id\n        invitation_token\n        updated_date\n        intent\n        status\n        context {\n          __typename\n          ... on ConsumerListingPartyAssociationContext {\n            intent\n            license_number\n            party_organization_title\n            phone_number\n            address {\n              street_name\n              municipality\n              country_primary_subdivision \n              postal_code\n            }\n          }\n        }\n        relatives {\n          object_id\n          object_type\n          recipient_role_code\n        }\n        recipient {\n          __typename\n          ... on InvitationDanglingUser {\n            first_name\n            last_name\n            email\n            phone\n          }\n\n          ... on MinimalUser {\n            first_name\n            last_name\n            email\n            party {\n              phones {\n                phone_id\n                number\n              }\n              addresses {\n                street_number\n                street_name\n                municipality\n                country_primary_subdivision\n                postal_code\n              }\n            }\n          }\n        }\n      }\n    "
  },
  merchandising: {
    reference: '...BlueprintMerchandisedListing',
    definition: "\n      fragment BlueprintMerchandisedListing on Listing {\n        updated_date\n        listing_id\n        urn\n        listing_status\n        reserve_price\n        closing_configuration {\n          responsibility_type\n          is_closing_document_required\n        }\n        listing_page_path\n        formatted_address(format: DOUBLE_LINE)\n        primary_photo\n        photos {\n          file_descriptor {\n            urls {\n              cdn\n            }\n          }\n        }\n        is_published\n        is_searchable\n        listing_configuration {\n          is_local_disclosure_applicable\n          agent_commission_message\n          are_private_tours_available\n          days_to_close\n          financing_available\n          occupancy_status\n          product_type\n          asset_type\n          is_third_party_online\n          monthly_hoa_name\n          monthly_hoa_phone\n          monthly_hoa_amount\n        }\n        days_on_market\n\n        valuation {\n          seller_current_value_amount\n        }\n        auction {\n          start_date\n          end_date\n          reserve_price\n          is_online\n        }\n\n        program_configuration {\n          earnest_money_deposit_minimum_amount\n          earnest_money_deposit_primary_amount\n        }\n\n        seller_terms {\n          inspection_terms {\n            is_option_contingency\n            is_contingency\n          }\n          leaseback_terms {\n            leaseback_period_in_days\n            leaseback_period_rent\n          }\n          finance_terms {\n            finance_preference\n            is_contingency\n          }\n          intent\n        }\n\n        strategy {\n          selling_method_attributes {\n            type\n            online_segment_type\n          }\n        }\n        \n        document_tracking {\n          document_status\n          document_type\n          initial_sent_date\n          completion_date\n          last_sent_date\n        }\n\n        documents {\n          metadata {\n            document_purpose_type_code\n          }\n          document_tracking_urn\n        }\n\n        listing_remarks {\n          mls_comment\n          seller_contract_terms\n        }\n\n        parties {\n          party_id\n          party_name\n          party_role\n          party_phone\n          party_email\n          party_license_number\n          party_organization_title\n          party_address {\n            street_description\n            municipality\n            country_primary_subdivision\n            postal_code\n          }\n        }\n\n        open_houses {\n          local_date\n          start_time\n          end_time\n          rank\n          is_appointment_only\n        }\n\n        primary_property {\n          property_id\n          property_documents {\n            property_document_id\n            property_id\n            document_file_name\n            document_internal_title\n            document_external_title\n            status\n            file_descriptor {\n              urls {\n                preview\n                cdn\n                download\n              }\n            }\n            metadata {\n              document_purpose_type_code\n            }\n          }\n          property_photos {\n            property_photo_id\n            created_date\n            updated_date\n            photo_internal_title\n            photo_external_title\n            metadata {\n              photo_default_rank\n            }\n            photo_tags\n            status\n            file_descriptor {\n              urls {\n                cdn\n              }\n            }\n          }\n          summary {\n            structure_type_code\n            total_bedrooms\n            total_bathrooms\n            square_footage\n            lot_size\n            apn\n            year_built\n            street_address\n            address {\n              municipality\n              country_secondary_subdivision\n              country_primary_subdivision\n              postal_code\n              coordinates {\n                lat\n                lon\n              }\n            }\n          }\n          is_newly_listed\n          current_user_tracking_state {\n            is_seen\n            is_updated\n          }\n        }\n        review_status\n        marketing {\n          agreement_sent_date\n          agreement_received_date\n        }\n      }\n    "
  },
  listingCard: {
    reference: '...ListingCardFields',
    definition: LISTING_CARDS_FRAGMENT
  }
};

var index$b = /*#__PURE__*/Object.freeze({
  __proto__: null,
  badgeTypes: types$3,
  badges: badges,
  constants: constants$1,
  fragments: fragments$2,
  hooks: hooks$6,
  providers: providers$6,
  utils: utils$6
});

var getNextProxyBidAmount = function getNextProxyBidAmount(listing, segment) {
  var _a, _b;
  if (isProxyBiddingActive(listing, segment)) {
    return Math.max(segment.starting_bid_amount, (((_a = segment.current_user_max_bid) === null || _a === void 0 ? void 0 : _a.max_bid_amount) || ((_b = listing.current_user_max_bid) === null || _b === void 0 ? void 0 : _b.max_bid_amount) || 0) + 1);
  }
  return null;
};
var isProxyBiddingActive = function isProxyBiddingActive(listing, segment) {
  var _a;
  return (!segment || onlineAuctionUtils.isAuctionNotStarted(segment)) && listing.is_current_user_registered_for_online_auction && ((_a = listing.listing_configuration) === null || _a === void 0 ? void 0 : _a.is_proxy_bidding_enabled);
};
var getBuyersPremiumExplanation = utils$6.getBuyersPremiumExplanation,
  getCostCalculations = utils$6.getCostCalculations,
  isCancelled = utils$6.isCancelled,
  isEstCreditBidPending = utils$6.isEstCreditBidPending,
  isPostponed = utils$6.isPostponed,
  isRemoteBidEnabled = utils$6.isRemoteBidEnabled,
  isTrustee = utils$6.isTrustee,
  isUsingSellerLevelFees = utils$6.isUsingSellerLevelFees,
  showOpeningBid = utils$6.showOpeningBid,
  shouldDisplayListPrice = utils$6.shouldDisplayListPrice,
  isSparkOffer = utils$6.isSparkOffer;
var listingUtils = {
  getBuyersPremiumExplanation: getBuyersPremiumExplanation,
  getCostCalculations: getCostCalculations,
  getNextProxyBidAmount: getNextProxyBidAmount,
  isCancelled: isCancelled,
  isEstCreditBidPending: isEstCreditBidPending,
  isPostponed: isPostponed,
  isProxyBiddingActive: isProxyBiddingActive,
  isRemoteBidEnabled: isRemoteBidEnabled,
  isTrustee: isTrustee,
  isUsingSellerLevelFees: isUsingSellerLevelFees,
  showOpeningBid: showOpeningBid,
  shouldDisplayListPrice: shouldDisplayListPrice,
  isSparkOffer: isSparkOffer
};

var utils$4 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getWhatFieldChanged: getWhatFieldChanged,
  listingUtils: listingUtils,
  liveAuctionUtils: liveAuctionUtils,
  onlineAuctionUtils: onlineAuctionUtils,
  shortenFlatLabel: shortenFlatLabel
});

var DEFAULT_MAX_LIMIT = 3;
var useBoundedArray = function useBoundedArray(_a) {
  var _b = _a.size,
    size = _b === void 0 ? DEFAULT_MAX_LIMIT : _b,
    _c = _a.onCapacityReachedText,
    onCapacityReachedText = _c === void 0 ? 'bounded array' : _c;
  var _d = useState(new Set()),
    keys = _d[0],
    setKeys = _d[1];
  var addElement = useCallback(function (key) {
    if (key && !keys.has(key)) {
      var latestElement = new Set(keys);
      latestElement.add(key);
      if (latestElement.size > size) {
        var elementToBeRemoved = Array.from(latestElement.values())[0];
        latestElement.delete(elementToBeRemoved);
        coreLogger.info("Max limit reached on ".concat(onCapacityReachedText, ", Removed element "), elementToBeRemoved);
      }
      setKeys(latestElement);
    }
  }, [onCapacityReachedText, keys, size]);
  var removeElement = useCallback(function (key) {
    if (key && keys.has(key)) {
      setKeys(function (prev) {
        var keys = new Set(prev);
        keys.delete(key);
        return keys;
      });
    }
  }, [keys]);
  return useMemo(function () {
    return {
      keys: keys,
      addElement: addElement,
      removeElement: removeElement
    };
  }, [keys, addElement, removeElement]);
};

var logger$5 = coreLogger.forModule('blueprint:bidding');
var MAX_LIMIT_FOCUSED_LISTINGS = 3;
function useLiveAuctions(_a) {
  var enabled = _a.enabled,
    initialData = _a.initialData,
    graphWebsocket = _a.graphWebsocket,
    user = _a.user;
  var _b = useIdempotentBlueprintCollection(initialData === null || initialData === void 0 ? void 0 : initialData.listings, {
      primaryKey: 'listing_id',
      utils: listingUtils,
      updateBehavior: 'merge'
    }),
    idempotentListings = _b.collection,
    attemptListingWrite = _b.attemptWrite;
  var _c = useIdempotentBlueprintCollection(initialData === null || initialData === void 0 ? void 0 : initialData.segments, {
      primaryKey: 'listing_id',
      utils: liveAuctionUtils,
      updateBehavior: 'merge'
    }),
    idempotentSegments = _c.collection,
    attemptSegmentWrite = _c.attemptWrite,
    attemptBatchSegmentWrite = _c.attemptBatchWrite;
  var _d = useBoundedArray({
      size: MAX_LIMIT_FOCUSED_LISTINGS,
      onCapacityReachedText: 'focused listings'
    }),
    focusedListings = _d.keys,
    focusListing = _d.addElement,
    unFocusListing = _d.removeElement;
  var data = useMemo(function () {
    return {
      focusedListings: Array.from(focusedListings),
      isFocusedListingsAtCapacity: focusedListings.size === MAX_LIMIT_FOCUSED_LISTINGS,
      listings: idempotentListings,
      segments: idempotentSegments
    };
  }, [focusedListings, idempotentListings, idempotentSegments]);
  var subjectIds = useMemo(function () {
    return initialData.listings.map(function (l) {
      return typeof l === 'string' ? l : l.listing_id;
    });
  }, [initialData.listings]);
  var output = useMemo(function () {
    return {
      data: data,
      actions: {
        focusListing: focusListing,
        unFocusListing: unFocusListing
      }
    };
  }, [data, focusListing, unFocusListing]);
  var prevLoggedInRef = useRef(user.logged_in);
  useEffect(function () {
    var controller = new AbortController();
    if (user.logged_in !== prevLoggedInRef.current) {
      prevLoggedInRef.current = user.logged_in;
      getLatestLiveAuctionSegments(controller, user.logged_in, subjectIds).then(function (data) {
        logger$5.info('User Login poll live segment loaded', data);
        if (data) {
          attemptSegmentWrite({
            data: data,
            source: 'local_optimistic_action'
          });
        }
        return null;
      }).catch(function (error) {
        logger$5.error('User Login online live segment poll error', error);
      });
    }
    return function () {
      return controller.abort();
    };
  }, [user.logged_in, subjectIds, attemptSegmentWrite]);
  if (!enabled) {
    return output;
  }
  useRealtimeWatcher({
    id: 'useLiveAuctions_Listing',
    subjectIds: subjectIds,
    polling: {
      enabled: true,
      frequency: SUPPORTED_OFFSETS.NORMAL,
      executor: function executor(_a) {
        var subjectIds = _a.subjectIds,
          controller = _a.controller;
        return (subjectIds === null || subjectIds === void 0 ? void 0 : subjectIds.length) ? getLatestLiveListings(subjectIds, controller) : Promise.resolve();
      }
    },
    websocket: {
      graphWebsocket: graphWebsocket,
      enabled: !configment.get('ENABLE_WEBSOCKET_KILL_SWITCH', false),
      executor: function executor(_a) {
        var subjectIds = _a.subjectIds;
        return {
          query: gql$1(templateObject_1$a || (templateObject_1$a = __makeTemplateObject(["\n          subscription blueprint_liveListingsUpdated($listingIds: [ID!]) {\n            listingsUpdated(filters: { listingIds: $listingIds }) {\n              update_date\n              listing_id\n              listing_status\n              auction {\n                starting_bid\n              }\n              reserve_price\n            }\n          }\n        "], ["\n          subscription blueprint_liveListingsUpdated($listingIds: [ID!]) {\n            listingsUpdated(filters: { listingIds: $listingIds }) {\n              update_date\n              listing_id\n              listing_status\n              auction {\n                starting_bid\n              }\n              reserve_price\n            }\n          }\n        "]))),
          variables: {
            listingIds: subjectIds
          }
        };
      },
      dataExtractor: function dataExtractor(data) {
        return [data.listingsUpdated].filter(Boolean);
      }
    },
    onData: function onData(payload) {
      var data = payload.data,
        source = payload.source;
      logger$5.info("New live listing data loaded. source=".concat(source), data);
      attemptListingWrite(payload);
    },
    onError: function onError(error) {
      logger$5.error('Realtime watcher error', error);
    },
    onEvent: function onEvent(event, ctx) {
      logger$5.info('Have event', event, ctx);
    }
  });
  useRealtimeWatcher({
    id: 'useLiveAuctions_ListingRemoteBidCandidateSubmission',
    subjectIds: subjectIds,
    websocket: {
      graphWebsocket: graphWebsocket,
      enabled: !configment.get('ENABLE_WEBSOCKET_KILL_SWITCH', false),
      executor: function executor(_a) {
        var subjectIds = _a.subjectIds;
        return {
          query: gql$1(templateObject_2$7 || (templateObject_2$7 = __makeTemplateObject(["\n          subscription blueprint_liveRemoteBidCandidateSubmitted(\n            $listingIds: [ID!]\n          ) {\n            remoteBidCandidateSubmitted(\n              filters: { listingIds: $listingIds, submittedByCurrentUser: true }\n            ) {\n              remote_bid {\n                listing_id\n                purchase_profile_id\n                remote_bid_amount\n              }\n            }\n          }\n        "], ["\n          subscription blueprint_liveRemoteBidCandidateSubmitted(\n            $listingIds: [ID!]\n          ) {\n            remoteBidCandidateSubmitted(\n              filters: { listingIds: $listingIds, submittedByCurrentUser: true }\n            ) {\n              remote_bid {\n                listing_id\n                purchase_profile_id\n                remote_bid_amount\n              }\n            }\n          }\n        "]))),
          variables: {
            listingIds: subjectIds
          }
        };
      },
      dataExtractor: function dataExtractor(data) {
        return [data.remoteBidCandidateSubmitted.remote_bid].filter(Boolean);
      }
    },
    onData: function onData(payload) {
      var data = payload.data,
        source = payload.source;
      var changedData = data.map(function (d) {
        return {
          listing_id: d.listing_id,
          current_user_remote_bid: d
        };
      });
      logger$5.info("Remote bid candidate submitted. source=".concat(source), changedData);
      attemptSegmentWrite({
        source: source,
        data: changedData,
        force: true
      });
    },
    onError: function onError(error) {
      logger$5.error('Realtime watcher error', error);
    },
    onEvent: function onEvent(event, ctx) {
      logger$5.info('Have event', event, ctx);
    }
  });
  var liveAuctionSegmentExecutor = useCallback(function (_a) {
    var subjectIds = _a.subjectIds,
      controller = _a.controller;
    return getLatestLiveAuctionSegments(controller, user.logged_in, subjectIds);
  }, [user]);
  useRealtimeWatcher({
    id: 'useLiveAuctions_LiveAuctionSegment',
    subjectIds: subjectIds,
    polling: {
      enabled: true,
      frequency: SUPPORTED_OFFSETS.CRITICAL,
      executor: liveAuctionSegmentExecutor
    },
    websocket: {
      graphWebsocket: graphWebsocket,
      enabled: !configment.get('ENABLE_WEBSOCKET_KILL_SWITCH', false),
      executor: function executor(_a) {
        var subjectIds = _a.subjectIds;
        return {
          query: gql$1(templateObject_3$4 || (templateObject_3$4 = __makeTemplateObject(["\n          subscription blueprint_liveAuctionSegmentUpdated($listingIds: [ID!]) {\n            liveAuctionSegmentUpdated(filters: { listingIds: $listingIds }) {\n              action\n              live_auction_segment {\n                starting_bid_amount\n                update_date\n                listing_id\n                auction_segment_id\n                bid_count\n                bidder_count\n                pending_update_status\n                segment_status\n                current_user_bidding_status\n                bidding_status\n                end_status\n                current_highest_bid {\n                  bid_amount\n                  bid_id\n                  bid_type\n                  belongs_to_current_user\n                  listing_id\n                  updated_date\n                }\n                configuration {\n                  bid_increment_amount\n                }\n                bid_extend {\n                  bid_extend_date_time\n                }\n              }\n            }\n          }\n        "], ["\n          subscription blueprint_liveAuctionSegmentUpdated($listingIds: [ID!]) {\n            liveAuctionSegmentUpdated(filters: { listingIds: $listingIds }) {\n              action\n              live_auction_segment {\n                starting_bid_amount\n                update_date\n                listing_id\n                auction_segment_id\n                bid_count\n                bidder_count\n                pending_update_status\n                segment_status\n                current_user_bidding_status\n                bidding_status\n                end_status\n                current_highest_bid {\n                  bid_amount\n                  bid_id\n                  bid_type\n                  belongs_to_current_user\n                  listing_id\n                  updated_date\n                }\n                configuration {\n                  bid_increment_amount\n                }\n                bid_extend {\n                  bid_extend_date_time\n                }\n              }\n            }\n          }\n        "]))),
          variables: {
            listingIds: subjectIds
          }
        };
      },
      dataExtractor: function dataExtractor(data) {
        var _a, _b;
        logger$5.info("New live segment data loaded. action=".concat((_a = data.liveAuctionSegmentUpdated) === null || _a === void 0 ? void 0 : _a.action));
        return [(_b = data.liveAuctionSegmentUpdated) === null || _b === void 0 ? void 0 : _b.live_auction_segment].filter(Boolean);
      }
    },
    onData: function onData(payload) {
      var data = payload.data,
        source = payload.source;
      logger$5.info("New live segment data loaded. source=".concat(source), data);
      var focusedSegments = data.filter(function (e) {
        return focusedListings.has(e.listing_id);
      });
      var batchedData = getBatchedSegmentData(source, focusedSegments, idempotentSegments);
      attemptBatchSegmentWrite(__spreadArray([{
        source: source,
        data: data
      }], batchedData, true));
    },
    onError: function onError(error) {
      logger$5.error('Realtime watcher error', error);
    },
    onEvent: function onEvent(event, ctx) {
      logger$5.info('Have event', event, ctx);
    }
  });
  var focusedListingsExecutor = useCallback(function (_a) {
    var subjectIds = _a.subjectIds,
      controller = _a.controller;
    return getLatestLiveFocusedListingsSegments(controller, subjectIds);
  }, [user]);
  useRealtimeWatcher({
    id: 'useLiveAuctions_FocusedListings',
    subjectIds: Array.from(focusedListings.values()),
    polling: {
      enabled: Boolean(focusedListings.size) && !___default.isEmpty(idempotentSegments),
      frequency: SUPPORTED_OFFSETS.CRITICAL,
      executor: focusedListingsExecutor
    },
    onData: function onData(payload) {
      var data = payload.data,
        source = payload.source;
      logger$5.info("New data for live focused listings loaded. source=".concat(source), JSON.stringify(data));
      attemptBatchSegmentWrite([{
        source: source,
        data: data,
        path: 'bids',
        updateBehavior: 'overwrite'
      }]);
    },
    onError: function onError(error) {
      logger$5.error('Realtime watcher error', error);
    },
    onEvent: function onEvent(event, ctx) {
      logger$5.info('Have event', event, ctx);
    }
  });
  return output;
}
function useRemoteBiddingFunds(_a) {
  var enabled = _a.enabled,
    graphWebsocket = _a.graphWebsocket,
    initialData = _a.initialData;
  if (!enabled) {
    return null;
  }
  var closeCurrentOperation = useRef(null);
  var _b = useState(initialData.fund),
    fund = _b[0],
    setFund = _b[1];
  useEffect(function () {
    graphWebsocket.subscribe({
      operationOptions: {
        query: gql$1(templateObject_4$3 || (templateObject_4$3 = __makeTemplateObject(["\n            subscription blueprint_currentUserFundUpdated {\n              remoteBidFundUpdated {\n                remote_bid_fund {\n                  fund_amount\n                  fund_status\n                }\n              }\n            }\n          "], ["\n            subscription blueprint_currentUserFundUpdated {\n              remoteBidFundUpdated {\n                remote_bid_fund {\n                  fund_amount\n                  fund_status\n                }\n              }\n            }\n          "])))
      },
      onData: function onData(data) {
        var _a;
        setFund((_a = data === null || data === void 0 ? void 0 : data.remoteBidFundUpdated) === null || _a === void 0 ? void 0 : _a.remote_bid_fund);
      },
      onError: function onError(error) {
        logger$5.warn(error);
      }
    }).then(function (subscriber) {
      closeCurrentOperation.current = subscriber.unsubscribe;
    }).catch(function (err) {
      return logger$5.warn(err);
    });
    return function () {
      var _a;
      return (_a = closeCurrentOperation.current) === null || _a === void 0 ? void 0 : _a.call(closeCurrentOperation);
    };
  }, [graphWebsocket]);
  return fund;
}
var templateObject_1$a, templateObject_2$7, templateObject_3$4, templateObject_4$3;

var logger$4 = coreLogger.forModule('blueprint:time');
var CurrentTimePoller = function () {
  function CurrentTimePoller() {
    this.listeners = [];
    this.intervalId = null;
    this.polling = false;
    this.nextListenerId = 0;
    this.currentTime = null;
  }
  CurrentTimePoller.prototype.subscribe = function (listener) {
    var id = this.nextListenerId++;
    this.listeners.push({
      id: id,
      fn: listener
    });
    if (!this.polling) {
      this.polling = true;
      this.schedulePoll();
    }
    return id;
  };
  CurrentTimePoller.prototype.getCurrentTime = function () {
    return this.currentTime;
  };
  CurrentTimePoller.prototype.unsubscribe = function (listenerId) {
    this.listeners = this.listeners.filter(function (_a) {
      var id = _a.id;
      return id !== listenerId;
    });
    if (this.listeners.length === 0) {
      this.terminatePoll();
    }
  };
  CurrentTimePoller.prototype.updateCurrentTime = function () {
    return __awaiter(this, void 0, void 0, function () {
      var newCurrentTime, err_1;
      var _this = this;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);
            return [4, getCurrentServerTime()];
          case 1:
            newCurrentTime = _a.sent();
            this.currentTime = newCurrentTime || new Date();
            this.listeners.forEach(function (_a) {
              var fn = _a.fn;
              return fn(_this.currentTime);
            });
            return [3, 3];
          case 2:
            err_1 = _a.sent();
            logger$4.error(err_1);
            return [3, 3];
          case 3:
            return [2];
        }
      });
    });
  };
  CurrentTimePoller.prototype.schedulePoll = function () {
    return __awaiter(this, void 0, void 0, function () {
      var _this = this;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.updateCurrentTime()];
          case 1:
            _a.sent();
            this.intervalId = setInterval(function () {
              _this.updateCurrentTime();
            }, CURRENT_SERVER_TIME_POLLING_INTERVAL);
            return [2];
        }
      });
    });
  };
  CurrentTimePoller.prototype.terminatePoll = function () {
    if (typeof this.intervalId === 'number') {
      clearInterval(this.intervalId);
    }
    this.intervalId = null;
    this.polling = false;
    this.currentTime = null;
  };
  return CurrentTimePoller;
}();
var makeUseCurrentTimeHook = function makeUseCurrentTimeHook(timePoller) {
  return function () {
    var unsubscribeId = useRef();
    var _a = useState(timePoller.getCurrentTime()),
      currentTime = _a[0],
      setCurrentTime = _a[1];
    useEffect(function () {
      unsubscribeId.current = timePoller.subscribe(setCurrentTime);
      return function () {
        if (typeof unsubscribeId.current === 'number') {
          timePoller.unsubscribe(unsubscribeId.current);
        }
      };
    }, []);
    return currentTime;
  };
};
var experimental_useCurrentTime = makeUseCurrentTimeHook(new CurrentTimePoller());
function useCurrentTime() {
  var time = useRef();
  time.current = new Date();
  return time.current;
}
var useMomentCurrentTime = function useMomentCurrentTime() {
  var currentTime = experimental_useCurrentTime();
  var currentServerTime = useMemo(function () {
    return moment(currentTime);
  }, [currentTime]);
  return currentServerTime;
};

var logger$3 = coreLogger.forModule('blueprint:bidding');
function useOnlineAuctions(_a) {
  var _this = this;
  var enabled = _a.enabled,
    initialData = _a.initialData,
    graphWebsocket = _a.graphWebsocket,
    user = _a.user,
    _b = _a.targetAudience,
    targetAudience = _b === void 0 ? TargetAudience.BUYER : _b;
  var _c = useIdempotentBlueprintCollection(initialData === null || initialData === void 0 ? void 0 : initialData.listings, {
      primaryKey: 'listing_id',
      utils: listingUtils,
      updateBehavior: 'merge',
      idempotencyKey: 'updated_date'
    }),
    idempotentListings = _c.collection,
    attemptListingWrite = _c.attemptWrite;
  var _d = useIdempotentBlueprintCollection(initialData === null || initialData === void 0 ? void 0 : initialData.segments, {
      primaryKey: 'listing_id',
      utils: onlineAuctionUtils,
      updateBehavior: 'merge'
    }),
    idempotentSegments = _d.collection,
    attemptSegmentWrite = _d.attemptWrite;
  var _e = useBoundedArray({
      onCapacityReachedText: 'focused listings'
    }),
    focusedListings = _e.keys,
    focusListing = _e.addElement,
    unFocusListing = _e.removeElement;
  var data = useMemo(function () {
    return {
      focusedListings: Array.from(focusedListings),
      listings: idempotentListings,
      segments: idempotentSegments
    };
  }, [focusedListings, idempotentListings, idempotentSegments]);
  var isSellerAudience = targetAudience === TargetAudience.SELLER;
  var currentTime = useCurrentTime();
  var subjectIds = useMemo(function () {
    return initialData.listings.map(function (l) {
      return typeof l === 'string' ? l : l.listing_id;
    });
  }, [initialData.listings]);
  var refreshFocusedListingsSegments = useCallback(function () {
    return __awaiter(_this, void 0, void 0, function () {
      var data_1, err_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);
            return [4, getLatestOnlineFocusedListingsSegments(new AbortController(), user.logged_in, subjectIds, isSellerAudience)];
          case 1:
            data_1 = _a.sent();
            logger$3.info("New segment bid rank data loaded through manual refresh: ", data_1);
            attemptSegmentWrite({
              data: data_1,
              source: 'local_optimistic_action',
              force: true
            });
            return [3, 3];
          case 2:
            err_1 = _a.sent();
            console.error(err_1);
            return [3, 3];
          case 3:
            return [2];
        }
      });
    });
  }, [user.logged_in, subjectIds, isSellerAudience, attemptSegmentWrite]);
  var output = useMemo(function () {
    return {
      data: data,
      actions: {
        focusListing: focusListing,
        unFocusListing: unFocusListing,
        refreshFocusedListingsSegments: refreshFocusedListingsSegments
      }
    };
  }, [data, focusListing, unFocusListing, refreshFocusedListingsSegments]);
  var prevLoggedInRef = useRef(user.logged_in);
  var updateAttemptedRef = useRef(false);
  useEffect(function () {
    var controller = new AbortController();
    if (user.logged_in !== prevLoggedInRef.current && !updateAttemptedRef.current) {
      var getLatestSegmentsPromise = getLatestOnlineSegments(controller, user.logged_in, subjectIds, isSellerAudience);
      var getLatestListingsPromise = getLatestOnlineListings(subjectIds, controller, user.logged_in);
      updateAttemptedRef.current = true;
      Promise.all([getLatestSegmentsPromise, getLatestListingsPromise]).then(function (_a) {
        var segments = _a[0],
          listings = _a[1];
        attemptSegmentWrite({
          data: segments,
          source: 'local_optimistic_action'
        });
        logger$3.info('User Login poll online segment loaded', segments);
        attemptListingWrite({
          data: listings,
          source: 'local_optimistic_action'
        });
        logger$3.info('User Login poll online listing loaded', listings);
        prevLoggedInRef.current = user.logged_in;
        updateAttemptedRef.current = false;
        return null;
      }).catch(function (error) {
        logger$3.error('User Login online segment/listing poll error', error);
      }).finally(function () {
        controller.abort();
      });
    }
  }, [user.logged_in, subjectIds, attemptSegmentWrite, attemptListingWrite, isSellerAudience]);
  if (!enabled) {
    return output;
  }
  useRealtimeWatcher({
    id: 'useOnlineAuctions_Listing',
    subjectIds: subjectIds,
    polling: {
      enabled: true,
      frequency: SUPPORTED_OFFSETS.NORMAL,
      executor: function executor(_a) {
        var subjectIds = _a.subjectIds,
          controller = _a.controller;
        return (subjectIds === null || subjectIds === void 0 ? void 0 : subjectIds.length) ? getLatestOnlineListings(subjectIds, controller) : Promise.resolve();
      }
    },
    websocket: {
      graphWebsocket: graphWebsocket,
      enabled: !configment.get('ENABLE_WEBSOCKET_KILL_SWITCH', false),
      executor: function executor(_a) {
        var subjectIds = _a.subjectIds;
        return {
          query: gql$1(templateObject_1$9 || (templateObject_1$9 = __makeTemplateObject(["\n          subscription blueprint_onlineListingsUpdated($listingIds: [ID!]) {\n            listingsUpdated(filters: { listingIds: $listingIds }) {\n              updated_date\n              listing_id\n              listing_status\n              reserve_price\n            }\n          }\n        "], ["\n          subscription blueprint_onlineListingsUpdated($listingIds: [ID!]) {\n            listingsUpdated(filters: { listingIds: $listingIds }) {\n              updated_date\n              listing_id\n              listing_status\n              reserve_price\n            }\n          }\n        "]))),
          variables: {
            listingIds: subjectIds
          }
        };
      },
      dataExtractor: function dataExtractor(data) {
        return [data.listingsUpdated].filter(Boolean);
      }
    },
    onData: function onData(payload) {
      var data = payload.data,
        source = payload.source;
      logger$3.info("New online listing data loaded. source=".concat(source), data);
      attemptListingWrite({
        data: data,
        source: source,
        force: true
      });
    },
    onError: function onError(error) {
      logger$3.error('Realtime watcher error', error);
    },
    onEvent: function onEvent(event, ctx) {
      logger$3.info('Have event', event, ctx);
    }
  });
  var focusedListingsExecutor = useCallback(function (_a) {
    var subjectIds = _a.subjectIds,
      controller = _a.controller;
    return getLatestOnlineFocusedListingsSegments(controller, user.logged_in, subjectIds, isSellerAudience);
  }, [isSellerAudience, user.logged_in]);
  useRealtimeWatcher({
    id: 'useOnlineAuctions_FocusedListingsBidSubmitted',
    subjectIds: Array.from(focusedListings.values()),
    websocket: {
      graphWebsocket: graphWebsocket,
      enabled: !configment.get('ENABLE_WEBSOCKET_KILL_SWITCH', false),
      executor: function executor(_a) {
        var subjectIds = _a.subjectIds;
        return {
          query: gql$1(templateObject_2$6 || (templateObject_2$6 = __makeTemplateObject(["\n          subscription blueprint_onlineAuctionSegmentBidSubmitted(\n            $listingIds: [ID!] #            $hasAuthenticatedUser: Boolean!\n            $submittedByCurrentUser: Boolean!\n          ) {\n            onlineAuctionSegmentBidSubmitted(\n              filters: {\n                listingIds: $listingIds\n                submittedByCurrentUser: $submittedByCurrentUser\n              }\n            ) {\n              bid {\n                updated_date\n                listing_id\n                bid_id\n                rank\n                type\n                bid_amount\n                bidder_party_id\n                version\n                created_date\n                negotiation_sequence {\n                  counters {\n                    listing_id\n                    bid_amount\n                    bid_id\n                    bidder_party_id\n                    type\n                    version\n\n                    updated_date\n                    created_date\n                    ...OnlineAuctionSegmentBidTermsFragment\n                  }\n                  latest_counter_bid {\n                    listing_id\n                    bid_amount\n                    bid_id\n                    bidder_party_id\n                    type\n                    version\n                    updated_date\n                    ...OnlineAuctionSegmentBidTermsFragment\n                  }\n                }\n                ...OnlineAuctionSegmentBidTermsFragment\n              }\n            }\n          }\n          ", "\n        "], ["\n          subscription blueprint_onlineAuctionSegmentBidSubmitted(\n            $listingIds: [ID!] #            $hasAuthenticatedUser: Boolean!\n            $submittedByCurrentUser: Boolean!\n          ) {\n            onlineAuctionSegmentBidSubmitted(\n              filters: {\n                listingIds: $listingIds\n                submittedByCurrentUser: $submittedByCurrentUser\n              }\n            ) {\n              bid {\n                updated_date\n                listing_id\n                bid_id\n                rank\n                type\n                bid_amount\n                bidder_party_id\n                version\n                created_date\n                negotiation_sequence {\n                  counters {\n                    listing_id\n                    bid_amount\n                    bid_id\n                    bidder_party_id\n                    type\n                    version\n\n                    updated_date\n                    created_date\n                    ...OnlineAuctionSegmentBidTermsFragment\n                  }\n                  latest_counter_bid {\n                    listing_id\n                    bid_amount\n                    bid_id\n                    bidder_party_id\n                    type\n                    version\n                    updated_date\n                    ...OnlineAuctionSegmentBidTermsFragment\n                  }\n                }\n                ...OnlineAuctionSegmentBidTermsFragment\n              }\n            }\n          }\n          ", "\n        "])), ONLINE_AUCTION_SEGMENT_BID_TERMS),
          variables: {
            listingIds: subjectIds,
            submittedByCurrentUser: targetAudience === TargetAudience.BUYER
          }
        };
      },
      dataExtractor: function dataExtractor(data) {
        return [data.onlineAuctionSegmentBidSubmitted.bid].filter(Boolean).map(function (data) {
          var _a;
          return _assign({
            listing_id: (_a = data.bid) === null || _a === void 0 ? void 0 : _a.listing_id
          }, data);
        });
      }
    },
    onData: function onData(payload) {
      var _a;
      var data = payload.data,
        source = payload.source;
      logger$3.info("New data for online focused listings bids submission loaded. source=".concat(source), JSON.stringify(data));
      var bid = data[0];
      if (bid) {
        updateIfExistingBidInRanking(attemptSegmentWrite, source, bid, (_a = idempotentSegments.mapped.get(bid.listing_id)) === null || _a === void 0 ? void 0 : _a.bids_ranking);
      }
    },
    onError: function onError(error) {
      logger$3.error('Realtime watcher error', error);
    },
    onEvent: function onEvent(event, ctx) {
      logger$3.info('Have event', event, ctx);
    }
  });
  useRealtimeWatcher({
    id: 'useOnlineAuctions_FocusedListings',
    subjectIds: Array.from(focusedListings.values()),
    polling: {
      enabled: Boolean(focusedListings.size) && !___default.isEmpty(idempotentSegments),
      frequency: SUPPORTED_OFFSETS.CRITICAL,
      executor: focusedListingsExecutor
    },
    websocket: {
      graphWebsocket: graphWebsocket,
      enabled: !configment.get('ENABLE_WEBSOCKET_KILL_SWITCH', false),
      executor: function executor(_a) {
        var subjectIds = _a.subjectIds;
        return {
          query: gql$1(templateObject_3$3 || (templateObject_3$3 = __makeTemplateObject(["\n          subscription blueprint_onlineSegmentsRankingUpdated(\n            $listingIds: [ID!]\n            $hasAuthenticatedUser: Boolean!\n          ) {\n            onlineAuctionBidRankingUpdated(\n              filters: { listingIds: $listingIds }\n            ) {\n              bids_ranking {\n                updated_date\n                listing_id\n                ranking {\n                  belongs_to_current_user @include(if: $hasAuthenticatedUser)\n                  is_viewable_by_current_user\n                    @include(if: $hasAuthenticatedUser)\n                  overtake_delta @include(if: $hasAuthenticatedUser)\n                  net_offer_equal_delta @include(if: $hasAuthenticatedUser)\n                  bid_id\n                  party_id\n                  rank\n                  seller_assigned_score\n                  system_calculated_score\n                  max_tied_rank\n                  bid {\n                    listing_id\n                    bid_amount\n                    bid_id\n                    bidder_party_id\n                    type\n                    version\n                    updated_date\n                    created_date\n                    negotiation_sequence {\n                      counters {\n                        listing_id\n                        bid_amount\n                        bid_id\n                        bidder_party_id\n                        type\n                        version\n\n                        updated_date\n                        created_date\n                        ...OnlineAuctionSegmentBidTermsFragment\n                      }\n                      latest_counter_bid {\n                        listing_id\n                        bid_amount\n                        bid_id\n                        bidder_party_id\n                        type\n                        version\n                        updated_date\n                        ...OnlineAuctionSegmentBidTermsFragment\n                      }\n                    }\n                    ...OnlineAuctionSegmentBidTermsFragment\n                  }\n                  party {\n                    person {\n                      first_name\n                      last_name\n                    }\n                  }\n                }\n              }\n            }\n          }\n          ", "\n        "], ["\n          subscription blueprint_onlineSegmentsRankingUpdated(\n            $listingIds: [ID!]\n            $hasAuthenticatedUser: Boolean!\n          ) {\n            onlineAuctionBidRankingUpdated(\n              filters: { listingIds: $listingIds }\n            ) {\n              bids_ranking {\n                updated_date\n                listing_id\n                ranking {\n                  belongs_to_current_user @include(if: $hasAuthenticatedUser)\n                  is_viewable_by_current_user\n                    @include(if: $hasAuthenticatedUser)\n                  overtake_delta @include(if: $hasAuthenticatedUser)\n                  net_offer_equal_delta @include(if: $hasAuthenticatedUser)\n                  bid_id\n                  party_id\n                  rank\n                  seller_assigned_score\n                  system_calculated_score\n                  max_tied_rank\n                  bid {\n                    listing_id\n                    bid_amount\n                    bid_id\n                    bidder_party_id\n                    type\n                    version\n                    updated_date\n                    created_date\n                    negotiation_sequence {\n                      counters {\n                        listing_id\n                        bid_amount\n                        bid_id\n                        bidder_party_id\n                        type\n                        version\n\n                        updated_date\n                        created_date\n                        ...OnlineAuctionSegmentBidTermsFragment\n                      }\n                      latest_counter_bid {\n                        listing_id\n                        bid_amount\n                        bid_id\n                        bidder_party_id\n                        type\n                        version\n                        updated_date\n                        ...OnlineAuctionSegmentBidTermsFragment\n                      }\n                    }\n                    ...OnlineAuctionSegmentBidTermsFragment\n                  }\n                  party {\n                    person {\n                      first_name\n                      last_name\n                    }\n                  }\n                }\n              }\n            }\n          }\n          ", "\n        "])), ONLINE_AUCTION_SEGMENT_BID_TERMS),
          variables: {
            listingIds: subjectIds,
            hasAuthenticatedUser: user.logged_in
          }
        };
      },
      dataExtractor: function dataExtractor(data) {
        return [data.onlineAuctionBidRankingUpdated].filter(Boolean).map(function (data) {
          var _a;
          return _assign({
            listing_id: (_a = data.bids_ranking) === null || _a === void 0 ? void 0 : _a.listing_id
          }, data);
        });
      }
    },
    onData: function onData(payload) {
      var data = payload.data,
        source = payload.source;
      logger$3.info("New data for online focused listings loaded. source=".concat(source), JSON.stringify(data));
      attemptSegmentWrite({
        data: data,
        source: source,
        force: true
      });
    },
    onError: function onError(error) {
      logger$3.error('Realtime watcher error', error);
    },
    onEvent: function onEvent(event, ctx) {
      logger$3.info('Have event', event, ctx);
    }
  });
  useRealtimeWatcher({
    id: 'useOnlineAuctions_ListingOnlineMaxBidSubmission',
    subjectIds: subjectIds,
    websocket: {
      graphWebsocket: graphWebsocket,
      enabled: !configment.get('ENABLE_WEBSOCKET_KILL_SWITCH', false),
      executor: function executor(_a) {
        var subjectIds = _a.subjectIds;
        return {
          query: gql$1(templateObject_4$2 || (templateObject_4$2 = __makeTemplateObject(["\n          subscription blueprint_listingOnlineMaxBidSubmission(\n            $listingIds: [ID!]\n            $submittedByCurrentUser: Boolean\n          ) {\n            listingOnlineMaxbidSubmitted(\n              filters: {\n                listingIds: $listingIds\n                submittedByCurrentUser: $submittedByCurrentUser\n              }\n            ) {\n              max_bid {\n                listing_id\n                max_bid_amount\n              }\n            }\n          }\n        "], ["\n          subscription blueprint_listingOnlineMaxBidSubmission(\n            $listingIds: [ID!]\n            $submittedByCurrentUser: Boolean\n          ) {\n            listingOnlineMaxbidSubmitted(\n              filters: {\n                listingIds: $listingIds\n                submittedByCurrentUser: $submittedByCurrentUser\n              }\n            ) {\n              max_bid {\n                listing_id\n                max_bid_amount\n              }\n            }\n          }\n        "]))),
          variables: {
            listingIds: subjectIds,
            submittedByCurrentUser: true
          }
        };
      },
      dataExtractor: function dataExtractor(data) {
        var _a;
        return [(_a = data.listingOnlineMaxbidSubmitted) === null || _a === void 0 ? void 0 : _a.max_bid].filter(Boolean);
      }
    },
    onData: function onData(payload) {
      var data = payload.data,
        source = payload.source;
      var changedData = data.map(function (d) {
        return {
          listing_id: d.listing_id,
          current_user_max_bid: d
        };
      });
      logger$3.info("Max bid submitted. source=".concat(source), changedData);
      attemptSegmentWrite({
        source: source,
        data: changedData,
        force: true
      });
    },
    onError: function onError(error) {
      logger$3.error('Realtime watcher error', error);
    },
    onEvent: function onEvent(event, ctx) {
      logger$3.info('Have event', event, ctx);
    }
  });
  var onlineAuctionSegmentExecutor = useCallback(function (_a) {
    var subjectIds = _a.subjectIds,
      controller = _a.controller;
    return getLatestOnlineSegments(controller, user.logged_in, subjectIds, isSellerAudience);
  }, [user, isSellerAudience]);
  useRealtimeWatcher({
    id: 'useOnlineAuctions_OnlineAuctionSegment',
    subjectIds: subjectIds,
    polling: {
      enabled: true,
      frequency: useCallback(function () {
        return computeNextOnlinePollingOffset(currentTime, idempotentSegments.raw.filter(Boolean));
      }, [currentTime, idempotentSegments]),
      executor: onlineAuctionSegmentExecutor
    },
    websocket: {
      graphWebsocket: graphWebsocket,
      enabled: !configment.get('ENABLE_WEBSOCKET_KILL_SWITCH', false),
      executor: function executor(_a) {
        var subjectIds = _a.subjectIds;
        return {
          query: gql$1(templateObject_5$1 || (templateObject_5$1 = __makeTemplateObject(["\n          subscription blueprint_onlineAuctionSegmentUpdated(\n            $listingIds: [ID!]\n            $isSellerAudience: Boolean!\n            $hasAuthenticatedUser: Boolean!\n          ) {\n            onlineAuctionSegmentUpdated(filters: { listingIds: $listingIds }) {\n              action\n              online_segment {\n                update_date\n                listing_id\n                online_segment_id\n                start_date\n                initial_end_date\n                current_increment_amount\n                segment_status\n                reserve_status\n                current_time\n                starting_bid_amount\n                match_bidding_period_end_date\n                is_match_bidding_ended\n                match_bid_count\n                bid_count\n                buyer_bid_count\n                current_highest_bid {\n                  bid_amount\n                  belongs_to_current_user\n                  type\n                }\n                current_bid_extension {\n                  extension_type\n                  reason\n                }\n                current_user_highest_bid {\n                  record_status\n                  listing_id\n                  bid_amount\n                  type\n                }\n                current_user_max_bid {\n                  max_bid_amount\n                  record_status\n                }\n                current_user_bidding_status\n                subject_to_status\n                configuration {\n                  bids_away_status\n                  is_one_away_enabled\n                  is_one_away_displayed\n                  is_initial_end_date_extended\n                  is_match_bidding_enabled\n                  is_max_bidding_enabled\n                  should_bid_again\n                  bid_again_count\n                  review_date\n                }\n                result {\n                  winning_bid_amount\n                }\n                ...SellerExclusiveOnlineAuctionSegmentFragment\n                  @include(if: $isSellerAudience)\n              }\n            }\n          }\n          ", "\n        "], ["\n          subscription blueprint_onlineAuctionSegmentUpdated(\n            $listingIds: [ID!]\n            $isSellerAudience: Boolean!\n            $hasAuthenticatedUser: Boolean!\n          ) {\n            onlineAuctionSegmentUpdated(filters: { listingIds: $listingIds }) {\n              action\n              online_segment {\n                update_date\n                listing_id\n                online_segment_id\n                start_date\n                initial_end_date\n                current_increment_amount\n                segment_status\n                reserve_status\n                current_time\n                starting_bid_amount\n                match_bidding_period_end_date\n                is_match_bidding_ended\n                match_bid_count\n                bid_count\n                buyer_bid_count\n                current_highest_bid {\n                  bid_amount\n                  belongs_to_current_user\n                  type\n                }\n                current_bid_extension {\n                  extension_type\n                  reason\n                }\n                current_user_highest_bid {\n                  record_status\n                  listing_id\n                  bid_amount\n                  type\n                }\n                current_user_max_bid {\n                  max_bid_amount\n                  record_status\n                }\n                current_user_bidding_status\n                subject_to_status\n                configuration {\n                  bids_away_status\n                  is_one_away_enabled\n                  is_one_away_displayed\n                  is_initial_end_date_extended\n                  is_match_bidding_enabled\n                  is_max_bidding_enabled\n                  should_bid_again\n                  bid_again_count\n                  review_date\n                }\n                result {\n                  winning_bid_amount\n                }\n                ...SellerExclusiveOnlineAuctionSegmentFragment\n                  @include(if: $isSellerAudience)\n              }\n            }\n          }\n          ", "\n        "])), SELLER_EXCLUSIVE_ONLINE_AUCTION_SEGMENT_FIELDS),
          variables: {
            listingIds: subjectIds,
            isSellerAudience: isSellerAudience,
            hasAuthenticatedUser: user.logged_in
          }
        };
      },
      dataExtractor: function dataExtractor(data) {
        var _a;
        return [(_a = data.onlineAuctionSegmentUpdated) === null || _a === void 0 ? void 0 : _a.online_segment].filter(Boolean);
      }
    },
    onData: function onData(_a) {
      var data = _a.data,
        source = _a.source;
      logger$3.info("New segment data loaded. source=".concat(source), data);
      attemptSegmentWrite({
        source: source,
        data: data
      });
    },
    onError: function onError(error) {
      logger$3.error('Realtime watcher error', error);
    },
    onEvent: function onEvent(event, ctx) {
      logger$3.info('Have event', event, ctx);
    }
  });
  useRealtimeWatcher({
    id: 'useOnlineAuctions_onlineAuctionListing',
    subjectIds: subjectIds,
    polling: {
      enabled: true,
      frequency: SUPPORTED_OFFSETS.NORMAL,
      executor: function executor(_a) {
        var subjectIds = _a.subjectIds,
          controller = _a.controller;
        return (subjectIds === null || subjectIds === void 0 ? void 0 : subjectIds.length) ? getLatestOnlineListings(subjectIds, controller) : Promise.resolve();
      }
    },
    websocket: {
      graphWebsocket: graphWebsocket,
      enabled: !configment.get('ENABLE_WEBSOCKET_KILL_SWITCH', false),
      executor: function executor(_a) {
        var subjectIds = _a.subjectIds;
        return {
          query: gql$1(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n          subscription blueprint_onlineAuctionBidderRegistrationUpdated(\n            $listingIds: [ID!]\n          ) {\n            onlineAuctionBidderRegistrationUpdated(\n              filters: { listingIds: $listingIds }\n            ) {\n              is_current_user_registered_for_online_auction\n              online_bidder_registration {\n                registration_status\n              }\n            }\n          }\n        "], ["\n          subscription blueprint_onlineAuctionBidderRegistrationUpdated(\n            $listingIds: [ID!]\n          ) {\n            onlineAuctionBidderRegistrationUpdated(\n              filters: { listingIds: $listingIds }\n            ) {\n              is_current_user_registered_for_online_auction\n              online_bidder_registration {\n                registration_status\n              }\n            }\n          }\n        "]))),
          variables: {
            listingIds: subjectIds
          }
        };
      },
      dataExtractor: function dataExtractor(data) {
        return [data.listingsUpdated].filter(Boolean);
      }
    },
    onData: function onData(payload) {
      var data = payload.data,
        source = payload.source;
      logger$3.info("New online listing data loaded. source=".concat(source), data);
      attemptListingWrite({
        data: data,
        source: source,
        force: true
      });
    },
    onError: function onError(error) {
      logger$3.error('Realtime watcher error', error);
    },
    onEvent: function onEvent(event, ctx) {
      logger$3.info('Have event', event, ctx);
    }
  });
  return output;
}
var templateObject_1$9, templateObject_2$6, templateObject_3$3, templateObject_4$2, templateObject_5$1, templateObject_6;

var hooks$5 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  experimental_useCurrentTime: experimental_useCurrentTime,
  useLiveAuctions: useLiveAuctions,
  useMomentCurrentTime: useMomentCurrentTime,
  useOnlineAuctions: useOnlineAuctions,
  useRemoteBiddingFunds: useRemoteBiddingFunds
});

var enums = types$4;

var index$a = /*#__PURE__*/Object.freeze({
  __proto__: null,
  enums: enums,
  hooks: hooks$5,
  providers: providers$7,
  types: types$4,
  utils: utils$4
});

var UI_DATE_FORMAT = 'MM/DD/YYYY';
var MAX_CHARACTERS_FOR_USING_GROUP_LABEL = 21;
var getFilterGroupDefinitionByName = function getFilterGroupDefinitionByName(definitions, name) {
  return definitions.find(function (def) {
    return def.name === name;
  }) || null;
};
var getFilterDefinition = function getFilterDefinition(filter) {
  if (['singleSelect', 'multiSelect', 'inlineSelect', 'range', 'boolean'].includes(filter.controlType)) {
    return filter;
  } else {
    throw new Error('Invalid control type');
  }
};
var getFilterDefinitionByName = function getFilterDefinitionByName(filterGroup, filterName) {
  for (var _i = 0, _a = filterGroup.items; _i < _a.length; _i++) {
    var item = _a[_i];
    if (item.itemType === 'section') {
      for (var _b = 0, _c = item.filters || []; _b < _c.length; _b++) {
        var filter = _c[_b];
        if (filter.name === filterName) {
          return getFilterDefinition(filter);
        }
      }
    } else if (item.itemType === 'filter' && item.name === filterName) {
      return getFilterDefinition(item);
    }
  }
  return null;
};
var getSingleFilterResetValue = function getSingleFilterResetValue(filter) {
  return match(filter.controlType).with('singleSelect', function () {
    return match(filter.controlValueType).with('string', function () {
      return '';
    }).otherwise(function () {
      return null;
    });
  }).with('multiSelect', function () {
    return [];
  }).with('inlineSelect', function () {
    var inlineFilter = filter;
    if (inlineFilter.mode === 'single') {
      return '';
    } else if (inlineFilter.mode === 'multi' || inlineFilter.mode === 'range') {
      return [];
    }
    return '';
  }).with('range', function () {
    return {
      min: null,
      max: null
    };
  }).with('boolean', function () {
    return false;
  }).otherwise(function () {
    return null;
  });
};
var initializeFilterGroupViewModel = function initializeFilterGroupViewModel(definition) {
  var groupVM = {};
  definition.items.forEach(function (item) {
    if (item.itemType === 'filter') {
      var filter = item;
      groupVM[filter.name] = getSingleFilterResetValue(filter);
    } else if (item.itemType === 'section') {
      var section = item;
      section.filters.forEach(function (filter) {
        groupVM[filter.name] = getSingleFilterResetValue(filter);
      });
    }
  });
  return groupVM;
};
var resetIndividualFilter = function resetIndividualFilter(definition, state, filter) {
  var _a, _b;
  var _c;
  var matchingModel = (_c = Object.entries(state).find(function (_a) {
    var name = _a[0],
      data = _a[1];
    return name !== definition.name && filter.name in data;
  })) === null || _c === void 0 ? void 0 : _c[0];
  if (!matchingModel) return state;
  return _assign(_assign({}, state), (_a = {}, _a[matchingModel] = _assign(_assign({}, state[matchingModel]), (_b = {}, _b[filter.name] = getSingleFilterResetValue(filter), _b)), _a));
};
var resetMatchingFiltersViewModel = function resetMatchingFiltersViewModel(definition, prevState) {
  var newState = _assign({}, prevState);
  definition.items.forEach(function (item) {
    if (item.itemType === 'filter') {
      var filter = item;
      newState = resetIndividualFilter(definition, newState, filter);
    } else if (item.itemType === 'section') {
      var section = item;
      section.filters.forEach(function (filter) {
        newState = resetIndividualFilter(definition, newState, filter);
      });
    }
  });
  return newState;
};
var _isClean = function isClean(v) {
  if (___default.isDate(v)) {
    return false;
  } else if (_typeof(v) === 'object' && !Array.isArray(v) && v !== null) {
    return Object.keys(v).every(function (key) {
      return _isClean(v[key]);
    });
  } else if (___default.isString(v) || ___default.isArray(v)) {
    return ___default.isEmpty(v);
  }
  return ___default.isNil(v) || v === false;
};
var isGroupFilterReset = function isGroupFilterReset(data) {
  var keys = Object.keys(data);
  return keys.every(function (key) {
    return _isClean(data[key]);
  });
};
var areAllFiltersReset = function areAllFiltersReset(dataCollection) {
  return Object.values(dataCollection).every(isGroupFilterReset);
};
var convertToViewModelValue = function convertToViewModelValue(value, definition) {
  return definition.converterOverrides && definition.converterOverrides.toViewModelValue ? definition.converterOverrides.toViewModelValue(value, definition) : value || null;
};
var convertToAppModelValue = function convertToAppModelValue(value, definition) {
  return definition.converterOverrides && definition.converterOverrides.toAppModelValue ? definition.converterOverrides.toAppModelValue(value, definition) : value;
};
var defaultFilterStateToViewModels = function defaultFilterStateToViewModels(filterState, filterDefinitions) {
  var vm = {};
  filterDefinitions.forEach(function (groupDefinition) {
    var groupName = groupDefinition.name;
    vm[groupName] = groupDefinition.items.reduce(function (acc, item) {
      var _a;
      if (item.itemType === 'filter') {
        return _assign(_assign({}, acc), (_a = {}, _a[item.name] = convertToViewModelValue(filterState[item.name], item), _a));
      } else if (item.itemType === 'section') {
        var section = item;
        return _assign(_assign({}, acc), section.filters.reduce(function (acc, filter) {
          var _a;
          return _assign(_assign({}, acc), (_a = {}, _a[filter.name] = convertToViewModelValue(filterState[filter.name], filter), _a));
        }, {}));
      }
      return acc;
    }, {});
  });
  return vm;
};
var defaultViewModelsToFilterState = function defaultViewModelsToFilterState(filterViewModels, prevFilterState, filterDefinitions) {
  var newState = _assign({}, prevFilterState);
  Object.keys(filterViewModels).forEach(function (groupName) {
    var groupDefinition = getFilterGroupDefinitionByName(filterDefinitions, groupName);
    var groupViewModel = filterViewModels[groupName];
    if (groupDefinition !== null) {
      Object.keys(groupViewModel).forEach(function (filterName) {
        newState[filterName] = convertToAppModelValue(groupViewModel[filterName], getFilterDefinitionByName(groupDefinition, filterName));
      });
    }
  });
  return newState;
};
var isSubset = function isSubset(a, b) {
  return ___default.difference(b, a).length === 0;
};
var arraysAreEqual = function arraysAreEqual(a, b) {
  if (!Array.isArray(a) || !Array.isArray(b)) {
    return false;
  }
  if (a.length !== b.length) {
    return false;
  }
  var setA = new Set(a);
  var setB = new Set(b);
  for (var _i = 0, _a = Array.from(setA); _i < _a.length; _i++) {
    var item = _a[_i];
    if (!setB.has(item)) {
      return false;
    }
  }
  return true;
};
var formatDate = function formatDate(date) {
  if (!date) return '';
  return moment(date).format(UI_DATE_FORMAT);
};
var formatNumber = function formatNumber(str, maximumFractionDigits) {
  if (str === void 0) {
    str = null;
  }
  if (maximumFractionDigits === void 0) {
    maximumFractionDigits = 0;
  }
  return str && !isNaN(Number(str)) ? Number(str).toLocaleString('en-US', {
    maximumFractionDigits: maximumFractionDigits
  }) : '0';
};
var formatRangeValue = function formatRangeValue(value, type) {
  return match(type).with('number', function () {
    return formatNumber(value);
  }).with('Date', function () {
    return formatDate(value);
  }).otherwise(function () {
    return value;
  });
};
var filterOptions = function filterOptions(value) {
  return function (option) {
    return value !== null && Array.isArray(value) && (Array.isArray(option.value) && isSubset(value, option.value) || value.includes(option.value));
  };
};
var getPartsFromFilterAndValue = function getPartsFromFilterAndValue(filterDefinition, value) {
  var filterLabel = filterDefinition.shortLabel || filterDefinition.label;
  return match(filterDefinition.controlType).with('singleSelect', function () {
    var option = filterDefinition.options.find(function (option) {
      return option.value === value;
    });
    return option ? [option.label] : [];
  }).with('multiSelect', function () {
    var options = filterDefinition.options.filter(filterOptions(value));
    return options.map(function (option) {
      return _getTextFromRichText(option.label);
    });
  }).with('inlineSelect', function () {
    if (filterDefinition.mode === 'single') {
      return ["".concat(filterLabel, ": ").concat(_getTextFromRichText(value) || '')];
    } else {
      var options = filterDefinition.options.filter(filterOptions(value));
      var textOptions = options.map(function (option) {
        return _getTextFromRichText(option.label);
      });
      return ["".concat(filterLabel, ": ").concat(textOptions.join(', '))];
    }
  }).with('range', function () {
    if (!value) return '';
    var v = value;
    var min = v.min ? formatRangeValue(v.min, filterDefinition.controlValueType) : '';
    var max = v.max ? formatRangeValue(v.max, filterDefinition.controlValueType) : '';
    if (min && max) return ["".concat(filterLabel, " [").concat(min.toString(), "\u23F5").concat(max.toString(), "]")];else if (min) return ["".concat(filterLabel, " [").concat(min.toString(), "\u23F5]")];else if (max) return ["".concat(filterLabel, " [\u23F5").concat(max.toString(), "]")];
    return [];
  }).with('boolean', function () {
    return value ? [filterLabel] : [];
  }).otherwise(function () {
    return [value];
  });
};
var getLabelFromParts = function getLabelFromParts(parts, groupLabel) {
  var result = match(parts.length).with(0, function () {
    return groupLabel;
  }).with(1, function () {
    var temp = "".concat(groupLabel, ": ").concat(parts[0]);
    return temp.length > MAX_CHARACTERS_FOR_USING_GROUP_LABEL ? parts[0] : temp;
  }).with(2, function () {
    return "".concat(parts[0], ", ").concat(parts[1]);
  }).otherwise(function (count) {
    return "".concat(groupLabel, ": (").concat(count, ")");
  });
  return result;
};
var getPartsFromGroup = function getPartsFromGroup(groupModel, groupDefinition) {
  var keys = Object.keys(groupModel);
  var names = keys.filter(function (key) {
    return !_isClean(groupModel[key]);
  });
  var count = names.length;
  var parts = [];
  for (var i = 0; i < count; i++) {
    var filterDefinition = getFilterDefinitionByName(groupDefinition, names[i]);
    if (filterDefinition) parts = __spreadArray(__spreadArray([], parts, true), getPartsFromFilterAndValue(filterDefinition, groupModel[names[i]]), true);
  }
  return parts;
};
var getLabelFromGroup = function getLabelFromGroup(groupModel, groupDefinition) {
  return getLabelFromParts(getPartsFromGroup(groupModel, groupDefinition), groupDefinition.label);
};
var getLabelFromAll = function getLabelFromAll(viewModels, definitions, defaultLabel) {
  var parts = definitions.map(function (definition) {
    var groupModel = viewModels[definition.name];
    return getPartsFromGroup(groupModel, definition);
  }).flat();
  return getLabelFromParts(parts, defaultLabel);
};
var _getTextFromRichText = function getTextFromRichText(richTextNode) {
  if (___default.isNil(richTextNode)) return '';
  var node = richTextNode;
  return match(_typeof(node)).with('string', function () {
    return node;
  }).with('number', function () {
    return node.toString();
  }).with('boolean', function () {
    return '';
  }).with('object', function () {
    var _a;
    if (node instanceof Array) return node.map(_getTextFromRichText).join('');
    if (node.props) {
      var nodeWithProps = node;
      if ((_a = nodeWithProps.props) === null || _a === void 0 ? void 0 : _a.children) {
        var children = nodeWithProps.props.children;
        return _getTextFromRichText(children);
      }
    }
    return '';
  }).otherwise(function () {
    console.warn('Unresolved `richTextNode` of type:', _typeof(node), node);
    return '';
  });
};
var jsonReplacer = function jsonReplacer(_key, value) {
  if (/*#__PURE__*/isValidElement(value)) {
    return _getTextFromRichText(value);
  }
  return value;
};
var deriveOptionsList = function deriveOptionsList(enums, override) {
  if (override === void 0) {
    override = {};
  }
  return Object.values(enums).map(function (entry) {
    return {
      value: entry,
      label: override[entry] || formatEnum$1(entry)
    };
  });
};

var utils$3 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  areAllFiltersReset: areAllFiltersReset,
  arraysAreEqual: arraysAreEqual,
  convertToAppModelValue: convertToAppModelValue,
  convertToViewModelValue: convertToViewModelValue,
  defaultFilterStateToViewModels: defaultFilterStateToViewModels,
  defaultViewModelsToFilterState: defaultViewModelsToFilterState,
  deriveOptionsList: deriveOptionsList,
  formatDate: formatDate,
  formatNumber: formatNumber,
  formatRangeValue: formatRangeValue,
  getFilterDefinitionByName: getFilterDefinitionByName,
  getFilterGroupDefinitionByName: getFilterGroupDefinitionByName,
  getLabelFromAll: getLabelFromAll,
  getLabelFromGroup: getLabelFromGroup,
  getLabelFromParts: getLabelFromParts,
  getPartsFromFilterAndValue: getPartsFromFilterAndValue,
  getPartsFromGroup: getPartsFromGroup,
  getTextFromRichText: _getTextFromRichText,
  initializeFilterGroupViewModel: initializeFilterGroupViewModel,
  isGroupFilterReset: isGroupFilterReset,
  jsonReplacer: jsonReplacer,
  resetMatchingFiltersViewModel: resetMatchingFiltersViewModel
});

var useFilters = function useFilters(_a) {
  var externalFilterState = _a.filterState,
    definitionGenerator = _a.definitionGenerator,
    definitionConfig = _a.definitionConfig,
    _b = _a.filterStateToViewModels,
    filterStateToViewModels = _b === void 0 ? defaultFilterStateToViewModels : _b,
    _c = _a.viewModelToFilterState,
    viewModelToFilterState = _c === void 0 ? defaultViewModelsToFilterState : _c;
  var _d = useState(definitionGenerator(definitionConfig)),
    filterDefinitions = _d[0],
    setFilterDefinitions = _d[1];
  useEffect(function () {
    setFilterDefinitions(definitionGenerator(definitionConfig));
  }, [definitionConfig, definitionGenerator]);
  var _e = useState(filterStateToViewModels(externalFilterState, filterDefinitions)),
    filterViewModels = _e[0],
    setFilterViewModels = _e[1];
  useEffect(function () {
    setFilterViewModels(filterStateToViewModels(externalFilterState, filterDefinitions));
  }, [externalFilterState, filterDefinitions, filterStateToViewModels]);
  var update = function update(modelName, key, newValue) {
    setFilterViewModels(function (prevState) {
      var _a, _b, _c, _d, _e;
      var _f;
      var matchingModel = (_f = Object.entries(prevState).find(function (_a) {
        var name = _a[0],
          data = _a[1];
        return name !== modelName && key in data;
      })) === null || _f === void 0 ? void 0 : _f[0];
      if (matchingModel) {
        return _assign(_assign({}, prevState), (_a = {}, _a[modelName] = _assign(_assign({}, prevState[modelName]), (_b = {}, _b[key] = newValue, _b)), _a[matchingModel] = _assign(_assign({}, prevState[matchingModel]), (_c = {}, _c[key] = newValue, _c)), _a));
      } else {
        return _assign(_assign({}, prevState), (_d = {}, _d[modelName] = _assign(_assign({}, prevState[modelName]), (_e = {}, _e[key] = newValue, _e)), _d));
      }
    });
  };
  var reset = function reset(modelName) {
    var groupDefinition = filterDefinitions.find(function (def) {
      return def.name === modelName;
    });
    if (!groupDefinition) throw new Error("Group definition not found for ".concat(modelName));
    setFilterViewModels(function (prevState) {
      var _a;
      return _assign(_assign({}, prevState), (_a = {}, _a[modelName] = initializeFilterGroupViewModel(groupDefinition), _a));
    });
    setFilterViewModels(function (prevState) {
      var updatedFilters = resetMatchingFiltersViewModel(groupDefinition, prevState);
      return _assign(_assign({}, prevState), updatedFilters);
    });
  };
  var resetAll = function resetAll() {
    var viewModels = {};
    for (var _i = 0, filterDefinitions_1 = filterDefinitions; _i < filterDefinitions_1.length; _i++) {
      var filterDefinition = filterDefinitions_1[_i];
      viewModels[filterDefinition.name] = initializeFilterGroupViewModel(filterDefinition);
    }
    setFilterViewModels(viewModels);
  };
  var data = useMemo(function () {
    return {
      filterState: viewModelToFilterState(filterViewModels, externalFilterState, filterDefinitions),
      filterViewModels: filterViewModels,
      filterDefinitions: filterDefinitions
    };
  }, [viewModelToFilterState, filterViewModels, externalFilterState, filterDefinitions]);
  var actions = {
    update: update,
    reset: reset,
    resetAll: resetAll
  };
  return {
    data: data,
    actions: actions
  };
};

var hooks$4 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  useFilters: useFilters
});

var FilterBuilder = function () {
  function FilterBuilder(name, controlType, controlValueType) {
    var _this = this;
    match(controlType).with('singleSelect', function () {
      if (name && ['string', 'number'].includes(controlValueType)) {
        _this.filter = {
          name: name,
          itemType: 'filter',
          label: null,
          description: null,
          controlType: controlType,
          controlValueType: controlValueType,
          options: []
        };
      } else {
        throw new Error('Invalid value name or type for singleSelect');
      }
    }).with('multiSelect', function () {
      if (name && ['string', 'number', 'string[]'].includes(controlValueType)) {
        _this.filter = {
          name: name,
          itemType: 'filter',
          label: null,
          description: null,
          controlType: controlType,
          controlValueType: controlValueType,
          options: []
        };
      } else {
        throw new Error('Invalid value name or type for multiSelect');
      }
    }).with('inlineSelect', function () {
      if (name && ['string', 'number'].includes(controlValueType)) {
        _this.filter = {
          name: name,
          itemType: 'filter',
          label: null,
          description: null,
          controlType: controlType,
          controlValueType: controlValueType,
          options: [],
          mode: 'multi'
        };
      } else {
        throw new Error('Invalid value name or type for inlineSelect');
      }
    }).with('range', function () {
      if (name && ['string', 'number', 'Date'].includes(controlValueType)) {
        _this.filter = {
          name: name,
          itemType: 'filter',
          label: null,
          description: null,
          controlType: controlType,
          controlValueType: controlValueType,
          min: null,
          max: null,
          placeholderMin: 'No Min',
          placeholderMax: 'No Max'
        };
      } else {
        throw new Error('Invalid name or value type for range');
      }
    }).with('boolean', function () {
      if (name && ['string', 'string[]', 'number', 'boolean'].includes(controlValueType)) {
        _this.filter = {
          name: name,
          itemType: 'filter',
          label: null,
          description: null,
          controlType: controlType,
          controlValueType: controlValueType
        };
      } else {
        throw new Error('Invalid name or value type for boolean');
      }
    }).otherwise(function () {
      throw new Error('Invalid control type');
    });
  }
  FilterBuilder.prototype.label = function (label) {
    this.filter.label = label;
    return this;
  };
  FilterBuilder.prototype.labelIconProps = function (iconProps) {
    this.filter.labelIconProps = iconProps;
    return this;
  };
  FilterBuilder.prototype.shortLabel = function (shortLabel) {
    this.filter.shortLabel = shortLabel;
    return this;
  };
  FilterBuilder.prototype.description = function (description) {
    this.filter.description = description;
    return this;
  };
  FilterBuilder.prototype.options = function (options) {
    if (this.filter.controlType === 'singleSelect') {
      this.filter.options = options;
    } else if (this.filter.controlType === 'multiSelect') {
      this.filter.options = options;
    } else if (this.filter.controlType === 'inlineSelect') {
      this.filter.options = options;
    } else {
      throw new Error('Invalid control type for setting options');
    }
    return this;
  };
  FilterBuilder.prototype.range = function (range) {
    if (this.filter.controlType === 'range') {
      this.filter.min = range.min;
      this.filter.max = range.max;
      this.filter.optionList = range.optionList;
    } else {
      throw new Error('Invalid control type for setting range');
    }
    return this;
  };
  FilterBuilder.prototype.mode = function (mode) {
    if (this.filter.controlType === 'inlineSelect') {
      this.filter.mode = mode;
    } else if (this.filter.controlType === 'multiSelect') {
      this.filter.mode = mode;
    } else if (this.filter.controlType === 'range') {
      this.filter.mode = mode;
    } else {
      throw new Error('Invalid control type for setting mode');
    }
    return this;
  };
  FilterBuilder.prototype.placeholder = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    if (this.filter.controlType === 'singleSelect' && args.length === 1) {
      this.filter.placeholder = args[0];
    } else if (this.filter.controlType === 'range' && args.length === 2) {
      this.filter.placeholderMin = args[0];
      this.filter.placeholderMax = args[1];
    } else {
      throw new Error('Invalid argument(s) for setting placeholder');
    }
    return this;
  };
  FilterBuilder.prototype.styleIntent = function (intent) {
    this.filter.styleIntent = intent;
    return this;
  };
  FilterBuilder.prototype.converterOverrides = function (overrides) {
    this.filter.converterOverrides = overrides;
    return this;
  };
  FilterBuilder.prototype.build = function () {
    return this.filter;
  };
  return FilterBuilder;
}();
var FilterSectionBuilder = function () {
  function FilterSectionBuilder(name) {
    this.section = {
      name: name,
      itemType: 'section',
      label: null,
      description: null,
      filters: [],
      styleIntent: {
        compact: false,
        showDivider: true
      }
    };
  }
  FilterSectionBuilder.prototype.label = function (label) {
    this.section.label = label;
    return this;
  };
  FilterSectionBuilder.prototype.labelIconProps = function (iconProps) {
    this.section.labelIconProps = iconProps;
    return this;
  };
  FilterSectionBuilder.prototype.description = function (description) {
    this.section.description = description;
    return this;
  };
  FilterSectionBuilder.prototype.filters = function (filters) {
    this.section.filters = filters;
    return this;
  };
  FilterSectionBuilder.prototype.styleIntent = function (intent) {
    this.section.styleIntent = intent;
    return this;
  };
  FilterSectionBuilder.prototype.build = function () {
    return this.section;
  };
  return FilterSectionBuilder;
}();
var FilterGroupBuilder = function () {
  function FilterGroupBuilder(name, label) {
    this.group = {
      name: name,
      label: label,
      itemType: 'group',
      description: null,
      styleIntent: {
        compact: false
      },
      items: []
    };
  }
  FilterGroupBuilder.prototype.label = function (label) {
    this.group.label = label;
    return this;
  };
  FilterGroupBuilder.prototype.description = function (description) {
    this.group.description = description;
    return this;
  };
  FilterGroupBuilder.prototype.labelIconProps = function (iconProps) {
    this.group.labelIconProps = iconProps;
    return this;
  };
  FilterGroupBuilder.prototype.items = function (items) {
    this.group.items = items;
    return this;
  };
  FilterGroupBuilder.prototype.styleIntent = function (intent) {
    this.group.styleIntent = intent;
    return this;
  };
  FilterGroupBuilder.prototype.build = function () {
    return this.group;
  };
  return FilterGroupBuilder;
}();

var builders = /*#__PURE__*/Object.freeze({
  __proto__: null,
  FilterBuilder: FilterBuilder,
  FilterGroupBuilder: FilterGroupBuilder,
  FilterSectionBuilder: FilterSectionBuilder
});

var index$9 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  builders: builders,
  hooks: hooks$4,
  utils: utils$3
});

var ALL_SUGGESTION_TYPES = ['state', 'city', 'zip', 'county', 'address', 'text', 'savedSearch', 'recentSearch', 'currentLocation', 'globalSearch'];
var SEARCH_SUGGESTION_GROUPS = {
  places: 'Places',
  listings: 'Listings',
  recentSearch: 'Recent Searches',
  savedSearches: 'Saved Searches',
  other: 'Other',
  textSearch: 'Text Search'
};
var SUGGESTION_CATEGORY_ICONS = ['heart', 'input-text', 'house-chimney', 'location-dot'];
var ALL_FORMATTING_TYPES = ['highlight'];
var MAX_SAVED_SEARCHES = 3;
var SAVED_SEARCH_SOURCE = 'ADC';
var SORT_ORDERS = {
  desc: 'desc',
  asc: 'asc'
};
var SORT_TYPES = {
  default: 'resi_sort_v2',
  defaultDesc: 'resi_sort_v2_desc',
  newlyAdded: 'asset_activation_dt_sort',
  propertyAddress: 'resi_property_address',
  auctionStartDate: 'auction_date_order',
  beds: 'beds',
  baths: 'baths',
  sqft: 'sqft',
  valuationEstimate: 'valuation_estimate',
  distance: 'distance'
};
var SORT_TYP_VALUES = ['resi_sort_v2', 'resi_sort_v2_desc', 'asset_activation_dt_sort', 'resi_property_address', 'auction_date_order', 'beds', 'baths', 'sqft', 'valuation_estimate', 'distance'];
var SORT_ORDER_VALUES = ['desc', 'asc'];
var SORT_TYPES_DESC_OVERRIDE = {
  starting_bid_sort: 'starting_bid_sort_desc',
  asset_activation_dt_sort: 'asset_activation_dt_sort_desc'
};
var NOT_IMPLEMENTED = Symbol.for('adc.filters.not_implemented');
var FILTER_GROUP_KEYS = {
  propertyTypeFilterGroup: 'propertyTypeFilterGroup',
  propertyInfoFilterGroup: 'propertyInfoFilterGroup',
  conditionFilterGroup: 'conditionFilterGroup',
  auctionTypeFilterGroup: 'auctionTypeFilterGroup',
  assetTypeFilterGroup: 'assetTypeFilterGroup',
  moreFilterGroup: 'moreFilterGroup',
  featuredFilterGroup: 'featuredFilterGroup',
  nearbySearchFilterGroup: 'nearbySearchFilterGroup',
  locationFilterGroup: 'locationFilterGroup',
  mapFilterGroup: 'mapFilterGroup',
  otherFilterGroup: 'otherFilterGroup'
};

var constants = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ALL_FORMATTING_TYPES: ALL_FORMATTING_TYPES,
  ALL_SUGGESTION_TYPES: ALL_SUGGESTION_TYPES,
  FILTER_GROUP_KEYS: FILTER_GROUP_KEYS,
  MAX_SAVED_SEARCHES: MAX_SAVED_SEARCHES,
  NOT_IMPLEMENTED: NOT_IMPLEMENTED,
  SAVED_SEARCH_SOURCE: SAVED_SEARCH_SOURCE,
  SEARCH_SUGGESTION_GROUPS: SEARCH_SUGGESTION_GROUPS,
  SORT_ORDERS: SORT_ORDERS,
  SORT_ORDER_VALUES: SORT_ORDER_VALUES,
  SORT_TYPES: SORT_TYPES,
  SORT_TYPES_DESC_OVERRIDE: SORT_TYPES_DESC_OVERRIDE,
  SORT_TYP_VALUES: SORT_TYP_VALUES,
  SUGGESTION_CATEGORY_ICONS: SUGGESTION_CATEGORY_ICONS
});

var logger$2 = coreLogger.forModule('blueprint:search');
var fetchLocationSuggestions = function fetchLocationSuggestions(search) {
  return fetch.forAuctionGraph({
    query: gql(templateObject_1$8 || (templateObject_1$8 = __makeTemplateObject(["\n      query ", " ($search: String!) {\n        location_suggestions(search: $search) {\n          results {\n            value\n            county\n            city\n            state\n            zip\n            type\n            url\n            coordinates {\n              lat\n              lon\n            }\n          }\n        }\n      }\n    "], ["\n      query ", " ($search: String!) {\n        location_suggestions(search: $search) {\n          results {\n            value\n            county\n            city\n            state\n            zip\n            type\n            url\n            coordinates {\n              lat\n              lon\n            }\n          }\n        }\n      }\n    "])), embeddableOperation('blueprint_locationSuggestions')),
    variables: {
      search: search
    }
  }).then(function (res) {
    return res.body;
  }).then(function (_a) {
    var _b;
    var data = _a.data;
    var rawLocationSuggestions = ((_b = data === null || data === void 0 ? void 0 : data.location_suggestions) === null || _b === void 0 ? void 0 : _b.results) || [];
    return {
      rawLocationSuggestions: rawLocationSuggestions
    };
  }).catch(function (e) {
    logger$2.warn(e);
    return {
      rawLocationSuggestions: []
    };
  });
};
var lookupLocation = function lookupLocation(search) {
  return fetch.forAuctionGraph({
    query: gql(templateObject_2$5 || (templateObject_2$5 = __makeTemplateObject(["\n          query ", " ($search: String!) {\n            determine_coordinates(search: $search) {\n              coordinates {\n                lat\n                lon\n              }\n            }\n          }\n        "], ["\n          query ", " ($search: String!) {\n            determine_coordinates(search: $search) {\n              coordinates {\n                lat\n                lon\n              }\n            }\n          }\n        "])), embeddableOperation('blueprint_determineCoordinates')),
    variables: {
      search: search
    }
  }).then(function (res) {
    return res.body;
  }).then(function (_a) {
    var data = _a.data;
    return data.determine_coordinates;
  }).catch(function (e) {
    logger$2.warn(e);
    return null;
  });
};
var fetchSavedSearches = function fetchSavedSearches(controller) {
  return fetch.forAuctionGraph({
    query: gql(templateObject_3$2 || (templateObject_3$2 = __makeTemplateObject(["\n      query ", " ($maxSavedSearches: PositiveInt!, $savedSearchSource: SavedSearchSource!) {\n      current_user {\n          saved_searches(filters: {\n            take: $maxSavedSearches,\n            source: $savedSearchSource,\n          }) {\n            saved_search_id\n            saved_search_name\n            parameters\n            namespace\n          }\n        }\n      }\n    "], ["\n      query ", " ($maxSavedSearches: PositiveInt!, $savedSearchSource: SavedSearchSource!) {\n      current_user {\n          saved_searches(filters: {\n            take: $maxSavedSearches,\n            source: $savedSearchSource,\n          }) {\n            saved_search_id\n            saved_search_name\n            parameters\n            namespace\n          }\n        }\n      }\n    "])), embeddableOperation('blueprint_savedSearches')),
    variables: {
      maxSavedSearches: MAX_SAVED_SEARCHES,
      savedSearchSource: SAVED_SEARCH_SOURCE
    }
  }, {
    controller: controller
  }).then(function (res) {
    return res.body;
  }).then(function (_a) {
    var _b;
    var data = _a.data;
    var rawSavedSearches = ((_b = data === null || data === void 0 ? void 0 : data.current_user) === null || _b === void 0 ? void 0 : _b.saved_searches) || [];
    return {
      rawSavedSearches: rawSavedSearches
    };
  }).catch(function (e) {
    logger$2.warn(e);
    return {
      rawSavedSearches: []
    };
  });
};
var fetchMarketingTagConfig = function fetchMarketingTagConfig() {
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      return [2, fetch.forAuctionGraph({
        query: gql(templateObject_4$1 || (templateObject_4$1 = __makeTemplateObject(["\n          query ", " {\n            active_listing_search_marketing_tags {\n              tag\n              configuration {\n                srp {\n                  order\n                  label\n                  tooltip\n                  is_tooltip_active\n                }\n              }\n            }\n          }\n        "], ["\n          query ", " {\n            active_listing_search_marketing_tags {\n              tag\n              configuration {\n                srp {\n                  order\n                  label\n                  tooltip\n                  is_tooltip_active\n                }\n              }\n            }\n          }\n        "])), embeddableOperation('blueprint_activeListingSearchMarketingTags'))
      }).then(function (res) {
        return res.body;
      }).then(function (_a) {
        var data = _a.data;
        return data === null || data === void 0 ? void 0 : data.active_listing_search_marketing_tags;
      }).catch(function (e) {
        logger$2.warn(e);
        return [];
      })];
    });
  });
};
var seekListingsFromFilters = function seekListingsFromFilters(_a) {
  var filters = _a.filters,
    aggregationFields = _a.aggregationFields,
    hasAuthenticatedUser = _a.hasAuthenticatedUser,
    _b = _a.searchSource,
    searchSource = _b === void 0 ? 'adc:blueprint:search' : _b;
  return __awaiter(void 0, void 0, void 0, function () {
    var startTime;
    return __generator(this, function (_c) {
      startTime = +Date.now();
      instrument.domainEvent({
        type: enums$1.DomainEventTypeName.SearchResultsPageFilterChanged,
        source: searchSource,
        data: {
          filters: filters
        }
      });
      return [2, fetch.forAuctionGraph({
        query: gql(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n        query ", "(\n          $filters: ListingCompatabilityFilters!,\n          $aggregationFields: [String!]!,\n          $hasAuthenticatedUser: Boolean!,\n          $requiresAggregation: Boolean!\n        ) {\n          seek_listings_from_filters(filters: $filters) {\n            total_count\n            total_pages\n            size\n            current_page\n            aggregation(fields: $aggregationFields) @include(if: $requiresAggregation)\n            content {\n                ...ListingCardFields\n                ...ListingPopupCardFields\n            }\n          }\n        }\n        ", "\n      "], ["\n        query ", "(\n          $filters: ListingCompatabilityFilters!,\n          $aggregationFields: [String!]!,\n          $hasAuthenticatedUser: Boolean!,\n          $requiresAggregation: Boolean!\n        ) {\n          seek_listings_from_filters(filters: $filters) {\n            total_count\n            total_pages\n            size\n            current_page\n            aggregation(fields: $aggregationFields) @include(if: $requiresAggregation)\n            content {\n                ...ListingCardFields\n                ...ListingPopupCardFields\n            }\n          }\n        }\n        ", "\n      "])), embeddableOperation('blueprint_seekListingsFromFilters'), webListingFragment),
        variables: {
          filters: filters,
          hasAuthenticatedUser: Boolean(hasAuthenticatedUser),
          aggregationFields: aggregationFields,
          requiresAggregation: aggregationFields.length > 0
        }
      }).then(function (res) {
        var _a;
        var result = res.body.data.seek_listings_from_filters;
        instrument.domainEvent({
          type: enums$1.DomainEventTypeName.SearchResultsPageResponseReceived,
          source: searchSource,
          data: {
            elapsed_ms: +Date.now() - startTime,
            records_returned: ((_a = result.content) === null || _a === void 0 ? void 0 : _a.length) || 0
          }
        });
        return result;
      })];
    });
  });
};
var templateObject_1$8, templateObject_2$5, templateObject_3$2, templateObject_4$1, templateObject_5;

var allListingTypesSelected = ['pending', 'closed', 'canceled'];
var interiorAccessSelected = 'y';
var financingAvailableSelected = 'y';
var maoFilterSelected = 'y';
var moreAllListingFilters = 'all_filters';
var brokerCoopAvailableSelected = 'y';
var hideEndingSoonSelected = 'y';
var noBuyerPremiumFilterSelected = 'n';
var showReserveSelected = 'y';
var vacantOccupancyStatus = ['vacant'];
var NEARBY_SEARCH_RADIUS_OPTIONS = [{
  key: '5',
  text: '5 Miles',
  value: 5
}, {
  key: '10',
  text: '10 Miles',
  value: 10
}, {
  key: '25',
  text: '25 Miles',
  value: 25
}, {
  key: '50',
  text: '50 Miles',
  value: 50
}, {
  key: '100',
  text: '100 Miles',
  value: 100
}];
NEARBY_SEARCH_RADIUS_OPTIONS.map(function (o) {
  return o.value;
});
var AGGREGATE_FIELDS = {
  property_group_type: 'primary_property_summary.structure_type_group.keyword',
  property_type: 'primary_property_summary.structure_type_code.keyword',
  remote_bid_assets: 'listing_summary.is_remote_bid_enabled'
};
var API_ADDRESS_FIELDS = {
  state: 'seller_property.country_primary_subdivision.keyword',
  county: 'seller_property.country_secondary_subdivision.keyword',
  zip: 'seller_property.postal_code.keyword',
  city: 'seller_property.municipality.keyword',
  coordinates: 'primary_property_summary.address.coordinates'
};
var LOCATION_PARAMS = ['property_city', 'property_zip', 'property_county'];
var PARAM_TO_API_FIELD_MAP = {
  property_city: API_ADDRESS_FIELDS.city,
  property_zip: API_ADDRESS_FIELDS.zip,
  property_county: API_ADDRESS_FIELDS.county
};
var DEFAULT_NEARBY_SEARCH_RADIUS = 50;

var getPropertyTypeFiltersInitialValues = function getPropertyTypeFiltersInitialValues(filters) {
  return {
    single_family: ___default.find(filters.propertyType, function (type) {
      return type === 'single-family';
    }) ? 'single-family' : '',
    multi_family: ___default.find(filters.propertyType, function (type) {
      return type === 'multi-family';
    }) ? 'multi-family' : '',
    condos_townhouses: ___default.find(filters.propertyType, function (type) {
      return type === 'condos-townhouses';
    }) ? 'condos-townhouses' : '',
    land: ___default.find(filters.propertyType, function (type) {
      return type === 'land';
    }) ? 'land' : ''
  };
};
var getPropertyInfoFiltersInitialValues = function getPropertyInfoFiltersInitialValues(filters) {
  return {
    beds: getMinSelectInputOptions(filters.beds),
    baths: getMinSelectInputOptions(filters.baths),
    sqft_min: filters.sqft.min ? "".concat(filters.sqft.min) : '',
    sqft_max: filters.sqft.max ? "".concat(filters.sqft.max) : ''
  };
};
var getAssetTypeFiltersInitialValues = function getAssetTypeFiltersInitialValues(filters) {
  return {
    bankOwned: ___default.find(filters.assetType, function (type) {
      return type === 'bank-owned';
    }) ? 'bankOwned' : '',
    foreclosure: ___default.find(filters.assetType, function (type) {
      return type === 'foreclosures';
    }) ? 'foreclosure' : '',
    shortSales: ___default.find(filters.assetType, function (type) {
      return type === 'short-sales';
    }) ? 'shortSales' : '',
    privateSeller: ___default.find(filters.assetType, function (type) {
      return type === 'private-seller';
    }) ? 'privateSeller' : ''
  };
};
var getAuctionTypeFiltersInitialValues = function getAuctionTypeFiltersInitialValues(filters) {
  return {
    online: ___default.find(filters.auctionFormat, function (type) {
      return type === 'online';
    }) ? 'online' : '',
    live: ___default.find(filters.auctionFormat, function (type) {
      return type === 'in_person';
    }) ? 'in_person' : '',
    remoteBid: ___default.find(filters.auctionFormat, function (type) {
      return type === 'remote_bid';
    }) ? 'remote_bid' : '',
    directOffer: ___default.find(filters.auctionFormat, function (type) {
      return type === 'direct_offer';
    }) ? 'direct_offer' : '',
    offer: ___default.find(filters.auctionFormat, function (type) {
      return type === 'offer';
    }) ? 'offer' : ''
  };
};
var getConditionFiltersInitialvalues = function getConditionFiltersInitialvalues(filters) {
  return {
    access_available: filters.accessAvailable ? interiorAccessSelected : '',
    financing_available: filters.financingAvailable ? financingAvailableSelected : '',
    occupancy_status: ___default.find(filters.occupancyStatus, function (type) {
      return type === 'vacant';
    }) ? vacantOccupancyStatus[0] : '',
    inspectionAllowed: filters.inspectionAllowed ? 'y' : ''
  };
};
var getFeaturedFiltersInitialValues = function getFeaturedFiltersInitialValues(filters, defaultOverride) {
  if (defaultOverride === void 0) {
    defaultOverride = {};
  }
  var activatedFeaturedFilters = {};
  Object.values(defaultOverride).forEach(function (value) {
    if ((filters.marketingTag || '').split(',').includes(value.toLowerCase())) {
      activatedFeaturedFilters[value] = value;
    }
  });
  return activatedFeaturedFilters;
};
var getMoreFiltersInitialValues = function getMoreFiltersInitialValues(filters) {
  return {
    broker_coop_available: filters.brokerCoopAvailable ? brokerCoopAvailableSelected : '',
    listing_type: ___default.difference(allListingTypesSelected, filters.listingType).length === 0 ? moreAllListingFilters : '',
    no_buyer_premium_filter: filters.noBuyerPremiumFilter ? noBuyerPremiumFilterSelected : '',
    presale: filters.presale ? maoFilterSelected : '',
    show_reserve: filters.showReserve ? showReserveSelected : '',
    hide_ending_soon: filters.hideEndingSoon ? hideEndingSoonSelected : '',
    leaseback_required: filters.leasebackRequired === 'n' ? 'n' : ''
  };
};
var getMinSelectInputOptions = function getMinSelectInputOptions(value) {
  if (value) {
    if (value >= 4) {
      return '4';
    } else if (value >= 3) {
      return '3';
    } else if (value >= 2) {
      return '2';
    } else if (value >= 1) {
      return '1';
    } else {
      return 'any';
    }
  }
  return 'any';
};
var getDefaultFeaturedFilters = function getDefaultFeaturedFilters(marketingTagsConfig) {
  var featuredFilterDefaultOverride = {};
  marketingTagsConfig.forEach(function (marketingTagObj) {
    featuredFilterDefaultOverride[marketingTagObj.tag] = marketingTagObj.tag;
  });
  return featuredFilterDefaultOverride;
};
var convertFiltersToUiFilterGroups = function convertFiltersToUiFilterGroups(filters, marketingTagsConfig) {
  if (marketingTagsConfig === void 0) {
    marketingTagsConfig = [];
  }
  var useNearbySearch = filters.useNearbySearch,
    nearbySearchRadius = filters.nearbySearchRadius,
    sort = filters.sort,
    search = filters.search,
    state = filters.state,
    city = filters.city,
    county = filters.county,
    zip = filters.zip,
    globalSearch = filters.globalSearch,
    mapView = filters.mapView,
    isMapShown = filters.isMapShown,
    mapBounds = filters.mapBounds,
    userCoords = filters.userCoords,
    geoLocation = filters.geoLocation,
    listingType = filters.listingType,
    reserveReduced = filters.reserveReduced,
    limit = filters.limit,
    offset = filters.offset,
    sellerCode = filters.sellerCode,
    foreclosureBidType = filters.foreclosureBidType,
    openedAssetId = filters.openedAssetId;
  return {
    propertyTypeFilterGroup: getPropertyTypeFiltersInitialValues(filters),
    propertyInfoFilterGroup: getPropertyInfoFiltersInitialValues(filters),
    conditionFilterGroup: getConditionFiltersInitialvalues(filters),
    auctionTypeFilterGroup: getAuctionTypeFiltersInitialValues(filters),
    assetTypeFilterGroup: getAssetTypeFiltersInitialValues(filters),
    moreFilterGroup: getMoreFiltersInitialValues(filters),
    featuredFilterGroup: getFeaturedFiltersInitialValues(filters, getDefaultFeaturedFilters(marketingTagsConfig)),
    nearbySearchFilterGroup: {
      useNearbySearch: useNearbySearch,
      nearbySearchRadius: nearbySearchRadius,
      sort: sort
    },
    locationFilterGroup: {
      search: search,
      state: state,
      city: city,
      county: county,
      zip: zip,
      globalSearch: globalSearch
    },
    mapFilterGroup: {
      openedAssetId: openedAssetId,
      mapView: mapView,
      isMapShown: isMapShown,
      mapBounds: mapBounds,
      userCoords: userCoords,
      geoLocation: geoLocation
    },
    otherFilterGroup: {
      listingType: listingType,
      reserveReduced: reserveReduced,
      limit: limit,
      offset: offset,
      sellerCode: sellerCode,
      foreclosureBidType: foreclosureBidType
    }
  };
};
var API_LOCATION_FILTERS = ['geo_location_box', 'geo_location', 'property_city', 'property_county', 'property_state', 'property_zip', 'search'];
var stripLocationFiltersIfGlobal = function stripLocationFiltersIfGlobal(filters) {
  if (filters.global_search === 'y') {
    for (var i = 0; i < API_LOCATION_FILTERS.length; i++) {
      delete filters[API_LOCATION_FILTERS[i]];
    }
    delete filters.nearby_search;
  }
  delete filters.global_search;
};
var converFiltersToListingCompatabilityFilters = function converFiltersToListingCompatabilityFilters(filters, isValidForNearbySearch) {
  var newFilters = new FiltersModel(filters);
  var listingCompatibilityFilters = newFilters.feToApiValue;
  listingCompatibilityFilters.version = 1;
  listingCompatibilityFilters.offset = filters.offset;
  listingCompatibilityFilters.limit = filters.limit;
  if (!isValidForNearbySearch) {
    delete listingCompatibilityFilters.nearby_search;
    delete listingCompatibilityFilters.nearby_search_radius;
  }
  stripLocationFiltersIfGlobal(listingCompatibilityFilters);
  return listingCompatibilityFilters;
};
var findFirstNonEmptyKey = function findFirstNonEmptyKey(obj, keys) {
  for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
    var key = keys_1[_i];
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var value = obj[key];
      if (value !== undefined && value !== null && value !== '') {
        return key;
      }
    }
  }
  return null;
};
var getLocationParamKey = function getLocationParamKey(listingFilters) {
  return findFirstNonEmptyKey(listingFilters, LOCATION_PARAMS);
};
var getLocationParamValue = function getLocationParamValue(listingFilters) {
  var key = getLocationParamKey(listingFilters);
  return key ? listingFilters[key] : null;
};
var getLocationAPIKey = function getLocationAPIKey(listingFilters) {
  var key = getLocationParamKey(listingFilters);
  return key ? PARAM_TO_API_FIELD_MAP[key] : null;
};
var formatAggregation = function formatAggregation(_a) {
  var _b, _c, _d;
  var listings = _a.listings,
    listingFilters = _a.listingFilters,
    collectionResult = _a.collectionResult,
    locationAggregateField = _a.locationAggregateField,
    requiresLocationAggregate = _a.requiresLocationAggregate;
  if (requiresLocationAggregate) {
    var filteredAggregation = collectionResult.aggregation || (_b = {}, _b["".concat(locationAggregateField, "_count")] = {}, _b);
    var normalizedEntry = getLocationParamValue(listingFilters).toLowerCase();
    listings.nearbyTotal = filteredAggregation["".concat(locationAggregateField, "_count")][normalizedEntry] || 0;
  }
  var propertyAggregation = (collectionResult === null || collectionResult === void 0 ? void 0 : collectionResult.aggregation) || (_c = {}, _c["".concat(AGGREGATE_FIELDS.property_type, "_count")] = {}, _c);
  var remoteBidAggregation = (collectionResult === null || collectionResult === void 0 ? void 0 : collectionResult.aggregation) || (_d = {}, _d["".concat(AGGREGATE_FIELDS.remote_bid_assets, "_count")] = {}, _d);
  listings.propertyTypeTotals = propertyAggregation["".concat(AGGREGATE_FIELDS.property_type, "_count")];
  listings.remoteBideTotals = remoteBidAggregation["".concat(AGGREGATE_FIELDS.remote_bid_assets, "_count")];
  return listings;
};
var formatLocationSearch = function formatLocationSearch(city, state, county, zip) {
  if (city && state) return [city, state].join(', ');
  if (county && state) return [county + ' county', state].join(', ');
  if (state && !zip) return state;
  return zip;
};
var getIsValidForNearbySearch = function getIsValidForNearbySearch(filters) {
  return filters.useNearbySearch === 'y' && filters.globalSearch !== 'y' && Boolean(!___default.isEmpty(filters.city) || !___default.isEmpty(filters.zip) || !___default.isEmpty(filters.county));
};
var getIsSortByDistance = function getIsSortByDistance(filters) {
  return filters.sort.type.includes(SORT_TYPES.distance);
};
var OUT_OF_US_STATES = {
  AS: 'American Samoa',
  FM: 'Federated States of Micronesia',
  GU: 'Guam',
  MH: 'Marshall Islands',
  MP: 'Northern Mariana Islands',
  PR: 'Puerto Rico',
  PW: 'Palau',
  VI: 'U.S. Virgin Islands',
  'Puerto Rico': 'Puerto Rico'
};
var ALL_STATES_MAPPING = {
  AL: 'Alabama',
  AK: 'Alaska',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OK: 'Oklahoma',
  OH: 'Ohio',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
  DC: 'District of Columbia'
};
var US_STATES_AND_TERRITORIES_MAPPING = _assign(_assign({}, ALL_STATES_MAPPING), OUT_OF_US_STATES);
var stateNameToCode = function stateNameToCode() {
  var statesNames = {};
  Object.keys(ALL_STATES_MAPPING).forEach(function (key) {
    var stateName = ALL_STATES_MAPPING[key].toUpperCase();
    statesNames[stateName] = key;
  });
  return statesNames;
};
var getStateCode = function getStateCode(state) {
  if (!___default.isString(state)) return null;
  var _state = state.toUpperCase();
  var states = stateNameToCode();
  var stateCode = states[_state] || US_STATES_AND_TERRITORIES_MAPPING[_state] && _state || null;
  return stateCode;
};

var productTypes = {
  resi_bo_v2: 'bank-owned',
  resi_ft: 'foreclosures',
  resi_new_foreclosed: 'newly-foreclosed',
  resi_ip: 'rentals',
  // TODO: product type or asset type ?
  resi_ss: 'short-sales',
  // TODO: product type or asset type ?
  resi_ps: 'private-seller'
};

/**
 * Usage: New asset type (product type) filter route
 * - new route has "_at" added after resi_ft & resi_new_foreclosed
 * - refer to toolkit-adc/src/components/header/constants/route
 */
var assetTypeFilterRoute = {
  resi_bo_v2: 'bank-owned',
  resi_ft: 'foreclosures_at',
  resi_new_foreclosed: 'newly-foreclosed_at',
  resi_ip: 'rentals',
  resi_ss: 'short-sales_at'
  // TODO: Private seller ?
};
var propertyTypes = {
  resi_sfr: 'single-family',
  resi_mfr: 'multi-family',
  resi_condo: 'condos-townhouses',
  resi_land: 'land'
};
var productDisplayTypes = {
  resi_bo_v2: 'Bank Owned',
  resi_ft: 'Foreclosures',
  resi_ip: 'Rentals',
  resi_ss: 'Short Sales'
};
var propertyDisplayTypes = {
  resi_sfr: 'Single Family',
  resi_mfr: 'Multi-family',
  resi_condo: 'Condo/Townhome',
  resi_land: 'Land'
};
var listingTypes = {
  active: 'Active',
  pending: 'Pending',
  closed: 'Sold',
  canceled: 'Canceled'
};
var assetEventTypes = {
  online: 'Online',
  in_person: 'In Person'
};
var mainDisplay = new Set(['State', 'City', 'County', 'Zip', 'Beds', 'Baths', 'Sqft Range']);
var propertyAndAssetTypesSet = new Set(['Property Type', 'Asset Type']);
var listAndAuctionTypesSet = new Set(['Listing Type', 'Auction Type']);
var showOnlySet = new Set(['Vacant', 'Financing Available', 'Interior Access Available', 'Reserve Disclosed', 'Hide Ending Soon', 'Broker Co-op', "No Buyer's Premium"]);
/*
 * Location Parameters
 */
var showOnlyFields = ['y_ica', 'y_fa', 'y_ia', 'y_sr', 'y_bc', 'y_nbp', 'y_hes',
// this was here before but it's not in srp showOnlyFields code
'y_cs',
// this was not here before but it is in srp showOnlyFields
'y_rr', 'y_ps', 'y_global', 'map_vt'];
var arrayToApiProductType = function arrayToApiProductType(value) {
  var apiProductTypes = [];
  // This is used to deal with the old search url pass 'bank-owned' only
  // We need the `newly-foreclosed` send to API

  if (value[0] === 'bank-owned' && value.length === 1) {
    var _apiProductTypes = Object.entries(productTypes).filter(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2);
        _ref2[0];
        var uiProductType = _ref2[1];
      return ['bank-owned', 'newly-foreclosed'].includes(uiProductType);
    }).map(function (productType) {
      return productType[0];
    });
    return _apiProductTypes.join(',');
  }
  value.forEach(function (type) {
    var productTypeEntry = Object.entries(productTypes).find(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2);
        _ref4[0];
        var uiProductType = _ref4[1];
      return uiProductType === type;
    });
    if (productTypeEntry) {
      apiProductTypes.push(productTypeEntry[0]);
    }
  });
  return apiProductTypes.join(',');
};

/**
 *
 * @param {*} sortType
 * @param {*} sortOrder
 * This function will allow to add to sort override desc to handle special cases like starting_bid/starting_bid_desc
 * In this kind of cases doesn't work to use an empty space to separate, you have a special value to be used from
 * api side. From now on you may only need to add it to SORT_TYPES_DESC_OVERRIDE and will be handled
 */
var getSortOrder = function getSortOrder(sortType, sortOrder) {
  return SORT_TYPES_DESC_OVERRIDE[sortType] ? SORT_TYPES_DESC_OVERRIDE[sortType] : "".concat(sortType, " ").concat(sortOrder);
};
var stringToSortObject = function stringToSortObject(value) {
  var sort = value.split(',')[0].split(' ');
  var sortType = SORT_TYPES.default;
  var sortOrder = SORT_ORDERS.asc;
  if (sort[0] === SORT_TYPES.defaultDesc) {
    return {
      type: SORT_TYPES.default,
      order: SORT_ORDERS.desc
    };
  }

  /**
   * Added this escape hatch to handle special sort cases like starting_bid/starting_bid_desc
   * where the default way using an empty space doesn't work from api side
   *
   * else continue with regular flow
   */
  var overrideSortKey = ___default.findKey(SORT_TYPES_DESC_OVERRIDE, function (value) {
    return value === sort[0];
  });
  if (overrideSortKey) {
    sortOrder = SORT_ORDERS.desc;
    sortType = overrideSortKey;
  } else {
    for (var item in SORT_TYPES) {
      if (SORT_TYPES[item] === sort[0]) {
        sortType = SORT_TYPES[item];
      }
    }
    if (sort[1]) {
      for (var _item in SORT_ORDERS) {
        if (SORT_ORDERS[_item] === sort[1]) {
          sortOrder = SORT_ORDERS[_item];
        }
      }
    }
  }
  return {
    type: sortType,
    order: sortOrder
  };
};
var sortObjectToString = function sortObjectToString(sort) {
  var addSortOrder = sort.order === SORT_ORDERS.desc;
  if (sort.type === SORT_TYPES.default && addSortOrder) return SORT_TYPES.defaultDesc;
  var preSort = addSortOrder ? getSortOrder(sort.type, sort.order) : sort.type;
  // 'resi_sort_v2' (default) must always be in the sort
  var resiSortV2 = sort.type === SORT_TYPES.default ? preSort : "".concat(preSort, ",").concat(SORT_TYPES.default);
  return resiSortV2;
};
var stringToSqftObject = function stringToSqftObject(value) {
  var sqftObject = {
    min: null,
    max: null
  };
  var sqftArray = value.split('_').map(function (d) {
    return d === 'any' ? null : parseInt(d);
  });
  if (sqftArray[0]) sqftObject.min = sqftArray[0];
  if (sqftArray[1]) sqftObject.max = sqftArray[1];
  return sqftObject;
};
var areBoundsSetSqft = function areBoundsSetSqft(min, max) {
  return min > 0 && max > 0;
};
var isReveresedRangeSqft = function isReveresedRangeSqft(min, max) {
  return min > max;
};
var sqftObjectToApi = function sqftObjectToApi(value) {
  var sqftApiObject = {};

  // sepecial case when user sets both inputs but reverses the range
  // min and max values will be reversed only for the API; no changes on url
  if (areBoundsSetSqft(value.min, value.max) && isReveresedRangeSqft(value.min, value.max)) {
    return {
      sqft_min: "".concat(value.max),
      sqft_max: "".concat(value.min)
    };
  }
  if (value.min) sqftApiObject.sqft_min = "".concat(value.min);
  if (value.max) sqftApiObject.sqft_max = "".concat(value.max);
  return sqftApiObject;
};
var arrayToApiPropertyType = function arrayToApiPropertyType(value) {
  var apiPropertyTypes = [];
  value.forEach(function (type) {
    var propertyType = Object.entries(propertyTypes).find(function (_ref5) {
      var _ref6 = _slicedToArray(_ref5, 2);
        _ref6[0];
        var uiPropertyType = _ref6[1];
      return uiPropertyType === type;
    });
    if (propertyType) apiPropertyTypes.push(propertyType[0]);
  });
  return apiPropertyTypes.join(',');
};
var stringToArrayFloat = function stringToArrayFloat(value) {
  return value.split(',').map(function (o) {
    return parseFloat(o);
  });
};
var stringToArrayAddingSpaces = function stringToArrayAddingSpaces(value) {
  return value.replace(/-/g, ' ').replace(/\+/g, '-').split(',').map(function (o) {
    return o.replace(/\w+/g, ___default.capitalize);
  });
};
var arrayToStringRemovingSpaces = function arrayToStringRemovingSpaces(value) {
  return value.join().replace(/-/g, '+').replace(/ /g, '-');
};
var stringToArray = function stringToArray(value) {
  return value.split(',');
};
var addUrlKey = function addUrlKey(value, filter) {
  if (showOnlyFields.includes(filter.url)) {
    return filter.url;
  } else if (filter.api === 'property_state') {
    return value;
  } else if (filter.api === 'property_county') {
    return "".concat(value, "-").concat(filter.url); // dash needed for county
  } else {
    return "".concat(value, "_").concat(filter.url);
  }
};
var stateFeToApi = function stateFeToApi() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  if (state[0]) {
    return getStateCode(state[0]);
  }
  return '';
};
var stringSpaceToDash = function stringSpaceToDash(value) {
  return value.replace(/-/g, '+').split(' ').join('-');
};
var auctionFormatConverterUpperCase = function auctionFormatConverterUpperCase(value) {
  var auctionArr = value.split(',');
  var auctionLabels = [];
  auctionArr.forEach(function (label) {
    var auctionLabel = assetEventTypes[label];
    if (auctionLabel) auctionLabels.push(auctionLabel);
  });
  return ___default.join(auctionLabels, ', ');
};
var booleanStringToBoolean = function booleanStringToBoolean(value) {
  return ___default.toLower(value) === 'y';
};
var noBuyerPremiumConverter = function noBuyerPremiumConverter(value) {
  return ___default.toLower(value) === 'n';
};
var propertyTypeConverter = function propertyTypeConverter(value) {
  var valueArr = value.split(',');
  var apiPropertyTypes = [];
  valueArr.forEach(function (type) {
    var propertyType = propertyTypes[type];
    if (propertyType) apiPropertyTypes.push(propertyType);
  });
  return apiPropertyTypes.join(',');
};
var propertyTypeConverterWithSpace = function propertyTypeConverterWithSpace(value) {
  var valueArr = value.split(',');
  var apiPropertyTypes = [];
  valueArr.forEach(function (type) {
    var propertyType = propertyDisplayTypes[type];
    if (propertyType) apiPropertyTypes.push(propertyType);
  });
  return apiPropertyTypes.join(', ');
};
var assetTypeConverter = function assetTypeConverter(value) {
  var valueArr = value.split(',');
  var apiProductTypes = [];
  valueArr.forEach(function (type) {
    var productType = productTypes[type];
    if (productType) apiProductTypes.push(productType);
  });
  return apiProductTypes.join(',');
};
var assetTypeConverterWithSpace = function assetTypeConverterWithSpace(value) {
  var valueArr = value.split(',');
  var apiProductTypes = [];
  valueArr.forEach(function (type) {
    var productType = productDisplayTypes[type];
    if (productType) apiProductTypes.push(productType);
  });
  return apiProductTypes.join(', ');
};
var listingTypeToLabels = function listingTypeToLabels(value) {
  var valueArr = value.split(',');
  var listingTypelabels = [];
  valueArr.forEach(function (type, i) {
    var listingType = valueArr.length > 2 && i === valueArr.length - 1 ? "or ".concat(listingTypes[type]) : listingTypes[type];
    if (listingType) listingTypelabels.push(listingType);
  });
  return listingTypelabels.join(', ');
};
var dateStringToUrl = function dateStringToUrl(value) {
  var isDisplay = !!value && moment(value).isSame(moment().add(5, 'days'), 'day');
  return isDisplay && "".concat(value, "_any");
};
var sqftObjectToString = function sqftObjectToString(value) {
  if (!(value.min || value.max)) return;
  return "".concat(value.min ? value.min : 'any', "_").concat(value.max ? value.max : 'any');
};
var sqftToLabel = function sqftToLabel(value) {
  if (!(value.min || value.max)) return;
  return "".concat(value.min ? value.min : 'Any', " to ").concat(value.max ? value.max : 'Any');
};
var checkOccupancy = function checkOccupancy(value) {
  return ___default.toLower(value) === 'vacant';
};
var numberWithPlus = function numberWithPlus(value) {
  return value && "".concat(value, "+");
};
var categorizeLabels = function categorizeLabels(labels, inputLabel, paramValue) {
  if (mainDisplay.has(inputLabel)) {
    labels.mainDisplay.push([inputLabel, paramValue]);
  } else if (propertyAndAssetTypesSet.has(inputLabel)) {
    labels.propertyAndAssetTypes.push([inputLabel, paramValue]);
  } else if (listAndAuctionTypesSet.has(inputLabel)) {
    labels.listAndAuctionTypes.push([inputLabel, paramValue]);
  } else if (showOnlySet.has(inputLabel)) {
    labels.showOnlyFields.push([inputLabel, paramValue]);
  }
};

/**
 * Convert asset type search param to filter route part
 */
var assetTypeRouteConverter = function assetTypeRouteConverter(value) {
  var valueArr = value.split(',');
  var apiProductTypes = [];
  valueArr.forEach(function (type) {
    var productType = assetTypeFilterRoute[type];
    if (productType) apiProductTypes.push(productType);
  });
  return apiProductTypes.join(',');
};

var schema = [{
  fe: 'search',
  api: 'search',
  url: 'qs',
  converter: {
    fe2api: ___default.identity,
    fe2url: ___default.identity,
    url2fe: ___default.identity,
    api2url: ___default.identity
  }
}, {
  label: 'State',
  fe: 'state',
  api: 'property_state',
  url: 0,
  converter: {
    fe2api: stateFeToApi,
    fe2url: ___default.join,
    url2fe: stringToArray,
    api2url: ___default.identity,
    url2label: ___default.identity
  }
}, {
  label: 'City',
  fe: 'city',
  api: 'property_city',
  url: 'ct',
  converter: {
    fe2api: ___default.join,
    fe2url: arrayToStringRemovingSpaces,
    url2fe: stringToArrayAddingSpaces,
    api2url: stringSpaceToDash,
    url2label: ___default.identity
  }
}, {
  label: 'County',
  fe: 'county',
  api: 'property_county',
  url: 'county',
  converter: {
    fe2api: ___default.join,
    fe2url: arrayToStringRemovingSpaces,
    url2fe: stringToArrayAddingSpaces,
    api2url: stringSpaceToDash,
    url2label: ___default.identity
  }
}, {
  label: 'Zip',
  fe: 'zip',
  api: 'property_zip',
  url: 'zp',
  converter: {
    fe2api: ___default.join,
    fe2url: ___default.join,
    url2fe: stringToArray,
    api2url: ___default.identity,
    url2label: ___default.identity
  }
}, {
  fe: 'mapBounds',
  api: 'geo_location_box',
  url: 'bounds',
  converter: {
    fe2api: ___default.join,
    fe2url: ___default.join,
    url2fe: stringToArrayFloat,
    api2url: ___default.identity
  }
}, {
  fe: 'geoLocation',
  api: 'geo_location',
  url: 'geoLocation',
  converter: {
    fe2api: ___default.join,
    fe2url: function fe2url() {},
    url2fe: stringToArrayFloat
  }
}, {
  fe: 'userCoords',
  api: 'coords',
  url: NOT_IMPLEMENTED,
  converter: {
    fe2api: ___default.join,
    fe2url: function fe2url() {},
    url2fe: function url2fe() {}
  }
}, {
  label: 'Listing Type',
  fe: 'listingType',
  api: 'listing_type',
  url: 'lt',
  converter: {
    fe2api: ___default.join,
    fe2url: ___default.join,
    url2fe: stringToArray,
    api2url: ___default.identity,
    url2label: listingTypeToLabels
  }
}, {
  label: 'Auction Type',
  fe: 'auctionFormat',
  api: 'asset_event_type',
  url: 'af',
  converter: {
    fe2api: ___default.join,
    fe2url: ___default.join,
    url2fe: stringToArray,
    api2url: ___default.identity,
    url2label: auctionFormatConverterUpperCase
  }
}, {
  label: 'Property Type',
  fe: 'propertyType',
  api: 'usecode_property_type',
  url: 'pt',
  converter: {
    fe2api: arrayToApiPropertyType,
    fe2url: ___default.join,
    url2fe: stringToArray,
    api2url: propertyTypeConverter,
    url2label: propertyTypeConverterWithSpace
  }
}, {
  label: 'Vacant',
  fe: 'occupancyStatus',
  api: 'occ_status',
  url: 'os',
  converter: {
    fe2api: ___default.join,
    fe2url: ___default.join,
    url2fe: stringToArray,
    api2url: ___default.identity,
    url2label: checkOccupancy
  }
}, {
  label: 'Beds',
  fe: 'beds',
  api: 'beds_min',
  url: 'bd',
  converter: {
    fe2api: ___default.toString,
    fe2url: ___default.toString,
    url2fe: parseFloat,
    api2url: ___default.identity,
    url2label: numberWithPlus
  }
}, {
  label: 'Baths',
  fe: 'baths',
  api: 'baths_min',
  url: 'bt',
  converter: {
    fe2api: ___default.toString,
    fe2url: ___default.toString,
    url2fe: parseFloat,
    api2url: ___default.identity,
    url2label: numberWithPlus
  }
}, {
  label: 'Sqft Range',
  fe: 'sqft',
  api: 'sqft_range',
  url: 'sqft',
  converter: {
    fe2api: sqftObjectToApi,
    fe2url: sqftObjectToString,
    url2fe: stringToSqftObject,
    api2url: sqftObjectToString,
    url2label: sqftToLabel
  }
}, {
  fe: 'sort',
  api: 'sort',
  url: 'st',
  converter: {
    fe2api: sortObjectToString,
    fe2url: sortObjectToString,
    url2fe: stringToSortObject,
    api2url: ___default.identity
  }
}, {
  label: 'Financing Available',
  fe: 'financingAvailable',
  api: 'fin_avl',
  url: 'y_fa',
  converter: {
    fe2api: ___default.identity,
    fe2url: ___default.identity,
    url2fe: ___default.identity,
    api2url: booleanStringToBoolean,
    url2label: booleanStringToBoolean
  }
}, {
  label: 'Interior Access Available',
  fe: 'accessAvailable',
  api: 'resi_ia',
  url: 'y_ia',
  converter: {
    fe2api: ___default.identity,
    fe2url: ___default.identity,
    url2fe: ___default.identity,
    api2url: booleanStringToBoolean,
    url2label: booleanStringToBoolean
  }
}, {
  fe: 'inspectionAllowed',
  api: 'inspection_allowed',
  url: 'y_ica',
  converter: {
    fe2api: ___default.identity,
    fe2url: ___default.identity,
    url2fe: ___default.identity
  }
}, {
  label: 'Reserve Disclosed',
  fe: 'showReserve',
  api: 'show_reserve',
  url: 'y_sr',
  converter: {
    fe2api: ___default.identity,
    fe2url: ___default.identity,
    url2fe: ___default.identity,
    api2url: booleanStringToBoolean,
    url2label: booleanStringToBoolean
  }
}, {
  label: 'Broker Co-op',
  fe: 'brokerCoopAvailable',
  api: 'broker_coop_avail',
  url: 'y_bc',
  converter: {
    fe2api: ___default.identity,
    fe2url: ___default.identity,
    url2fe: ___default.identity,
    api2url: booleanStringToBoolean,
    url2label: booleanStringToBoolean
  }
}, {
  label: "No Buyer's Premium",
  fe: 'noBuyerPremiumFilter',
  api: 'buyer_premium_avail',
  url: 'y_nbp',
  converter: {
    fe2api: ___default.identity,
    fe2url: ___default.identity,
    url2fe: ___default.identity,
    api2url: noBuyerPremiumConverter,
    url2label: noBuyerPremiumConverter
  }
}, {
  label: 'Hide Ending Soon',
  fe: 'hideEndingSoon',
  api: 'hide_ending_soon',
  url: 'y_hes',
  converter: {
    fe2api: ___default.identity,
    fe2url: ___default.identity,
    url2fe: ___default.identity,
    api2url: booleanStringToBoolean,
    url2label: booleanStringToBoolean
  }
}, {
  label: 'Leaseback Required',
  fe: 'leasebackRequired',
  api: 'leaseback_required',
  url: 'lbr',
  converter: {
    fe2api: ___default.identity,
    fe2url: ___default.identity,
    url2fe: ___default.identity,
    api2url: booleanStringToBoolean,
    url2label: booleanStringToBoolean
  }
}, {
  fe: 'presale',
  api: 'presale',
  url: 'y_ps',
  converter: {
    fe2api: ___default.identity,
    fe2url: ___default.identity,
    url2fe: ___default.identity,
    api2url: booleanStringToBoolean
  }
}, {
  fe: 'globalSearch',
  api: 'global_search',
  url: 'y_global',
  converter: {
    fe2api: ___default.identity,
    fe2url: ___default.identity,
    url2fe: ___default.identity,
    api2url: ___default.identity
  }
}, {
  fe: 'mapView',
  api: 'map_vt',
  url: 'map_vt',
  converter: {
    fe2api: ___default.noop,
    fe2url: ___default.identity,
    url2fe: ___default.identity
  }
}, {
  fe: 'openedAssetId',
  api: 'oa',
  url: 'oa',
  converter: {
    fe2api: ___default.noop,
    fe2url: ___default.toString,
    url2fe: parseFloat,
    api2url: ___default.noop
  }
}, {
  api: 'distance',
  url: 'rd',
  converter: {
    api2url: ___default.identity
  }
}, {
  api: 'location',
  url: 'lq',
  converter: {
    api2url: ___default.identity
  }
}, {
  fe: 'limit',
  api: 'limit',
  url: 'rpp',
  converter: {
    fe2api: ___default.toString,
    fe2url: ___default.toString,
    url2fe: parseInt
  }
}, {
  fe: 'marketingTag',
  api: 'marketing_tags',
  url: 'mt',
  converter: {
    fe2api: ___default.identity,
    fe2url: ___default.identity,
    url2fe: ___default.identity,
    api2url: ___default.identity
  }
}, {
  fe: 'sellerCode',
  api: 'seller_cd',
  url: 'sc',
  converter: {
    fe2api: ___default.join,
    fe2url: ___default.join,
    url2fe: stringToArray
  }
}, {
  fe: 'useNearbySearch',
  api: 'nearby_search',
  url: 'nbs',
  converter: {
    fe2api: ___default.identity,
    fe2url: ___default.identity,
    url2fe: ___default.identity,
    api2url: ___default.identity
  }
}, {
  fe: 'nearbySearchRadius',
  api: 'nearby_search_radius',
  url: 'nsr',
  converter: {
    fe2api: parseInt,
    fe2url: ___default.toString,
    url2fe: parseInt,
    api2url: ___default.identity
  }
}, {
  api: 'ending_soon_dt_all_min',
  url: 'dt',
  converter: {
    fe2api: ___default.toString,
    fe2url: ___default.toString,
    url2fe: parseInt,
    api2url: dateStringToUrl
  }
}, {
  fe: 'implicitLocationCoordinates',
  api: 'implicitLocationCoordinates',
  url: NOT_IMPLEMENTED,
  converter: {
    fe2api: ___default.identity,
    fe2url: function fe2url() {},
    url2fe: function url2fe() {}
  }
}, {
  label: 'Asset Type',
  fe: 'assetType',
  api: 'usecode_product_type',
  url: 'at',
  converter: {
    fe2api: arrayToApiProductType,
    fe2url: ___default.join,
    url2fe: stringToArray,
    api2url: assetTypeConverter,
    url2label: assetTypeConverterWithSpace
  }
}, {
  fe: 'foreclosureBidType',
  api: 'bid_type_label',
  url: 'bl',
  converter: {
    fe2api: ___default.join,
    fe2url: ___default.join,
    url2fe: stringToArray
  }
}];
var FiltersModel = function () {
  function FiltersModel(props) {
    this._filters = Object.assign({}, props);
  }
  Object.defineProperty(FiltersModel.prototype, "rawValue", {
    get: function get() {
      return this._filters;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(FiltersModel.prototype, "labels", {
    get: function get() {
      var _this = this;
      var labels = {
        mainDisplay: [],
        propertyAndAssetTypes: [],
        listAndAuctionTypes: [],
        showOnlyFields: []
      };
      this._filters.sqft_range = {
        min: ___default.get(this._filters, 'sqft_min'),
        max: ___default.get(this._filters, 'sqft_max')
      };
      schema.forEach(function (param) {
        var apiParamValue = param.api === 'is_asset_online_event' ? ___default.toLower(_this._filters[param.api]) : _this._filters[param.api];
        if (apiParamValue) {
          var labelParamValue = param.converter.url2label && param.converter.url2label(apiParamValue);
          if (labelParamValue) categorizeLabels(labels, param.label, labelParamValue);
        }
      });
      return labels;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(FiltersModel.prototype, "feToApiValue", {
    get: function get() {
      var _this = this;
      var apiFilters = {};
      schema.forEach(function (filter) {
        var feFilterValue = _this._filters[filter.fe];
        if (feFilterValue) {
          var urlFilterValue = filter.converter.fe2api(feFilterValue);
          if (urlFilterValue) {
            if (filter.fe === 'auctionDate' || filter.fe === 'sqft') {
              apiFilters = _assign(_assign({}, apiFilters), urlFilterValue);
            } else {
              apiFilters[filter.api] = urlFilterValue;
            }
          }
        }
      });
      return apiFilters;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(FiltersModel.prototype, "feToUrlValue", {
    get: function get() {
      var _this = this;
      var urlFilters = [];
      schema.forEach(function (filter) {
        var feFilterValue = _this._filters[filter.fe];
        if (feFilterValue) {
          var urlFilterValue = filter.converter.fe2url(feFilterValue);
          if (urlFilterValue) urlFilters.push(addUrlKey(urlFilterValue, filter));
        }
      });
      return urlFilters.join('/');
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(FiltersModel.prototype, "apiToUrlValue", {
    get: function get() {
      var _this = this;
      var urlParams = [];
      this._filters.sqft_range = {
        min: ___default.get(this._filters, 'sqft_min'),
        max: ___default.get(this._filters, 'sqft_max')
      };
      schema.forEach(function (param) {
        var _a, _b;
        var apiParamValue = param.api === 'is_asset_online_event' ? ___default.toLower(_this._filters[param.api]) : _this._filters[param.api];
        if (apiParamValue) {
          var urlParamValue = (_b = (_a = param.converter).api2url) === null || _b === void 0 ? void 0 : _b.call(_a, apiParamValue);
          if (urlParamValue) urlParams.push(addUrlKey(urlParamValue, param));
        }
      });
      return urlParams.join('/');
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(FiltersModel.prototype, "lastFoundCoordinates", {
    get: function get() {
      return this._filters.lastFoundLocationCoordinates;
    },
    enumerable: false,
    configurable: true
  });
  FiltersModel.urlToFe = function (queryParams) {
    var feFilters = {};
    var urlFilters = {};
    var unmapped = 0;
    var urlData = decodeURIComponent(queryParams).split('/');
    urlData.shift();
    urlData.forEach(function (urlVal) {
      if (showOnlyFields.includes(urlVal)) {
        if (urlVal === 'y_nbp') {
          urlFilters[urlVal] = 'n';
        } else {
          urlFilters[urlVal] = 'y';
        }
      } else {
        urlVal = urlVal.split('_');
        var key = urlVal.pop();
        urlVal = urlVal.join('_');
        if (!urlVal && key && ___default.endsWith(key.toLowerCase(), '-county')) {
          urlVal = key.toLowerCase().replace('-county', '');
          key = 'county';
        }
        if (key && urlVal) {
          urlFilters[key] = urlVal;
        } else {
          urlFilters[unmapped++] = key;
        }
      }
    });
    schema.forEach(function (filter) {
      var urlFilterValue = urlFilters[filter.url];
      if (urlFilterValue) {
        feFilters[filter.fe] = filter.converter.url2fe(urlFilterValue);
      }
    });
    return feFilters;
  };
  return FiltersModel;
}();

var isReactNative = function isReactNative() {
  return typeof navigator !== 'undefined' && navigator.product === 'ReactNative';
};
var getPlatform = function getPlatform() {
  return isReactNative() ? 'mobile' : 'web';
};

var DEFAULT_BLUEPRINT_TAGS = ["platform:".concat(getPlatform())];
var increment = function increment(name, value, tags) {
  if (value === void 0) {
    value = 1;
  }
  if (tags === void 0) {
    tags = [];
  }
  var newTags = __spreadArray(__spreadArray([], tags, true), DEFAULT_BLUEPRINT_TAGS, true);
  instrument.increment(name, value, newTags);
};
var blueprintInstrument = {
  increment: increment
};

var FILTER_BUCKETS = {
  FILTERS: 'FILTERS',
  SORTS: 'SORTS',
  SEARCHES: 'SEARCHES'
};
var FILTER_TRACKING_METRIC_NAME = 'search_filter_changed';
var defaultProcessedFilterObject = {
  name: '',
  value: null,
  bucket: ''
};
var LOCATION_FILTER_PRECEDENCE = ['city', 'county', 'state'];
var TRACKED_FILTER_NAME_BLOCK_LIST = new Set(__spreadArray(__spreadArray([], LOCATION_FILTER_PRECEDENCE, true), ['implicit_location_coordinates', 'offset'], false));
var FILTER_FIELD_TO_BUCKET_MAPPING = {
  map_bounds: {
    bucket: FILTER_BUCKETS.SEARCHES,
    clearValue: true
  },
  city: {
    bucket: FILTER_BUCKETS.SEARCHES,
    clearValue: true
  },
  state: {
    bucket: FILTER_BUCKETS.SEARCHES
  },
  county: {
    bucket: FILTER_BUCKETS.SEARCHES
  },
  zip: {
    bucket: FILTER_BUCKETS.SEARCHES,
    clearValue: true
  },
  text: {
    bucket: FILTER_BUCKETS.SEARCHES
  },
  search: {
    bucket: FILTER_BUCKETS.SEARCHES,
    clearValue: true
  },
  property_type: {
    bucket: FILTER_BUCKETS.FILTERS
  },
  asset_type: {
    bucket: FILTER_BUCKETS.FILTERS
  },
  auction_format: {
    bucket: FILTER_BUCKETS.FILTERS
  },
  occupancy_status: {
    bucket: FILTER_BUCKETS.FILTERS
  },
  financing_available: {
    bucket: FILTER_BUCKETS.FILTERS,
    clearValue: true
  },
  listing_type: {
    bucket: FILTER_BUCKETS.FILTERS
  },
  hide_ending_soon: {
    bucket: FILTER_BUCKETS.FILTERS,
    clearValue: true
  },
  access_available: {
    bucket: FILTER_BUCKETS.FILTERS,
    clearValue: true
  },
  usenearby_search: {
    bucket: FILTER_BUCKETS.FILTERS
  },
  presale: {
    bucket: FILTER_BUCKETS.FILTERS,
    clearValue: true
  },
  no_buyer_premium_filter: {
    bucket: FILTER_BUCKETS.FILTERS,
    clearValue: true
  },
  broker_coop_available: {
    bucket: FILTER_BUCKETS.FILTERS,
    clearValue: true
  },
  show_reserve: {
    bucket: FILTER_BUCKETS.FILTERS,
    clearValue: true
  },
  beds: {
    bucket: FILTER_BUCKETS.FILTERS
  },
  baths: {
    bucket: FILTER_BUCKETS.FILTERS
  },
  sqft: {
    bucket: FILTER_BUCKETS.FILTERS,
    clearValue: true
  },
  nearby_search_radius: {
    bucket: FILTER_BUCKETS.FILTERS
  },
  use_nearby_search: {
    bucket: FILTER_BUCKETS.FILTERS
  },
  auction_date: {
    bucket: FILTER_BUCKETS.SORTS
  },
  newly_added: {
    bucket: FILTER_BUCKETS.SORTS
  },
  address: {
    bucket: FILTER_BUCKETS.SORTS
  },
  price: {
    bucket: FILTER_BUCKETS.SORTS
  },
  distance: {
    bucket: FILTER_BUCKETS.FILTERS
  },
  marketing_tag: {
    bucket: FILTER_BUCKETS.FILTERS
  }
};
var getFilterBucketFromFilterName = function getFilterBucketFromFilterName(filterName) {
  var _a;
  return (_a = FILTER_FIELD_TO_BUCKET_MAPPING[filterName]) === null || _a === void 0 ? void 0 : _a.bucket;
};
var getLocationTrackingObject = function getLocationTrackingObject(newFilters) {
  var keyToExtract = ___default.find(LOCATION_FILTER_PRECEDENCE, function (key) {
    return ___default.get(newFilters, key) && ___default.get(newFilters, key).length > 0;
  });
  if (keyToExtract && newFilters[keyToExtract]) {
    return {
      name: keyToExtract,
      value: '',
      bucket: FILTER_BUCKETS.SEARCHES,
      event: FILTER_TRACKING_METRIC_NAME
    };
  }
  return null;
};
var allObjectValuesEmpty = function allObjectValuesEmpty(obj) {
  return !Object.values(obj).some(function (x) {
    return Boolean(x);
  });
};
var processCommaSeparatedStringDiff = function processCommaSeparatedStringDiff(newValue, oldValue) {
  return newValue.split(',').filter(function (element) {
    return !oldValue.split(',').includes(element);
  }) || [];
};
var processFilterChanged = function processFilterChanged(keysChanged, previousFilters, currentFilters) {
  var oldFilters = ___default.clone(previousFilters);
  var newFilters = ___default.clone(currentFilters);
  var singularFilterTurnedOn = _assign({}, defaultProcessedFilterObject);
  var locationTrackingObject = getLocationTrackingObject(newFilters);
  if (locationTrackingObject) return locationTrackingObject;
  var newFiltersTrimmed = ___default.omit.apply(___default, __spreadArray([newFilters], Array.from(TRACKED_FILTER_NAME_BLOCK_LIST), false));
  var oldFiltersTrimmed = ___default.omit.apply(___default, __spreadArray([oldFilters], Array.from(TRACKED_FILTER_NAME_BLOCK_LIST), false));
  var keysChangedPositively = keysChanged.filter(function (key) {
    if (Array.isArray(newFiltersTrimmed[key])) {
      var newArrayFilterValue = newFiltersTrimmed[key];
      var oldArrayFilterValue_1 = oldFiltersTrimmed[key];
      return !___default.isEmpty(newArrayFilterValue === null || newArrayFilterValue === void 0 ? void 0 : newArrayFilterValue.filter(function (x) {
        return !(oldArrayFilterValue_1 === null || oldArrayFilterValue_1 === void 0 ? void 0 : oldArrayFilterValue_1.includes(x));
      }));
    } else if (___default.isObject(newFiltersTrimmed[key])) {
      var newObjectFilterValue = newFiltersTrimmed[key];
      return !allObjectValuesEmpty(newObjectFilterValue);
    } else if (typeof newFiltersTrimmed[key] === 'string') {
      var newStringFilterValue = newFiltersTrimmed[key];
      var oldStringFilterValue = String(oldFiltersTrimmed[key]);
      if (newStringFilterValue.includes(',') || (oldStringFilterValue || '').includes(',')) {
        return !___default.isEmpty(processCommaSeparatedStringDiff(newStringFilterValue, oldStringFilterValue));
      } else {
        return !___default.isEmpty(newStringFilterValue) || newStringFilterValue;
      }
    } else {
      return !___default.isEmpty(newFiltersTrimmed[key]) || newFiltersTrimmed[key];
    }
  });
  var key = keysChangedPositively[0];
  var snakeCaseKey = ___default.snakeCase(key);
  var config = FILTER_FIELD_TO_BUCKET_MAPPING[snakeCaseKey];
  if (Array.isArray(newFiltersTrimmed[key])) {
    var arrValue = newFiltersTrimmed[key];
    if (arrValue.length) {
      arrValue = arrValue[0];
    }
  }
  if (key === 'sort' && newFiltersTrimmed[key]) {
    var sortFilter = newFiltersTrimmed[key];
    singularFilterTurnedOn.name = sortFilter.type;
    singularFilterTurnedOn.value = sortFilter.order;
    singularFilterTurnedOn.bucket = FILTER_BUCKETS.SORTS;
    singularFilterTurnedOn.event = FILTER_TRACKING_METRIC_NAME;
  } else {
    if (key) {
      if (config) {
        singularFilterTurnedOn.name = snakeCaseKey;
        singularFilterTurnedOn.value = config.clearValue ? '' : newFiltersTrimmed[key];
        singularFilterTurnedOn.bucket = getFilterBucketFromFilterName(snakeCaseKey);
        singularFilterTurnedOn.event = FILTER_TRACKING_METRIC_NAME;
      } else {
        singularFilterTurnedOn.name = snakeCaseKey;
        singularFilterTurnedOn.event = "untracked_".concat(FILTER_TRACKING_METRIC_NAME);
      }
    }
  }
  return singularFilterTurnedOn;
};
var searchResultBuckets = {
  empty: 'empty',
  small: 'small',
  medium: 'medium',
  large: 'large'
};
var getResultGroup = function getResultGroup(total) {
  if (total === 0) return searchResultBuckets.empty;
  if (total <= 20) return searchResultBuckets.small;
  if (total <= 50) return searchResultBuckets.medium;
  return searchResultBuckets.large;
};

var trackSearchResultBuckets = function trackSearchResultBuckets(listings) {
  var assetTotals = {
    total: listings.total_count || 0,
    nearbyTotal: listings.nearbyTotal || 0
  };
  blueprintInstrument.increment('listing_search_result_count_buckets', 1, ["result_group:".concat(getResultGroup(assetTotals.total || 0))]);
};
var trackFilterChanged = function trackFilterChanged(previousFilters, currentFilters) {
  var keysChanged = getObjectDiff(previousFilters, currentFilters);
  var filterData = processFilterChanged(keysChanged, previousFilters, currentFilters);
  var metricName = filterData === null || filterData === void 0 ? void 0 : filterData.event;
  if (filterData && metricName && (filterData === null || filterData === void 0 ? void 0 : filterData.name)) {
    var filterName = (filterData === null || filterData === void 0 ? void 0 : filterData.name) || '';
    var filterValue = (filterData === null || filterData === void 0 ? void 0 : filterData.value) || '';
    var filterBucket = (filterData === null || filterData === void 0 ? void 0 : filterData.bucket) || '';
    var filterLabels = ["filter_name:".concat(filterName), "filter_value:".concat(filterValue), "filter_bucket:".concat(filterBucket)];
    blueprintInstrument.increment(metricName, 1, filterLabels);
  }
};
var getObjectDiff = function getObjectDiff(obj1, obj2) {
  var diff = Object.keys(obj1).reduce(function (result, key) {
    var typedKey = key;
    var resultKeyIndex = result.indexOf(typedKey);
    if (!isEqual(obj1[typedKey], obj2[typedKey]) && resultKeyIndex < 0) {
      result.push(typedKey);
    }
    return result;
  }, []);
  return diff;
};

var zodListingType = z.union([z.tuple([z.literal('active')]), z.union([z.tuple([z.literal('pending'), z.literal('closed'), z.literal('canceled')]), z.tuple([z.literal('pending'), z.literal('canceled'), z.literal('closed')]), z.tuple([z.literal('closed'), z.literal('pending'), z.literal('canceled')]), z.tuple([z.literal('closed'), z.literal('canceled'), z.literal('pending')]), z.tuple([z.literal('canceled'), z.literal('pending'), z.literal('closed')]), z.tuple([z.literal('canceled'), z.literal('closed'), z.literal('pending')])])]);
var zodYesOrFalse = z.union([z.literal('y'), z.literal(false)]);
var zodFilterSchema = z.object({
  search: z.string(),
  state: z.string().array(),
  city: z.string().array(),
  county: z.string().array(),
  zip: z.string().array(),
  mapBounds: z.number().array(),
  userCoords: z.string().array(),
  geoLocation: z.string().array(),
  listingType: zodListingType,
  auctionFormat: z.array(z.union([z.literal('online'), z.literal('in_person'), z.literal('remote_bid'), z.literal('direct_offer'), z.literal('offer')])),
  propertyType: z.array(z.union([z.literal('single-family'), z.literal('multi-family'), z.literal('condos-townhouses'), z.literal('land')])),
  occupancyStatus: z.array(z.literal('vacant')),
  nearbySearchRadius: z.union([z.literal(5), z.literal(10), z.literal(25), z.literal(50), z.literal(100)]).nullable(),
  beds: z.number().nullable(),
  baths: z.number().nullable(),
  sqft: z.object({
    min: z.number().positive().nullable(),
    max: z.number().positive().nullable()
  }),
  sort: z.object({
    type: z.union([z.literal('resi_sort_v2'), z.literal('resi_sort_v2_desc'), z.literal('asset_activation_dt_sort'), z.literal('resi_property_address'), z.literal('auction_date_order'), z.literal('beds'), z.literal('baths'), z.literal('sqft'), z.literal('valuation_estimate'), z.literal('distance')]),
    order: z.union([z.literal('asc'), z.literal('desc')])
  }),
  financingAvailable: zodYesOrFalse,
  accessAvailable: zodYesOrFalse,
  inspectionAllowed: zodYesOrFalse,
  showReserve: zodYesOrFalse,
  brokerCoopAvailable: zodYesOrFalse,
  reserveReduced: z.boolean(),
  noBuyerPremiumFilter: z.union([z.literal('n'), z.literal(false)]),
  hideEndingSoon: zodYesOrFalse,
  leasebackRequired: z.literal('n').nullable(),
  presale: zodYesOrFalse,
  globalSearch: zodYesOrFalse,
  limit: z.number().nullable(),
  offset: z.number().nonnegative(),
  sellerCode: z.string().array(),
  useNearbySearch: z.union([z.literal('y'), z.literal('n'), z.literal(false)]),
  assetType: z.array(z.union([z.literal('bank-owned'), z.literal('newly-foreclosed'), z.literal('foreclosures'), z.literal('private-seller'), z.literal('short-sales')])),
  foreclosureBidType: z.string().array(),
  marketingTag: z.string(),
  openedAssetId: z.union([z.string(), z.number()]).nullable(),
  mapView: z.union([z.boolean(), z.literal('y')]),
  isMapShown: z.boolean()
});
zodFilterSchema.pick({
  useNearbySearch: true,
  nearbySearchRadius: true,
  sort: true
}).strict();
zodFilterSchema.pick({
  search: true,
  state: true,
  city: true,
  county: true,
  zip: true,
  globalSearch: true
}).strict();
zodFilterSchema.pick({
  mapView: true,
  isMapShown: true,
  mapBounds: true,
  geoLocation: true,
  userCoords: true
}).strict();
zodFilterSchema.pick({
  listingType: true,
  reserveReduced: true,
  limit: true,
  offset: true,
  sellerCode: true,
  foreclosureBidType: true,
  openedAssetId: true
}).strict();
zodFilterSchema.strict();

var transformMarketingConfigToOptions$1 = function transformMarketingConfigToOptions(marketingConfig) {
  return marketingConfig.sort(function (a, b) {
    return a.configuration.srp.order - b.configuration.srp.order;
  }).map(function (item) {
    var _a;
    return {
      value: item.tag.toLowerCase(),
      label: item.configuration.srp.label,
      tooltip: item.configuration.srp.is_tooltip_active && ((_a = item.configuration.srp.tooltip) === null || _a === void 0 ? void 0 : _a.length) ? item.configuration.srp.tooltip : null
    };
  });
};
var propertyFilterDefinition = new FilterGroupBuilder('property', 'Property').description('Filter by property details').items([new FilterBuilder('beds', 'singleSelect', 'number').label('Beds').styleIntent({
  width: 'half'
}).options([{
  value: null,
  label: 'Any'
}, {
  value: 1,
  label: '1+ Beds'
}, {
  value: 2,
  label: '2+ Beds'
}, {
  value: 3,
  label: '3+ Beds'
}, {
  value: 4,
  label: '4+ Beds'
}, {
  value: 5,
  label: '5+ Beds'
}]).build(), new FilterBuilder('baths', 'singleSelect', 'number').label('Baths').styleIntent({
  width: 'half'
}).options([{
  value: null,
  label: 'Any'
}, {
  value: 1,
  label: '1+ Baths'
}, {
  value: 2,
  label: '2+ Baths'
}, {
  value: 3,
  label: '3+ Baths'
}, {
  value: 4,
  label: '4+ Baths'
}, {
  value: 5,
  label: '5+ Baths'
}]).build(), new FilterBuilder('sqft', 'range', 'number').label('Square Feet').shortLabel('Sqft').range({
  min: 0,
  max: 1000000
}).build(), new FilterBuilder('propertyType', 'multiSelect', 'string[]').label('Type').description('Filter by property type').options([{
  value: ['single-family'],
  label: 'Single Family',
  icon: 'house'
}, {
  value: ['multi-family'],
  label: 'Multi Family',
  icon: 'apartment'
}, {
  value: ['condos-townhouses'],
  label: 'Condo, single unit',
  icon: 'arrow-right-to-city'
}, {
  value: ['land'],
  label: 'Land',
  icon: 'trees'
}]).build()]).build();
var assetOptions$1 = [{
  value: ['bank-owned', 'newly-foreclosed'],
  label: 'REO Bank Owned'
}, {
  value: ['foreclosures'],
  label: 'Foreclosure Homes'
}, {
  value: ['private-seller'],
  label: 'Private Seller'
}];
var getAssetTypeFilterDefinition = function getAssetTypeFilterDefinition(optionsDecorator) {
  var decoratedOptions = optionsDecorator ? optionsDecorator(assetOptions$1, 'assetType') : assetOptions$1;
  return new FilterGroupBuilder('assetType', 'Asset Type').items([new FilterBuilder('assetType', 'multiSelect', 'string[]').label(null).options(decoratedOptions).build()]).build();
};
var auctionFormatFilterDefinition = new FilterGroupBuilder('auctionFormat', 'Buying Type').items([new FilterBuilder('auctionFormat', 'multiSelect', 'string[]').label(null).options([{
  value: ['online'],
  label: 'Online Auction'
}, {
  value: ['in_person'],
  label: 'In Person Auction'
}, {
  value: ['remote_bid'],
  label: 'Remote Bid'
}, {
  value: ['direct_offer'],
  label: 'Direct Offer'
}]).build()]).build();
var conditionFilterDefinition = new FilterGroupBuilder('condition', 'Condition').description('Most properties on Auction.com are sold "Cash only" and "As-is," and many are occupied. Use these filters to potentially reduce your risk.').styleIntent({
  compact: true
}).items([new FilterBuilder('occupancyStatus', 'multiSelect', 'string[]').options([{
  value: ['vacant'],
  label: 'Vacant',
  description: 'Not all foreclosure properties are empty, but for these no eviction is needed.  '
}]).build(), new FilterBuilder('accessAvailable', 'boolean', 'string').label('Interior Access Available').description('Schedule a visit to view the property').converterOverrides({
  toViewModelValue: function toViewModelValue(v) {
    return v === 'y';
  },
  toAppModelValue: function toAppModelValue(v) {
    return v ? 'y' : null;
  }
}).build(), new FilterBuilder('financingAvailable', 'boolean', 'string').label('Eligible for Financing').description('These could be financed with a residential mortgage.').converterOverrides({
  toViewModelValue: function toViewModelValue(v) {
    return v === 'y';
  },
  toAppModelValue: function toAppModelValue(v) {
    return v ? 'y' : null;
  }
}).build()]).build();
var getMarketingTagFilterDefinition$1 = function getMarketingTagFilterDefinition(marketingTagConfig) {
  return new FilterGroupBuilder('marketingTag', 'Featured').items([new FilterBuilder('marketingTag', 'multiSelect', 'string').options(transformMarketingConfigToOptions$1(marketingTagConfig)).converterOverrides({
    toViewModelValue: function toViewModelValue(v) {
      if (typeof v === 'string') {
        return v.split(',');
      }
      return v ? [v.toString()] : [];
    },
    toAppModelValue: function toAppModelValue(v) {
      if (Array.isArray(v)) {
        return v.join(',');
      } else {
        return v;
      }
    }
  }).build()]).build();
};
var moreFiltersFilterDefinition = new FilterGroupBuilder('moreFilters', 'More Filters').items([new FilterSectionBuilder('hideProperties').label('Hide properties that:').filters([new FilterBuilder('hideEndingSoon', 'boolean', 'boolean').label('Auction Ending Soon').description('Ending in the next 5 days').styleIntent({
  width: 'full'
}).converterOverrides({
  toViewModelValue: function toViewModelValue(v) {
    return v === 'y';
  },
  toAppModelValue: function toAppModelValue(v) {
    return v ? 'y' : null;
  }
}).build()]).build(), new FilterSectionBuilder('showProperties').label('Show only properties that have/are:').styleIntent({
  compact: true
}).filters([new FilterBuilder('listingType', 'boolean', 'string[]').label('Sold, Pending, or Canceled').converterOverrides({
  toViewModelValue: function toViewModelValue(v) {
    return arraysAreEqual(v, ['pending', 'closed', 'canceled']);
  },
  toAppModelValue: function toAppModelValue(v) {
    return v ? ['pending', 'closed', 'canceled'] : ['active'];
  }
}).build(), new FilterBuilder('brokerCoopAvailable', 'boolean', 'string').label('Broker Coop').converterOverrides({
  toViewModelValue: function toViewModelValue(v) {
    return v === 'y';
  },
  toAppModelValue: function toAppModelValue(v) {
    return v ? 'y' : null;
  }
}).build(), new FilterBuilder('showReserve', 'boolean', 'string').label('Reserve Disclosed').converterOverrides({
  toViewModelValue: function toViewModelValue(v) {
    return v === 'y';
  },
  toAppModelValue: function toAppModelValue(v) {
    return v ? 'y' : null;
  }
}).build(), new FilterBuilder('noBuyerPremiumFilter', 'boolean', 'string').label("No Buyer's Premium").converterOverrides({
  toViewModelValue: function toViewModelValue(v) {
    return v === 'n';
  },
  toAppModelValue: function toAppModelValue(v) {
    return v ? 'n' : null;
  }
}).build(), new FilterBuilder('presale', 'boolean', 'string').label('First Look').description('Learn more (TBD LINK HERE)').converterOverrides({
  toViewModelValue: function toViewModelValue(v) {
    return v === 'y';
  },
  toAppModelValue: function toAppModelValue(v) {
    return v ? 'y' : null;
  }
}).build()]).build()]).build();
var definitionGenerator$1 = function definitionGenerator(config) {
  return __spreadArray(__spreadArray([propertyFilterDefinition, getAssetTypeFilterDefinition(config === null || config === void 0 ? void 0 : config.optionsDecorator), auctionFormatFilterDefinition, conditionFilterDefinition], (config === null || config === void 0 ? void 0 : config.marketingTagConfig) ? [getMarketingTagFilterDefinition$1(config.marketingTagConfig)] : [], true), [moreFiltersFilterDefinition], false);
};
var getAssetType = function getAssetType(value) {
  return match(value).with(P.when(function (arr) {
    return arraysAreEqual(arr, ['bank-owned', 'newly-foreclosed']);
  }), function () {
    return graph.enums.AssetType.BankOwned;
  }).with(P.when(function (arr) {
    return arraysAreEqual(arr, ['foreclosures']);
  }), function () {
    return graph.enums.AssetType.Foreclosure;
  }).with(P.when(function (arr) {
    return arraysAreEqual(arr, ['private-seller']);
  }), function () {
    return graph.enums.AssetType.PrivateSeller;
  }).with(P.when(function (arr) {
    return arraysAreEqual(arr, ['short-sale']);
  }), function () {
    return graph.enums.AssetType.ShortSale;
  }).with(P.when(function (arr) {
    return arraysAreEqual(arr, ['rentals']);
  }), function () {
    return graph.enums.AssetType.Rentals;
  }).otherwise(function () {
    return graph.enums.AssetType.BankOwned;
  });
};

var getFiltersDefaultState = function getFiltersDefaultState(maxResultsAllowed, defaultNearbySearchRadius) {
  return {
    search: '',
    state: [],
    city: [],
    county: [],
    zip: [],
    mapBounds: [],
    userCoords: [],
    geoLocation: [],
    listingType: ['active'],
    auctionFormat: [],
    propertyType: [],
    occupancyStatus: [],
    nearbySearchRadius: defaultNearbySearchRadius,
    beds: null,
    baths: null,
    sqft: {
      min: null,
      max: null
    },
    sort: {
      type: SORT_TYPES.auctionStartDate,
      order: SORT_ORDERS.asc
    },
    financingAvailable: false,
    accessAvailable: false,
    inspectionAllowed: false,
    showReserve: false,
    brokerCoopAvailable: false,
    reserveReduced: false,
    noBuyerPremiumFilter: false,
    hideEndingSoon: false,
    leasebackRequired: null,
    openedAssetId: null,
    presale: false,
    globalSearch: false,
    limit: maxResultsAllowed,
    offset: 0,
    sellerCode: [],
    useNearbySearch: 'y',
    assetType: [],
    foreclosureBidType: [],
    mapView: false,
    isMapShown: true,
    marketingTag: ''
  };
};
var logger$1 = coreLogger.forModule('blueprint:listingsSearch');
var attemptToLocateGeoCenter = function attemptToLocateGeoCenter(filters) {
  return __awaiter(void 0, void 0, void 0, function () {
    var suggestionType, cityCounty, coordinatesLookup, searchText, result, coordinates;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          suggestionType = '';
          if (filters.zip.length) {
            suggestionType = 'zip';
          } else if (filters.city.length) {
            suggestionType = 'city';
          } else if (filters.county.length) {
            suggestionType = 'county';
          } else {
            return [2, null];
          }
          cityCounty = suggestionType === 'county' ? filters.county && "".concat(filters.county[0], " County") : filters.city && filters.city[0];
          coordinatesLookup = suggestionType === 'zip' ? [filters.zip[0]] : [cityCounty, filters.state && filters.state[0]];
          if (!coordinatesLookup.every(Boolean)) return [3, 2];
          searchText = suggestionType === 'zip' ? coordinatesLookup[0] : formatLocationSearch.apply(void 0, coordinatesLookup);
          return [4, lookupLocation(searchText)];
        case 1:
          result = _a.sent();
          if (!result) {
            return [2, null];
          }
          coordinates = result.coordinates;
          if (!coordinates || ___default.isEmpty(coordinates)) {
            return [2, null];
          }
          return [2, coordinates];
        case 2:
          return [2, null];
      }
    });
  });
};
var validateFilters = function validateFilters(filters, filtersDefaultState) {
  if (!filters) {
    return filtersDefaultState;
  }
  var parsed = zodFilterSchema.safeParse(filters);
  if (!parsed.success) {
    logger$1.warn('error parsing filters: ', parsed.error.issues);
    return null;
  }
  return parsed.data;
};
var parseFiltersFromUrl = function parseFiltersFromUrl(url, filtersDefaultState) {
  if (!url) {
    return filtersDefaultState;
  }
  var urlWithoutSearchParams = splitUrl(url).urlWithoutSearchParams;
  var path = urlWithoutSearchParams.replace(/^\/residential\/?/, '/');
  var urlFilters = FiltersModel.urlToFe(path);
  var validatedFilters = validateFilters(_assign(_assign({}, filtersDefaultState), urlFilters));
  return validatedFilters !== null && validatedFilters !== void 0 ? validatedFilters : filtersDefaultState;
};
var splitUrl = function splitUrl(url) {
  var searchParamsStart = url.indexOf('?');
  if (searchParamsStart !== -1) {
    return {
      urlWithoutSearchParams: url.slice(0, searchParamsStart),
      searchParams: new URLSearchParams(url.slice(searchParamsStart))
    };
  }
  return {
    urlWithoutSearchParams: url,
    searchParams: new URLSearchParams('')
  };
};
var useListingsSearch = function useListingsSearch(_a) {
  var url = _a.url,
    currentLocation = _a.currentLocation,
    _b = _a.definitionGenerator,
    definitionGenerator = _b === void 0 ? definitionGenerator$1 : _b,
    user = _a.user,
    featureFlags = _a.featureFlags,
    maxResultsAllowed = _a.maxResultsAllowed,
    _c = _a.marketingTagsConfig,
    marketingTagsConfig = _c === void 0 ? [] : _c,
    _d = _a.defaultNearbySearchRadius,
    defaultNearbySearchRadius = _d === void 0 ? DEFAULT_NEARBY_SEARCH_RADIUS : _d;
  var filtersDefaultState = useMemo(function () {
    return getFiltersDefaultState(maxResultsAllowed, defaultNearbySearchRadius);
  }, [maxResultsAllowed, defaultNearbySearchRadius]);
  var filtersInitialState = useMemo(function () {
    return parseFiltersFromUrl(url, filtersDefaultState);
  }, [url, filtersDefaultState]);
  var defaultUiFilterGroups = useMemo(function () {
    return convertFiltersToUiFilterGroups(filtersDefaultState, marketingTagsConfig);
  }, [filtersDefaultState, marketingTagsConfig]);
  var initialUiFilterGroups = useMemo(function () {
    return convertFiltersToUiFilterGroups(filtersInitialState, marketingTagsConfig);
  }, [marketingTagsConfig, filtersInitialState]);
  var searchParams = splitUrl(url).searchParams;
  var _e = useState(url),
    currentUrl = _e[0],
    setCurrentUrl = _e[1];
  var _f = useState(searchParams),
    urlSearchParams = _f[0],
    setUrlSearchParams = _f[1];
  var _g = useState(filtersInitialState),
    currentFilters = _g[0],
    setCurrentFilters = _g[1];
  var _h = useState(initialUiFilterGroups),
    currentUiFilterGroups = _h[0],
    setCurrentUiFilterGroups = _h[1];
  var _j = useState(converFiltersToListingCompatabilityFilters(currentFilters)),
    listingCompatabilityFilters = _j[0],
    setListingCompatabilityFilters = _j[1];
  var config = useMemo(function () {
    return {
      filterState: currentFilters,
      definitionGenerator: definitionGenerator,
      definitionConfig: {
        marketingTags: marketingTagsConfig,
        featureFlags: featureFlags
      }
    };
  }, [currentFilters, definitionGenerator, featureFlags, marketingTagsConfig]);
  var _k = useFilters(config),
    filtersData = _k.data,
    filtersActions = _k.actions;
  var _l = useState(true),
    isLoading = _l[0],
    setIsLoading = _l[1];
  var _m = useState({
      total_count: 0,
      content: []
    }),
    listings = _m[0],
    setListings = _m[1];
  var _o = useState(null),
    currentSearchId = _o[0],
    setCurrentSearchId = _o[1];
  var __RATIONALIZE_YOUR_AWFUL_HACKJOB__ = useRef({
    nearbySearchRadius: false,
    filtersToOmitFromUrl: new Set(['listingType', 'sort', 'useNearbySearch'])
  });
  var processFilters = useCallback(function (newCurrentFilters, newQueryParams) {
    return __awaiter(void 0, void 0, void 0, function () {
      var newUiFilterGroups, isValidForNearbySearch, isSortByDistance, requiresGeoLocationCoordinates, coordinates, filtersToOmitFromUrl, path, searchParams, newCurrentUrl, displayOnlyFilters, newCurrentUrlWithoutDisplayOnlyFilters, newCurrentSearchId, newListingCompatabilityFilters;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            newUiFilterGroups = convertFiltersToUiFilterGroups(newCurrentFilters, marketingTagsConfig);
            isValidForNearbySearch = getIsValidForNearbySearch(newCurrentFilters);
            isSortByDistance = getIsSortByDistance(newCurrentFilters);
            if (!isValidForNearbySearch) {
              newCurrentFilters.geoLocation = [];
            }
            if (isSortByDistance) {
              if (currentLocation === null || currentLocation === void 0 ? void 0 : currentLocation.coordinates) {
                newCurrentFilters.userCoords = [currentLocation.coordinates.latitude, currentLocation.coordinates.longitude];
              } else {
                newCurrentFilters.sort = _assign({}, filtersDefaultState.sort);
              }
            } else {
              newCurrentFilters.userCoords = [];
            }
            requiresGeoLocationCoordinates = isValidForNearbySearch && ___default.isEmpty(newCurrentFilters.geoLocation);
            if (!requiresGeoLocationCoordinates) return [3, 2];
            return [4, attemptToLocateGeoCenter(newCurrentFilters)];
          case 1:
            coordinates = _a.sent();
            newCurrentFilters.geoLocation = coordinates ? [coordinates.lat, coordinates.lon] : [];
            _a.label = 2;
          case 2:
            filtersToOmitFromUrl = ['limit'];
            __RATIONALIZE_YOUR_AWFUL_HACKJOB__.current.filtersToOmitFromUrl.forEach(function (filter) {
              return filtersToOmitFromUrl.push(filter);
            });
            if (!__RATIONALIZE_YOUR_AWFUL_HACKJOB__.current.nearbySearchRadius) {
              filtersToOmitFromUrl.push('nearbySearchRadius');
            }
            path = new FiltersModel(___default.omit(newCurrentFilters, filtersToOmitFromUrl)).feToUrlValue;
            searchParams = newQueryParams ? newQueryParams.toString() : urlSearchParams.toString();
            newCurrentUrl = "/residential/".concat(path).concat(searchParams ? '?' + searchParams : '');
            displayOnlyFilters = ['mapView', 'openedAssetId'];
            newCurrentUrlWithoutDisplayOnlyFilters = "/residential/".concat(new FiltersModel(___default.omit(newCurrentFilters, __spreadArray(['limit'], displayOnlyFilters, true))).feToUrlValue);
            newCurrentSearchId = MurmurHash3(newCurrentUrlWithoutDisplayOnlyFilters).result();
            newListingCompatabilityFilters = converFiltersToListingCompatabilityFilters(newCurrentFilters, isValidForNearbySearch);
            newQueryParams && setUrlSearchParams(newQueryParams);
            setCurrentFilters(newCurrentFilters);
            setListingCompatabilityFilters(newListingCompatabilityFilters);
            setCurrentUiFilterGroups(newUiFilterGroups);
            setCurrentUrl(function (currentUrl) {
              if (currentUrl.endsWith('/') && currentUrl.slice(0, -1) === newCurrentUrl) {
                return currentUrl;
              }
              return newCurrentUrl;
            });
            setCurrentSearchId(newCurrentSearchId);
            return [2];
        }
      });
    });
  }, [marketingTagsConfig, currentLocation === null || currentLocation === void 0 ? void 0 : currentLocation.coordinates, urlSearchParams, filtersDefaultState.sort]);
  var prevUrl = adcHooks.usePrevious(url);
  useEffect(function () {
    if (prevUrl !== url && currentUrl !== url) {
      var newCurrentFilters_1 = parseFiltersFromUrl(url, filtersDefaultState);
      var searchParams_1 = splitUrl(url).searchParams;
      var processFiltersFunc = function processFiltersFunc() {
        return __awaiter(void 0, void 0, void 0, function () {
          return __generator(this, function (_a) {
            return [2, processFilters(newCurrentFilters_1, searchParams_1)];
          });
        });
      };
      processFiltersFunc();
    }
  }, [url, currentUrl, prevUrl, filtersDefaultState, processFilters]);
  var prevSearchId = adcHooks.usePrevious(currentSearchId);
  useEffect(function () {
    var fetchData = function fetchData() {
      return __awaiter(void 0, void 0, void 0, function () {
        var locationAggregateField, requiresLocationAggregate, requiresSeoAggregate, aggregationFields, collectionResult, listingResults, listings_1, err_1;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              setIsLoading(true);
              locationAggregateField = getLocationAPIKey(listingCompatabilityFilters);
              requiresLocationAggregate = listingCompatabilityFilters.geo_location && locationAggregateField;
              requiresSeoAggregate = listingCompatabilityFilters.property_state || listingCompatabilityFilters.property_city || listingCompatabilityFilters.property_county;
              aggregationFields = __spreadArray(__spreadArray([], requiresSeoAggregate && !featureFlags['fe.resi.search-enable-aggregation-seo-optimization'] ? [AGGREGATE_FIELDS.property_type, AGGREGATE_FIELDS.remote_bid_assets] : [], true), requiresLocationAggregate ? [locationAggregateField] : [], true);
              _a.label = 1;
            case 1:
              _a.trys.push([1, 3, 4, 5]);
              return [4, seekListingsFromFilters({
                filters: listingCompatabilityFilters,
                aggregationFields: aggregationFields,
                hasAuthenticatedUser: user.logged_in
              })];
            case 2:
              collectionResult = _a.sent();
              listingResults = collectionResult.content;
              listingResults = filterOpenHouses(listingResults);
              listings_1 = formatAggregation({
                listings: {
                  offset: listingCompatabilityFilters.offset || 0,
                  content: listingResults,
                  total_count: collectionResult.total_count
                },
                listingFilters: listingCompatabilityFilters,
                collectionResult: collectionResult,
                requiresLocationAggregate: requiresLocationAggregate,
                locationAggregateField: locationAggregateField
              });
              trackSearchResultBuckets(listings_1);
              setListings(listings_1);
              return [3, 5];
            case 3:
              err_1 = _a.sent();
              logger$1.error(err_1);
              return [3, 5];
            case 4:
              setIsLoading(false);
              return [7];
            case 5:
              return [2];
          }
        });
      });
    };
    if (prevSearchId !== currentSearchId) {
      fetchData();
    }
  }, [user.logged_in, currentSearchId, prevSearchId, filtersDefaultState, listingCompatabilityFilters, currentFilters, featureFlags]);
  adcHooks.useMountEffect(function () {
    var newCurrentFilters = parseFiltersFromUrl(currentUrl, filtersDefaultState);
    var areLocationsFiltersSet = newCurrentFilters.search || !___default.isEmpty(newCurrentFilters.state) || !___default.isEmpty(newCurrentFilters.city) || !___default.isEmpty(newCurrentFilters.county) || !___default.isEmpty(newCurrentFilters.zip) || !___default.isEmpty(newCurrentFilters.mapBounds);
    var isGlobalSearchSet = newCurrentFilters.globalSearch === 'y';
    if (currentLocation === null || currentLocation === void 0 ? void 0 : currentLocation.coordinates) {
      newCurrentFilters.userCoords = [currentLocation.coordinates.latitude, currentLocation.coordinates.longitude];
    }
    if (areLocationsFiltersSet || isGlobalSearchSet) {
      var urlFilters_1 = FiltersModel.urlToFe(currentUrl);
      Array.from(__RATIONALIZE_YOUR_AWFUL_HACKJOB__.current.filtersToOmitFromUrl).forEach(function (filter) {
        if (urlFilters_1[filter]) {
          __RATIONALIZE_YOUR_AWFUL_HACKJOB__.current.filtersToOmitFromUrl.delete(filter);
        }
      });
      newCurrentFilters = _assign(_assign({}, filtersDefaultState), newCurrentFilters);
    }
    if (!(areLocationsFiltersSet || isGlobalSearchSet)) {
      if (currentLocation === null || currentLocation === void 0 ? void 0 : currentLocation.city) {
        newCurrentFilters.city = [currentLocation.city];
      }
      if (currentLocation === null || currentLocation === void 0 ? void 0 : currentLocation.state) {
        newCurrentFilters.state = [currentLocation.state];
      }
      if (currentLocation === null || currentLocation === void 0 ? void 0 : currentLocation.coordinates) {
        newCurrentFilters.geoLocation = [currentLocation.coordinates.latitude, currentLocation.coordinates.longitude];
      }
      __RATIONALIZE_YOUR_AWFUL_HACKJOB__.current.filtersToOmitFromUrl = new Set([]);
    }
    var processFiltersFunc = function processFiltersFunc() {
      return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
          return [2, processFilters(newCurrentFilters)];
        });
      });
    };
    processFiltersFunc();
  });
  var onFilterChange = function onFilterChange(newFilters) {
    logger$1.info('onFilterChange ', newFilters);
    __RATIONALIZE_YOUR_AWFUL_HACKJOB__.current.filtersToOmitFromUrl = new Set([]);
    if (newFilters === null || newFilters === void 0 ? void 0 : newFilters.nearbySearchRadius) {
      __RATIONALIZE_YOUR_AWFUL_HACKJOB__.current.nearbySearchRadius = true;
    }
    var locationFilterKeys = ['search', 'state', 'city', 'county', 'zip', 'globalSearch', 'geoLocation', 'mapBounds', 'useNearbySearch', 'nearbySearchRadius'];
    if (newFilters) {
      if (newFilters.mapBounds) {
        newFilters.search = '';
        newFilters.city = [];
        newFilters.state = [];
        newFilters.county = [];
        newFilters.geoLocation = [];
        newFilters.zip = [];
        newFilters.globalSearch = false;
      }
      if (newFilters.openedAssetId) {
        urlSearchParams.set('selectedListingId', newFilters.openedAssetId);
        var newUrlSearchParams = new URLSearchParams(urlSearchParams.toString());
        setUrlSearchParams(newUrlSearchParams);
      }
      processFilters(_assign(_assign({}, currentFilters), newFilters));
      trackFilterChanged(currentFilters, newFilters);
    } else {
      var newCurrentFilters = _assign(_assign({}, ___default.omit(filtersDefaultState, locationFilterKeys)), ___default.pick(currentFilters, locationFilterKeys));
      processFilters(newCurrentFilters);
      trackFilterChanged(currentFilters, newCurrentFilters);
    }
  };
  var onLocationSuggestionSelect = function onLocationSuggestionSelect(suggestion) {
    var newCurrentFilters = match(suggestion).with({
      type: 'currentLocation'
    }, function () {
      var city = suggestion.filters.property_city || (currentLocation === null || currentLocation === void 0 ? void 0 : currentLocation.city);
      var state = suggestion.filters.property_state || (currentLocation === null || currentLocation === void 0 ? void 0 : currentLocation.state);
      var geoLocation = suggestion.filters.geo_location || (currentLocation === null || currentLocation === void 0 ? void 0 : currentLocation.coordinates);
      var newCurrentFilters = {
        city: city ? [city] : [],
        state: state ? [state] : [],
        county: [],
        zip: [],
        geoLocation: geoLocation ? [geoLocation.latitude, geoLocation.longitude] : [],
        search: '',
        mapBounds: [],
        globalSearch: false
      };
      return _assign(_assign({}, currentFilters), newCurrentFilters);
    }).with({
      type: 'globalSearch'
    }, function () {
      var newCurrentFilters = {
        city: [],
        state: [],
        county: [],
        zip: [],
        geoLocation: [],
        search: '',
        mapBounds: [],
        globalSearch: 'y'
      };
      return _assign(_assign({}, currentFilters), newCurrentFilters);
    }).otherwise(function () {
      var _a;
      var geoLocation = ((_a = suggestion.filters.geo_location) === null || _a === void 0 ? void 0 : _a.split(',')) || [];
      var emptyLocationFilters = {
        city: [],
        state: [],
        county: [],
        zip: [],
        search: '',
        mapBounds: [],
        globalSearch: false,
        geoLocation: geoLocation
      };
      var currentFiltersWithResetLocationFilters = _assign(_assign({}, currentFilters), emptyLocationFilters);
      var newCurrentFilters = parseFiltersFromUrl(suggestion.link, currentFiltersWithResetLocationFilters);
      return newCurrentFilters;
    });
    __RATIONALIZE_YOUR_AWFUL_HACKJOB__.current.filtersToOmitFromUrl = new Set([]);
    processFilters(newCurrentFilters);
  };
  var data = {
    listings: listings,
    currentUiFilterGroups: currentUiFilterGroups,
    defaultUiFilterGroups: defaultUiFilterGroups,
    currentFilters: currentFilters,
    listingCompatabilityFilters: listingCompatabilityFilters,
    currentUrl: currentUrl,
    currentSearchId: currentSearchId,
    isLoading: isLoading,
    filtersData: filtersData
  };
  var actions = {
    onFilterChange: onFilterChange,
    onLocationSuggestionSelect: onLocationSuggestionSelect,
    filtersActions: filtersActions
  };
  return {
    data: data,
    actions: actions
  };
};

var MAX_DISPLAYABLE_SUGGESTIONS = 35;
var MAX_DISPLAYABLE_SUGGESTIONS_PER_TYPE = 7;
var locationTypePrecedenceList = ['state', 'city', 'zip', 'county', 'address'];
var isValidLocation = function isValidLocation(location) {
  if (location.city) {
    var isAirForceBase = location.city.toLowerCase().includes('afb') || location.city.toLowerCase().includes('air force base');
    return !isAirForceBase;
  }
  return true;
};
var enforceSuggestionCorrectness = function enforceSuggestionCorrectness(suggestion) {
  if (suggestion.type === 'zip') {
    delete suggestion.city;
    delete suggestion.county;
    delete suggestion.state;
  } else if (suggestion.type === 'city') {
    delete suggestion.county;
  }
  return suggestion;
};
var constructLinkFromFilters = function constructLinkFromFilters(filters) {
  var filtersModel = new FiltersModel(filters);
  return "/residential/".concat(filtersModel.apiToUrlValue);
};
var normalizeGraphType = function normalizeGraphType(location) {
  var filters = {
    version: 1,
    property_city: location.city || '',
    property_state: location.state || '',
    property_zip: location.zip || '',
    property_county: location.county || '',
    geo_location: location.coordinates ? [location.coordinates.lat, location.coordinates.lon].join(',') : null
  };
  var link = location.type === 'address' ? location.url : constructLinkFromFilters(filters);
  return {
    filters: filters,
    link: link || '/residential',
    icon: {
      name: location.type === 'address' ? 'house-chimney' : 'location-dot'
    },
    label: location.value || '',
    subLabel: location.type || '',
    category: location.type === 'address' ? 'Listings' : 'Places',
    hideSubLabelWhenCategorized: location.type === 'address',
    type: location.type || 'text'
  };
};
var normalizeGraphSaveSearchType = function normalizeGraphSaveSearchType(savedSearch) {
  var filters = savedSearch.parameters;
  return {
    filters: filters,
    link: constructLinkFromFilters(filters),
    label: savedSearch.saved_search_name || savedSearch.saved_search_id || '',
    icon: {
      name: 'heart'
    },
    subLabel: 'saved search',
    category: 'Saved Searches',
    hideSubLabelWhenCategorized: true,
    type: 'savedSearch'
  };
};
var normalizeStateType = function normalizeStateType(state) {
  var upperCaseStateValue = state.toUpperCase();
  var filters = {
    version: 1,
    property_state: state
  };
  return {
    filters: filters,
    link: constructLinkFromFilters(filters),
    label: upperCaseStateValue,
    icon: {
      name: 'location-dot'
    },
    subLabel: 'state',
    category: 'Places',
    hideSubLabelWhenCategorized: false,
    type: 'state'
  };
};
var normalizeGlobalSearch = function normalizeGlobalSearch() {
  var filters = {
    version: 1,
    global_search: 'y'
  };
  return {
    filters: filters,
    link: constructLinkFromFilters(filters),
    label: 'All Locations',
    category: 'Other',
    hideSubLabelWhenCategorized: false,
    subLabel: 'US',
    icon: {
      name: 'earth-americas'
    },
    type: 'globalSearch'
  };
};
var normalizeCurrentLocation = function normalizeCurrentLocation(currentLocation) {
  var filters = {
    version: 1,
    property_city: currentLocation.city || '',
    property_state: currentLocation.state || ''
  };
  return {
    filters: filters,
    link: constructLinkFromFilters(filters),
    label: 'Current Location',
    category: 'Other',
    hideSubLabelWhenCategorized: false,
    subLabel: currentLocation.city && currentLocation.state ? "".concat(currentLocation.city, ", ").concat(currentLocation.state) : '',
    icon: {
      name: 'location-arrow'
    },
    type: 'currentLocation'
  };
};
var normalizeLocationSuggestions = function normalizeLocationSuggestions(locations) {
  var suggestions = [];
  var validLocations = locations.filter(isValidLocation);
  var partitionedSuggestionTypes = ___default.groupBy(validLocations, 'type');
  var suggestionsRemaining = MAX_DISPLAYABLE_SUGGESTIONS;
  for (var _i = 0, locationTypePrecedenceList_1 = locationTypePrecedenceList; _i < locationTypePrecedenceList_1.length; _i++) {
    var typePriority = locationTypePrecedenceList_1[_i];
    if (!suggestionsRemaining) break;
    if (!partitionedSuggestionTypes[typePriority]) continue;
    var typeSample = partitionedSuggestionTypes[typePriority].slice(0, Math.min(MAX_DISPLAYABLE_SUGGESTIONS_PER_TYPE, suggestionsRemaining));
    suggestions.push.apply(suggestions, typeSample);
    suggestionsRemaining = suggestionsRemaining - typeSample.length;
  }
  return suggestions.map(enforceSuggestionCorrectness).map(normalizeGraphType);
};
var normalizeSearchTextEntryType = function normalizeSearchTextEntryType(searchText) {
  var filters = {
    version: 1,
    search: searchText
  };
  return {
    filters: filters,
    link: constructLinkFromFilters(filters),
    label: searchText,
    subLabel: 'text',
    category: 'Text Search',
    hideSubLabelWhenCategorized: true,
    type: 'text',
    icon: {
      name: 'input-text'
    }
  };
};
var normalizeRecentSearch = function normalizeRecentSearch(suggestion) {
  return _assign(_assign({}, suggestion), {
    subLabel: 'recent',
    category: 'Recent Searches',
    hideSubLabelWhenCategorized: false
  });
};

var lookupSuggestions = function lookupSuggestions(search) {
  return __awaiter(void 0, void 0, void 0, function () {
    var results;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (!search.length) return [2, {
            locationSuggestions: []
          }];
          return [4, fetchLocationSuggestions(search)];
        case 1:
          results = _a.sent();
          return [2, {
            locationSuggestions: normalizeLocationSuggestions(results.rawLocationSuggestions)
          }];
      }
    });
  });
};
var lookupSavedSearches = function lookupSavedSearches(controller) {
  return __awaiter(void 0, void 0, void 0, function () {
    var results;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4, fetchSavedSearches(controller)];
        case 1:
          results = _a.sent();
          return [2, results.rawSavedSearches.map(normalizeGraphSaveSearchType)];
      }
    });
  });
};

var SUGGESTIONS_CACHE_TTL = ms('20m');
ms('60s');

var UNIQUE_RECENT_SEARCHES_KEY = 'blueprint::recentSearches';
var TYPING_DEBOUNCE_MS = 300;
var cache = new LRUCache({
  max: 20,
  ttl: SUGGESTIONS_CACHE_TTL
});
function generateSearchInputFromFilters(filters) {
  if (___default.isNil(filters)) return '';
  return match(filters).when(function (filters) {
    return filters.search;
  }, function (filters) {
    return filters.search;
  }).when(function (filters) {
    return filters.global_search === 'y';
  }, function () {
    return 'All Locations';
  }).when(function (filters) {
    return filters.property_city && filters.property_state;
  }, function (filters) {
    return "".concat(filters.property_city, ", ").concat(filters.property_state);
  }).when(function (filters) {
    return filters.property_county && filters.property_state;
  }, function (filters) {
    return "".concat(filters.property_county, " County, ").concat(filters.property_state);
  }).when(function (filters) {
    return filters.property_state;
  }, function (filters) {
    return filters.property_state;
  }).when(function (filters) {
    return filters.property_zip;
  }, function (filters) {
    return filters.property_zip;
  }).otherwise(function () {
    return '';
  });
}
function useLocationSuggestions(_a) {
  var _this = this;
  var filters = _a.filters,
    currentLocation = _a.currentLocation,
    user = _a.user,
    includedSuggestionTypes = _a.includedSuggestionTypes,
    maxRecentSearches = _a.maxRecentSearches,
    deviceStorage = _a.deviceStorage,
    _b = _a.elmId,
    elmId = _b === void 0 ? '' : _b,
    graphWebsocket = _a.graphWebsocket;
  var includedSuggestionTypesMemo = useMemo(function () {
    return includedSuggestionTypes || ALL_SUGGESTION_TYPES.slice();
  }, [includedSuggestionTypes]);
  var _c = useState({
      suggestions: null,
      locationSuggestions: null,
      searchText: generateSearchInputFromFilters(filters),
      selectedSuggestion: null,
      filters: filters,
      loading: false
    }),
    state = _c[0],
    setState = _c[1];
  var isMounted = useIsMounted();
  var isIncludedSuggestionType = useCallback(function (suggestionType) {
    return includedSuggestionTypesMemo.includes(suggestionType);
  }, [includedSuggestionTypesMemo]);
  var savedSearches = useSavedSearches({
    enabled: Boolean(user === null || user === void 0 ? void 0 : user.logged_in) && isIncludedSuggestionType('savedSearch'),
    graphWebsocket: graphWebsocket
  })[0];
  var _d = useRecentSearches(maxRecentSearches, deviceStorage),
    recentSearches = _d[0],
    updateRecentSearches = _d[1];
  var hasInput = function hasInput(input) {
    return (input || '').length > 0;
  };
  var setLoading = useCallback(function (loading) {
    if (!isMounted) return;
    setState(function (prev) {
      return _assign(_assign({}, prev), {
        loading: loading
      });
    });
  }, [isMounted]);
  var pruneSuggestions = useCallback(function (suggestions) {
    if (___default.isEqual(includedSuggestionTypesMemo, ALL_SUGGESTION_TYPES)) return suggestions;
    return suggestions.filter(function (suggestion) {
      return isIncludedSuggestionType(suggestion.type);
    });
  }, [includedSuggestionTypesMemo, isIncludedSuggestionType]);
  useEffect(function () {
    var suggestions = [];
    if (state.searchText && hasInput(state.searchText)) {
      if (isIncludedSuggestionType('state') && geo.states.mapped.has(state.searchText.toUpperCase())) {
        suggestions.push(normalizeStateType(state.searchText));
      } else if (state.locationSuggestions) {
        suggestions.push.apply(suggestions, pruneSuggestions(state.locationSuggestions));
      }
    }
    if (isIncludedSuggestionType('text') && state.searchText && hasInput(state.searchText)) {
      suggestions.push(normalizeSearchTextEntryType(state.searchText));
    }
    if (isIncludedSuggestionType('currentLocation') && currentLocation) {
      suggestions.push(normalizeCurrentLocation(currentLocation));
    }
    if (!(state.searchText && hasInput(state.searchText)) && isIncludedSuggestionType('recentSearch') && recentSearches) {
      suggestions.push.apply(suggestions, recentSearches.map(function (suggestion) {
        return normalizeRecentSearch(suggestion);
      }));
    }
    if (isIncludedSuggestionType('globalSearch')) suggestions.push(normalizeGlobalSearch());
    if (isIncludedSuggestionType('savedSearch') && savedSearches) {
      suggestions.push.apply(suggestions, savedSearches);
    }
    setState(function (prev) {
      return _assign(_assign({}, prev), {
        suggestions: suggestions
      });
    });
  }, [currentLocation, isIncludedSuggestionType, pruneSuggestions, recentSearches, savedSearches, state.locationSuggestions, state.searchText]);
  var getSuggestions = useCallback(function (searchText) {
    return __awaiter(_this, void 0, void 0, function () {
      var cacheKey, cacheData_1, locationSuggestions_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            cacheKey = "".concat(searchText, "_").concat(elmId);
            if (!!___default.isNil(searchText)) return [3, 2];
            cacheData_1 = cache.get(cacheKey);
            if (!___default.isNil(cacheData_1)) {
              setState(function (prev) {
                return _assign(_assign({}, prev), {
                  locationSuggestions: (cacheData_1 === null || cacheData_1 === void 0 ? void 0 : cacheData_1.locationSuggestions) || []
                });
              });
              return [2];
            }
            setLoading(true);
            return [4, lookupSuggestions(searchText)];
          case 1:
            locationSuggestions_1 = _a.sent().locationSuggestions;
            cache.set(cacheKey, {
              locationSuggestions: locationSuggestions_1
            });
            if (!isMounted) return [2];
            setState(function (prev) {
              return _assign(_assign({}, prev), {
                locationSuggestions: locationSuggestions_1
              });
            });
            setLoading(false);
            _a.label = 2;
          case 2:
            return [2];
        }
      });
    });
  }, [isMounted, setLoading, elmId]);
  var debouncedGetSuggestions = useMemo(function () {
    return ___default.debounce(getSuggestions, TYPING_DEBOUNCE_MS);
  }, [getSuggestions]);
  var update = useCallback(function (_a) {
    var searchText = _a.searchText;
    return __awaiter(_this, void 0, void 0, function () {
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            setState(function (prev) {
              return _assign(_assign({}, prev), {
                searchText: searchText,
                selectedSuggestion: null
              });
            });
            return [4, debouncedGetSuggestions(searchText)];
          case 1:
            return [2, _b.sent()];
        }
      });
    });
  }, [debouncedGetSuggestions]);
  var trackSelectionChange = useCallback(function (suggestion) {
    setState(function (prev) {
      return _assign(_assign({}, prev), {
        selectedSuggestion: suggestion
      });
    });
  }, []);
  var autoSelectSuggestion = useCallback(function () {
    var _a;
    var nullSuggestion = {
      filters: {},
      link: '/residential',
      label: '',
      subLabel: '',
      category: 'Other',
      type: 'currentLocation',
      hideSubLabelWhenCategorized: false
    };
    if (!state.suggestions || ((_a = state.suggestions) === null || _a === void 0 ? void 0 : _a.length) === 0) {
      return nullSuggestion;
    }
    if (state.selectedSuggestion) {
      return state.selectedSuggestion;
    }
    if (!state.suggestions.find(function (suggestion) {
      return suggestion.category === SEARCH_SUGGESTION_GROUPS.textSearch;
    })) {
      return nullSuggestion;
    }
    return state.suggestions[0];
  }, [state.selectedSuggestion, state.suggestions]);
  useEffect(function () {
    var searchText = generateSearchInputFromFilters(filters);
    setState(function (prev) {
      return _assign(_assign({}, prev), {
        filters: filters,
        searchText: searchText
      });
    });
    update({
      searchText: searchText
    });
  }, [filters, update]);
  var actions = useMemo(function () {
    return {
      update: update,
      autoSelectSuggestion: autoSelectSuggestion,
      trackSelectionChange: trackSelectionChange,
      updateRecentSearches: updateRecentSearches
    };
  }, [autoSelectSuggestion, update, trackSelectionChange, updateRecentSearches]);
  var data = useMemo(function () {
    return {
      suggestions: state.suggestions,
      searchText: state.searchText,
      loading: state.loading
    };
  }, [state.suggestions, state.searchText, state.loading]);
  return {
    data: data,
    actions: actions
  };
}
var useRecentSearches = function useRecentSearches(maxRecentSearches, deviceStorage) {
  if (maxRecentSearches === void 0) {
    maxRecentSearches = 1;
  }
  if (deviceStorage === void 0) {
    deviceStorage = new DeviceStorageAdapter({
      storage: new NullDeviceStorage({
        namespace: 'recentSearch'
      })
    });
  }
  var initialValue = useMemo(function () {
    return [];
  }, []);
  var _a = useLocalStorage({
      key: UNIQUE_RECENT_SEARCHES_KEY,
      initialValue: initialValue,
      deviceStorage: deviceStorage
    }),
    recentSearches = _a[0],
    _setRecentSearches = _a[1];
  var updateRecentSearches = useCallback(function (suggestion) {
    return __awaiter(void 0, void 0, void 0, function () {
      var tags, newSuggestions, newRecentSearches;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            tags = ["type:".concat(suggestion.type)];
            savedSearchLogger.info("instrument increment suggestion_selection tags: ".concat(tags));
            blueprintInstrument.increment('suggestion_selection', 1, tags);
            if ((recentSearches === null || recentSearches === void 0 ? void 0 : recentSearches.length) && recentSearches.find(function (recentSearchesItem) {
              return recentSearchesItem.label === suggestion.label;
            })) {
              return [2];
            }
            if (!___default.without(ALL_SUGGESTION_TYPES, 'savedSearch', 'currentLocation', 'globalSearch').includes(suggestion.type)) return [3, 2];
            newSuggestions = [suggestion];
            newRecentSearches = (recentSearches === null || recentSearches === void 0 ? void 0 : recentSearches.length) >= maxRecentSearches ? newSuggestions.concat(recentSearches).slice(0, maxRecentSearches) : newSuggestions.concat(recentSearches);
            return [4, _setRecentSearches(newRecentSearches)];
          case 1:
            _a.sent();
            _a.label = 2;
          case 2:
            return [2];
        }
      });
    });
  }, [_setRecentSearches, maxRecentSearches, recentSearches]);
  return [recentSearches, updateRecentSearches];
};
var savedSearchLogger = coreLogger.forModule('blueprint:saved_search');
var useSavedSearchesSubscriptionHook = function useSavedSearchesSubscriptionHook(_a) {
  var graphWebsocket = _a.graphWebsocket,
    _b = _a.enabled,
    enabled = _b === void 0 ? true : _b;
  var closeCurrentOperation = useRef(null);
  var _c = useState(null),
    savedSearchMessage = _c[0],
    setSavedSearchMessage = _c[1];
  var isEnabled = graphWebsocket && enabled;
  useEffect(function () {
    if (isEnabled) {
      savedSearchLogger.info('subscribing');
      graphWebsocket.subscribe({
        operationOptions: {
          query: gql$1(templateObject_1$7 || (templateObject_1$7 = __makeTemplateObject(["\n              subscription blueprint_userSavedSearchUpdated {\n                savedSearchUpdated {\n                  action\n                  saved_search {\n                    saved_search_id\n                    saved_search_name\n                    parameters\n                    namespace\n                  }\n                }\n              }\n            "], ["\n              subscription blueprint_userSavedSearchUpdated {\n                savedSearchUpdated {\n                  action\n                  saved_search {\n                    saved_search_id\n                    saved_search_name\n                    parameters\n                    namespace\n                  }\n                }\n              }\n            "])))
        },
        onData: function onData(data) {
          savedSearchLogger.info('New data loaded', data);
          var savedSearchMessage = data.savedSearchUpdated;
          setSavedSearchMessage(savedSearchMessage);
        },
        onError: function onError(error) {
          savedSearchLogger.warn(error);
        }
      }).then(function (graphSubscriber) {
        closeCurrentOperation.current = graphSubscriber.unsubscribe;
        return true;
      }).catch(function (err) {
        return savedSearchLogger.warn(err);
      });
    }
    if (!isEnabled && typeof closeCurrentOperation.current === 'function') {
      savedSearchLogger.info('unsubscribing');
      closeCurrentOperation.current();
      setSavedSearchMessage(null);
      closeCurrentOperation.current = null;
    }
  }, [graphWebsocket, isEnabled]);
  useEffect(function () {
    return function () {
      var _a;
      savedSearchLogger.info('unsubscribing on unmount');
      (_a = closeCurrentOperation.current) === null || _a === void 0 ? void 0 : _a.call(closeCurrentOperation);
    };
  }, []);
  return savedSearchMessage;
};
var useSavedSearches = function useSavedSearches(_a) {
  var enabled = _a.enabled,
    graphWebsocket = _a.graphWebsocket;
  var _b = useState([]),
    savedSearches = _b[0],
    setSavedSearches = _b[1];
  useEffect(function () {
    if (!enabled) {
      savedSearches.length > 0 && setSavedSearches([]);
      return;
    }
    var fetchSavedSearches = function fetchSavedSearches() {
      return __awaiter(void 0, void 0, void 0, function () {
        var savedSearchSuggestions;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              if (savedSearches.length > 0) {
                return [2];
              }
              return [4, lookupSavedSearches()];
            case 1:
              savedSearchSuggestions = _a.sent();
              setSavedSearches(savedSearchSuggestions);
              return [2];
          }
        });
      });
    };
    fetchSavedSearches().catch(function (err) {
      return coreLogger.error(err);
    });
  }, [enabled, setSavedSearches, savedSearches.length]);
  var incomingSavedSearchMessage = useSavedSearchesSubscriptionHook({
    graphWebsocket: graphWebsocket,
    enabled: enabled && !configment.get('ENABLE_WEBSOCKET_KILL_SWITCH', false)
  });
  useEffect(function () {
    if (incomingSavedSearchMessage) {
      var action = incomingSavedSearchMessage.action,
        savedSearch_1 = incomingSavedSearchMessage.saved_search;
      action.toLowerCase() === 'create' && setSavedSearches(function (savedSearches) {
        var newSavedSearches = __spreadArray([normalizeGraphSaveSearchType(savedSearch_1)], savedSearches, true);
        return newSavedSearches.slice(0, MAX_SAVED_SEARCHES);
      });
    }
  }, [incomingSavedSearchMessage]);
  return [savedSearches];
};
var templateObject_1$7;

var hooks$3 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  generateSearchInputFromFilters: generateSearchInputFromFilters,
  useListingsSearch: useListingsSearch,
  useLocationSuggestions: useLocationSuggestions
});

var nonHighlightableRows = ['globalSearch', 'currentLocation', 'text'];
var findMatchingText = function findMatchingText(suggestion, searchText) {
  var label = suggestion.label,
    type = suggestion.type;
  var response = {
    type: 'highlight',
    key: searchText,
    offsets: []
  };
  if (nonHighlightableRows.includes(type)) {
    return response;
  }
  if (typeof searchText !== 'string' || searchText.length < 2) {
    return response;
  }
  var escapedSearchText = escapeRegExp(searchText);
  var regex = new RegExp("(".concat(escapedSearchText, ")"), 'gi');
  var match;
  while ((match = regex.exec(label)) !== null) {
    response.offsets.push([match.index, match.index + match[0].length]);
  }
  response.key = escapedSearchText;
  return response;
};
var getCategoryIcon = function getCategoryIcon(category) {
  return match(category).when(function (value) {
    return value === SEARCH_SUGGESTION_GROUPS.savedSearches;
  }, function () {
    return {
      name: 'heart'
    };
  }).when(function (value) {
    return value === SEARCH_SUGGESTION_GROUPS.textSearch;
  }, function () {
    return {
      name: 'input-text'
    };
  }).when(function (value) {
    return value === SEARCH_SUGGESTION_GROUPS.listings || value === SEARCH_SUGGESTION_GROUPS.recentSearch;
  }, function () {
    return {
      name: 'house-chimney'
    };
  }).otherwise(function () {
    return {
      name: 'location-dot'
    };
  });
};
var sortSuggestionsByCategory = function sortSuggestionsByCategory(suggestions) {
  var suggestionGroupOrder = Object.values(SEARCH_SUGGESTION_GROUPS);
  return suggestions.sort(function (a, b) {
    var indexA = suggestionGroupOrder.indexOf(a.category);
    var indexB = suggestionGroupOrder.indexOf(b.category);
    if (indexA !== -1 && indexB !== -1) {
      return indexA - indexB;
    }
    if (indexA !== -1) {
      return -1;
    }
    if (indexB !== -1) {
      return 1;
    }
    return 0;
  });
};
var getFormattedResultsWithCategories = function getFormattedResultsWithCategories(suggestions, formatResult) {
  if (suggestions === null) {
    return {};
  }
  var groupedSuggestions = {};
  var sortedSuggestions = sortSuggestionsByCategory(suggestions);
  sortedSuggestions.forEach(function (suggestion, index) {
    var category = suggestion.category;
    if (!groupedSuggestions[category]) {
      groupedSuggestions[category] = {
        name: category,
        results: [],
        icon: getCategoryIcon(category)
      };
    }
    groupedSuggestions[category].results.push(formatResult(suggestion, index));
  });
  return groupedSuggestions;
};
var getIsFilterSetChanged = function getIsFilterSetChanged(uiFilterGroup, defaultFilterGroup) {
  return !isEqual(defaultFilterGroup, uiFilterGroup);
};

var utils$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  assetTypeRouteConverter: assetTypeRouteConverter,
  findMatchingText: findMatchingText,
  getCategoryIcon: getCategoryIcon,
  getFormattedResultsWithCategories: getFormattedResultsWithCategories,
  getIsFilterSetChanged: getIsFilterSetChanged
});

var types$2 = /*#__PURE__*/Object.freeze({
  __proto__: null
});

var types$1 = /*#__PURE__*/Object.freeze({
  __proto__: null
});

Object.values(SEARCH_SUGGESTION_GROUPS);

var types = /*#__PURE__*/Object.freeze({
  __proto__: null,
  BuyerListingSearchTypes: types$2,
  UseListingsSearchTypes: types$1
});

var transformMarketingConfigToOptions = function transformMarketingConfigToOptions(marketingConfig) {
  return marketingConfig.sort(function (a, b) {
    return a.configuration.srp.order - b.configuration.srp.order;
  }).map(function (item) {
    var _a;
    return {
      value: item.tag.toLowerCase(),
      label: item.configuration.srp.label,
      tooltip: item.configuration.srp.is_tooltip_active && ((_a = item.configuration.srp.tooltip) === null || _a === void 0 ? void 0 : _a.length) ? item.configuration.srp.tooltip : null
    };
  });
};
var propertyFilter = new FilterBuilder('propertyType', 'multiSelect', 'string[]').label('Property').mode('checkboxButton').options([{
  value: ['single-family'],
  label: 'Single Family',
  icon: 'house'
}, {
  value: ['multi-family'],
  label: 'Multi Family',
  icon: 'apartment'
}, {
  value: ['condos-townhouses'],
  label: 'Condo, single unit',
  icon: 'arrow-right-to-city'
}, {
  value: ['land'],
  label: 'Land',
  icon: 'trees'
}]);
var propertyTypeFilterDefinition = new FilterGroupBuilder('propertyType', 'Property Type').items([propertyFilter.styleIntent({
  displayTitle: false
}).build()]).build();
var saleFormatFilter = new FilterBuilder('saleFormat', 'multiSelect', 'string[]').label('Sale Format').mode('checkboxButton').options([{
  value: ['online'],
  label: 'Online Auction',
  icon: 'desktop'
}, {
  value: ['in_person'],
  label: 'In Person Auction',
  icon: 'gavel'
}, {
  value: ['remote_bid'],
  label: 'Remote Bid',
  icon: 'mobile-signal-out'
}, {
  value: ['direct_offer'],
  label: 'Direct Offer',
  icon: 'messages-dollar'
}]);
var saleFormatFilterDefinition = new FilterGroupBuilder('saleFormat', 'Sale Format').items([saleFormatFilter.styleIntent({
  displayTitle: false
}).build()]).build();
var assetOptions = [{
  value: ['bank-owned', 'newly-foreclosed'],
  label: 'REO Bank Owned'
}, {
  value: ['foreclosures'],
  label: 'Foreclosure Homes'
}, {
  value: ['private-seller'],
  label: 'Private Seller'
}];
var getListingTypeFilter = function getListingTypeFilter(optionsDecorator) {
  var decoratedOptions = optionsDecorator ? optionsDecorator(assetOptions, 'listingType') : assetOptions;
  return new FilterBuilder('listingType', 'multiSelect', 'string[]').label('Listing Type').options(decoratedOptions);
};
var getListingTypeFilterDefinition = function getListingTypeFilterDefinition(optionsDecorator) {
  return new FilterGroupBuilder('listingType', 'Listing Type').items([getListingTypeFilter(optionsDecorator).styleIntent({
    displayTitle: false
  }).build()]).build();
};
var getOccupancyFilter = function getOccupancyFilter() {
  return new FilterBuilder('occupancy', 'multiSelect', 'string[]').label('Occupancy').labelIconProps({
    name: 'house-person-return'
  }).options([{
    value: ['tenant'],
    label: 'Tenant Occupied'
  }, {
    value: ['adv_occupied'],
    label: 'Adversely Occupied'
  }, {
    value: ['rentback'],
    label: 'Seller Rentback'
  }, {
    value: ['vacant'],
    label: 'Vacant'
  }, {
    value: ['vacant_at_closing'],
    label: 'Vacant at Closing'
  }]);
};
var occupancyFilterDefinition = new FilterGroupBuilder('occupancy', 'Occupancy').items([getOccupancyFilter().styleIntent({
  displayTitle: false
}).build()]).build();
var getMarketingTagFilterDefinition = function getMarketingTagFilterDefinition(marketingTagConfig) {
  return new FilterSectionBuilder('marketInsights').label('').filters([new FilterBuilder('marketingTag', 'multiSelect', 'string').label('Market Insights & Deal Signals').labelIconProps({
    name: 'chart-mixed'
  }).mode('chip').options(transformMarketingConfigToOptions(marketingTagConfig)).converterOverrides({
    toViewModelValue: function toViewModelValue(v) {
      if (typeof v === 'string') {
        return v.split(',');
      }
      return v ? [v.toString()] : [];
    },
    toAppModelValue: function toAppModelValue(v) {
      if (Array.isArray(v)) {
        return v.join(',');
      } else {
        return v;
      }
    }
  }).build()]).build();
};
var buyerAdvantagesSectionDefinition = new FilterSectionBuilder('buyerAdvantages').label('Buyer Advantages').labelIconProps({
  name: 'magnifying-glass-dollar'
}).styleIntent({
  showDivider: false,
  twoColumns: 'desktop-only'
}).filters([new FilterBuilder('listingType', 'boolean', 'string[]').label('Sold, Pending, or Canceled').converterOverrides({
  toViewModelValue: function toViewModelValue(v) {
    return arraysAreEqual(v, ['pending', 'closed', 'canceled']);
  },
  toAppModelValue: function toAppModelValue(v) {
    return v ? ['pending', 'closed', 'canceled'] : ['active'];
  }
}).build(), new FilterBuilder('brokerCoopAvailable', 'boolean', 'string').label('Broker Coop').converterOverrides({
  toViewModelValue: function toViewModelValue(v) {
    return v === 'y';
  },
  toAppModelValue: function toAppModelValue(v) {
    return v ? 'y' : null;
  }
}).build(), new FilterBuilder('showReserve', 'boolean', 'string').label('Reserve Disclosed').converterOverrides({
  toViewModelValue: function toViewModelValue(v) {
    return v === 'y';
  },
  toAppModelValue: function toAppModelValue(v) {
    return v ? 'y' : null;
  }
}).build(), new FilterBuilder('noBuyerPremiumFilter', 'boolean', 'string').label("No Buyer's Premium").converterOverrides({
  toViewModelValue: function toViewModelValue(v) {
    return v === 'n';
  },
  toAppModelValue: function toAppModelValue(v) {
    return v ? 'n' : null;
  }
}).build(), new FilterBuilder('presale', 'boolean', 'string').label('First Look').description('Learn more (TBD LINK HERE)').converterOverrides({
  toViewModelValue: function toViewModelValue(v) {
    return v === 'y';
  },
  toAppModelValue: function toAppModelValue(v) {
    return v ? 'y' : null;
  }
}).build()]).build();
var getMoreFiltersDefinition = function getMoreFiltersDefinition(config) {
  return new FilterGroupBuilder('moreFilters', 'Filters').styleIntent({
    displayType: 'drawer'
  }).labelIconProps({
    name: 'sliders'
  }).items(__spreadArray(__spreadArray([new FilterSectionBuilder('propertySection').label('').filters([propertyFilter.build(), new FilterBuilder('beds', 'inlineSelect', 'number').label('Beds').mode('range').options([{
    value: '0',
    label: 'Studio'
  }, {
    value: '1',
    label: '1'
  }, {
    value: '2',
    label: '2'
  }, {
    value: '3',
    label: '3'
  }, {
    value: '4',
    label: '4'
  }, {
    value: '5',
    label: '5+'
  }]).build(), new FilterBuilder('baths', 'inlineSelect', 'number').label('Baths').mode('single').options([{
    value: '1',
    label: '1+'
  }, {
    value: '1.5',
    label: '1.5+'
  }, {
    value: '2',
    label: '2+'
  }, {
    value: '2.5',
    label: '2.5+'
  }, {
    value: '3',
    label: '3+'
  }, {
    value: '4',
    label: '4+'
  }]).build(), new FilterBuilder('sqft', 'range', 'number').label('Square Footage').styleIntent({
    width: 'half'
  }).shortLabel('Sqft').mode('select').range({
    optionList: [500, 750, 1000, 1100, 1200, 1300, 1400, 1500, 1600, 1700, 1800, 1900, 2000, 2500, 3000, 4000, 5000]
  }).build(), new FilterBuilder('price', 'range', 'number').label('Price Range').styleIntent({
    width: 'half'
  }).mode('select').shortLabel('Price').range({
    optionList: [50000, 100000, 200000, 300000, 400000, 500000, 600000, 700000, 800000, 900000, 1000000]
  }).build()]).build(), new FilterSectionBuilder('listingSection').label('').filters([saleFormatFilter.build(), getListingTypeFilter(config === null || config === void 0 ? void 0 : config.optionsDecorator).styleIntent({
    twoColumns: 'desktop-only'
  }).build()]).build(), getOccupancyFilter().styleIntent({
    compact: true,
    twoColumns: 'desktop-only'
  }).build(), buyerAdvantagesSectionDefinition], (config === null || config === void 0 ? void 0 : config.marketingTagConfig) ? [getMarketingTagFilterDefinition(config.marketingTagConfig)] : [], true), [new FilterSectionBuilder('listingStatus').label('').styleIntent({
    twoColumns: 'all',
    showDivider: false
  }).filters([new FilterBuilder('status', 'multiSelect', 'string[]').label('Status').labelIconProps({
    name: 'house-circle-check'
  }).styleIntent({
    width: 'half'
  }).options([{
    value: ['for-sale'],
    label: 'For Sale',
    description: '(Offer only)'
  }, {
    value: ['in-progress'],
    label: 'Auction in Progress'
  }, {
    value: ['clear'],
    label: 'Cleared Sale'
  }, {
    value: ['pending'],
    label: 'Pending Sale'
  }, {
    value: ['closed'],
    label: 'Completed Sale'
  }]).build(), new FilterBuilder('time', 'singleSelect', 'string').label('Time on Auction.com').labelIconProps({
    name: 'clock'
  }).styleIntent({
    width: 'half'
  }).options([{
    value: null,
    label: 'No Max'
  }, {
    value: 1,
    label: 'Less than 7 days'
  }, {
    value: 2,
    label: '7-30 days'
  }, {
    value: 3,
    label: '30-90 days'
  }, {
    value: 4,
    label: 'More than 90 days'
  }]).build()]).build()], false)).build();
};
var definitionGenerator = function definitionGenerator(config) {
  return (config === null || config === void 0 ? void 0 : config.isMobile) ? [getMoreFiltersDefinition(config)] : [propertyTypeFilterDefinition, saleFormatFilterDefinition, getListingTypeFilterDefinition(config === null || config === void 0 ? void 0 : config.optionsDecorator), occupancyFilterDefinition, getMoreFiltersDefinition(config)];
};

var index$8 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  definitionGenerator: definitionGenerator$1,
  getAssetType: getAssetType,
  newDefinitionGenerator: definitionGenerator
});

var providers$5 = {
  lookupLocation: lookupLocation,
  fetchMarketingTagConfig: fetchMarketingTagConfig,
  fetchLocationSuggestions: fetchLocationSuggestions
};

var index$7 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  buyerListingSearchFilters: index$8,
  constants: constants,
  hooks: hooks$3,
  providers: providers$5,
  types: types,
  utils: utils$2
});

var deviceStorageKey = 'blueprint::nudges';
var defautConfig = {
  purchase_profiles: '2d',
  investor_preferences: '1w',
  sms_opt_in: '1w',
  authentication_prompt: '2w',
  feedback_button_prompt: '90d'
};
var useApplicationNudges = function useApplicationNudges(_a) {
  var _b = _a.config,
    config = _b === void 0 ? defautConfig : _b,
    _c = _a.deviceStorage,
    deviceStorage = _c === void 0 ? new DeviceStorageAdapter({
      storage: new NullDeviceStorage({
        namespace: 'nudges'
      })
    }) : _c;
  var _d = useState({
      active: new Set(),
      inactive: new Set()
    }),
    nudgeData = _d[0],
    setNudgeData = _d[1];
  var initialStorageNudgeData = useMemo(function () {
    return {
      sms_opt_in: null,
      purchase_profiles: null,
      investor_preferences: null,
      authentication_prompt: null,
      feedback_button_prompt: null
    };
  }, []);
  var getConfigValue = useCallback(function (key) {
    return (config === null || config === void 0 ? void 0 : config[key]) || defautConfig[key];
  }, [config]);
  var _e = useLocalStorage({
      key: deviceStorageKey,
      initialValue: initialStorageNudgeData,
      deviceStorage: deviceStorage
    }),
    storageNudgeData = _e[0],
    _setStorageNudgeData = _e[1];
  var isExpired = useCallback(function (lastNudge, key) {
    if (typeof lastNudge === 'undefined') {
      return true;
    }
    var currentDate = new Date();
    var calculatedNextNudge = new Date(lastNudge);
    calculatedNextNudge.setMilliseconds(calculatedNextNudge.getMilliseconds() + ms(getConfigValue(key)));
    return currentDate > calculatedNextNudge;
  }, [getConfigValue]);
  var getNudgeNextPeriodInMS = useCallback(function (entryKey) {
    return getConfigValue(entryKey);
  }, [getConfigValue]);
  var calculateNudgeData = useCallback(function (storageData) {
    var out = {
      active: new Set([]),
      inactive: new Set([])
    };
    if (!___default.isNil(storageData)) {
      var storageEntries = Object.entries(storageData);
      storageEntries.forEach(function (_a) {
        var key = _a[0],
          item = _a[1];
        if (isExpired(item === null || item === void 0 ? void 0 : item.lastNudgedAt, key)) {
          out.active.add(key);
        } else {
          out.inactive.add(key);
        }
      });
    }
    return out;
  }, [isExpired]);
  useEffect(function () {
    setNudgeData(calculateNudgeData(storageNudgeData));
  }, [calculateNudgeData, storageNudgeData]);
  var nudge = useCallback(function (entryKey) {
    return __awaiter(void 0, void 0, void 0, function () {
      var nextReminder, additionalTime, newStorageNudgeData;
      var _a;
      var _b;
      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            if (!isExpired((_b = storageNudgeData === null || storageNudgeData === void 0 ? void 0 : storageNudgeData[entryKey]) === null || _b === void 0 ? void 0 : _b.lastNudgedAt, entryKey)) {
              return [2];
            }
            nextReminder = new Date();
            additionalTime = ms(getNudgeNextPeriodInMS(entryKey));
            nextReminder.setMilliseconds(nextReminder.getMilliseconds() + additionalTime);
            newStorageNudgeData = _assign(_assign({}, storageNudgeData), (_a = {}, _a[entryKey] = {
              lastNudgedAt: new Date().toISOString(),
              nextNudgeScheduledAt: nextReminder.toISOString()
            }, _a));
            setNudgeData(calculateNudgeData(storageNudgeData));
            return [4, _setStorageNudgeData(newStorageNudgeData)];
          case 1:
            _c.sent();
            return [2];
        }
      });
    });
  }, [storageNudgeData, _setStorageNudgeData, getNudgeNextPeriodInMS, calculateNudgeData, isExpired, setNudgeData]);
  var getRemainingTime = useCallback(function (entryKey) {
    var _a;
    var currentDate = new Date();
    var nextNudgeScheduled = (_a = storageNudgeData[entryKey]) === null || _a === void 0 ? void 0 : _a.nextNudgeScheduledAt;
    var nextNudgeDate = nextNudgeScheduled ? new Date(nextNudgeScheduled) : new Date();
    return nextNudgeDate.getTime() - currentDate.getTime();
  }, [storageNudgeData]);
  return {
    data: nudgeData,
    actions: {
      nudge: nudge,
      getRemainingTime: getRemainingTime
    }
  };
};

var index$6 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  useApplicationNudges: useApplicationNudges
});

var updateOptInInformation = function updateOptInInformation(variables) {
  return fetch__default.forAuctionGraph({
    query: gql(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject(["\n        mutation ", "($phone: String!, $isOptIn: Boolean!){\n          updateVerifiedPhoneOptIn(phone: $phone, isOptIn: $isOptIn)\n        }\n     "], ["\n        mutation ", "($phone: String!, $isOptIn: Boolean!){\n          updateVerifiedPhoneOptIn(phone: $phone, isOptIn: $isOptIn)\n        }\n     "])), embeddableOperation('blueprint_updateVerifiedPhone')),
    variables: variables
  }).then(function (_a) {
    var body = _a.body;
    if (body.errors && body.errors[0]) {
      throw body.errors[0];
    }
    return body.data.updateVerifiedPhoneOptIn;
  });
};
var getUserMarketingMilestones = function getUserMarketingMilestones() {
  return fetch__default.forAuctionGraph({
    query: gql(templateObject_2$4 || (templateObject_2$4 = __makeTemplateObject(["\n        query ", "{\n          current_user {\n            marketing_milestones {\n              survey_feedback_submitted_date\n            }\n          }\n        }\n      "], ["\n        query ", "{\n          current_user {\n            marketing_milestones {\n              survey_feedback_submitted_date\n            }\n          }\n        }\n      "])), embeddableOperation('getUserMarketingMilestones'))
  }).then(function (_a) {
    var body = _a.body;
    return body.data.current_user;
  });
};
var setUserMarketingMilestones = function setUserMarketingMilestones() {
  return fetch__default.forAuctionGraph({
    query: "\n        mutation ".concat(embeddableOperation('blueprint_upsertUserMarketingMilestones'), " {\n          upsertUserMarketingMilestones {\n            survey_feedback_submitted_date\n          }\n        }\n      ")
  }).then(function (_a) {
    var body = _a.body;
    return body.data.current_user;
  });
};
var SavePropertyError = function (_super) {
  __extends(SavePropertyError, _super);
  function SavePropertyError() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  return SavePropertyError;
}(Error);
var saveProperty = function saveProperty(propertyId) {
  return fetch__default.forAuctionGraph({
    query: gql(templateObject_3$1 || (templateObject_3$1 = __makeTemplateObject(["\n    mutation ", "($input: SavePropertyInput!) {\n      saveProperty(input: $input)\n    }\n  "], ["\n    mutation ", "($input: SavePropertyInput!) {\n      saveProperty(input: $input)\n    }\n  "])), embeddableOperation('blueprint_saveProperty')),
    variables: {
      input: {
        property_id: propertyId
      }
    }
  }).then(function (res) {
    if (res.body.errors) {
      throw new SavePropertyError();
    }
    return {
      status: 'success'
    };
  });
};
var deleteSavedProperty = function deleteSavedProperty(propertyId) {
  return fetch__default.forAuctionGraph({
    query: gql(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    mutation ", "($input: DeleteSavedPropertyInput!) {\n      deleteSavedProperty(input: $input)\n    }\n  "], ["\n    mutation ", "($input: DeleteSavedPropertyInput!) {\n      deleteSavedProperty(input: $input)\n    }\n  "])), embeddableOperation('blueprint_deleteSavedProperty')),
    variables: {
      input: {
        property_id: propertyId
      }
    }
  }).then(function (res) {
    if (res.body.errors) {
      throw new SavePropertyError();
    }
    return {
      status: 'success'
    };
  });
};
var templateObject_1$6, templateObject_2$4, templateObject_3$1, templateObject_4;

var providers$4 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  deleteSavedProperty: deleteSavedProperty,
  getUserMarketingMilestones: getUserMarketingMilestones,
  saveProperty: saveProperty,
  setUserMarketingMilestones: setUserMarketingMilestones,
  updateOptInInformation: updateOptInInformation
});

var useSavedProperties = function useSavedProperties(_a) {
  var initialData = _a.initialData;
  var savedInitialData = useMemo(function () {
    return initialData.map(function (property) {
      return _assign(_assign({}, property), {
        saved_at: new Date()
      });
    });
  }, [initialData]);
  var _b = useIdempotentBlueprintCollection(savedInitialData, {
      primaryKey: 'property_id',
      updateBehavior: 'merge',
      idempotencyKey: 'saved_at'
    }),
    savedProperties = _b.collection,
    attemptSavedPropertiesWrite = _b.attemptWrite;
  var updateSaveProperty = function updateSaveProperty(propertyId, value) {
    return __awaiter(void 0, void 0, void 0, function () {
      var action;
      return __generator(this, function (_a) {
        action = value ? saveProperty : deleteSavedProperty;
        return [2, action(propertyId).then(function (r) {
          attemptSavedPropertiesWrite({
            data: [{
              property_id: propertyId,
              is_currently_saved: value,
              saved_at: new Date()
            }],
            source: 'local_optimistic_action'
          });
          return r;
        })];
      });
    });
  };
  return {
    data: {
      savedProperties: savedProperties
    },
    actions: {
      updateSaveProperty: updateSaveProperty
    }
  };
};

var hooks$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  useSavedProperties: useSavedProperties
});

var index$5 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  hooks: hooks$2,
  providers: providers$4
});

var partialGraphErrorFactory = function partialGraphErrorFactory(message, errors) {
  var e = new Error(message);
  e.errors = errors;
  return e;
};
var getUserTrusteePurchaseProfiles = function getUserTrusteePurchaseProfiles(controller) {
  return fetch.forAuctionGraph({
    query: "query ".concat(embeddableOperation('blueprint_trusteePurchaseProfiles'), " {\n          current_user {\n            purchase_profiles(filters:{ productTypes: [TRUSTEE] }) {\n              ... on TrusteePurchaseProfile {\n                purchase_profile_id\n                profile_name\n                is_default\n                updated_date\n              }\n            }\n          }\n        }")
  }, {
    controller: controller
  }).then(function (res) {
    return res.body;
  }).then(function (_a) {
    var data = _a.data,
      errors = _a.errors;
    if (data === null || data.current_user.purchase_profiles === null) {
      throw partialGraphErrorFactory('Could not fetch current user', errors);
    }
    return data.current_user.purchase_profiles;
  });
};
var getUserReoPurchaseProfiles = function getUserReoPurchaseProfiles(controller) {
  return fetch.forAuctionGraph({
    query: "query ".concat(embeddableOperation('blueprint_reoPurchaseProfiles'), " {\n          current_user {\n            purchase_profiles(filters:{ productTypes: [REO, DAY_1_REO] }) {\n              ... on ReoPurchaseProfile {\n                offer_template_id\n                percent_complete\n                template_name\n              }\n            }\n          }\n        }")
  }, {
    controller: controller
  }).then(function (res) {
    return res.body;
  }).then(function (_a) {
    var data = _a.data,
      errors = _a.errors;
    if (data === null || data.current_user.purchase_profiles === null) {
      throw partialGraphErrorFactory('Could not fetch current user', errors);
    }
    return data.current_user.purchase_profiles;
  });
};
var TRUSTEE_PURCHASE_PROFILE_FRAGMENT = "\n  fragment TrusteePurchaseProfileFragment on TrusteePurchaseProfile {\n    purchase_profile_id\n    profile_name\n    is_default\n    updated_date\n  }\n";
var getTrusteePurchaseProfilesFromPartyId = function getTrusteePurchaseProfilesFromPartyId(partyId, controller) {
  return fetch.forAuctionGraph({
    variables: {
      partyId: partyId
    },
    query: "query ".concat(embeddableOperation('blueprint_trusteePurchaseProfilesFromPartyId'), "($partyId: ID!) {\n          user_from_party(partyId: $partyId) {\n            purchase_profiles(filters:{ productTypes: [TRUSTEE] }) {\n              ...TrusteePurchaseProfileFragment\n            }\n          }\n        }\n        ").concat(TRUSTEE_PURCHASE_PROFILE_FRAGMENT)
  }, {
    controller: controller
  }).then(function (res) {
    return res.body;
  }).then(function (_a) {
    var data = _a.data,
      errors = _a.errors;
    if (data === null || data.user_from_party.purchase_profiles === null) {
      throw partialGraphErrorFactory('Could not fetch user', errors);
    }
    return data.user_from_party.purchase_profiles;
  });
};
var trusteeProfileSubscriptionQuery = function trusteeProfileSubscriptionQuery() {
  return gql$1(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject(["subscription ", " {\n      trusteePurchaseProfileUpdated {\n        action\n        trustee_purchase_profile {\n          ...TrusteePurchaseProfileFragment\n        }\n      }\n    },\n    ", ""], ["subscription ", " {\n      trusteePurchaseProfileUpdated {\n        action\n        trustee_purchase_profile {\n          ...TrusteePurchaseProfileFragment\n        }\n      }\n    },\n    ", ""])), embeddableOperation('blueprint_trusteePurchaseProfileUpdated'), TRUSTEE_PURCHASE_PROFILE_FRAGMENT);
};
var trusteeProfileWithFilterSubscriptionQuery = function trusteeProfileWithFilterSubscriptionQuery() {
  return gql$1(templateObject_2$3 || (templateObject_2$3 = __makeTemplateObject(["subscription ", "($partyIds: [ID!]!) {\n      trusteePurchaseProfileUpdated(filters: { partyIds: $partyIds }) {\n        action\n        trustee_purchase_profile {\n          ...TrusteePurchaseProfileFragment\n        }\n      }\n    },\n    ", ""], ["subscription ", "($partyIds: [ID!]!) {\n      trusteePurchaseProfileUpdated(filters: { partyIds: $partyIds }) {\n        action\n        trustee_purchase_profile {\n          ...TrusteePurchaseProfileFragment\n        }\n      }\n    },\n    ", ""])), embeddableOperation('blueprint_trusteePurchaseProfileUpdated'), TRUSTEE_PURCHASE_PROFILE_FRAGMENT);
};
var templateObject_1$5, templateObject_2$3;

var providers$3 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getTrusteePurchaseProfilesFromPartyId: getTrusteePurchaseProfilesFromPartyId,
  getUserReoPurchaseProfiles: getUserReoPurchaseProfiles,
  getUserTrusteePurchaseProfiles: getUserTrusteePurchaseProfiles,
  trusteeProfileSubscriptionQuery: trusteeProfileSubscriptionQuery,
  trusteeProfileWithFilterSubscriptionQuery: trusteeProfileWithFilterSubscriptionQuery
});

var USER_INFO_POLLING_FREQUENCY = ms('30s');

var logger = coreLogger.forModule('blueprint:purchaseProfiles');
function useForeclosurePurchaseProfiles(_a) {
  var enabled = _a.enabled,
    initialData = _a.initialData,
    graphWebsocket = _a.graphWebsocket;
  if (!enabled) {
    return initialData.user.purchase_profiles || [];
  }
  var _b = useState((initialData.user.purchase_profiles || []).filter(function (profile) {
      return profile !== null && profile.__typename === 'TrusteePurchaseProfile';
    })),
    purchaseProfiles = _b[0],
    setPurchaseProfiles = _b[1];
  useRealtimeWatcher({
    id: 'useForeclosurePurchaseProfiles_TrusteePurchaseProfile',
    subjectIds: [typeof initialData.user.user_id === 'string' ? initialData.user.user_id : 'user_id'],
    polling: {
      enabled: true,
      frequency: USER_INFO_POLLING_FREQUENCY,
      executor: function executor(_a) {
        var controller = _a.controller;
        return getUserTrusteePurchaseProfiles(controller);
      }
    },
    websocket: {
      graphWebsocket: graphWebsocket,
      enabled: !configment.get('ENABLE_WEBSOCKET_KILL_SWITCH', false),
      executor: function executor() {
        return {
          query: gql$1(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject(["\n          subscription ", " {\n            trusteePurchaseProfileUpdated {\n              action\n              trustee_purchase_profile {\n                purchase_profile_id\n                profile_name\n                is_default\n              }\n            }\n          }\n        "], ["\n          subscription ", " {\n            trusteePurchaseProfileUpdated {\n              action\n              trustee_purchase_profile {\n                purchase_profile_id\n                profile_name\n                is_default\n              }\n            }\n          }\n        "])), embeddableOperation('blueprint_trusteePurchaseProfileUpdated'))
        };
      },
      dataExtractor: function dataExtractor(data) {
        return [data.trusteePurchaseProfileUpdated];
      }
    },
    onData: function onData(_a) {
      var data = _a.data,
        source = _a.source;
      logger.info("New data loaded. source=".concat(source), data);
      if (source === 'polling') {
        setPurchaseProfiles(data);
      }
      if (source === 'websocket') {
        var purchaseProfileData = data[0];
        var action = purchaseProfileData.action;
        var purchaseProfile_1 = purchaseProfileData.trustee_purchase_profile;
        switch (action) {
          case 'DELETE':
            return setPurchaseProfiles(function (purchaseProfiles) {
              return purchaseProfiles.filter(function (p) {
                return p.purchase_profile_id !== purchaseProfile_1.purchase_profile_id;
              });
            });
          case 'CREATE':
            return setPurchaseProfiles(function (purchaseProfiles) {
              return __spreadArray(__spreadArray([], purchaseProfiles, true), [purchaseProfile_1], false);
            });
          case 'UPDATE':
            return setPurchaseProfiles(function (purchaseProfiles) {
              return purchaseProfiles.map(function (p) {
                return p.purchase_profile_id === purchaseProfile_1.purchase_profile_id ? ___default.merge({}, p, purchaseProfile_1) : p;
              });
            });
        }
      }
    },
    onError: function onError(error) {
      logger.error('Realtime watcher error', error);
    },
    onEvent: function onEvent(event, ctx) {
      logger.info('Have event', event, ctx);
    }
  });
  return purchaseProfiles;
}
function useReoPurchaseProfiles(_a) {
  var enabled = _a.enabled,
    initialData = _a.initialData,
    graphWebsocket = _a.graphWebsocket;
  if (!enabled) {
    return initialData.user.purchase_profiles || [];
  }
  var _b = useState((initialData.user.purchase_profiles || []).filter(function (profile) {
      return profile !== null && profile.__typename === 'ReoPurchaseProfile';
    })),
    purchaseProfiles = _b[0],
    setPurchaseProfiles = _b[1];
  useRealtimeWatcher({
    id: 'useReoPurchaseProfiles_reoPurchaseProfile',
    subjectIds: [typeof initialData.user.user_id === 'string' ? initialData.user.user_id : 'user_id'],
    polling: {
      enabled: true,
      frequency: USER_INFO_POLLING_FREQUENCY,
      executor: function executor(_a) {
        var controller = _a.controller;
        return getUserReoPurchaseProfiles(controller);
      }
    },
    websocket: {
      graphWebsocket: graphWebsocket,
      enabled: !configment.get('ENABLE_WEBSOCKET_KILL_SWITCH', false),
      executor: function executor() {
        return {
          query: gql$1(templateObject_2$2 || (templateObject_2$2 = __makeTemplateObject(["\n          subscription ", " {\n            reoPurchaseProfileUpdated {\n              action\n              reo_purchase_profile {\n                offer_template_id\n                percent_complete\n                template_name\n              }\n            }\n          }\n        "], ["\n          subscription ", " {\n            reoPurchaseProfileUpdated {\n              action\n              reo_purchase_profile {\n                offer_template_id\n                percent_complete\n                template_name\n              }\n            }\n          }\n        "])), embeddableOperation('blueprint_reoPurchaseProfileUpdated'))
        };
      },
      dataExtractor: function dataExtractor(data) {
        return [data.reoPurchaseProfileUpdated];
      }
    },
    onData: function onData(_a) {
      var data = _a.data,
        source = _a.source;
      logger.info("New data loaded. source=".concat(source), data);
      if (source === 'polling') {
        setPurchaseProfiles(data);
      }
      if (source === 'websocket') {
        var purchaseProfileData = data[0];
        var action = purchaseProfileData.action;
        var purchaseProfile_2 = purchaseProfileData.reo_purchase_profile;
        switch (action) {
          case 'DELETE':
            return setPurchaseProfiles(function (purchaseProfiles) {
              return purchaseProfiles.filter(function (p) {
                return p.offer_template_id !== purchaseProfile_2.offer_template_id;
              });
            });
          case 'CREATE':
            return setPurchaseProfiles(function (purchaseProfiles) {
              return __spreadArray(__spreadArray([], purchaseProfiles, true), [purchaseProfile_2], false);
            });
          case 'UPDATE':
            return setPurchaseProfiles(function (purchaseProfiles) {
              return purchaseProfiles.map(function (p) {
                return p.offer_template_id === purchaseProfile_2.offer_template_id ? ___default.merge({}, p, purchaseProfile_2) : p;
              });
            });
        }
      }
    },
    onError: function onError(error) {
      logger.error('Realtime watcher error', error);
    },
    onEvent: function onEvent(event, ctx) {
      logger.info('Have event', event, ctx);
    }
  });
  return purchaseProfiles;
}
function useTrusteePurchaseProfiles(_a) {
  var enabled = _a.enabled,
    initialData = _a.initialData,
    graphWebsocket = _a.graphWebsocket;
  var _b = useIdempotentBlueprintCollection([], {
      primaryKey: 'purchase_profile_id',
      idempotencyKey: 'updated_date',
      updateBehavior: 'merge'
    }),
    attemptWrite = _b.attemptWrite,
    idempotentProfiles = _b.collection;
  var data = useMemo(function () {
    return {
      profiles: idempotentProfiles
    };
  }, [idempotentProfiles]);
  var output = useMemo(function () {
    return {
      data: data
    };
  }, [data]);
  if (!enabled) {
    return output;
  }
  var result = match(initialData).with({
    partyIds: [P.string]
  }, function (_a) {
    var partyIds = _a.partyIds;
    return {
      isSuperUser: true,
      partyIds: partyIds
    };
  }).with({
    user: {
      party_id: P.string
    }
  }, function (_a) {
    var user = _a.user;
    return {
      isSuperUser: false,
      partyIds: [user.party_id]
    };
  }).otherwise(function () {
    return null;
  });
  if (result === null) {
    return output;
  }
  useRealtimeWatcher({
    id: 'useTrusteePurchaseProfiles_TrusteePurchaseProfile',
    subjectIds: result.partyIds,
    polling: {
      enabled: enabled,
      frequency: USER_INFO_POLLING_FREQUENCY,
      executor: function executor(_a) {
        var controller = _a.controller;
        return result.isSuperUser ? getTrusteePurchaseProfilesFromPartyId(result.partyIds[0], controller) : getUserTrusteePurchaseProfiles(controller);
      }
    },
    websocket: {
      graphWebsocket: graphWebsocket,
      enabled: !configment.get('ENABLE_WEBSOCKET_KILL_SWITCH', false),
      executor: function executor() {
        return {
          query: result.isSuperUser ? trusteeProfileWithFilterSubscriptionQuery() : trusteeProfileSubscriptionQuery(),
          variables: {
            partyIds: result.partyIds
          }
        };
      },
      dataExtractor: function dataExtractor(data) {
        return [data.trusteePurchaseProfileUpdated];
      }
    },
    onData: function onData(payload) {
      var data = payload.data,
        source = payload.source;
      var profiles = [];
      logger.info("New data loaded. source=".concat(source), data);
      if (source === 'polling') {
        profiles = data;
        attemptWrite({
          data: profiles,
          source: source
        });
      }
      if (source === 'websocket') {
        var purchaseProfileData = data[0];
        var action = purchaseProfileData.action;
        var purchaseProfile_3 = purchaseProfileData.trustee_purchase_profile;
        var profiles_1 = match(action).with('DELETE', function () {
          return idempotentProfiles.raw.filter(function (p) {
            return p.purchase_profile_id !== purchaseProfile_3.purchase_profile_id;
          });
        }).with('CREATE', function () {
          return __spreadArray(__spreadArray([], idempotentProfiles.raw, true), [purchaseProfile_3], false);
        }).with('UPDATE', function () {
          return idempotentProfiles.raw.map(function (p) {
            return p.purchase_profile_id === purchaseProfile_3.purchase_profile_id ? ___default.merge({}, p, purchaseProfile_3) : p;
          });
        }).exhaustive();
        attemptWrite({
          data: profiles_1,
          source: source
        });
      }
    },
    onError: function onError(error) {
      logger.error('Realtime watcher error', error);
    },
    onEvent: function onEvent(event, ctx) {
      logger.info('Have event', event, ctx);
    }
  });
  return output;
}
var templateObject_1$4, templateObject_2$2;

var hooks$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  useForeclosurePurchaseProfiles: useForeclosurePurchaseProfiles,
  useReoPurchaseProfiles: useReoPurchaseProfiles,
  useTrusteePurchaseProfiles: useTrusteePurchaseProfiles
});

var checkHasACompleteProfile = function checkHasACompleteProfile(purchaseProfileResponse) {
  return ___default.some(purchaseProfileResponse, function (profile) {
    return profile.percent_complete === 100;
  });
};

var utils$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  checkHasACompleteProfile: checkHasACompleteProfile
});

var index$4 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  hooks: hooks$1,
  providers: providers$3,
  utils: utils$1
});

var creditTypes = [graph.enums.TransactionType.Credit, graph.enums.TransactionType.PendingCredit];
var debitTypes = [graph.enums.TransactionType.Debit, graph.enums.TransactionType.PendingDebit, graph.enums.TransactionType.Void];
var getTargetContext = function getTargetContext(log) {
  var contextIdentifiers = log.context_identifiers || [];
  return contextIdentifiers.find(function (c) {
    return log.id === (c === null || c === void 0 ? void 0 : c.transaction_log_id);
  }) || contextIdentifiers[0];
};
var getListing = function getListing(log) {
  var _a;
  var targetContext = getTargetContext(log);
  var listing = ['LiveAuctionSegment', 'OnlineAuctionSegment'].includes(((_a = targetContext === null || targetContext === void 0 ? void 0 : targetContext.resolved_context) === null || _a === void 0 ? void 0 : _a.__typename) || '') ? _.get(targetContext === null || targetContext === void 0 ? void 0 : targetContext.resolved_context, 'listing') : targetContext === null || targetContext === void 0 ? void 0 : targetContext.resolved_context;
  return listing;
};
var getLogDescription = function getLogDescription(description, formatted_address) {
  if (formatted_address === void 0) {
    formatted_address = '';
  }
  return {
    description: "".concat(description).concat(formatted_address ? " ".concat(formatted_address) : ''),
    unresolved_description: "".concat(description).concat(formatted_address ? " {{listing.formatted_address}}" : '')
  };
};
var logDescriptionMatch = function logDescriptionMatch(log) {
  var _a;
  var contextIdentifiers = log.context_identifiers || [];
  var targetContext = getTargetContext(log);
  var maybeWireTransfer = contextIdentifiers.find(function (i) {
    return (i === null || i === void 0 ? void 0 : i.context_source) === graph.enums.TransactionContextSource.ManualWireTransfer;
  });
  var listing = getListing(log);
  var formattedAddress = (listing === null || listing === void 0 ? void 0 : listing.formatted_address) ? (_a = listing === null || listing === void 0 ? void 0 : listing.formatted_address) === null || _a === void 0 ? void 0 : _a[0] : '';
  var buildDescription = function buildDescription(description, connector) {
    if (connector === void 0) {
      connector = 'for';
    }
    return formattedAddress ? "".concat(description, " ").concat(connector) : description;
  };
  var value = match(_assign(_assign({}, log), {
    targetContext: targetContext
  })).with({
    payment_type: graph.enums.BuyerPaymentType.LiveRemoteBidding,
    transaction_type: P.when(function (type) {
      return !!type && creditTypes.includes(type);
    }),
    transaction_log_type: P.when(function (t) {
      return [graph.enums.TransactionLogType.Reversal, graph.enums.TransactionLogType.Refund].includes(t);
    }),
    targetContext: P.when(function (context) {
      return Boolean((context === null || context === void 0 ? void 0 : context.action) === graph.enums.TransactionContextAction.CreditForCancellation);
    })
  }, function () {
    return getLogDescription(buildDescription('Funds Added for cancelation', 'of'), formattedAddress);
  }).with({
    payment_type: graph.enums.BuyerPaymentType.LiveRemoteBidding,
    transaction_type: P.when(function (type) {
      return !!type && creditTypes.includes(type);
    }),
    transaction_log_type: graph.enums.TransactionLogType.Payment
  }, function () {
    return getLogDescription((maybeWireTransfer === null || maybeWireTransfer === void 0 ? void 0 : maybeWireTransfer.id) ? "Funds Added - Wire ID ".concat(maybeWireTransfer.id) : 'General Funding');
  }).with({
    payment_type: graph.enums.BuyerPaymentType.LiveRemoteBidding,
    transaction_type: P.when(function (type) {
      return !!type && debitTypes.includes(type);
    }),
    transaction_log_type: graph.enums.TransactionLogType.Charge,
    targetContext: P.when(function (context) {
      return Boolean((context === null || context === void 0 ? void 0 : context.action) === graph.enums.TransactionContextAction.RemainingPaymentForClosing);
    })
  }, function () {
    return getLogDescription(buildDescription('Remaining Payment'), formattedAddress);
  }).with({
    payment_type: graph.enums.BuyerPaymentType.LiveRemoteBidding,
    transaction_type: P.when(function (type) {
      return !!type && debitTypes.includes(type);
    }),
    transaction_log_type: graph.enums.TransactionLogType.Charge,
    targetContext: P.when(function (context) {
      return Boolean((context === null || context === void 0 ? void 0 : context.action) === graph.enums.TransactionContextAction.AssignTheBidHold);
    })
  }, function () {
    return getLogDescription(buildDescription('Assign the Bid (Hold)'), formattedAddress);
  }).with({
    payment_type: graph.enums.BuyerPaymentType.LiveRemoteBidding,
    transaction_type: P.when(function (type) {
      return !!type && creditTypes.includes(type);
    }),
    transaction_log_type: graph.enums.TransactionLogType.Reversal,
    targetContext: P.when(function (context) {
      return Boolean((context === null || context === void 0 ? void 0 : context.action) === graph.enums.TransactionContextAction.AssignTheBidReturn);
    })
  }, function () {
    return getLogDescription(buildDescription('Assign the Bid (Return)'), formattedAddress);
  }).with({
    payment_type: graph.enums.BuyerPaymentType.LiveRemoteBidding,
    transaction_type: P.when(function (type) {
      return !!type && creditTypes.includes(type);
    }),
    transaction_log_type: graph.enums.TransactionLogType.Reversal
  }, function () {
    return getLogDescription(buildDescription('You did not execute the contract'), formattedAddress);
  }).with({
    payment_type: graph.enums.BuyerPaymentType.LiveRemoteBidding,
    transaction_type: P.when(function (type) {
      return !!type && debitTypes.includes(type);
    }),
    charge_reason: graph.enums.ChargeReason.Sale
  }, function () {
    var stateDepositRule = _.get(targetContext === null || targetContext === void 0 ? void 0 : targetContext.resolved_context, 'configuration.state_deposit_rule');
    var description = Boolean(stateDepositRule) && stateDepositRule !== '100%' ? 'Winning Bid Deposit' : 'Payment';
    return getLogDescription(buildDescription(description), formattedAddress);
  }).with({
    payment_type: graph.enums.BuyerPaymentType.OnlineBidDeposit,
    transaction_type: P.when(function (type) {
      return !!type && creditTypes.includes(type);
    }),
    transaction_log_type: graph.enums.TransactionLogType.Reversal
  }, function () {
    return getLogDescription('Funds Added to Wallet by Auction.com');
  }).with({
    payment_type: graph.enums.BuyerPaymentType.OnlineBidDeposit,
    transaction_type: P.when(function (type) {
      return !!type && creditTypes.includes(type);
    }),
    targetContext: P.when(function (context) {
      return Boolean((context === null || context === void 0 ? void 0 : context.action) === graph.enums.TransactionContextAction.BiddingRegistration);
    })
  }, function () {
    return getLogDescription("Registration Deposit".concat(formattedAddress ? ": ".concat(formattedAddress) : ''));
  }).with({
    payment_type: graph.enums.BuyerPaymentType.OnlineBidDeposit,
    transaction_type: P.when(function (type) {
      return !!type && creditTypes.includes(type);
    })
  }, function () {
    return getLogDescription('Wallet Deposit');
  }).with({
    payment_type: graph.enums.BuyerPaymentType.OnlineBidDeposit,
    transaction_type: P.when(function (type) {
      return !!type && debitTypes.includes(type);
    }),
    payment_method_type: graph.enums.PaymentMethodType.Card,
    transaction_log_type: graph.enums.TransactionLogType.Dispute
  }, function () {
    return getLogDescription('Return of Funds: Credit Card Dispute');
  }).with({
    payment_type: graph.enums.BuyerPaymentType.OnlineBidDeposit,
    transaction_type: P.when(function (type) {
      return !!type && debitTypes.includes(type);
    }),
    transaction_log_type: graph.enums.TransactionLogType.Dispute
  }, function () {
    return getLogDescription('Return of Funds: Dispute');
  }).with({
    payment_type: graph.enums.BuyerPaymentType.OnlineBidDeposit,
    transaction_type: P.when(function (type) {
      return !!type && debitTypes.includes(type);
    }),
    charge_reason: graph.enums.ChargeReason.ManualFallout
  }, function () {
    return getLogDescription("Failure to perform".concat(formattedAddress ? " on ".concat(formattedAddress) : ''));
  }).with({
    payment_type: graph.enums.BuyerPaymentType.OnlineBidDeposit,
    transaction_type: P.when(function (type) {
      return !!type && debitTypes.includes(type);
    }),
    charge_reason: graph.enums.ChargeReason.AutoFallout
  }, function () {
    return getLogDescription("Failure to perform".concat(formattedAddress ? " on ".concat(formattedAddress) : ''));
  }).with({
    payment_type: graph.enums.BuyerPaymentType.OnlineBidDeposit,
    transaction_log_type: graph.enums.TransactionLogType.Payment,
    transaction_status: graph.enums.TransactionStatus.Failed,
    failure_reason: graph.enums.PaymentFailureReason.InsufficientFunds
  }, function () {
    return getLogDescription('Insufficient Funds');
  }).with({
    payment_type: graph.enums.BuyerPaymentType.OnlineBidDeposit,
    transaction_log_type: graph.enums.TransactionLogType.Payment,
    transaction_status: graph.enums.TransactionStatus.Failed
  }, function () {
    return getLogDescription('Failed Deposit');
  }).with({
    payment_type: graph.enums.BuyerPaymentType.OnlineBidDeposit,
    transaction_log_type: graph.enums.TransactionLogType.Refund,
    transaction_status: graph.enums.TransactionStatus.Failed
  }, function () {
    return getLogDescription('Failed Refund');
  }).with({
    transaction_type: P.when(function (type) {
      return !!type && debitTypes.includes(type);
    }),
    transaction_log_type: graph.enums.TransactionLogType.Refund
  }, function () {
    return getLogDescription('Return of Funds');
  }).with({
    transaction_type: P.when(function (type) {
      return !!type && creditTypes.includes(type);
    })
  }, function () {
    return getLogDescription('General Funding');
  }).with({
    transaction_type: P.when(function (type) {
      return !!type && debitTypes.includes(type);
    })
  }, function () {
    return getLogDescription('General Debit');
  }).otherwise(function () {
    return getLogDescription('');
  });
  return value;
};
var numberSignMatch = function numberSignMatch(log) {
  return match(log).with({
    transaction_type: P.when(function (type) {
      return !!type && creditTypes.includes(type);
    })
  }, {
    payment_type: graph.enums.BuyerPaymentType.OnlineBidDeposit,
    transaction_status: graph.enums.TransactionStatus.Processing
  }, {
    payment_type: graph.enums.BuyerPaymentType.OnlineBidDeposit,
    transaction_type: graph.enums.TransactionType.Void,
    transaction_log_type: graph.enums.TransactionLogType.Refund
  }, function () {
    return log.transaction_amount ? '+' : '';
  }).with({
    transaction_type: P.when(function (type) {
      return !!type && debitTypes.includes(type);
    })
  }, {
    payment_type: graph.enums.BuyerPaymentType.OnlineBidDeposit,
    transaction_status: graph.enums.TransactionStatus.Failed
  }, function () {
    return log.transaction_amount ? '-' : '';
  }).otherwise(function () {
    return '';
  });
};
var formatAmount = function formatAmount(log, numberSign) {
  var _a;
  var nSign = numberSign !== null && numberSign !== void 0 ? numberSign : numberSignMatch(log);
  return "".concat(nSign ? "".concat(nSign, " ") : '').concat(formatMoney$1((_a = log.transaction_amount) !== null && _a !== void 0 ? _a : 0, {
    minimumFractionDigits: 2
  }));
};
var transactionTypeMatch = function transactionTypeMatch(log) {
  return match(log).with({
    payment_type: graph.enums.BuyerPaymentType.OnlineBidDeposit,
    transaction_status: graph.enums.TransactionStatus.Processing
  }, {
    transaction_type: graph.enums.TransactionType.PendingCredit
  }, {
    payment_type: graph.enums.BuyerPaymentType.OnlineBidDeposit,
    transaction_type: graph.enums.TransactionType.Void,
    transaction_log_type: graph.enums.TransactionLogType.Refund
  }, function () {
    return graph.enums.TransactionType.Credit;
  }).with({
    payment_type: graph.enums.BuyerPaymentType.OnlineBidDeposit,
    transaction_status: graph.enums.TransactionStatus.Failed
  }, {
    transaction_type: graph.enums.TransactionType.PendingDebit
  }, {
    transaction_type: graph.enums.TransactionType.Void
  }, function () {
    return graph.enums.TransactionType.Debit;
  }).otherwise(function () {
    return log.transaction_type;
  });
};

var utils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  formatAmount: formatAmount,
  getListing: getListing,
  logDescriptionMatch: logDescriptionMatch,
  numberSignMatch: numberSignMatch,
  transactionTypeMatch: transactionTypeMatch
});

var requestRefund = function requestRefund(variables) {
  return fetch.forAuctionGraph({
    query: gql(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n        mutation ", "($type: BuyerPaymentType!) {\n          requestRefund(type: $type) {\n            total_refunded_amount\n            refund_transactions {\n              transaction_status\n              refund_intent_status\n            }\n          }\n        }\n        "], ["\n        mutation ", "($type: BuyerPaymentType!) {\n          requestRefund(type: $type) {\n            total_refunded_amount\n            refund_transactions {\n              transaction_status\n              refund_intent_status\n            }\n          }\n        }\n        "])), embeddableOperation('blueprint_wallet_requestRefund')),
    variables: variables
  }).then(function (res) {
    var errors = ___default.get(res, 'body.errors[0]');
    if (errors) throw errors;
    return res;
  });
};
var templateObject_1$3;

var providers$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  requestRefund: requestRefund
});

var index$3 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  providers: providers$2,
  utils: utils
});

var create = function create(invite) {
  return fetch.forAuctionGraph({
    variables: {
      input: invite
    },
    query: gql(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n        mutation ", "(input: CreateInvitation!) {\n          createInvitation(input: $input) {\n            invitation_id\n          }\n        }\n      "], ["\n        mutation ", "(input: CreateInvitation!) {\n          createInvitation(input: $input) {\n            invitation_id\n          }\n        }\n      "])), embeddableOperation('blueprint_invitations_accept'))
  }).then(function (response) {
    if (response.body.errors && response.body.errors[0]) {
      throw response.body.errors[0];
    }
    return response.body.data.createInvitation;
  });
};
var accept = function accept(invitationToken) {
  return fetch.forAuctionGraph({
    query: gql(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject(["\n        mutation ", "($invitationToken: String!) {\n          acceptInvitation(invitationToken: $invitationToken) {\n            invitation_token\n          }\n        }\n      "], ["\n        mutation ", "($invitationToken: String!) {\n          acceptInvitation(invitationToken: $invitationToken) {\n            invitation_token\n          }\n        }\n      "])), embeddableOperation('blueprint_invitations_accept')),
    variables: {
      invitationToken: invitationToken
    }
  }).then(function (res) {
    var result = res.body.data.acceptInvitation;
    if (!(result === null || result === void 0 ? void 0 : result.invitation_token)) {
      if (res.body.errors) {
        var errors = res.body.errors;
        throw errors[0];
      }
      throw new Error('Failed to accept invitation');
    }
  });
};
var revoke = function revoke(invitationToken) {
  return fetch.forAuctionGraph({
    variables: {
      invitationToken: invitationToken
    },
    query: gql(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        mutation ", "($invitationToken: String!) {\n          revokeInvitation(invitationToken: $invitationToken) {\n            invitation_id\n            updated_date\n            status\n          }\n        }\n      "], ["\n        mutation ", "($invitationToken: String!) {\n          revokeInvitation(invitationToken: $invitationToken) {\n            invitation_id\n            updated_date\n            status\n          }\n        }\n      "])), embeddableOperation('blueprint_invitations_revoke'))
  }).then(function (response) {
    if (response.body.errors && response.body.errors[0]) {
      throw response.body.errors[0];
    }
    return response.body.data.revokeInvitation;
  });
};
var templateObject_1$2, templateObject_2$1, templateObject_3;

var providers$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  accept: accept,
  create: create,
  revoke: revoke
});

var fragments = {
  pendingInvitation: {
    reference: '...BlueprintInvitationPendingInvitation',
    definition: gql(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n      fragment BlueprintInvitationPendingInvitation on Invitation {\n        invitation_id\n        invitation_token\n        updated_date\n        created_date\n        status\n        relatives {\n          object_description\n          object_type\n          object_id\n          recipient_role_code\n        }\n      }\n    "], ["\n      fragment BlueprintInvitationPendingInvitation on Invitation {\n        invitation_id\n        invitation_token\n        updated_date\n        created_date\n        status\n        relatives {\n          object_description\n          object_type\n          object_id\n          recipient_role_code\n        }\n      }\n    "])))
  }
};
var templateObject_1$1;

var fragments$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  default: fragments
});

var index$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  fragments: fragments$1,
  providers: providers$1
});

var PROGRESS_INCREMENT_FACTOR = 0.2;
function useFlow(_a) {
  var _b;
  var definition = _a.definition,
    context = _a.context,
    emitter = _a.emitter;
  var firstStepId = definition[0].id;
  var _c = useState(function () {
      var _a;
      return _a = {}, _a[firstStepId] = false, _a;
    }),
    stepTouchedMap = _c[0],
    setStepTouchedMap = _c[1];
  var derivedStartingStepId = useOnce(function () {
    var _a;
    var stepId = (_a = definition.find(function (step) {
      var _a;
      return !((_a = step === null || step === void 0 ? void 0 : step.canBeSkipped) === null || _a === void 0 ? void 0 : _a.call(step, {
        context: context
      }));
    })) === null || _a === void 0 ? void 0 : _a.id;
    return stepId !== null && stepId !== void 0 ? stepId : firstStepId;
  });
  var _d = useState([[derivedStartingStepId, 0]]),
    history = _d[0],
    setHistory = _d[1];
  var stepsVisited = history.map(function (_a) {
    var step = _a[0];
    return step;
  });
  var progressIncrements = history.map(function (_a) {
    var inc = _a[1];
    return inc;
  });
  var currentProgress = progressIncrements.reduce(function (sum, a) {
    return sum + a;
  }, 0);
  var remainingProgress = 100 - currentProgress;
  var stepMap = React.useMemo(function () {
    return definition.reduce(function (acc, step) {
      acc[step.id] = step;
      return acc;
    }, {});
  }, [definition]);
  var _e = React.useState(derivedStartingStepId),
    currentStep = _e[0],
    setCurrentStep = _e[1];
  var currentStepTouched = (_b = stepTouchedMap[currentStep]) !== null && _b !== void 0 ? _b : false;
  var setCurrentStepTouched = React.useCallback(function (flag) {
    setStepTouchedMap(function (prev) {
      var _a;
      return _assign(_assign({}, prev), (_a = {}, _a[currentStep] = flag, _a));
    });
  }, [currentStep, setStepTouchedMap]);
  var actions = React.useMemo(function () {
    return {
      advance: function advance(props) {
        var propsAndContext = _assign(_assign({}, props), {
          context: context
        });
        var stepDef = stepMap[currentStep];
        var isLast = stepDef.isLastStep(propsAndContext);
        if (isLast) {
          emitter === null || emitter === void 0 ? void 0 : emitter.on('flow:complete', {
            from: currentStep
          });
          return;
        }
        var nextStepId = stepDef.next(propsAndContext);
        if (!nextStepId) return;
        setCurrentStep(nextStepId);
        setStepTouchedMap(function (prev) {
          var _a;
          var _b;
          return _assign(_assign({}, prev), (_a = {}, _a[nextStepId] = (_b = prev[nextStepId]) !== null && _b !== void 0 ? _b : false, _a));
        });
        var nextIncrement = stepDef.isLastStep(propsAndContext) ? remainingProgress : remainingProgress * PROGRESS_INCREMENT_FACTOR;
        setHistory(function (h) {
          return __spreadArray(__spreadArray([], h, true), [[nextStepId, nextIncrement]], false);
        });
        emitter === null || emitter === void 0 ? void 0 : emitter.on('flow:advance', {
          from: currentStep,
          to: nextStepId
        });
      },
      retreat: function retreat() {
        if (stepsVisited.length <= 1) return;
        setHistory(function (h) {
          if (h.length <= 1) return h;
          var newHistory = h.slice(0, -1);
          var prevStepId = newHistory[newHistory.length - 1][0];
          setCurrentStep(prevStepId);
          emitter === null || emitter === void 0 ? void 0 : emitter.on('flow:retreat', {
            from: currentStep,
            to: prevStepId
          });
          return newHistory;
        });
      },
      reset: function reset() {
        var _a;
        setCurrentStep(firstStepId);
        setHistory([[firstStepId, 0]]);
        setStepTouchedMap((_a = {}, _a[firstStepId] = false, _a));
      },
      setCurrentStepTouched: setCurrentStepTouched
    };
  }, [context, currentStep, emitter, firstStepId, remainingProgress, setCurrentStepTouched, stepMap, stepsVisited.length]);
  var currentStepObject = stepMap[currentStep];
  var data = React.useMemo(function () {
    return {
      currentStepTouched: currentStepTouched,
      currentProgress: currentProgress,
      currentStepObject: currentStepObject,
      stepsVisited: stepsVisited
    };
  }, [currentStepTouched, currentProgress, currentStepObject, stepsVisited]);
  return {
    data: data,
    actions: actions
  };
}
var hooks = {
  useFlow: useFlow
};

var index$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  hooks: hooks
});

var getCommunicationPreferences = function getCommunicationPreferences(searchUrn) {
  return fetch__default.forAuctionGraph({
    query: gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        query ", "($searchUrn: URN!) {\n          communication_preference(searchUrn: $searchUrn) {\n            urn\n            owner {\n              ... on MinimalPreferenceUser {\n                user_id\n                party_id\n                signup_source\n              }\n              ... on MinimalLead {\n                lead_id\n              }\n            }\n            rules {\n              audience\n              channel\n              opt_status\n            }\n          }\n        }\n      "], ["\n        query ", "($searchUrn: URN!) {\n          communication_preference(searchUrn: $searchUrn) {\n            urn\n            owner {\n              ... on MinimalPreferenceUser {\n                user_id\n                party_id\n                signup_source\n              }\n              ... on MinimalLead {\n                lead_id\n              }\n            }\n            rules {\n              audience\n              channel\n              opt_status\n            }\n          }\n        }\n      "])), embeddableOperation('blueprint_communication_preferences_get')),
    variables: {
      searchUrn: searchUrn
    }
  }).then(function (res) {
    var _a;
    var errors = (_a = res.body.errors) === null || _a === void 0 ? void 0 : _a[0];
    if (errors) throw errors;
    return res.body.data.communication_preference;
  }).catch(function (error) {
    console.error('Error fetching communication preferences:', error);
    throw error;
  });
};
var updateCommunicationPreferences = function updateCommunicationPreferences(urn, rules) {
  return fetch__default.forAuctionGraph({
    query: gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n          mutation ", "(\n            $urn: URN!\n            $rules: [CommunicationPreferenceRuleInput!]!\n          ) {\n            setCommunicationPreference(urn: $urn, rules: $rules)\n          }\n        "], ["\n          mutation ", "(\n            $urn: URN!\n            $rules: [CommunicationPreferenceRuleInput!]!\n          ) {\n            setCommunicationPreference(urn: $urn, rules: $rules)\n          }\n        "])), embeddableOperation('blueprint_communication_preferences_update')),
    variables: {
      urn: urn,
      rules: rules
    }
  }).then(function (res) {
    var _a;
    var errors = (_a = res.body.errors) === null || _a === void 0 ? void 0 : _a[0];
    if (errors) throw errors;
    return res.body.data.setCommunicationPreference;
  }).catch(function (error) {
    console.error('Error updating communication preferences:', error);
    throw error;
  });
};
var templateObject_1, templateObject_2;

var providers = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getCommunicationPreferences: getCommunicationPreferences,
  updateCommunicationPreferences: updateCommunicationPreferences
});

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  providers: providers
});

export { types$2 as BuyerListingSearchTypes, types$1 as UseListingsSearchTypes, index$a as bidding, index as communicationPreferences, index$9 as filters, index$1 as flows, formatters, index$2 as invitations, index$b as listing, index$6 as nudges, index$c as primitives, index$4 as purchaseProfiles, index$7 as search, index$5 as user, utils$7 as utils, index$3 as wallet };
//# sourceMappingURL=blueprint.js.map
